webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(8);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function deepMerge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if (typeof val === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 2 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.12
 * (c) 2014-2020 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Technically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals. ' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a special value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      if (false) {
        warn(
          ("The .native modifier for v-on is only valid on components but it was used on <" + tag + ">."),
          context
        );
      }
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack because all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.12';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes([oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecessary `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being passed as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:|^#/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anything as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (name === 'v-slot' || name[0] === '#') {
            checkFunctionParameterExpression(value, (name + "=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stripped = exp.replace(stripStringRE, '');
  var keywordMatch = stripped.match(unaryOperatorsRE);
  if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

function checkFunctionParameterExpression (exp, text, warn, range) {
  try {
    new Function(exp, '');
  } catch (e) {
    warn(
      "invalid function parameter expression: " + (e.message) + " in\n\n" +
      "    " + exp + "\n\n" +
      "  Raw expression: " + (text.trim()) + "\n",
      range
    );
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4), __webpack_require__(18).setImmediate))

/***/ }),
/* 4 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]());

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(25),
  /* template */
  __webpack_require__(28),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(26),
  /* template */
  __webpack_require__(27),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(1);
var normalizeHeaderName = __webpack_require__(35);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(12);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(12);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var settle = __webpack_require__(36);
var buildURL = __webpack_require__(9);
var buildFullPath = __webpack_require__(38);
var parseHeaders = __webpack_require__(41);
var isURLSameOrigin = __webpack_require__(42);
var createError = __webpack_require__(13);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(43);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(37);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
  var defaultToConfig2Keys = [
    'baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress',
    'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath'
  ];

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys);

  var otherKeys = Object
    .keys(config2)
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  return config;
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_touch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_resource__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_analytics__);
/*jshint esversion: 6 */
/* The Vue build version to load with the `import` command
(runtime-only or standalone) has been set in webpack.base.conf with an alias. */

var path = __webpack_require__(17);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a.config.swipe = {
  direction: 'horizontal',
  threshold: 10,
  velocity: 0.3,
  pointers: 1
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a, { name: 'v-touch' });

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_analytics___default.a, {
  id: ['UA-137347938-1', 'UA-64435914-1'],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  autoTracking: {
    pageviewTemplate: function pageviewTemplate(route) {
      return {
        page: path.join(window.location.pathname, route.path),
        title: document.title,
        location: window.location.href
      };
    }
  },
  debug: {
    enabled: false
  }
});

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  data: {},
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  }
}).$mount('#app');

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(19);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(2)))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(21)
  __webpack_require__(22)
  __webpack_require__(23)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(46),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    pageNum: {
      type: Number,
      default: 0
    },
    ttlPages: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      pageNumber: this.pageNum,
      totalPages: this.ttlPages,
      info: false,
      buyBar: true,
      buyMenu: false,
      socialMenu: false,
      otherBooks: false,
      focused: false,
      dialogBuy: false,
      dialogShare: false,
      notifications: false,
      sound: true,
      widgets: false,
      show: false,
      iSize: 50,
      selectBook: "Books",
      home: this.$route.path,
      drawer: false,
      drawerRight: false,
      items: [],
      books: [],
      booksChanged: '',
      socials: [{
        title: "LinkedIn",
        img: "static/img/linkedin-logo.svg",
        url: "https://www.linkedin.com/shareArticle?mini=true&url=https://textcafe.co/books/QtftwR/%3F1730409574387&title=The%20Books%20of%20Ezra%20and%20Nehemiah%2C%20New%20International%20Commentary%20on%20the%20Old%20Testament%20%28NICOT%29&summary=The%20books%20of%20Ezra%20and%20Nehemiah%20represent%20a%20significant%20turning%20point%20in%20biblical%20history.%20They%20tell%20the%20story%20not%20only%20of%20the%20rebuilding%20of%20the%20temple%20in%20Jerusalem%20but%20also%20of%20the%20resurrection%20of%20God%26rsquo%3Bs%20people%20from%20the%20death%20of%20exile.%20Hannah%20Harri&source=LinkedIn",
        icon: "ion-social-linkedin"
      }, {
        title: "Facebook",
        img: "static/img/facebook-logo.svg",
        url: "https://www.facebook.com/sharer/sharer.php?u=https://textcafe.co/books/QtftwR/%3F1730409574387",
        icon: "ion-social-facebook"
      }, {
        title: "Twitter",
        img: "static/img/twitter-logo-silhouette.svg",
        url: "https://twitter.com/intent/tweet?text=The%20books%20of%20Ezra%20and%20Nehemiah%20represent%20a%20significant%20turning%20point%20in%20biblical%20history.%20They%20tell%20the%20story%20not%20only%20of%20the%20rebuilding%20of%20t%0Dhttps://textcafe.co/books/QtftwR/%3F1730409574387&amp;via=textcafecom",
        icon: "ion-social-twitter"
      }, {
        title: "Tumblr",
        img: "static/img/tumblr-letter-logo.svg",
        url: "https://www.tumblr.com/widgets/share/tool?canonicalUrl=https://textcafe.co/books/QtftwR/%3F1730409574387&posttype=link&caption=The%20books%20of%20Ezra%20and%20Nehemiah%20represent%20a%20significant%20turning%20point%20in%20biblical%20history.%20They%20tell%20the%20story%20not%20only%20of%20the%20rebuilding%20of%20the%20temple%20in%20Jerusalem%20but%20also%20of%20the%20resurrection%20of%20God%26rsquo%3Bs%20people%20from%20the%20death%20of%20exile.%20Hannah%20Harri",
        icon: "ion-social-tumblr"
      }, {
        title: "Pinterest",
        img: "static/img/pinterest-logo.svg",
        url: "http://www.pinterest.com/pin/create/button/?url=https://textcafe.co/books/QtftwR/%3F1730409574387&description=The%20books%20of%20Ezra%20and%20Nehemiah%20represent%20a%20significant%20turning%20point%20in%20biblical%20history.%20They%20tell%20the%20story%20not%20only%20of%20the%20rebuilding%20of%20the%20temple%20in%20Jerusalem%20but%20also%20of%20the%20resurrection%20of%20God%26rsquo%3Bs%20people%20from%20the%20death%20of%20exile.%20Hannah%20Harri&media=https://textcafe.co/books/QtftwR/tc-custom/9781467464024.jpg",
        icon: "ion-social-pinterest"
      }],
      buys: [{
        title: 'Amazon US',
        img: 'https://textcafe.co/domain-icons/Amazon.com_A_Smile.svg',
        url: 'https://www.amazon.com/dp/0802825486?tag=mobilebookcom-20&ref=nosim',
        alt: 'None'
      }, {
        title: '',
        img: 'https://www.google.com/s2/favicons?domain=christianbook.com',
        url: 'https://www.christianbook.com/Christian/Books/product?&event=AFF&p=1201454&isbn=9781467464024',
        alt: ''
      }, {
        title: 'Google Play',
        img: 'https://textcafe.co/global-css/img/Google_Play_symbol.svg',
        url: 'https://play.google.com/store/books/details?id=z8uAEAAAQBAJ&amp;rdid=book-z8uAEAAAQBAJ&amp;rdot=1&amp;source=gbs_atb&amp;pcampaignid=books_booksearch_atb&gl=us',
        alt: 'None'
      }],
      right: null,
      left: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('https://www.textcafe.com/widget/get-samples.json?related=9781467464024').then(function (response) {
      return _this.books = response.data.map(function (item) {
        return {
          title: item.title,
          img: item.coverImagePath,
          url: item.socialUrl,
          alt: "This image is the cover for the book " + item.title
        };
      });
    }).catch(function (error) {
      return (
        // handle error
        console.log(error)
      );
    });
  },

  created: function created() {
    var _this2 = this;

    this.$router.options.routes.forEach(function (route) {
      _this2.items.push({
        path: route.path,
        name: route.name,
        component: route.component,
        //image: "static/img/ilG6Mf.jpg"
        image: '/books/QtftwR/tc-custom/9781467464024.jpg?1730409574387',
        alt: 'The Books of Ezra and Nehemiah, New International Commentary on the Old Testament (NICOT)'
      });
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("pageNum", function (newValue) {
      _this2.pageNum = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("ttlPages", function (newValue) {
      _this2.ttlPages = newValue;
    });
  },
  watch: {
    $route: function $route(to, from) {
      if (to.path === "/") {
        this.home = this.$route.path;
      } else {
        this.home = null;
      }
    },

    iSize: function iSize(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("iSizeChanged", newValue);
    },
    books: function books(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("booksChanged", Date.now());
    }
  },
  methods: {
    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    },
    onBlur: function onBlur() {
      if (this.show === true) {
        this.show = false;
        this.$emit("blur");
      }
    },
    onFocus: function onFocus() {
      if (this.show === false) {
        this.show = true;
        this.$el.querySelector(".book-page").$emit("focus");
      }
    },
    buyClick: function buyClick(url) {
      //const url = '/foo/bar'
      // this.$ga.query('send', 'event', 'outbound', 'click', url, {
      //     transport: 'beacon',
      //     hitCallback () {
      //        //document.location = url
      //     }
      // })
      this.$ga.event({
        eventCategory: 'purchase',
        eventAction: 'click',
        eventLabel: url
        // eventValue: 123
      });
    },
    shareClick: function shareClick(network) {
      this.$ga.event({
        eventCategory: 'share',
        eventAction: 'click',
        eventLabel: network
        // eventValue: 123
      });
    }
  },
  components: {
    settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default.a,
    reader: __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default.a
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var SLIDE_TIME = document.documentElement.clientWidth > 480 ? 500 : 300;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "reader",
  props: {
    value1: {
      type: Number,
      default: 22
    },
    selected: {
      type: String
    },
    ex8: {
      type: String,
      default: "Auto"
    },
    value2: {
      type: Number
    },
    value3: {
      type: Number,
      default: 100
    }
  },
  data: function data() {
    return {
      pageNum: 0,
      pageNumber: 1,
      ttlPages: 0,
      totalPages: 0,
      home: false,
      div: 0,
      prevX: null,
      xDownEnd: null,
      fontSize: this.value1,
      fontFamily: this.selected,
      columns: this.ex8,
      widthSize: this.value2,
      brightness: this.value3,
      currentColor: "#f3f3f3",
      cols: "2 220px",
      position: { scrollTop: 0, scrollLeft: 0 },
      offset: null,
      height: 0,
      isOver: false,
      routeNames: ["home", "005_Contents", "006_Excursuses", "007_General", "008_Abbreviations", "009_Bibliography", "010_Chapter01", "last"],
      routeTransition: "slide-left",
      rest: true,
      selectedView: "Book1",
      progress: 0,
      hiddenEl: false,
      brandReaderUrl: "",
      brandLogoUrl: "",
      currentUrl: "https://textcafe.co/books/QtftwR/",
      waiting: false
    };
  },

  created: function created() {
    var _this = this;

    document.addEventListener("mousewheel", this.onScroll, false);
    window.addEventListener('resize', this.resize);
    this.resize();
    this.getTtlPages();

    if (document.documentElement.offsetWidth >= 768) {
      this.hiddenEl = true;
    } else {
      this.hiddenEl = false;
    }

    this.$router.options.routes.forEach(function (route) {
      _this.routeNames.push(route.name);
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontSizeChanged", function (newValue) {
      _this.fontSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontFamilyChanged", function (newValue) {
      _this.fontFamily = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("columnsCountChanged", function (newValue) {
      _this.columns = newValue;
      if (_this.columns === "Single") {
        _this.cols = "1 auto";
      } else if (_this.columns === "Auto") {
        _this.cols = "2 220px";
      }
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("widthChanged", function (newValue) {
      _this.widthSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("brightnessChanged", function (newValue) {
      _this.brightness = newValue;
    });
  },

  destroyed: function destroyed() {
    document.removeEventListener("mousewheel", this.onScroll, false);
    document.removeEventListener("resize", this.resize, false);
  },
  updated: function updated() {
    this.getTtlPages();
    this.resize();
    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };
  },
  mounted: function mounted() {
    this.resize();

    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };

    this.getTtlPages();

    var bgColor = document.getElementsByClassName("book-content")[0].style.backgroundColor,
        hexDigits = new Array("0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f");
    function rgb2hex(rgb) {
      rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
      return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
    }
    function hex(x) {
      return isNaN(x) ? "00" : hexDigits[(x - x % 16) / 16] + hexDigits[x % 16];
    }
    this.currentColor = rgb2hex(bgColor);
  },

  watch: {
    $route: function $route(to, from, next) {
      var toDepth = this.routeNames.indexOf(to.name);
      var fromDepth = this.routeNames.indexOf(from.name);
      this.routeTransition = toDepth < fromDepth ? "slide-right" : "slide-left";

      this.progress = 0;
      this.pageNumber = 1;
    },

    pageNum: function pageNum(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("pageNum", newValue);
    },
    ttlPages: function ttlPages(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("ttlPages", newValue);
    }
  },
  methods: {
    resize: function resize() {
      this.height = document.documentElement.clientHeight;
    },
    linkTo: function linkTo(refName) {
      var element = document.getElementById(refName);
      var elementOffset = Math.ceil(element.offsetLeft);
      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);
      var onStart = Math.ceil(page.scrollLeft);
      var destinationOffset = Math.floor(elementOffset / (page.offsetWidth + gap));
      var target = destinationOffset * (page.offsetWidth + gap) - onStart;
      if (destinationOffset + 1 !== this.pageNumber) {
        this.scrollIt(target, 300, "easeOutQuad", false);
        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pctScrolled = Math.floor(destinationOffset * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
        this.pageNumber = destinationOffset + 1;
      }
    },
    getTtlPages: function getTtlPages() {
      this.$nextTick(function () {
        var page = this.$el.querySelector(".book-page");

        var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));
        this.ttlPages = ttlPages;
        this.totalPages = this.ttlPages + 1;
      });
    },
    tapped: function tapped() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    tappedIn: function tappedIn() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    scrollIt: function scrollIt(destination) {
      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;

      var _this2 = this;

      var easing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "easeInOutQuart";
      var callback = arguments[3];

      var easings = {
        linear: function linear(t) {
          return t;
        },
        easeInQuad: function easeInQuad(t) {
          return t * t;
        },
        easeOutQuad: function easeOutQuad(t) {
          return t * (2 - t);
        },
        easeInOutQuad: function easeInOutQuad(t) {
          return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        },
        easeInCubic: function easeInCubic(t) {
          return t * t * t;
        },
        easeOutCubic: function easeOutCubic(t) {
          return --t * t * t + 1;
        },
        easeInOutCubic: function easeInOutCubic(t) {
          return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
        },
        easeInQuart: function easeInQuart(t) {
          return t * t * t * t;
        },
        easeOutQuart: function easeOutQuart(t) {
          return 1 - --t * t * t * t;
        },
        easeInOutQuart: function easeInOutQuart(t) {
          return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
        },
        easeInQuint: function easeInQuint(t) {
          return t * t * t * t * t;
        },
        easeOutQuint: function easeOutQuint(t) {
          return 1 + --t * t * t * t * t;
        },
        easeInOutQuint: function easeInOutQuint(t) {
          return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
        }
      };

      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap;

      var start = Math.ceil(page.scrollLeft);

      var startTime = "now" in window.performance ? performance.now() : new Date().getTime();

      var documentWidth = Math.max(page.scrollWidth || page.offsetWidth || page.clientWidth);

      var windowWidth = window.innerWidth || window.clientWidth;

      var destinationOffsetToScroll = start + destination;

      function scroll() {
        var now = "now" in window.performance ? performance.now() : new Date().getTime();
        var time = Math.min(1, (now - startTime) / duration);
        var timeFunction = easings[easing](time);
        page.scroll(Math.ceil(timeFunction * (destinationOffsetToScroll - start) + start), 0);
        if (timeFunction === 1 || start === destinationOffsetToScroll) {
          if (callback) {
            callback();
          }
          return;
        }
        requestAnimationFrame(scroll);
      }
      scroll();
      setTimeout(function () {
        _this2.waiting = false;
      }, 250);
    },


    next: function next(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";
      var book = this.$el.querySelector(".book-content");
      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;
      var windowWidth = window.innerWidth || window.clientWidth;
      var trackLength = scrollArea - (page.offsetWidth + gap);

      // var pageNum = Math.floor(page.scrollLeft / (page.offsetWidth + gap));
      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.floor(scrollLeft / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      pageNum += 1;

      this.pageNumber += 1;

      if (page.scrollWidth - (scrollLeft + page.offsetWidth) !== 0 && pctScrolled !== 100) {
        var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = nextPage - scrollLeft;

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index + 1] });

        this.pageNumber = 1;
        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    prev: function prev(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";

      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;

      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
      var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      this.pageNumber -= 1;

      var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

      if (scrollLeft !== 0 && pageNum !== 0) {
        var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
        var pageNumber = Math.floor(scrollLeft / (page.offsetWidth + gap));

        pageNum -= 1;
        var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = -1 * (scrollLeft - prevPage);

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index - 1] });

        this.pageNumber = 1;

        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    over: function over() {
      this.isOver = true;
    },
    out: function out() {
      this.isOver = false;
    },
    onScroll: function onScroll(e, position) {
      this.position = position;
      if (this.isOver === true) {
        var page = this.$el.querySelector(".book-page"),
            gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
            deltaX = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail)),
            end = page.scrollWidth - (page.scrollLeft + page.offsetWidth),
            offset = page.offsetWidth + gap;

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pageNum = Math.round(page.scrollLeft / (page.offsetWidth + gap));

        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;

        if (deltaX === 1) {
          if (page.scrollLeft !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum -= 1;

            this.pageNumber -= 1;
            var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = -1 * (page.scrollLeft - prevPage);

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        } else if (deltaX === -1) {
          if (page.scrollWidth - (page.scrollLeft + page.offsetWidth) !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum += 1;

            this.pageNumber += 1;
            var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = nextPage - page.scrollLeft;

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        }
      } else {
        return;
      }
    },
    fadeIn: function fadeIn() {
      var page = this.$el.querySelector(".book-page");
      page.style.opacity = 0;
      var last = +new Date();
      var tick = function tick() {
        page.style.opacity = +page.style.opacity + (new Date() - last) / 400;
        last = +new Date();
        if (+page.style.opacity < 1) {
          window.requestAnimationFrame && requestAnimationFrame(tick) || setTimeout(tick, 16);
        }
      };
      tick();
    },

    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    }
  },
  computed: {
    isMobile: function isMobile() {
      var check = false;
      (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    }
  },
  components: {
    Settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings___default.a
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "settings",
  data: function data() {
    return {
      events: [],
      value1: 22,
      value2: 70,
      value3: 100,
      ex8: "Auto",
      selected: "Old-Cabin",
      fonts: ["Old-Cabin", "Raleway-Bitter", "Ubuntu-Abel", "Droid-Abril", "Garamond-Clicker", "Alice-Playfair", "Judson-Quando"],
      classes: ["white", "black", "sepia"]
    };
  },

  watch: {
    value1: function value1(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontSizeChanged", newValue);
    },
    selected: function selected(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontFamilyChanged", newValue);
    },
    ex8: function ex8(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("columnsCountChanged", newValue);
    },
    value2: function value2(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("widthChanged", newValue);
    },
    value3: function value3(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("brightnessChanged", newValue);
    }
  },
  methods: {
    reloadBook: function reloadBook() {
      window.location.reload(true);
    },
    changeClassWhite: function changeClassWhite() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      console.log(document.getElementsByTagName("footer")[0]);
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("white");
        el2.classList.add("white");
        el3.classList.add("white");
        el4.classList.add("white");
      } else {
        el.className += " white";
        el2.className += " white";
        el3.className += " white";
        el4.className += " white";
      }
    },
    changeClassBlack: function changeClassBlack() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("black");
        el2.classList.add("black");
        el3.classList.add("black");
        el4.classList.add("black");
      } else {
        el.className += " black";
        el2.className += " black";
        el3.className += " black";
        el4.className += " black";
      }
    },
    changeClassSepia: function changeClassSepia() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.add("sepia");
        el2.classList.add("sepia");
        el3.classList.add("sepia");
        el4.classList.add("sepia");
      } else {
        el.className += " sepia";
        el2.className += " sepia";
        el3.className += " sepia";
        el4.className += " sepia";
      }
    }
  }
});

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "settings"
  }, [_c('ul', {
    staticClass: "settings-list"
  }, [_c('li', [_c('span', [_vm._v("Reload book: ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "reloadBookBtn",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reloadBook()
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-loop-strong")])], 1)], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.fonts,
      "overflow": "",
      "single-line": "",
      "return-objectauto": "",
      "append-icon": "ion-ios-arrow-down",
      "hide-details": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = true
      }
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font size:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value1 + 'px' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 17,
      "max": 27,
      "step": 1
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "columns-setting"
  }, [_c('span', [_vm._v("Page columns:")]), _c('br'), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Auto",
      "value": "Auto",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Single",
      "value": "Single",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "width-setting"
  }, [_c('span', [_vm._v("Page width:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value2 + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 50,
      "max": 90
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Brightness:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s((_vm.value3 - 100) + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "step": 1,
      "min": 0,
      "max": 200
    },
    model: {
      value: (_vm.value3),
      callback: function($$v) {
        _vm.value3 = $$v
      },
      expression: "value3"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Color mode:")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "colors"
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "id": "white",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassWhite()
      }
    }
  }, [_vm._v("\n          White\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "black",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassBlack()
      }
    }
  }, [_vm._v("\n          Black\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "sepia",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassSepia()
      }
    }
  }, [_vm._v("\n          Sepia\n        ")])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap",
    style: ({
      'filter': 'brightness(' + _vm.brightness + '%)',
      'height': _vm.height - 49 + 'px'
    })
  }, [_c('v-progress-linear', {
    model: {
      value: (_vm.progress),
      callback: function($$v) {
        _vm.progress = $$v
      },
      expression: "progress"
    }
  }), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowleft']),
      expression: "['arrowleft']"
    }],
    staticClass: "nav-btn left",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.prev($event)
      },
      "shortkey": _vm.prev
    }
  }, [_c('v-icon', {
    style: ({
      'left': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowright']),
      expression: "['arrowright']"
    }],
    staticClass: "nav-btn right",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.next($event)
      },
      "shortkey": _vm.next
    }
  }, [_c('v-icon', {
    style: ({
      'right': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "book-content",
    style: ({
      'width': _vm.widthSize + '%',
      'background-color': _vm.currentColor,
      'height': _vm.height - 78 + 'px'
    }),
    on: {
      "mouseenter": _vm.over,
      "mouseleave": _vm.out
    }
  }, [(_vm.isMobile) ? _c('v-touch', {
    staticClass: "touch-swipe",
    class: {
      active: _vm.hiddenEl
    },
    on: {
      "swipeleft": _vm.next,
      "swiperight": _vm.prev,
      "tap": _vm.tapped
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    key: _vm.div,
    staticClass: "book-page",
    class: _vm.fontFamily,
    style: ({
      'font-size': _vm.fontSize + 'px',
      'columns': _vm.cols
    }),
    attrs: {
      "enable-resize-watcher": ""
    },
    on: {
      "tap": _vm.tappedIn,
      "swipe": _vm.tappedIn,
      "click": _vm.tappedIn
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.routeTransition,
      "mode": "out-in"
    }
  }, [_c('router-view', {
    key: _vm.$route.name,
    staticClass: "view"
  })], 1)], 1)], 1), _vm._v(" "), _c('footer', {
    class: _vm.fontFamily,
    style: ({
      'font-size': (_vm.fontSize - 5) + 'px'
    })
  }, [(_vm.brandReaderUrl) ? _c('div', [_c('v-btn', {
    staticClass: "HC-footer-button",
    attrs: {
      "flat": "",
      "ripple": false,
      "tag": "a",
      "href": _vm.brandReaderUrl,
      "target": "_blank"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = false, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('i', [_c('img', {
    attrs: {
      "src": _vm.brandLogoUrl
    }
  })])])], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "foots"
  }, [_c('span', [_c('em', [_vm._v(_vm._s(this.$route.name))])]), _vm._v(" - page "), _c('span', [_c('em', [_vm._v(_vm._s(this.pageNumber))])]), _vm._v(" "), (this.totalPages > 1) ? _c('span', [_c('em', [_vm._v(_vm._s("/ " + this.totalPages))])]) : _vm._e()]), _vm._v(" "), _c('v-spacer')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(30);

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var bind = __webpack_require__(8);
var Axios = __webpack_require__(31);
var mergeConfig = __webpack_require__(14);
var defaults = __webpack_require__(11);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(15);
axios.CancelToken = __webpack_require__(44);
axios.isCancel = __webpack_require__(10);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(45);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var buildURL = __webpack_require__(9);
var InterceptorManager = __webpack_require__(32);
var dispatchRequest = __webpack_require__(33);
var mergeConfig = __webpack_require__(14);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var transformData = __webpack_require__(34);
var isCancel = __webpack_require__(10);
var defaults = __webpack_require__(11);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(13);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(39);
var combineURLs = __webpack_require__(40);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(15);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "toolbar": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info
      }
    },
    model: {
      value: (_vm.info),
      callback: function($$v) {
        _vm.info = $$v
      },
      expression: "info"
    }
  }, [_c('v-card', {
    staticClass: "infoDialog"
  }, [_c('div', {
    staticClass: "menuIns"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-navicon")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-browsers-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Contents")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Navigate to book chapters")])]), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip2"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Related Books")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Other books you might like")])]), _vm._v(" "), _c('div', {
    staticClass: "socMenu"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-linkedin")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-facebook")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-twitter")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-tumblr")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-pinterest")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuMob"
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Share Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Share book to your social network")])]), _vm._v(" "), _c('div', {
    staticClass: "resize-settings"
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "resize-settings-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Settings button")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Change colors and fonts")])]), _vm._v(" "), _c('div', {
    staticClass: "left-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('div', {
    staticClass: "left-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Left/Previous")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to previous page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe right.")])]), _vm._v(" "), _c('div', {
    staticClass: "right-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "right-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Right/Next")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to next page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe left.")])]), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-mob"
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Buy Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Click to stores where you can buy this book")])]), _vm._v(" "), _c('div', {
    staticClass: "headline"
  }, [_vm._v("Instructions")]), _vm._v(" "), _c('v-btn', {
    staticClass: "closeDialog",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "menu",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', _vm._l((_vm.items), function(item) {
    return _c('v-list-tile', {
      key: item.name,
      attrs: {
        "href": item.path,
        "to": item.path,
        "exact": "",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "height": "55px",
        "alt": item.alt,
        "src": item.image
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(item.name))])], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "otherBooks",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks
      }
    },
    model: {
      value: (_vm.otherBooks),
      callback: function($$v) {
        _vm.otherBooks = $$v
      },
      expression: "otherBooks"
    }
  }, [_c('v-list', [_c('h6', [_vm._v("Other books you might like:")]), _vm._v(" "), _vm._l((_vm.books), function(book) {
    return _c('v-list-tile', {
      key: book.title,
      attrs: {
        "href": book.url,
        "target": "_blank",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": book.alt,
        "src": book.img
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(book.title))])], 1)], 1)
  })], 2)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "settings-drawer",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "right": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.drawerRight),
      callback: function($$v) {
        _vm.drawerRight = $$v
      },
      expression: "drawerRight"
    }
  }, [_c('v-list', [_c('settings')], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "mini-bar",
    attrs: {
      "mini-variant": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.buyBar),
      callback: function($$v) {
        _vm.buyBar = $$v
      },
      expression: "buyBar"
    }
  }, [_c('v-list', {
    attrs: {
      "ripple": false
    }
  }, [_vm._v("Shop:\n      "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })])
  })], 2)], 1), _vm._v(" "), _c('v-toolbar', {
    staticClass: "main-menu",
    attrs: {
      "fixed": "",
      "persistent": ""
    }
  }, [_c('v-btn', {
    staticClass: "main-menu-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-navicon")])], 1), _vm._v(" "), (_vm.books.length > 0) ? _c('v-btn', {
    key: _vm.booksChanged,
    staticClass: "otherBooks-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.drawer = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-browsers-outline")])], 1) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    staticClass: "desktop-social-btn",
    staticStyle: {
      "margin-left": "5%"
    }
  }, _vm._l((_vm.socials), function(social) {
    return _c('v-btn', {
      key: social.title,
      attrs: {
        "flat": "",
        "href": social.url,
        "target": "_blank",
        "ripple": false
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1)
  }), 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-buy-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu, _vm.info = false, _vm.drawer = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "buy-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu
      }
    },
    model: {
      value: (_vm.buyMenu),
      callback: function($$v) {
        _vm.buyMenu = $$v
      },
      expression: "buyMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Purchase this book: ")]), _vm._v(" "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })]), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(buy.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-social-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu, _vm.info = false, _vm.buyMenu = false, _vm.drawer = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "social-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "persistent": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu
      }
    },
    model: {
      value: (_vm.socialMenu),
      callback: function($$v) {
        _vm.socialMenu = $$v
      },
      expression: "socialMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Share this book: ")]), _vm._v(" "), _vm._l((_vm.socials), function(social) {
    return _c('v-list-tile', {
      key: social.title,
      attrs: {
        "href": social.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(social.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "info-btn",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info, _vm.drawer = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-information-outline")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "settings-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = !_vm.drawerRight, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawer = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('reader')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Reader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_000_Cover__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_000_Cover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_000_Cover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_001_HalfTitle__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_001_HalfTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_001_HalfTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_002_FM01__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_002_FM01___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_002_FM01__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_003_TitlePage__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_003_TitlePage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_003_TitlePage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_004_Copyright__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_004_Copyright___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_004_Copyright__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_005_Contents__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_005_Contents___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_005_Contents__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_006_Excursuses__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_006_Excursuses___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_006_Excursuses__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_007_General__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_007_General___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_007_General__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_008_Abbreviations__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_008_Abbreviations___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_008_Abbreviations__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_009_Bibliography__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_009_Bibliography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_009_Bibliography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_010_Chapter01__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_010_Chapter01___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_010_Chapter01__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_011_Part01__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_011_Part01___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_011_Part01__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_012_Chapter02a__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_012_Chapter02a___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_012_Chapter02a__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_012_Chapter02b__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_012_Chapter02b___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_012_Chapter02b__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_012_Chapter02c__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_012_Chapter02c___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_012_Chapter02c__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_013_Part02__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_013_Part02___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_013_Part02__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_014_Chapter03a__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_014_Chapter03a___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_014_Chapter03a__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_014_Chapter03b__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_014_Chapter03b___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_014_Chapter03b__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_014_Chapter03c__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_014_Chapter03c___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_014_Chapter03c__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_last__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_last__);
/*jshint esversion: 6 */


























__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    "path": "/",
    "name": "home",
    "component": __WEBPACK_IMPORTED_MODULE_3__components_home___default.a
  }, {
    "path": "/005_Contents",
    "name": "005_Contents",
    "component": __WEBPACK_IMPORTED_MODULE_9__components_005_Contents___default.a
  }, {
    "path": "/006_Excursuses",
    "name": "006_Excursuses",
    "component": __WEBPACK_IMPORTED_MODULE_10__components_006_Excursuses___default.a
  }, {
    "path": "/007_General",
    "name": "007_General",
    "component": __WEBPACK_IMPORTED_MODULE_11__components_007_General___default.a
  }, {
    "path": "/008_Abbreviations",
    "name": "008_Abbreviations",
    "component": __WEBPACK_IMPORTED_MODULE_12__components_008_Abbreviations___default.a
  }, {
    "path": "/009_Bibliography",
    "name": "009_Bibliography",
    "component": __WEBPACK_IMPORTED_MODULE_13__components_009_Bibliography___default.a
  }, {
    "path": "/010_Chapter01",
    "name": "010_Chapter01",
    "component": __WEBPACK_IMPORTED_MODULE_14__components_010_Chapter01___default.a
  }, {
    "path": "/last",
    "name": "last",
    "component": __WEBPACK_IMPORTED_MODULE_23__components_last___default.a
  }]
}));

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
  * vue-router v2.8.1
  * (c) 2017 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

var View = {
  name: 'router-view',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      if (parent.$vnode && parent.$vnode.data.routerView) {
        depth++;
      }
      if (parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children)
  }
};

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

function extend (to, from) {
  for (var key in from) {
    to[key] = from[key];
  }
  return to
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */


var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'router-link',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null
            ? 'router-link-active'
            : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null
            ? 'router-link-exact-active'
            : globalExactActiveClass;
    var activeClass = this.activeClass == null
            ? activeClassFallback
            : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null
            ? exactActiveClassFallback
            : this.exactActiveClass;
    var compareTarget = location.path
      ? createRoute(null, location, null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) { on[e] = handler; });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var extend = _Vue.util.extend;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('router-view', View);
  Vue.component('router-link', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}

pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
    return filler(params || {}, { pretty: true })
  } catch (e) {
    if (false) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  }
}

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
      "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(
    path,
    parent,
    pathToRegexpOptions.strict
  );

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null
      ? {}
      : route.components
        ? route.props
        : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
          "the default child route will not be rendered. Remove the name from " +
          "this route and use the name of the default child route for named " +
          "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias)
      ? route.alias
      : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (path, parent, strict) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */


function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next.name || next._normalized) {
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = assign({}, next);
    next._normalized = true;
    var params = assign(assign({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

function assign (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */


function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      if (record) {
        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
        return _createRoute(record, location, redirectedFrom)
      }
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
        ? originalRedirect(createRoute(record, location, null, router))
        : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      params[key.name] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */


var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  window.history.replaceState({ key: getStateKey() }, '');
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior(to, from, isPop ? position : null);

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition((shouldScroll), position);
      }).catch(function (err) {
        if (false) {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    var el = document.querySelector(shouldScroll.selector);
    if (el) {
      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState = inBrowser && (function () {
  var ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now
  ? window.performance
  : Date;

var _key = genKey();

function genKey () {
  return Time.now().toFixed(3)
}

function getStateKey () {
  return _key
}

function setStateKey (key) {
  _key = key;
}

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) { cb(route); });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) { cb(err); });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort()
  }

  var ref = resolveQueue(this.current.matched, route.matched);
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' && (
            typeof to.path === 'string' ||
            typeof to.name === 'string'
          ))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) { cb(); });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid)
  })
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      next(cb);
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (instances[key]) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */


var HTML5History = (function (History$$1) {
  function HTML5History (router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;

    if (expectScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (expectScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History$$1 ) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */


var HashHistory = (function (History$$1) {
  function HashHistory (router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History$$1 ) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(
      cleanPath(base + '/#' + location)
    );
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1)
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */


var AbstractHistory = (function (History$$1) {
  function AbstractHistory (router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // main app already initialized.
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  var location = normalizeLocation(
    to,
    current || this.history.current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '2.8.1';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(51),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Navigation from '@/components/Navigation'
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  data: function data() {
    return {};
  },

  components: {
    // 'navigation': Navigation
  }
});

/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Hannah K. Harrington\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('BR'), _c('B', [_vm._v("Hannah K. Harrington")]), _vm._v(" is professor of Old Testament at Patten University, Oakland, California. Along with her numerous articles on the Bible, Second Temple Judaism, and Christianity, Harrington's other books include "), _c('I', [_vm._v("Holiness: Rabbinic Judaism and the Graeco-Roman World")]), _vm._v(" and "), _c('I', [_vm._v("The Purity and Sanctuary of the Body in Second Temple Judaism.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/QtftwR/tc-custom/9781467464024.jpg?1730409574387",
      "alt": "This image is the cover for the book The Books of Ezra and Nehemiah, New International Commentary on the Old Testament (NICOT)"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Books of Ezra and Nehemiah, New International Commentary on the Old Testament (NICOT)\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The books of Ezra and Nehemiah represent a significant turning point in biblical history. They tell the story not only of the rebuilding of the temple in Jerusalem but also of the resurrection of God’s people from the death of exile. Hannah Harrington thus begins her commentary with an evocative description of these books as “the story of a new Israel forged out of the old” and “the text of a people clinging to their genealogical past and attempting to preserve their heritage while walking forward into uncharted territory.” ")]), _c('p', [_vm._v("Throughout this commentary, Harrington combines analytical research on the language and culture behind the books of Ezra and Nehemiah with challenging thoughts for the Christian church today, bringing to bear a unique perspective on these books not as the end of Old Testament history but as early documents of the Second Temple period. Accordingly, Harrington incorporates a wealth of information from other Jewish literature of the time to freshly illuminate many of the topics and issues at hand while focusing on the interpretation and use of these books for Christian life today.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Wm. B. Eerdmans Publishing Co.\n   ")])])
}]}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(54),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(57),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(59),
  /* template */
  __webpack_require__(60),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(62),
  /* template */
  __webpack_require__(63),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(65),
  /* template */
  __webpack_require__(66),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(68),
  /* template */
  __webpack_require__(69),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/006_Excursuses#fm-1"
    }
  }, [_vm._v("List of Excursuses")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/007_General#fm-2"
    }
  }, [_vm._v("General Editor’s Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Abbreviations#fm-3"
    }
  }, [_vm._v("List of Abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Bibliography#fm-4"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#ch-1"
    }
  }, [_vm._v("INTRODUCTION TO EZRA AND NEHEMIAH")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec-1"
    }
  }, [_vm._v("I. T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EXT")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec2-1"
    }
  }, [_vm._v("A. Language")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec2-2"
    }
  }, [_vm._v("B. Sources")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec2-3"
    }
  }, [_vm._v("C. Sections")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec3-1"
    }
  }, [_vm._v("1. Ezra Memoir")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec3-2"
    }
  }, [_vm._v("2. Nehemiah Memoir")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec3-3"
    }
  }, [_vm._v("3. Prologue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec2-4"
    }
  }, [_vm._v("D. Canonicity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec-2"
    }
  }, [_vm._v("II. D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ATE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec2-5"
    }
  }, [_vm._v("A. Order")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec2-6"
    }
  }, [_vm._v("B. Ezra-Nehemiah and Chronicles")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec2-7"
    }
  }, [_vm._v("C. Separate Authorship Theory")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec2-8"
    }
  }, [_vm._v("D. Compilation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec-3"
    }
  }, [_vm._v("III. M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ETHODOLOGY")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec-4"
    }
  }, [_vm._v("IV. S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ETTING")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec2-9"
    }
  }, [_vm._v("A. Yehud")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec2-10"
    }
  }, [_vm._v("B. Jerusalem")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec2-11"
    }
  }, [_vm._v("C. Literary Criticism")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec3-4"
    }
  }, [_vm._v("1. Themes and Purpose")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec3-5"
    }
  }, [_vm._v("2. Literary Techniques")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec3-6"
    }
  }, [_vm._v("3. Literature and History")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec2-12"
    }
  }, [_vm._v("D. Social Science")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec-5"
    }
  }, [_vm._v("V. P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ERSIAN")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ULE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec2-13"
    }
  }, [_vm._v("A. History vs. Historicity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec2-14"
    }
  }, [_vm._v("B. Cyrus II (559–530 BCE)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec3-7"
    }
  }, [_vm._v("1. The Conquests of Cyrus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec3-8"
    }
  }, [_vm._v("2. The Jews under Cyrus’s Rule")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec2-15"
    }
  }, [_vm._v("C. Darius I (522–485 BCE)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec3-9"
    }
  }, [_vm._v("1. The Reign of Darius I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec3-10"
    }
  }, [_vm._v("2. The Jews under Darius I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec2-16"
    }
  }, [_vm._v("D. Artaxerxes I (465–424 BCE)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec3-11"
    }
  }, [_vm._v("1. Artaxerxes Longimanus I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec3-12"
    }
  }, [_vm._v("2. Artaxerxes and Ezra")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec3-13"
    }
  }, [_vm._v("3. Artaxerxes and Nehemiah")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec2-17"
    }
  }, [_vm._v("E. Internal Jewish Leadership")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec-6"
    }
  }, [_vm._v("VI. S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ECOND")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EMPLE")]), _vm._v(" J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UDAISM")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec2-18"
    }
  }, [_vm._v("A. Monotheism")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec2-19"
    }
  }, [_vm._v("B. Torah")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec3-14"
    }
  }, [_vm._v("1. Torah for Everyone")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec3-15"
    }
  }, [_vm._v("2. Heritage: What Was Ezra’s Torah?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec3-16"
    }
  }, [_vm._v("3. Legacy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec2-20"
    }
  }, [_vm._v("C. Sanctuary: The Second Temple")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec2-21"
    }
  }, [_vm._v("D. Holy People")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec-7"
    }
  }, [_vm._v("VII. C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HRISTIAN")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PPLICATION")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec-8"
    }
  }, [_vm._v("VIII. O"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UTLINE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Part01#pt-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE BOOK OF EZRA")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#ch-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TEXT AND COMMENTARY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I. F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ROM")]), _vm._v(" B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ABYLONIAN")]), _vm._v(" E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("XILES TO")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EMPLE")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OMMUNITY")]), _vm._v(" (1:1–6:22)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec2-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Return to Jerusalem (1:1–2:70)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec3-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Preparation for Return (1:1–11)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec4-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a. Imperial Authorization (1:1–4)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec4-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b. Enthusiastic Response and Financial Support (1:5–6)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec4-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c. Return of the Sacred Vessels (1:7–11)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec3-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Genealogical Record of the Returnees (2:1–70)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec4-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a. Returnees by Descent (2:1–20)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec4-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b. Returnees by City (2:21–35)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec4-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c. Temple and Related Personnel (2:36–58)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec4-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("d. Undocumented Israelites/Priests (2:59–63)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec4-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("e. Total Returnees and Animals (2:64–67)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec4-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("f. Financial Donations and Conclusion (2:68–70)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec2-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Rebuilding the Temple (3:1–6:22)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec3-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Rebuilding the Foundations (3:1–13)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec4-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a. Rebuilding and Dedicating the Altar (3:1–6)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec4-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b. Laying the Temple Foundations (3:7–13)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec5"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec5-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("(1) Requisition of Materials (3:7)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec5"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec5-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("(2) Commencement of the Work (3:8–9)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec5"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec5-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("(3) Laying the Foundations amid Worship (3:10–11)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec5"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec5-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("(4) Mixed Emotions (3:12–13)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec3-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Opposition to the Building Effort (4:1–6:22)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec4-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a. The Local Population Rejected (4:1–3)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec4-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b. Opposition Begins (4:4–6)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec4-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c. Aramaic Letters of Opposition and Suspension During the Time of Artaxerxes I (4:7–24)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec5"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec5-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("(1) The Letter of Bishlam, Mithredath, and Tabeel (4:7)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec5"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec5-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("(2) The Letter of Rehum and Shimshai (4:8–16)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec5"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec5-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("(3) Artaxerxes’s Response (4:17–24)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec4-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("d. Encouragement of the Prophets (5:1–2)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec4-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("e. Tattenai’s Complaint (5:3–17)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec5"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec5-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("(1) Interrogation of the Builders (5:3–5)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec5"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec5-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("(2) Letter to Darius Requesting an Investigation (5:6–17)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec4-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("f. Darius’s Decrees (6:1–12)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec5"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec5-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("(1) Cyrus’s Edict Is Found in the Archives (6:1–5)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec5"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec5-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("(2) Order to Complete the Temple with Imperial Aid (6:6–10)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec5"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec5-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("(3) Threats for Neglecting or Changing the Decree (6:11–12)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec4-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("g. Completion and Dedication of the Temple (6:13–18)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec4-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("h. Celebration of the Passover and the Festival of Unleavened Bread (6:19–22)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II. T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("INISTRY OF")]), _vm._v(" E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ZRA")]), _vm._v(" (7:1–10:44)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec2-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Ezra’s Authorization (7:1–28)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec3-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Introduction to Ezra (7:1–10)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec4-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a. Ezra’s Genealogy (7:1–5)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec4-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b. Ezra’s Mission (7:6–10)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec3-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. The Commission of Ezra by Artaxerxes I (7:11–26)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec3-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Ezra’s Praise to Yahweh (7:27–28)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec2-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Ezra’s Journey to Jerusalem (8:1–36)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec3-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. List of Returning Families (8:1–14)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec3-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Assembly of the People and Search for Levites (8:15–20)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec3-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Fasting and Prayer (8:21–23)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec3-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Commissioning the Priests and Levites with Sacred Valuables (8:24–30)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec3-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. The Journey from the River Ahava to Jerusalem (8:31–34)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec3-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Worship at the Temple and Delivery of the Imperial Orders (8:35–36)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec2-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C. The Intermarriage Crisis (9:1–10:44)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec3-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Ezra’s Trauma (9:1–15)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec4-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a. Elders Inform Ezra of the Sacrilege of “Holy Seed” (9:1–2)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec4-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b. Ezra’s Horrified Reaction (9:3–5)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02c#sec4-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c. Ezra’s Prayer (9:6–15)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02c#sec3-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Ezra’s Action (10:1–44)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02c#sec4-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a. Confession (10:1–4)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02c#sec4-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b. Oath (10:5–8)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02c#sec4-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c. Assembly in the Rain (10:9–15)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02c#sec4-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("d. Investigation of Intermarriage Cases and Expulsion (10:16–17)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02c#sec4-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("e. List of Offenders and Expulsion of Wives (10:18–44)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec5"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02c#sec5-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("(1) Temple Personnel (10:18–24)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec5"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02c#sec5-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("(2) Laity (10:25–44)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Part02#pt-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE BOOK OF NEHEMIAH")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#ch-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TEXT AND COMMENTARY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I. N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EHEMIAH")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EBUILDS THE")]), _vm._v(" W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ALL OF")]), _vm._v(" J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ERUSALEM")]), _vm._v(" (1:1–6:19)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec2-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Report of Jerusalem in Distress (1:1–3)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec2-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Nehemiah’s Reaction (1:4–11)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Mourning (1:4)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Prayer (1:5–11)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec2-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C. Artaxerxes Commissions Nehemiah (2:1–10)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Nehemiah Blurts Out His Problem to the King (2:1–3)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. The King Approves and Supports Nehemiah’s Journey to Jerusalem (2:4–9)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Opposition from Sanballat and Tobiah (2:10)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec2-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D. Nehemiah Surveys the Wall (2:11–20)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Private Inspection by Night (2:11–15)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Meeting with Local Jewish Leaders (2:16–18)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Dealing with Opposition (2:19–20)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec2-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E. The Leaders and Their Crews Rebuild the Wall in Sections (3:1–32)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Priests Rebuild the Northern End (3:1)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Reconstruction of the Northern and Western Sections (3:2–15)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Reconstruction of the Eastern Section (3:16–27)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Further Repairs to the Eastern Section (3:28–32)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec2-32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("F. External Opposition to the Building Project (4:1–23 [3:33–4:17])")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Scoffing from Sanballat and Tobiah (4:1–3 [3:33–35])")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Nehemiah’s Prayer and Enclosure of the Wall (4:4–6 [3:36–38])")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Threats and Discouragement (4:7–12[1–6])")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Nehemiah Provides Military Protection, and the Builders Bear Arms (4:13–23[7–17])")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec2-33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("G. Internal Oppression (5:1–19)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Complaint of Oppression by Fellow Jews (5:1–5)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Nehemiah Accuses Creditors of Abusing Kinship Bonds and Orders Restoration (5:6–11)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Creditors Swear to Obey Nehemiah’s Order in a Public Ceremony (5:12–13)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Nehemiah’s Selfless Devotion to the Project and the People (5:14–19)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec2-34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("H. Sanballat, Tobiah, and Geshem Attempt to Destroy Nehemiah (6:1–19)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. A Plot to Lure Nehemiah away from the Jobsite (6:1–9)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. An Attempt to Lock Nehemiah in the Temple by Engaging False Prophecy (6:10–14)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Completion of the Wall Despite Opposition (6:15–16)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Intimidation Through Tobiah’s Family Network (6:17–19)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ESTORING THE")]), _vm._v(" H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OLY")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OMMUNITY")]), _vm._v(" (7:1–13:31)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec2-35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Setting a Guard for Jerusalem (7:1–3)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec2-36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Registering the People (7:4–73a[4–72a])")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Planning for the Repopulation of Jerusalem (7:4–5)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Returnees by Descent (7:6–25)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Returnees by City (7:26–38)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Temple and Related Personnel (7:39–60)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Undocumented Israelites/Priests (7:61–65)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Total Returnees and Animals (7:66–69[66–68])")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Financial Donations and Conclusion (7:70–73a[69–72a])")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#sec2-37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C. Teaching, Celebrating, and Observing the Law (7:73b–8:18 [7:72b–8:18])")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#sec3-63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Ezra Reads the Law (7:73b–8:4 [7:72b–8:4])")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#sec3-64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. People Worship (8:5–6)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#sec3-65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Levites Teach the Law (8:7–8)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#sec3-66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. People Celebrate (8:9–12)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#sec3-67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. The Festival of Booths (8:13–18)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#sec2-38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D. Covenant Renewal (9:1–10:39)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#sec3-68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Confession (9:1–3)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#sec3-69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. The Levites’ Penitential Prayer on Behalf of the Community (9:4–37)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#sec3-70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. The Solemn Oath (9:38–10:39 [10:1–10:40])")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#sec4-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a. Introduction (9:38 [10:1])")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#sec4-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b. Signatories (10:1–27[2–28])")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#sec4-32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c. Stipulations (10:28–39[29–40])")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#sec2-39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E. Resettlement of Jerusalem (11:1–36)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#sec3-71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Casting Lots to Repopulate the City (11:1–2)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#sec3-72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. List of Residents (11:3–36)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#sec4-33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a. Lay Families (11:3–9)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#sec4-34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b. Priestly Families (11:10–14)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#sec4-35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c. Levites and Gatekeepers (11:15–24)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#sec4-36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("d. Residents Outside of Jerusalem (11:25–36)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec5"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#sec5-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("(1) Judah (11:25–30)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec5"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#sec5-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("(2) Benjamin (11:31–36)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03c#sec2-40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("F. Temple Personnel (12:1–26)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03c#sec3-73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Priests and Levites During Zerubbabel’s Time (12:1–9)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03c#sec3-74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. The Line of High Priests (12:10–11)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03c#sec3-75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Priests in Joiakim’s Day (12:12–21)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03c#sec3-76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Leaders of Families of Levites (12:22–26)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03c#sec2-41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("G. The Dedication of the Wall of Jerusalem (12:27–47)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03c#sec3-77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Preparation (12:27–30)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03c#sec3-78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Processions (12:31–43)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03c#sec3-79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Worship (12:44–47)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03c#sec2-42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("H. Nehemiah’s Reforms (13:1–31)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03c#sec3-80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Excluding Foreigners (13:1–3)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03c#sec3-81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Expelling Tobiah from the Temple (13:4–9)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03c#sec3-82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Reinstating Tithes for Levites (13:10–14)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03c#sec3-83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Sanctifying the Sabbath (13:15–22)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03c#sec3-84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Dealing with Intermarriage (13:23–29)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03c#sec3-85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Nehemiah’s Summary and Prayer (13:30–31)")])])])])
}]}

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(71),
  /* template */
  __webpack_require__(72),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-1"
    }
  }, [_vm._v("Excursuses")]), _vm._v(" "), _c('p', {
    staticClass: "excur"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#exc1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "pad1"
  }, [_vm._v("1. T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EOPLE OF THE")]), _vm._v(" E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("XILE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "excur"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#exc2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "pad1"
  }, [_vm._v("2. B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LOODLINES IN")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ECOND")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EMPLE")]), _vm._v(" J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UDAISM")])])])]), _vm._v(" "), _c('p', {
    staticClass: "excur"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#exc3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "pad1"
  }, [_vm._v("3. T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EOPLE OF THE")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AND")])])])]), _vm._v(" "), _c('p', {
    staticClass: "excur"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#exc4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "pad1"
  }, [_vm._v("4. W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AS THE")]), _vm._v(" E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("XILIC")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OMMUNITY A")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ECT")]), _vm._v("?")])])]), _vm._v(" "), _c('p', {
    staticClass: "excur"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#exc5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "pad1"
  }, [_vm._v("5. M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ESSIANISM IN")]), _vm._v(" E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ZRA")]), _vm._v("-N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EHEMIAH")]), _vm._v("?")])])]), _vm._v(" "), _c('p', {
    staticClass: "excur"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#exc6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "pad1"
  }, [_vm._v("6. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ITUAL")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("URIFICATION")])])])]), _vm._v(" "), _c('p', {
    staticClass: "excur"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#exc7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "pad1"
  }, [_vm._v("7. M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IDRASH")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORAH")])])])]), _vm._v(" "), _c('p', {
    staticClass: "excur"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#exc8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "pad1"
  }, [_vm._v("8. Z"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ADOKITE")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RIESTS IN THE")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ECOND")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EMPLE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "excur"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02c#exc9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "pad1"
  }, [_vm._v("9. T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ACRILEGE OF")]), _vm._v(" I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NTERMARRIAGE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "excur"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02c#exc10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONVERSION IN")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ECOND")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EMPLE")]), _vm._v(" J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UDAISM")])])]), _vm._v(" "), _c('p', {
    staticClass: "excur"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#exc11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ASTING IN")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ECOND")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EMPLE")]), _vm._v(" J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UDAISM")])])]), _vm._v(" "), _c('p', {
    staticClass: "excur"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#exc12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AMARIANS AND")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AMARITANS")])])]), _vm._v(" "), _c('p', {
    staticClass: "excur"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#exc13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONSECRATION OF THE")]), _vm._v(" W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ALL")])])]), _vm._v(" "), _c('p', {
    staticClass: "excur"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#exc14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AME")]), _vm._v(" Y"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AHWEH")])])]), _vm._v(" "), _c('p', {
    staticClass: "excur"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#exc15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UBILEE AND")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ABBATICAL")]), _vm._v(" Y"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EARS")])])]), _vm._v(" "), _c('p', {
    staticClass: "excur"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#exc16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ROPHECY IN")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ECOND")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EMPLE")]), _vm._v(" J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UDAISM")])])]), _vm._v(" "), _c('p', {
    staticClass: "excur"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#exc17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17. S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HOULD")]), _vm._v(" N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EHEMIAH")]), _vm._v(" 8 F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OLLOW")]), _vm._v(" E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ZRA")]), _vm._v(" 8?")])]), _vm._v(" "), _c('p', {
    staticClass: "excur"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#exc18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18. T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EGACIES OF")]), _vm._v(" E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ZRA AND")]), _vm._v(" N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EHEMIAH")])])]), _vm._v(" "), _c('p', {
    staticClass: "excur"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#exc19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19. P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ENITENTIAL")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RAYER IN")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ECOND")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EMPLE")]), _vm._v(" J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UDAISM")])])]), _vm._v(" "), _c('p', {
    staticClass: "excur"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#exc20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20. C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OVENANT AND")]), _vm._v(" K"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("INSHIP")])])]), _vm._v(" "), _c('p', {
    staticClass: "excur"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#exc21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21. J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ERUSALEM, THE")]), _vm._v(" H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OLY")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ITY")])])]), _vm._v(" "), _c('p', {
    staticClass: "excur"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03c#exc22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22. M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("USIC AND")]), _vm._v(" W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORSHIP")])])]), _vm._v(" "), _c('p', {
    staticClass: "excur"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03c#exc23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23. G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ENTILE")]), _vm._v(" I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MPURITY")])])])])])
}]}

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(74),
  /* template */
  __webpack_require__(75),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-2"
    }
  }, [_vm._v("General Editor’s Preface")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Long ago St. Paul wrote: “I planted, Apollos watered, but God gave the growth” (1 Cor. 3:6 NRSV). He was right: ministry indeed requires a team effort—the collective labors of many skilled hands and minds. Someone digs up the dirt and drops in seed, while others water the ground to nourish seedlings to growth. The same team effort over time has brought this commentary series to its position of prominence today. Professor E. J. Young “planted” it more than fifty years ago, enlisting its first contributors and himself writing its first published volumes. Professor R. K. Harrison “watered” it, signing on other scholars and wisely editing everyone’s finished products. As General Editor, I now tend their planting, and, true to Paul’s words, through five decades God has indeed graciously “[given] the growth.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Today the New International Commentary on the Old Testament enjoys a wide readership of scholars, priests, pastors, rabbis, and other serious Bible students. Thousands of readers across the religious spectrum and in countless countries consult its volumes in their ongoing preaching, teaching, and research. They warmly welcome the publication of each new volume and eagerly await its eventual transformation from an emerging “series” into a complete commentary “set.” But as humanity experiences a new century of history, an era commonly called “postmodern,” what kind of commentary series is NICOT? What distinguishes it from other similarly well-established series?")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Its volumes aim to publish biblical scholarship of the highest quality. Each contributor writes as an expert, both in the biblical text itself and in the relevant scholarly literature, and each commentary conveys the results of wide reading and careful, mature reflection. Ultimately, its spirit is eclectic, each contributor gleaning interpretive insights from any useful source, whatever its religious or philosophical viewpoint, and integrating them into his or her interpretation of a biblical book. The series draws on recent methodological innovations in biblical scholarship: for example, canon criticism, the so-called new literary criticism, reader-response theories, and sensitivity to gender-based and ethnic readings. NICOT volumes also aim to be irenic in tone, summarizing and critiquing influential views with fairness while defending their own. Its list of contributors includes male and female scholars from a number of Christian faith-groups. The diversity of contributors and their freedom to draw on all relevant methodologies give the entire series an exciting and enriching variety.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("What truly distinguishes this series, however, is that it speaks from within that interpretive tradition known as evangelicalism. Evangelicalism is an informal movement within Protestantism that cuts across traditional denominational lines. Its heart and soul is the conviction that the Bible is God’s inspired Word, written by gifted human writers, through which God calls humanity to enjoy a loving personal relationship with its Creator and Savior. True to that tradition, NICOT volumes do not treat the Old Testament as just an ancient literary artifact on a par with the "), _c('em', [_vm._v("Iliad")]), _vm._v(" or Gilgamesh"), _c('em', [_vm._v(".")]), _vm._v(" They are not literary autopsies of ancient parchment cadavers but rigorous, reverent wrestlings with wonderfully human writings through which the living God speaks his powerful Word. NICOT delicately balances “criticism” (i.e., the use of standard critical methodologies) with humble respect, admiration, and even affection for the biblical text. As an evangelical commentary, it pays particular attention to the text’s literary features, theological themes, and implications for the life of faith today.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Ultimately, NICOT aims to serve women and men of faith who desire to hear God’s voice afresh through the Old Testament. With gratitude to God for two marvelous gifts—the Scriptures themselves and keen-minded scholars to explain their message—I welcome readers of all kinds to savor the good fruit of this series.")]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OBERT")]), _vm._v(" L. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UBBARD")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("R")]), _vm._v(".")])])])
}]}

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(77),
  /* template */
  __webpack_require__(78),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-3"
    }
  }, [_vm._v("Abbreviations")]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("AB")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Anchor Bible")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("ABRL")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Anchor Bible Reference Library")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ANET")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Ancient Near Eastern Texts Relating to the Old Testament")]), _vm._v(". Edited by J. B. Pritchard. 3rd ed. Princeton: Princeton University Press, 1969")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BA")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Biblical Archaeologist")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BAR")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Biblical Archaeology Review")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BASOR")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Bulletin of the American Schools of Oriental Research")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BBB")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Bonner biblische Beiträge")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BDB")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Brown, F., S. R. Driver, and C. A. Briggs. "), _c('em', [_vm._v("A Hebrew and English Lexicon of the Old Testament")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BHK")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Biblia Hebraica")]), _vm._v(". Edited by R. Kittel. Leipzig: Hinrichs, 1905–1906")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BHQ")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Biblia Hebraic Quinta")]), _vm._v(". Edited by A. Schenker et al. Stuttgart: Deutsche Bibelgesellschaft, 2004–")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BHS")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Biblia Hebraica Stuttgartensia")]), _vm._v(". Edited by K. Elliger and W. Rudolph. Stuttgart: Deutsche Bibelgesellschaft, 1983")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BibInt")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Biblical Interpretation")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BJSUCSD")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Biblical and Judaic Studies from the University of California, San Diego")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BN")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Biblische Notizen")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BZAW")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Beihefte zur")]), _vm._v(" "), _c('em', [_vm._v("Zeitschrift für die alttestamentliche Wissenschaft")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("CAP")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Cowley, A. E. "), _c('em', [_vm._v("Aramaic Papyri of the Fifth Century B.C.")]), _vm._v(" Oxford: Clarendon, 1923")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("CBET")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Contributions to Biblical Exegesis and Theology")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("CHJ")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Cambridge History of Judaism")]), _vm._v(". Edited by W. D. Davies and L. Finkelstein. 4 vols. Cambridge: Cambridge University Press, 1984–2006")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("DCH")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Dictionary of Classical Hebrew.")]), _vm._v(" Edited by D. J. A. Clines. 9 vols. Sheffield: Sheffield Phoenix, 1993–2014")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("DEJ")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Eerdmans Dictionary of Early Judaism")]), _vm._v(". Edited by J. J. Collins and D. C. Harlow. Grand Rapids: Eerdmans, 2010")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("DJD")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Discoveries in the Judaean Desert")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("DSD")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Dead Sea Discoveries")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("FAT")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Forschungen zum Alten Testament")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("FGH")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Die Fragmente der griechischen Historiker")]), _vm._v(". Edited by F. Jacoby. Leiden: Brill, 1954–1964")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("HALOT")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Hebrew and Aramaic Lexicon of the Old Testament.")]), _vm._v(" L. Koehler, W. Baumgartner, and J. J. Stamm. Translated and edited under the supervision of M. E. J. Richardson. 5 vols. Leiden: Brill, 1994–2000")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("HAT")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Handbuch zum Alten Testament")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("HSM")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Harvard Semitic Monographs")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("IB")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Interpreter’s Bible.")]), _vm._v(" 12 vols. Edited by G. A. Buttrick et al. Nashville: Abingdon, 1953–56")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("IEJ")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Israel Exploration Journal")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JAJ")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal of Ancient Judaism")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("JAJSup")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Supplements to the Journal of Ancient Judaism")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JAOS")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal of the American Oriental Society")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JBL")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal of Biblical Literature")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JQR")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Jewish Quarterly Review")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JSJ")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal for the Study of Judaism")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("JSJSup")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Supplements to the Journal for the Study of Judaism")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JSOT")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal for the Study of the Old Testament")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("JSOTSup")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Journal for the Study of the Old Testament Supplement Series")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JSQ")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Jewish Studies Quarterly")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JTS")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal of Theological Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("KAT")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Kommentar zum Alten Testament")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("LCL")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Loeb Classical Library")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("LHBOTS")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("The Library of Hebrew Bible/Old Testament Studies")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("LXX")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Septuagint")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NAC")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("The New American Commentary")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("NETS")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("A New English Translation of the Septuagint")]), _vm._v(". Edited by A. Pietersma and B. G. Wright. New York: Oxford University Press, 2007")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("OBO")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Orbis Biblicus et Orientalis")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("OTL")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Old Testament Library")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("OTS")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Old Testament Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("PEQ")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Palestine Exploration Quarterly")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("PFT")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Persepolis Fortification Tablets")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("RB")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Revue Biblique")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("RevQ")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Revue de Qumran")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("SBL")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Society of Biblical Literature")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("SBLMS")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Society of Biblical Literature Monograph Series")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("ScrHier")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Scripta Hierosolymitana")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("STDJ")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Studies on the Texts of the Desert of Judah")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("SVTP")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Studia in Veteris Testamenti Pseudepigraphica")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("SymS")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Symposium Series")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("TAD")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Textbook of Aramaic Documents from Ancient Egypt.")]), _vm._v(" Translated and edited by B. Porten and A. Yardeni. 4 vols. Jerusalem: Hebrew University Press, 1986–1999")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("TBC")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Torch Biblical Commentaries")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("TDOT")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Theological Dictionary of the Old Testament")]), _vm._v(". Edited by G. Johannes Botterweck, H. Ringgren, and H.-J. Fabry. 17 vols. Grand Rapids: Eerdmans, 1980–2020")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("TOTC")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Tyndale Old Testament Commentaries")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("VT")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Vetus Testamentum")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("VTSup")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Supplements to Vetus Testamentum")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("WBC")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Word Biblical Commentary")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("WUNT")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Wissenschaftliche Untersuchungen zum Neuen Testament")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ZAW")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Zeitschrift für die alttestamentliche Wissenschaft")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ZDPV")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Zeitschrift des Deutschen Palästina-Vereins")])])])])])])])])
}]}

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(80),
  /* template */
  __webpack_require__(81),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-4"
    }
  }, [_vm._v("Bibliography")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Ackerman, S. "), _c('em', [_vm._v("Under Every Green Tree: Popular Religion in Sixth-Century Judah")]), _vm._v(". Atlanta: SBL Press, 1992.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Ackroyd, P. R. "), _c('em', [_vm._v("1 and 2 Chronicles")]), _vm._v(". TBC. London: SCM Press, 1973.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. “The Temple Vessels—A Continuity Theme.” Pages 166–81 in "), _c('em', [_vm._v("Studies in the Religion of Ancient Israel")]), _vm._v(". Edited by G. W. Anderson et al. VTSup 23. Leiden: Brill, 1972.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Adler, Y. "), _c('em', [_vm._v("The Archaeology of Purity: Archaeological Evidence for the Observance of Ritual Purity in Eretz-Israel from the Hasmonean Period to the End of the Talmudic Period (164 BCE–400 CE)")]), _vm._v(" (Hebrew). Ramat Gan: Bar-Ilan University, 2011.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. “Between Priestly Cult and Common Culture: The Material Evidence of Ritual Purity Observance in Early Roman Jerusalem Reassessed.” "), _c('em', [_vm._v("JAJ")]), _vm._v(" 7 (2016): 228–48.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Albertz, R., and B. Becking. “Problems and Possibilities: Perspectives on Postexilic Yahwism.” Pages xi–xxi in "), _c('em', [_vm._v("Yahwism after the Exile: Perspectives on Israelite Religion in the Persian Era: Papers Read at the First Meeting of the European Association for Biblical Studies, Utrecht, 6–9 August 2000")]), _vm._v(". Edited by R. Albertz and B. Becking. Assen: Van Gorcum, 2003.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Allrick, H. L. “The Lists of Zerubbabel (Nehemiah 7 and Ezra 2) and the Hebrew Numerical Notation.” "), _c('em', [_vm._v("BASOR")]), _vm._v(" 136 (1954): 21–27.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Alt, A. “Die Rolle Samarias bei der Entstehung des Judentums.” Pages 316–37 of vol. 2 of "), _c('em', [_vm._v("Kleine Schriften zur Geschichte Volkes Israels.")]), _vm._v(" Munich: Beck, 1953.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Angel, H. “The Literary Significance of the Name Lists in Ezra-Nehemiah.” "), _c('em', [_vm._v("Jewish Bible Quarterly")]), _vm._v(" 35 (2007): 143–52.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Avigad, N. "), _c('em', [_vm._v("Bullae and Seals from a Postexilic Judean Archive")]), _vm._v(". Jerusalem: Institute of Archaeology of the Hebrew University, 1976.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Avi-Yonah, M. "), _c('em', [_vm._v("The Herodian Period")]), _vm._v(". New Brunswick, NJ: Rutgers University Press, 1975.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Bauckham, R. "), _c('em', [_vm._v("Jesus and the God of Israel: God Crucified and Other Studies on the New Testament’s Christology of Divine Identity")]), _vm._v(". Grand Rapids: Eerdmans, 2008.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Baumgarten, J. M. “The Disqualification of Priests in 4Q Fragments of the ‘Damascus Document,’ a Specimen of the Recovery of Pre-Rabbinic Halakha.” Pages 503–13 in vol. 2 of "), _c('em', [_vm._v("The Madrid Qumran Congress")]), _vm._v(". Edited by J. Trebolle-Barrera and L. V. Montaner. STDJ 11. Leiden: Brill, 1992.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. “The Exclusion of ‘Netinim’ and Proselytes in 4QFlorilegium.” "), _c('em', [_vm._v("RevQ")]), _vm._v(" 29 (1972): 87–96.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Becking, B. “Law as Expression of Religion (Ezra 7–10).” Pages 18–31 in "), _c('em', [_vm._v("Yahwism after the Exile: Perspectives on Israelite Religion in the Persian Era")]), _vm._v(". Edited by B. Becking and R. Albertz. Studies in Theology and Religion 5. Assen: Van Gorcum, 2003.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Bede. "), _c('em', [_vm._v("On Ezra and Nehemiah")]), _vm._v(". Translated by S. DeGregorio. Translated Texts for Historians 47. Liverpool: Liverpool University Press, 2006.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Bedford, P. R. "), _c('em', [_vm._v("Temple Restoration in Early Achaemenid Judah")]), _vm._v(". Leiden: Brill, 2001.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Ben Zvi, E. “Inclusion and Exclusion from Israel as Conveyed by the Use of the Term ‘Israel’ in Post-Monarchic Biblical Texts.” Pages 95–149 in "), _c('em', [_vm._v("The Pitcher Is Broken: Memorial Essays for Gösta Ahlström")]), _vm._v(". Edited by S. W. Holloway and L. K. Handy. JSOTSup 190. Sheffield: Sheffield Academic, 1995.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Berger, P. R. “Zu den Namen "), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("ששבצר")]), _vm._v(" und "), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("שנאצר")]), _vm._v(" (Esr 1:8, 11; 5:14, 16 bzw. 1 Chr 3:18).” "), _c('em', [_vm._v("ZAW")]), _vm._v(" 83 (1971): 98–100.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Berquist, J. "), _c('em', [_vm._v("Judaism in Persia’s Shadow: A Social and Historical Approach")]), _vm._v(". Minneapolis: Fortress, 1995.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. “The Social Context of Postexilic Judaism.” Pages 20–54 in "), _c('em', [_vm._v("Passion, Vitality and Foment: The Dynamics of Second Temple Judaism")]), _vm._v(". Edited by L. M. Luker. Harrisburg, PA: Trinity Press International, 2001.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Bickerman, E. “The Edict of Cyrus in Ezra 1.” "), _c('em', [_vm._v("JBL")]), _vm._v(" 65 (1946): 247–75.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. “En marge de l’Ecriture, I. Le comput des années de règne des Achéménides (Neh i, 2; ii, 1 et Thuc. viii, 58).” "), _c('em', [_vm._v("RB")]), _vm._v(" 88 (1981): 19–23.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. "), _c('em', [_vm._v("From Ezra to the Last of the Maccabees: Foundations of Postbiblical Judaism")]), _vm._v(". New York: Schocken, 1962.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Blenkinsopp, J. “The Development of Jewish Sectarianism.” Pages 385–404 in "), _c('em', [_vm._v("Judah and the Judeans in the Fourth Century B.C.E.")]), _vm._v(" Edited by O. Lipschits, G. N. Knoppers, and R. Albertz. Winona Lake, IN: Eisenbrauns, 2007.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. "), _c('em', [_vm._v("Ezra-Nehemiah: A Commentary")]), _vm._v(". OTL. Philadelphia: Westminster, 1988.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. “Ezra-Nehemiah: Unity or Disunity?” Pages 306–14 in "), _c('em', [_vm._v("Unity and Disunity in Ezra-Nehemiah: Redaction, Rhetoric and Reader")]), _vm._v(". Edited by M. Boda and P. Redditt. Sheffield: Sheffield Phoenix, 2008.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. "), _c('em', [_vm._v("Gibeon and Israel")]), _vm._v(". Cambridge: Cambridge University Press, 1972.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. "), _c('em', [_vm._v("Judaism: The First Phase: The Place of Ezra and Nehemiah in the Origins of Judaism")]), _vm._v(". Grand Rapids: Eerdmans, 2009.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. “The Mission of Udjahorresnet and Those of Ezra and Nehemiah.” "), _c('em', [_vm._v("JBL")]), _vm._v(" (1987): 409–21.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. “The Qumran Sect in Second Temple Sectarianism.” Pages 10–25 in "), _c('em', [_vm._v("New Directions in Qumran Studies")]), _vm._v(". Edited by W. J. Lyons, J. G. Campbell, and L. K. Pietersen. London: T&T Clark, 2005.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. “Temple and Society in Achaemenid Judah.” Pages 22–53 in "), _c('em', [_vm._v("Persian Period")]), _vm._v(". Vol. 1 of "), _c('em', [_vm._v("Second Temple Studies")]), _vm._v(". Edited by P. R. Davies. JSOTSup 117. Sheffield: JSOT Press, 1991.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Boccaccini, G. "), _c('em', [_vm._v("Roots of Rabbinic Judaism")]), _vm._v(":"), _c('em', [_vm._v("An Intellectual History, From Ezekiel to Daniel.")]), _vm._v(" Grand Rapids: Eerdmans, 2002.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Boda, M. "), _c('em', [_vm._v("Praying the Tradition")]), _vm._v(". Berlin: de Gruyter, 1999.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Botta, A. F. “Elephantine, Elephantine Papyri.” Pages 574–77 in "), _c('em', [_vm._v("The Eerdmans Dictionary of Early Judaism")]), _vm._v(". Edited by J. J. Collins and D. C. Harlow. Grand Rapids: Eerdmans, 2010.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Breneman, M. "), _c('em', [_vm._v("Ezra, Nehemiah, Esther")]), _vm._v(". NAC 10. Nashville: Broadman & Holman, 1993.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Briant, P. "), _c('em', [_vm._v("From Cyrus to Alexander: A History of the Persian Empire")]), _vm._v(". Translated by P. T. Daniels. Winona Lake, IN: Eisenbrauns, 2002. Translation of "), _c('em', [_vm._v("Histoire de l’Empire perse: De Cyrus à Alexandre")]), _vm._v(". Paris: Fayard, 1996.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Brooke, G. J. “The Books of Chronicles and the Scrolls from Qumran.” Pages 35–48 in "), _c('em', [_vm._v("Reflection and Refraction: Studies in Biblical Historiography in Honour of A. Graeme Auld")]), _vm._v(". Edited by R. Rezetko, T. H. Lim, and W. B. Aucker. VTSup 113. Leiden: Brill, 2007.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Broshi, M. “La population de l’ancienne Jérusalem.” "), _c('em', [_vm._v("RB")]), _vm._v(" 82 (1975): 5–14.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Brown, P. A. “The Problem of Mixed Marriages in Ezra 9–10.” "), _c('em', [_vm._v("Bibliotheca Sacra")]), _vm._v(" 162 (2005): 437–58.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Brueggemann, W. "), _c('em', [_vm._v("Theology of the Old Testament: Testimony, Dispute, Advocacy")]), _vm._v(". Minneapolis: Fortress, 1997.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Brutti, M. "), _c('em', [_vm._v("The Development of the High Priesthood during the Pre-Hasmonean Period: History, Ideology, Theology")]), _vm._v(". Leiden: Brill, 2006.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Carter, C. E. "), _c('em', [_vm._v("The Emergence of Yehud in the Persian Period: A Social and Demographic Study")]), _vm._v(". JSOTSup 294. Sheffield: Sheffield Academic, 1999.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Chazon, E. G. “Lowly to Lofty: The Hodayot’s Use of Liturgical Traditions to Shape Sectarian Identity and Religious Experience.” "), _c('em', [_vm._v("RevQ")]), _vm._v(" 26 (2013): 3–19.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Clauss, J. “Understanding the Mixed Marriages of Ezra-Nehemiah in the Light of Temple-Building and the Book’s Concept of Jerusalem.” Pages 109–31 in "), _c('em', [_vm._v("Mixed Marriages: Intermarriage and Group Identity in the Second Temple Period")]), _vm._v(". Edited by C. Frevel. LHBOTS 547. London: T&T Clark, 2011.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Clines, D. J. A. "), _c('em', [_vm._v("Ezra, Nehemiah, Esther")]), _vm._v(". NCBC. Grand Rapids: Eerdmans, 1984.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. “Nehemiah 10 as an Example of Early Jewish Biblical Exegesis.” "), _c('em', [_vm._v("JSOT")]), _vm._v(" 21 (1981): 111–17.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Coggins, R. J. "), _c('em', [_vm._v("The Books of Ezra and Nehemiah")]), _vm._v(". Cambridge: Cambridge University Press, 1976.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Cohen, S. J. D. "), _c('em', [_vm._v("The Beginnings of Jewishness: Boundaries, Varieties, Uncertainties")]), _vm._v(". Berkeley: University of California Press, 1999.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. “From the Bible to the Talmud: The Prohibition of Intermarriage.” "), _c('em', [_vm._v("Hebrew Annual Review")]), _vm._v(" 7 (1983): 23–39.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. "), _c('em', [_vm._v("From the Maccabees to the Mishnah")]), _vm._v(". Louisville: Westminster John Knox, 1988.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Coogan, M. D. “For We, Like You, Worship Your God: Three Biblical Portrayals of Samaritan Origins.” "), _c('em', [_vm._v("VT")]), _vm._v(" 38 (1988): 286–92.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. “Life in the Diaspora: Jews at Nippur in the Fifth Century B. C.” "), _c('em', [_vm._v("BA")]), _vm._v(" 37 (1974): 6–12.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Cowley, A. “The Meaning of "), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("מקום")]), _vm._v(" in Hebrew.” "), _c('em', [_vm._v("JTS")]), _vm._v(" 17 (1916): 174–76.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Cross, F. “Personal Names in the Samaria Papyri.” "), _c('em', [_vm._v("BASOR")]), _vm._v(" 344 (November 2006): 75–90.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Davies, G. "), _c('em', [_vm._v("Ezra and Nehemiah")]), _vm._v(". Berit Olam. Collegeville, MN: Liturgical Press, 1999.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Davies, P. R. “Scenes from the Early History of Judaism.” Pages 145–82 in "), _c('em', [_vm._v("The Triumph of Elohim: From Yahwisms to Judaisms")]), _vm._v(". Edited by D. V. Edelman. CBET 13. Kampen: Kok Pharos, 1995.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Davis, K. “Caves of Dispute.” "), _c('em', [_vm._v("DSD")]), _vm._v(" 24 (2017): 229–70.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Davis, K., et al. “Nine Dubious ‘Dead Sea Scrolls’ Fragments from the Twenty-First Century.” "), _c('em', [_vm._v("DSD")]), _vm._v(" 24 (2017): 189–228.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Day, J. “Gibeon and the Gibeonites in the Old Testament.” Pages 113–38 in "), _c('em', [_vm._v("Reflection and Refraction: Studies in Biblical Historiography in Honour of A. Graeme Auld")]), _vm._v(". Edited by R. Rezetko, T. H. Lim, and W. B. Aucker. VTSup 113. Leiden: Brill, 2006.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Douglas, M. "), _c('em', [_vm._v("Natural Symbols: Explorations in Cosmology")]), _vm._v(". London: Routledge, 1996.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. “Pollution.” Pages 336–41 in vol. 12 of "), _c('em', [_vm._v("International Encylopedia of the Social Sciences")]), _vm._v(". Edited by D. L. Sills. New York: Macmillan, 1968.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. "), _c('em', [_vm._v("Purity and Danger.")]), _vm._v(" London: Routledge, 1966.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. “Responding to Ezra: The Priests and the Foreign Wives.” "), _c('em', [_vm._v("BibInt")]), _vm._v(" 10 (2002): 1–23.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Edelman, D. V. “Introduction.” Pages 145–82 in "), _c('em', [_vm._v("The Triumph of Elohim: From Yahwisms to Judaisms")]), _vm._v(". Edited D. V. Edelman. CBET 13. Kampen: Kok Pharos, 1995.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Eskenazi, T. C. "), _c('em', [_vm._v("In an Age of Prose: A Literary Approach to Ezra-Nehemiah.")]), _vm._v(" SBLMS 36. Atlanta: Scholars Press, 1988.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. “Out from the Shadows: Biblical Women in the Post-Exilic Era.” "), _c('em', [_vm._v("JSOT")]), _vm._v(" 54 (1992): 25–43.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. “The Structure of Ezra-Nehemiah and the Integrity of the Book.” "), _c('em', [_vm._v("JBL")]), _vm._v(" 107 (1988): 641–56.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. “Unity and Disunity in Ezra-Nehemiah: Responses and Reflections.” Pages 315–28 in "), _c('em', [_vm._v("Unity and Disunity in Ezra-Nehemiah: Redaction, Rhetoric and Reader.")]), _vm._v(" Edited by M. Boda and P. Redditt. Sheffield: Sheffield Phoenix, 2008.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Eskenazi, T. C., and E. P. Judd. “Marriage to a Stranger in Ezra 9–10.” Pages 266–85 in "), _c('em', [_vm._v("Temple Community in the Persian Period")]), _vm._v(". Vol. 2 of "), _c('em', [_vm._v("Second Temple Studies")]), _vm._v(". Ed. T. C. Eskenazi and K. H. Richards. JSOTSup 175. Sheffield: Sheffield Academic, 1994.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Falk, D. K. “Festivals and Holy Days.” Pages 636–45 in "), _c('em', [_vm._v("The Eerdmans Dictionary of Early Judaism")]), _vm._v(". Edited by J. J. Collins and D. C. Harlow. Grand Rapids: Eerdmans, 2010.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Fensham, F. C. "), _c('em', [_vm._v("The Books of Ezra and Nehemiah.")]), _vm._v(" NICOT. Grand Rapids: Eerdmans, 1982.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Fishbane, M. "), _c('em', [_vm._v("Biblical Interpretation in Ancient Israel.")]), _vm._v(" Oxford: Clarendon, 1985.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Forshey, H. O. “The Construct Chain "), _c('em', [_vm._v("na")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ḥ")]), _c('em', [_vm._v("alat YHWH/’elōhîm")]), _vm._v(".” "), _c('em', [_vm._v("BASOR")]), _vm._v(" 220 (1974).")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Frei, P. “Zentralgewalt und Lokalautonomie im Achämenidenreich.” Pages 8–131 in "), _c('em', [_vm._v("Reichsidee und Reichsorganisation im Perserreich.")]), _vm._v(" By P. Frei and K. Koch. 2nd ed. OBO 55. Fribourg: Universitätsverlag, 1996.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Frevel, C. "), _c('em', [_vm._v("Aschera und der Ausschlie")]), _c('span', {
    staticClass: "greek-italic"
  }, [_vm._v("β")]), _c('em', [_vm._v("lichkeitsanspruch YHWHs.")]), _vm._v(" BBB 94. Weinheim: Beltz Athenäum, 1995.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Fried, L. "), _c('em', [_vm._v("The Priest and the Great King: Temple-Palace Relations in the Persian Empire.")]), _vm._v(" BJSUCSD 10. Winona Lake, IN: Eisenbrauns, 2004.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. “A Silver Coin of Yo"), _c('span', {
    staticClass: "chari-r"
  }, [_vm._v("ḥ")]), _vm._v("anan Hakkôhēn.” "), _c('em', [_vm._v("Transeuphratène")]), _vm._v(" 25 (2003): 47–67.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. “Who Wrote Ezra-Nehemiah—and Why Did They?” Pages 75–97 in "), _c('em', [_vm._v("Unity and Disunity in Ezra-Nehemiah: Redaction, Rhetoric and Reader.")]), _vm._v(" Edited by M. Boda and P. Redditt. Sheffield: Sheffield Phoenix, 2008.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Fröhlich, I. “"), _c('em', [_vm._v("Mamzēr")]), _vm._v(" in Qumran Texts—The Problem of Mixed Marriages from Ezra’s Time: Law, Literature and Practice.” "), _c('em', [_vm._v("Transeuphratène")]), _vm._v(" 29 (2005): 103–15.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Galling, K. “The ‘Gōlā-List’ according to Ezra 2 || Nehemiah 7.” "), _c('em', [_vm._v("JBL")]), _vm._v(" 70 (1951): 149–58.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Ginsberg, H. L. "), _c('em', [_vm._v("The Israelian Heritage of Judaism.")]), _vm._v(" New York: Jewish Theological Seminary, 1982.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Goitein, S. D. “Nicknames as Family Names.” "), _c('em', [_vm._v("JAOS")]), _vm._v(" 90 (1970): 517–24.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Gorman, F. "), _c('em', [_vm._v("The Ideology of Ritual: Space, Time and Status in the Priestly Theology.")]), _vm._v(" JSOTSup 91. Sheffield: JSOT Press, 1990.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Grabbe, L. “Ethnic Groups in Jerusalem.” Pages 145–63 in "), _c('em', [_vm._v("Jerusalem in Ancient History and Tradition")]), _vm._v(". Edited by T. L. Thompson. JSOTSup 381. London: T&T Clark, 2003.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. "), _c('em', [_vm._v("Ezra-Nehemiah.")]), _vm._v(" Old Testament Readings. London: Routledge, 1998.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. “Israel’s Historical Reality after the Exile.” Pages 9–32 in "), _c('em', [_vm._v("The Crisis of Israelite Religion: Transformation of Religious Tradition in Exilic and Post-Exilic Times.")]), _vm._v(" Edited by B. Becking and M. Korpel. OTS 42. Leiden: Brill, 1999.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. "), _c('em', [_vm._v("Judaic Religion in the Second Temple Period: Belief and Practice from the Exile to Yavneh")]), _vm._v(". London: Routledge, 2000.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. “The Law of Moses in the Ezra Tradition: More Virtual Than Real.” Pages 91–114 in "), _c('em', [_vm._v("Persia and Torah: The Theory of Imperial Authorization of the Pentateuch")]), _vm._v(". Edited by J. W. Watts. SymS 17. Atlanta: SBL Press, 2001.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. “‘Mind the Gaps’: Ezra, Nehemiah and the Judean Restoration.” Pages 83–104 in "), _c('em', [_vm._v("Restoration: Old Testament, Jewish and Christian Perspectives.")]), _vm._v(" Edited by J. M. Scott. JSJSup 72. Leiden: Brill, 2001.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. "), _c('em', [_vm._v("Yehud: A History of the Persian Province of Judah")]), _vm._v(". Vol. 1 of "), _c('em', [_vm._v("A History of the Jews and Judaism in the Second Temple Period")]), _vm._v(". London: T&T Clark, 2004.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Halpern, B. “A Historiographic Commentary on Ezra 1–6: Achronological Narrative and Dual Chronology in Israelite Historiography.” Pages 81–142 in "), _c('em', [_vm._v("The Hebrew Bible and Its Interpreters")]), _vm._v(". Edited by W. Propp, B. Halpern, and D. N. Freedman. Winona Lake, IN: Eisenbrauns, 1990.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Haran, M. “The Gibeonites, the Nethinim and the Sons of Solomon’s Servants.” "), _c('em', [_vm._v("VT")]), _vm._v(" 11 (1961): 159–69.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Harrington, H. K. “Holiness and Purity in Ezra-Nehemiah.” Pages 98–116 in "), _c('em', [_vm._v("Unity and Disunity in Ezra-Nehemiah: Redaction, Rhetoric and Reader.")]), _vm._v(" Edited by M. Boda and P. Redditt. Sheffield: Sheffield Phoenix, 2008.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. “Identity and Alterity in the Dead Sea Scrolls.” Pages 71–89 in "), _c('em', [_vm._v("Jewish Identity and Politics between the Maccabees and Bar Kokhba: Groups, Normativity, and Rituals")]), _vm._v(". Edited by B. Eckhardt. JSJSup 155. Leiden: Brill, 2012.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. “Intermarriage in Qumran Texts: The Legacy of Ezra-Nehemiah.” Pages 251–79 in "), _c('em', [_vm._v("Mixed Marriages: Intermarriage and Group Identity in the Second Temple Period")]), _vm._v(". Edited by C. Frevel. LHBOTS 547. London: T&T Clark, 2011.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. “Keeping Outsiders Out: Impurity at Qumran.” Pages 187–203 in "), _c('em', [_vm._v("Defining Identities: We, You, and the Other in the Dead Sea Scrolls: Proceedings of the Fifth Meeting of the IOQS in Groningen")]), _vm._v(". Edited by F. García Martínez and M. Popovic. Leiden: Brill, 2008.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. "), _c('em', [_vm._v("The Purity and Sanctuary of the Body in Second Temple Judaism")]), _vm._v(". JAJSup 33. Göttingen: Vandenhoeck & Ruprecht, 2019.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. "), _c('em', [_vm._v("The Purity Texts.")]), _vm._v(" Companion to the Qumran Scrolls 5. London: T&T Clark, 2004.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Hayes, C. E. "), _c('em', [_vm._v("Gentile Impurities and Jewish Identities: Intermarriage and Conversion from the Bible to the Talmud")]), _vm._v(". Oxford: Oxford University Press, 2002.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Hoglund, K. "), _c('em', [_vm._v("Achaemenid Imperial Administration in Syria-Palestine and the Missions of Ezra and Nehemiah.")]), _vm._v(" Atlanta: Scholars Press, 1992.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Holmgren, F. C. "), _c('em', [_vm._v("Ezra and Nehemiah: Israel Alive Again")]), _vm._v(". International Theological Commentary. Grand Rapids: Eerdmans, 1987.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Hölscher, G. “Die Bücher Esra und Nehemia.” In "), _c('em', [_vm._v("Die heilige Schrift des Alten Testaments")]), _vm._v(". Edited by E. Kautzsch and A. Bertholet. 4th ed. Tübingen: Mohr, 1923.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Houtman, C. “Ezra and the Law.” "), _c('em', [_vm._v("OTS")]), _vm._v(" 21 (1981): 91–115.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Hübner, U. “Das Fragment einer Tonfigurine vom Tell el-Milh: Überlegungen zur Funktion der sog. Pfeiler-figurinen in der israelitischen Volksreligion.” "), _c('em', [_vm._v("ZDPV")]), _vm._v(" 105 (1989): 47–55.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Hurtado, L. W. “Monotheism.” Pages 961–64 in "), _c('em', [_vm._v("The Eerdmans Dictionary of Early Judaism")]), _vm._v(". Edited by J. J. Collins and D. C. Harlow. Grand Rapids: Eerdmans, 2010.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Instone-Brewer, D. "), _c('em', [_vm._v("Divorce and Remarriage in the Bible.")]), _vm._v(" Grand Rapids: Eerdmans, 2002.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Jaffee, M. "), _c('em', [_vm._v("Dynamics of Texts and Traditions.")]), _vm._v(" Upper Saddle River, NJ: Prentice-Hall, 1997.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Janzen, D. “The Cries of Jerusalem: Ethnic, Cultic, Legal, and Geographic Boundaries in Ezra-Nehemiah.” Pages 117–35 in "), _c('em', [_vm._v("Unity and Disunity in Ezra-Nehemiah: Redaction, Rhetoric and Reader.")]), _vm._v(" Edited by M. Boda and P. Redditt. Sheffield: Sheffield Phoenix, 2008.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. “Scholars, Witches, Ideologues, and What the Text Said: Ezra 9–10 and Its Interpretation.” Pages 48–69 in "), _c('em', [_vm._v("Approaching Yehud: New Approaches to the Study of the Persian Period")]), _vm._v(". Edited by J. L. Berquist. Semeia Studies 50. Atlanta: SBL; Leiden: Brill, 2007.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. "), _c('em', [_vm._v("Witch-hunts, Purity and Social Boundaries: The Expulsion of the Foreign Women in Ezra 9–10")]), _vm._v(". Sheffield: Sheffield Academic, 2002.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Japhet, S. "), _c('em', [_vm._v("1 and 2 Chronicles: A Commentary")]), _vm._v(". OTL. Louisville: Westminster, 1993.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. “Composition and Chronology in the Book of Ezra-Nehemiah.” Pages 189–216 in "), _c('em', [_vm._v("Temple and Community in the Persian Period")]), _vm._v(". Vol. 2 of "), _c('em', [_vm._v("Second Temple Studies.")]), _vm._v(" Edited by T. C. Eskenazi and K. H. Richards. JSOTSup 175. Sheffield: Sheffield Academic, 1994.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. “Sheshbazzar and Zerubbabel: Against the Background of the Historical and Religious Tendencies of Ezra-Nehemiah, Part 1.” "), _c('em', [_vm._v("ZAW")]), _vm._v(" 94 (1982): 66–98.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. “Sheshbazzar and Zerubbabel: Against the Background of the Historical and Religious Tendencies of Ezra-Nehemiah, Part 2.” "), _c('em', [_vm._v("ZAW")]), _vm._v(" 95 (1983): 218–29.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. “The Supposed Common Authorship of Chronicles and Ezra-Nehemiah Investigated Anew.” "), _c('em', [_vm._v("VT")]), _vm._v(" 18 (1968): 330–72.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. “What May Be Learned from Ezra–Nehemiah about the Composition of the Pentateuch?” Pages 543–61 in "), _c('em', [_vm._v("The Formation of the Pentateuch: Bridging the Academic Cultures of Europe, Israel, and North America")]), _vm._v(". Edited by J. C. Gertz et al. FAT 111. Tübingen: Mohr Siebeck, 2016.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Jastrow, M. "), _c('em', [_vm._v("Sefer Milim: Dictionary of the Targumim, Talmud Babli, Yerushalmi, and Midrashic Literature.")]), _vm._v(" New York: Judaic Press, 1982.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Jerusalmi, I. "), _c('em', [_vm._v("The Aramaic Sections of Ezra and Daniel: A Philological Commentary with Frequent References to Talmudic Aramaic Parallels and a Synopsis of the Regular Verb.")]), _vm._v(" Cincinnati: Hebrew Union College, 1982.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Jokiranta, J. “Social Identity Approach: Identity Constructing Elements in the Psalms Pesher.” Pages 85–109 in "), _c('em', [_vm._v("Defining Identities: We, You, and the Other in the Dead Sea Scrolls: Proceedings of the Fifth Meeting of the IOQS in Groningen.")]), _vm._v(" Edited by F. García Martínez and M. Popovic. Leiden: Brill, 2008.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Karrer-Grube, C. “Scrutinizing the Conceptual Unity of Ezra and Nehemiah.” Pages 136–59 in "), _c('em', [_vm._v("Unity and Disunity in Ezra-Nehemiah: Redaction, Rhetoric and Reader")]), _vm._v(". Edited by M. Boda and P. Redditt. Sheffield: Sheffield Phoenix, 2008.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Kaufman, Y. "), _c('em', [_vm._v("History of the Israelite Faith")]), _vm._v(" (Hebrew). 8 vols. Jerusalem: Bialik Institute, 1956.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Keel, O., and Ch. Uehlinger. "), _c('em', [_vm._v("Gods, Goddesses, and Images of God in Ancient Israel")]), _vm._v(". Minneapolis: Fortress, 1992.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Kellermann, U. “Erwägungen zum Problem der Ezradatierung.” "), _c('em', [_vm._v("ZAW")]), _vm._v(" 80 (1968): 55–87.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. "), _c('em', [_vm._v("Nehemia: Quellen, Überlieferung, und Geschichte")]), _vm._v(". BZAW 102. Berlin: Töpelmann, 1967.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Kidner, D. "), _c('em', [_vm._v("Ezra and Nehemiah: An Introduction and Commentary")]), _vm._v(". TOTC. Leicester: Inter-Varsity, 1979.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Kletter, R. “Pots and Polities: Material Remains of Late Iron Age Judah in Relation to Its Political Borders.” "), _c('em', [_vm._v("BASOR")]), _vm._v(" 314 (1999): 19–54.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Knibb, M. “The Exile in the Literature of the Intertestamental Period.” "), _c('em', [_vm._v("Heythrop Journal")]), _vm._v(" 17 (1976): 253–72.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Knohl, I. "), _c('em', [_vm._v("The Sanctuary of Silence: The Priestly Torah and the Holiness School")]), _vm._v(". Minneapolis: Fortress, 1995.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Knowles, M. "), _c('em', [_vm._v("Centrality Practiced: Jerusalem in the Religious Practice of Yehud and the Diaspora in the Persian Period.")]), _vm._v(" Atlanta: SBL Press, 2006.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Kooij, A. van der. “Nehemiah 8:8 and the Question of the ‘Targum’-Tradition.” Pages 70–91 in "), _c('em', [_vm._v("Tradition of the Text: Studies Offered to Dominique Barthélemy in Celebration of His 70th Birthday")]), _vm._v(". Edited by G. J. Norton and S. Pisano. OBO 109. Göttingen: Vandenhoeck & Ruprecht, 1991.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Kraemer, D. “On the Relationship of the Books of Ezra and Nehemiah.” "), _c('em', [_vm._v("JSOT")]), _vm._v(" 59 (1993): 73–92.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Kugler, R. “Priests.” Pages 1096–99 in "), _c('em', [_vm._v("The Eerdmans Dictionary of Early Judaism")]), _vm._v(". Edited by J. J. Collins and D. C. Harlow. Grand Rapids: Eerdmans, 2010.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Kuhrt, A. “The Cyrus Cylinder and Achaemenid Imperial Policy.” "), _c('em', [_vm._v("JSOT")]), _vm._v(" 25 (1983): 83–97.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Larson, K., and K. Dahlen. "), _c('em', [_vm._v("Ezra, Nehemiah, Esther")]), _vm._v(". Holman Old Testament Commentary. Nashville: Broadman & Holman Publishers, 2005.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Leuchter, M"), _c('em', [_vm._v(". The Levites and the Boundaries of Israelite Identity")]), _vm._v(". Oxford: Oxford University Press, 2017.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. “The Politics of Ritual Rhetoric: A Proposed Sociopolitical Context for the Redaction of Leviticus 1–16.” "), _c('em', [_vm._v("VT")]), _vm._v(" 60 (2010): 345–65.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Levering, M. "), _c('em', [_vm._v("Ezra and Nehemiah.")]), _vm._v(" Brazos Theological Commentary on the Bible. Grand Rapids: Brazos, 2007.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Levine, B. A. “Later Sources on the Netinim.” Pages 101–7 in "), _c('em', [_vm._v("Orient and Occident: Essays Presented to C. H. Gordon on the Occasion of His Sixty-Fifth Birthday")]), _vm._v(". Edited by H. A. Hoffner. Neukirchen-Vluyn: Neukirchener, 1973.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. “The Netinim.” "), _c('em', [_vm._v("JBL")]), _vm._v(" 82 (1963): 207–12.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Levine, L. "), _c('em', [_vm._v("The Ancient Synagogue: The First Thousand Years")]), _vm._v(". New Haven: Yale University Press, 2000.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. “Jerusalem.” Pages 789–97 in "), _c('em', [_vm._v("The Eerdmans Dictionary of Early Judaism")]), _vm._v(". Edited by J. J. Collins and D. C. Harlow. Grand Rapids: Eerdmans, 2010.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Lewis, C. S. "), _c('em', [_vm._v("Mere Christianity")]), _vm._v(". London: Macmillan, 1952.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Lipschits, O. “Achaemenid Imperial Policy, Settlement Processes in Palestine, and the Status of Jerusalem in the Middle of the Fifth Century BCE.” Pages 19–52 in "), _c('em', [_vm._v("Judah and the Judeans in the Persian (Achaemenid) Period")]), _vm._v(". Edited by O. Lipschits and M. Oeming. Winona Lake, IN: Eisenbrauns, 2006.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. "), _c('em', [_vm._v("The Fall and Rise of Jerusalem: Judah under Babylonian Rule.")]), _vm._v(" Winona Lake, IN: Eisenbrauns, 2005.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Loader, W. "), _c('em', [_vm._v("The Dead Sea Scrolls on Sexuality: Attitudes towards Sexuality in Sectarian and Related Literature at Qumran.")]), _vm._v(" Grand Rapids: Eerdmans, 2009.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. "), _c('em', [_vm._v("Enoch, Levi, and Jubilees on Sexuality: Attitudes toward Sexuality in the")]), _vm._v(" "), _c('em', [_vm._v("Early Enoch Literature, the Aramaic Levi Document, and the Book of Jubilees.")]), _vm._v(" Grand Rapids: Eerdmans, 2007.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Maccoby, H. “Holiness and Purity: The Holy People in Leviticus and Ezra-Nehemiah.” Pages 153–70 in "), _c('em', [_vm._v("Reading Leviticus: A Conversation with Mary Douglas.")]), _vm._v(" Edited by J. F. A. Sawyer. JSOT 227. Sheffield: Sheffield Academic, 1996.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Mazar, E. “The Wall That Nehemiah Built.” "), _c('em', [_vm._v("BAR")]), _vm._v(" 35 (2009): 24–33, 66.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("McCarthy, D. “Covenant and Law in Chronicles-Nehemiah.” "), _c('em', [_vm._v("CBQ")]), _vm._v(" 44 (1982): 25–44.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("McConville, J. G. "), _c('em', [_vm._v("Ezra, Nehemiah, and Esther")]), _vm._v(". The Daily Study Bible Series. Louisville: Westminster John Knox, 2006.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Meyers, C., and E. Meyers. "), _c('em', [_vm._v("Haggai and Zechariah")]), _vm._v(". AB 25B. New York: Doubleday, 1987.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Middlemas, J. "), _c('em', [_vm._v("The Templeless Age: An Introduction to the History, Literature and Theology of the “Exile.”")]), _vm._v(" Louisville: Westminster John Knox, 2007.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Milgrom, J. “The Concept of "), _c('em', [_vm._v("ma")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("al")]), _vm._v(" in the Bible and the Ancient Near East.” "), _c('em', [_vm._v("JAOS")]), _vm._v(" 96 (1976): 236–47.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. “Further Studies in the Temple Scroll.” "), _c('em', [_vm._v("JQR")]), _vm._v(" 81 (1980): 1–17, 89–106.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. "), _c('em', [_vm._v("The JPS Torah Commentary: Numbers.")]), _vm._v(" Philadelphia: Jewish Publication Society, 1990.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. "), _c('em', [_vm._v("Leviticus 1–16: A New Translation with Introduction and Commentary.")]), _vm._v(" AB 3. New York: Doubleday, 1991.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. "), _c('em', [_vm._v("Leviticus 17–22")]), _vm._v(": "), _c('em', [_vm._v("A New Translation with Introduction and Commentary.")]), _vm._v(" AB 3A. New York: Doubleday, 2000.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. "), _c('em', [_vm._v("Leviticus 23–27: A New Translation with Introduction and Commentary")]), _vm._v(". AB 3B. New York: Doubleday, 2000.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. “The Scriptural Foundations and Derivations in the Laws of Purity of the Temple Scroll.” Pages 83–99 in "), _c('em', [_vm._v("Archaeology and History in the Dead Sea Scrolls: The New York University Conference in Memory of Yigael Yadin.")]), _vm._v(" Edited by L. H. Schiffman. JSOTSup 8. Sheffield: JSOT, 1990.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Moffat, D. P. "), _c('em', [_vm._v("Ezra’s Social Drama: Identity Formation, Marriage and Social Conflict in Ezra 9 and 10.")]), _vm._v(" New York: Bloomsbury, 2013.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Myers, J. "), _c('em', [_vm._v("Ezra, Nehemiah: A New Translation with Introduction and Commentary.")]), _vm._v(" AB 14. Garden City, NY: Doubleday, 1965.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Naveh, J. “Gleanings of Some Pottery Inscriptions.” "), _c('em', [_vm._v("IEJ")]), _vm._v(" 46 (1996): 44–51.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Neusner, J. "), _c('em', [_vm._v("The Judaism the Rabbis Take for Granted")]), _vm._v(". Atlanta: Scholars Press, 1994.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Nihan, C. "), _c('em', [_vm._v("From Priestly Torah to Pentateuch: A Study in the Composition of the Book of Leviticus.")]), _vm._v(" FAT 2/25. Tübingen: Mohr Siebeck, 2007.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Olyan, S. “Purity Ideology in Ezra-Nehemiah as a Tool to Reconstitute the Community.” "), _c('em', [_vm._v("JSJ")]), _vm._v(" 35 (2004): 1–16.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. "), _c('em', [_vm._v("Rites and Rank: Hierarchy in Biblical Representations of Cult.")]), _vm._v(" Princeton: Princeton University Press, 2000.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Pearce, Laurie E. “Identifying Judeans and Judean Identity in the Babylonian Evidence.” Pages 7–32 in "), _c('em', [_vm._v("Exile and Return: The Babylonian Context")]), _vm._v(". Edited by Jonathan Stokl and Caroline Waerzeggers. BZAW 478. Berlin: de Gruyter, 2015.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Polak, F. H. “Sociolinguistics and the Judean Speech Community in the Achaemenid Empire.” Pages 589–628 in "), _c('em', [_vm._v("Judah and the Judeans in the Persian Period.")]), _vm._v(" Edited by O. Lipschits and M. Oeming. Winona Lake, IN: Eisenbrauns, 2006.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Polotsky, H. J. “Aramäisch "), _c('em', [_vm._v("prs")]), _vm._v(" und des ‘Huzvaresch.’” "), _c('em', [_vm._v("Le Museon")]), _vm._v(" 45 (1932): 273–83.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Pomykala, K. E. "), _c('em', [_vm._v("The Davidic Dynasty Tradition in Early Judaism: Its History and Significance for Messianism")]), _vm._v(". SBL Early Judaism and Its Literature 7. Atlanta: Scholars, 1995.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Porten, B. “Aramaic Papyri and Parchments: A New Look.” "), _c('em', [_vm._v("BA")]), _vm._v(" 49 (1979): 74–104.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Rad, G. von. "), _c('em', [_vm._v("Theologie des Alten Testaments")]), _vm._v(". 6th ed. Vol. 1. Munich: Kaiser, 1969.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Regev, E. “Abominated Temple and a Holy Community: The Formation of the Notions of Purity and Impurity in Qumran.” "), _c('em', [_vm._v("DSD")]), _vm._v(" 10 (2003): 243–78.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. “Non-Priestly Purity and Its Religious Aspects according to Historical Sources and Archaeological Findings.” Pages 223–44 in "), _c('em', [_vm._v("Purity and Holiness")]), _vm._v(". Edited by M. Poorthuis and J. Schwartz. Leiden: Brill, 2000.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. “Pure Individualism: The Idea of Non-Priestly Purity in Ancient Judaism.” "), _c('em', [_vm._v("JSJ")]), _vm._v(" 31 (2000): 176–202.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Roberts, M. "), _c('em', [_vm._v("Ezra, Nehemiah, Esther")]), _vm._v(". Mastering the Old Testament 11. Dallas: Word, 1993.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Römer, T., ed. "), _c('em', [_vm._v("The Books of Leviticus and Numbers.")]), _vm._v(" Leuven: Peeters, 2007.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Römer, T., and K. Schmid, eds. "), _c('em', [_vm._v("Les dernières rédactions du Pentateuque, de l’Hexateuque et de l’ Ennéateuque")]), _vm._v(". BETL 203. Leuven: Peeters, 2007.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Rosenberg, A. J. "), _c('em', [_vm._v("Mikraoth Gedoloth: Daniel, Ezra, Nehemiah")]), _vm._v(". New York: Judaica Press, 1991.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Rosenthal, F. "), _c('em', [_vm._v("A Grammar of Biblical Aramaic.")]), _vm._v(" Wiesbaden: Otto Harrassowitz, 1974.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Rudolph, W. "), _c('em', [_vm._v("Esra und Nehemia")]), _vm._v(". HAT 20. Tübingen: Mohr Siebeck, 1949.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Rundgren, F. “Über einen juristischen Terminus bei Esra 6:6.” "), _c('em', [_vm._v("ZAW")]), _vm._v(" 70 (1958): 209–15.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Sacchi, P. "), _c('em', [_vm._v("The History of the Second Temple Period.")]), _vm._v(" Sheffield: Sheffield Academic, 2000.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Safrai, S. “Early Testimonies in the New Testament of Laws and Practices Relating to Pilgrimage and Passover.” Pages 41–51 in vol. 1 of "), _c('em', [_vm._v("Jesus’ Last Week: Jerusalem Studies in the Synoptic Gospels")]), _vm._v(". Edited by S. Notley, M. Turnage, and B. Becker. Leiden: Brill, 2006.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. "), _c('em', [_vm._v("Pilgrimage at the Time of the Second Temple")]), _vm._v(" (Hebrew). Tel Aviv: Am Hassefer, 1965.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Safrai, S., and M. Stern, eds. "), _c('em', [_vm._v("The Jewish People in the First Century")]), _vm._v(". Vol. 2. Assen: Van Gorcum, 1976.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Sanders, E. P. "), _c('em', [_vm._v("Judaism: Practice and Belief, 63 BCE–66 CE.")]), _vm._v(" London: SCM; Philadelphia: Trinity Press International, 1992.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Sanderson, J. "), _c('em', [_vm._v("An Exodus Scroll from Qumran: 4QPaleoExodm and the Samaritan Tradition")]), _vm._v(". Harvard Semitic Studies 30. Atlanta: Scholars Press, 1986.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Schaeder, H. H. "), _c('em', [_vm._v("Esra der Schreiber")]), _vm._v(". Tübingen: Mohr, 1930.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Schaper, J. “Priestly Purity and Social Organisation in Persian Period Judah.” "), _c('em', [_vm._v("BN")]), _vm._v(" 118 (2003): 51–57.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Schiffman, L. H. "), _c('em', [_vm._v("From Text to Tradition: A History of Judaism in Second Temple and Rabbinic Times")]), _vm._v(". Hoboken, NJ: Ktav, 1991.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. "), _c('em', [_vm._v("Halakhah at Qumran")]), _vm._v(". Studies in Judaism in Late Antiquity 16. Leiden: Brill, 1975.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. "), _c('em', [_vm._v("Qumran and Jerusalem: Studies in the DSS and the History of Judaism.")]), _vm._v(" Grand Rapids: Eerdmans, 2010.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. "), _c('em', [_vm._v("Who Was a Jew? Rabbinic and Halakhic Perspectives on the Jewish Christian Schism")]), _vm._v(". Hoboken, NJ: Ktav, 1985.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Schwartz, D. R. “Temple or City: What Did Hellenistic Jews See in Jerusalem?” Pages 114–27 in "), _c('em', [_vm._v("The Centrality of Jerusalem: Historical Perspectives")]), _vm._v(". Edited by M. Poorthuis and C. Safrai. Kampen: Kok Pharos, 1996.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Schwartz, S. "), _c('em', [_vm._v("Imperialism and Jewish Society, 200 B.C.E. to 640 C.E.")]), _vm._v(" Princeton, NJ: Princeton University Press, 2004.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Segal, J. B. "), _c('em', [_vm._v("The Hebrew Passover from Earliest Times")]), _vm._v(". Oxford: Oxford University Press, 1963.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Segal, R. “Response to Hyam Maccoby’s ‘Holiness and Purity.’” Pages 171–73 in "), _c('em', [_vm._v("Reading Leviticus: A Conversation with Mary Douglas.")]), _vm._v(" Edited by J. F. A. Sawyer. JSOTSup 227. Sheffield: Sheffield Academic, 1997.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Shaked, S. “The Influence of the Iranian Religion on Judaism.” Pages 236–51 in "), _c('em', [_vm._v("The Restoration—The Persian Period")]), _vm._v(" (Hebrew). Edited by H. Tadmor. Jerusalem, 1982.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Sharp, C. “Phinehan Zeal and Rhetorical Strategy in 4QMMT.” "), _c('em', [_vm._v("RevQ")]), _vm._v(" 18 (1997): 207–22.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Siedlecki, A. “Contextualizations of Ezra-Nehemiah.” Pages 263–76 in "), _c('em', [_vm._v("Unity and Disunity in Ezra-Nehemiah: Redaction, Rhetoric and Reader.")]), _vm._v(" Edited by M. Boda and P. Redditt. Sheffield: Sheffield Phoenix, 2008.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Simons, J. "), _c('em', [_vm._v("Jerusalem in the Old Testament: Researches and Theories.")]), _vm._v(" Leiden: Brill, 1952.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Slotki, J. "), _c('em', [_vm._v("Daniel, Ezra and Nehemiah: Hebrew Text and English Translation with an Introduction and Commentary.")]), _vm._v(" Soncino Books of the Bible. London: Soncino, 1951.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Smith, D. L. “The Politics of Ezra: Sociological Indicators of Postexilic Judaean Society.” Pages 73–97 in "), _c('em', [_vm._v("Persian Period")]), _vm._v(". Vol. 1 of "), _c('em', [_vm._v("Second Temple Studies")]), _vm._v(". Edited by P. R. Davies. JSOTSup 117. Sheffield: JSOT Press, 1991.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Smith, M. “The Dead Sea Sect in Relation to Ancient Judaism.” "), _c('em', [_vm._v("NTS")]), _vm._v(" 7 (1960/1961): 347–60.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Smith-Christopher, D. "), _c('em', [_vm._v("A Biblical Theology of Exile.")]), _vm._v(" Minneapolis: Fortress, 2002.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. “The Mixed Marriage Crisis in Ezra 9–10 and Nehemiah 13.” Pages 243–65 in "), _c('em', [_vm._v("Temple and Community in the Persian Period")]), _vm._v(". Vol. 2 of "), _c('em', [_vm._v("Second Temple Studies.")]), _vm._v(" Edited by T. C. Eskenazi and K. H. Richards. JSOTSup 175. Sheffield: Sheffield Academic, 1994.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Spiro, S. J. “Who Was the "), _c('span', {
    staticClass: "chari-r"
  }, [_vm._v("Ḥ")]), _vm._v("aber? A New Approach to an Ancient Institution.” "), _c('em', [_vm._v("JSJ")]), _vm._v(" 11 (1980): 186–215.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Steiner, R. C. “Bishlam’s Archival Search Report in Nehemiah’s Archive: Multiple Introductions and Reverse Chronological Order as Clues to the Origin of the Aramaic Letters in Ezra 4–6.” "), _c('em', [_vm._v("JBL")]), _vm._v(" 125 (2006): 641–85.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. “The "), _c('em', [_vm._v("Mbqr")]), _vm._v(" at Qumran, the "), _c('em', [_vm._v("Episkopos")]), _vm._v(" in the Athenian Empire, and the Meaning of "), _c('em', [_vm._v("Lbqr’")]), _vm._v(" in Ezra 7:14: On the Relation of Ezra’s Mission to the Persian Legal Project.” "), _c('em', [_vm._v("JBL")]), _vm._v(" 120 (2001): 623–46.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Steinmann, A. E. "), _c('em', [_vm._v("Ezra and Nehemiah")]), _vm._v(". Concordia Commentary. St. Louis: Concordia, 2010.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Stern, E. "), _c('em', [_vm._v("The Assyrian, Babylonian, and Persian Periods (732–332 B.C.E.)")]), _vm._v(". Vol. 2 of "), _c('em', [_vm._v("Archaeology of the Land of the Bible")]), _vm._v(". ABRL. New York: Doubleday, 2001.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. “What Happened to the Cult Figurines? Israelite Religion Purified after the Exile.” "), _c('em', [_vm._v("BAR")]), _vm._v(" 15 (1989): 22–29, 53.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Stern, E., and Y. Magen. “Archaeological Evidence for the First Stage of the Samaritan Temple on Mount Gerizim.” "), _c('em', [_vm._v("IEJ")]), _vm._v(" 52 (2002): 49–57.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Stone, M. E. "), _c('em', [_vm._v("Scriptures, Sects and Visions: A Profile of Judaism from Ezra to the Jewish Revolts.")]), _vm._v(" Philadelphia: Fortress, 1980.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Stone, M. E., J. C. Greenfield, and E. Eshel. "), _c('em', [_vm._v("The Aramaic Levi Document: Edition, Translation, Commentary")]), _vm._v(". SVTP 19. Leiden: Brill, 2004.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Talmon, S. “‘Exile’ and ‘Restoration’ in the Conceptual World of Ancient Judaism.” Pages 107–46 in "), _c('em', [_vm._v("Restoration: Old Testament, Jewish and Christian Perspectives")]), _vm._v(". Edited by J. M. Scott. JSJSup 72. Leiden: Brill, 2001.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. “Ezra and Nehemiah.” Pages 357–64 in "), _c('em', [_vm._v("Literary Guide to the Bible")]), _vm._v(". Edited by R. Alter and F. Kermode. London: Collins, 1987.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. “Ezra and Nehemiah (Books and Men).” Pages 317–28 in "), _c('em', [_vm._v("Interpreter’s Dictionary of the Bible: Supplementary Volume.")]), _vm._v(" Nashville: Abingdon, 1976.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. "), _c('em', [_vm._v("King, Cult and Calendar in Ancient Israel: Collected Studies")]), _vm._v(". Jerusalem: Magnes, 1986.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Talmon, S., and J. Ben-Dov. “Calendrical Documents and Mišmarot.” Pages 1–166 in "), _c('em', [_vm._v("Calendrical Texts")]), _vm._v(". Vol. 16 of "), _c('em', [_vm._v("Qumran Cave 4.")]), _vm._v(" Edited by S. Talmon, J. Ben-Dov, and U. Glessmer. DJD 21. Oxford: Clarendon, 2001.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. “Mišmarot Lists (4Q322–324c) and ‘Historical Texts’ (4Q322a; 4Q331–4Q333) in Qumran Documents.” Pages 927–42 in "), _c('em', [_vm._v("Birkat Shalom:")]), _vm._v(" "), _c('em', [_vm._v("Studies in the Bible, Ancient Near Eastern Literature, and Postbiblical Judaism Presented to Shalom M. Paul on the Occasion of His Seventieth Birthday")]), _vm._v(". Edited by Ch. Cohen. Winona Lake, IN: Eisenbrauns, 2008.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Teeter, D. A. “Scribes and Scribalism.” Pages 1201–4 in "), _c('em', [_vm._v("The Eerdmans Dictionary of Early Judaism")]), _vm._v(". Edited by J. J. Collins and D. C. Harlow. Grand Rapids: Eerdmans, 2010.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Thiele, R. "), _c('em', [_vm._v("The Mysterious Numbers of the Hebrew Kings.")]), _vm._v(" Exeter: Paternoster, 1966.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Thiessen, M. “The Function of a Conjunction: Inclusivist or Exclusivist Strategies in Ezra 6.19–21 and Nehemiah 10.29–30?” "), _c('em', [_vm._v("JSOT")]), _vm._v(" 34 (2009): 63–79.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Throntveit, M. A. "), _c('em', [_vm._v("Ezra-Nehemiah")]), _vm._v(". Interpretation. Louisville: John Knox, 1992.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Torrey, C. C. "), _c('em', [_vm._v("The Composition and Historical Value of Ezra-Nehemiah")]), _vm._v(". BZAW. Giessen: J. Ricker, 1896.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Trudinger, P. "), _c('em', [_vm._v("The Psalms of the Tamid Service: A Liturgical Text from the Second Temple")]), _vm._v(". Leiden: Brill, 2004.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Turner, V. "), _c('em', [_vm._v("Dramas, Fields, and Metaphors: Symbolic Action in Human Society")]), _vm._v(". Ithaca, NY: Cornell University Press, 1974.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Ulrich, E. “Ezra and Qohelet Manuscripts from Qumran (4QEzra and 4QQoh"), _c('sup', [_vm._v("a")]), _c('sup', [_vm._v(",")]), _c('sup', [_vm._v("b")]), _vm._v(").” Pages 139–57 in "), _c('em', [_vm._v("Priests, Prophets, and Scribes: Essays on the Formation and Heritage of Second Temple Judaism in Honour of Joseph Blenkinsopp")]), _vm._v(". Edited by E. Ulrich et al. JSOTSup 149. Sheffield: Sheffield Academic, 1992.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Ussishkin, D. “Nehemiah’s City Wall and the Size of Jerusalem.” Pages 101–30 in "), _c('em', [_vm._v("New Perspectives on Ezra-Nehemiah: History and Historiography, Text, Literature, and Interpretation")]), _vm._v(". Edited by I. Kalimi. Winona Lake, IN: Eisenbrauns, 2012.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Vanderhooft, D. S. "), _c('em', [_vm._v("The Neo-Babylonian Empire and Babylon in the Latter Prophets")]), _vm._v(". HSM 59. Atlanta: Scholars Press, 1999.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("VanderKam, J. C. “Ezra-Nehemiah or Ezra and Nehemiah?” Pages 55–75 in "), _c('em', [_vm._v("Priests, Prophets and Scribes")]), _vm._v(". Edited by E. Ulrich et al. JSOTSup 149. Sheffield: Sheffield Academic, 1992.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. "), _c('em', [_vm._v("From Joshua to Caiaphas: High Priests after the Exile")]), _vm._v(". Minneapolis: Fortress, 2004.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Vaux, R. de. “The Decrees of Cyrus and Darius on the Rebuilding of the Temple.” Pages 63–96 in "), _c('em', [_vm._v("The Bible and the Ancient Near East.")]), _vm._v(" Ed. R. de Vaux and D. McHugh. Garden City, NY: Doubleday, 1971.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Vincent, H., and A. Steve. "), _c('em', [_vm._v("Jerusalem de l’Ancien Testament: Recherches d’archéologie et d’histoire")]), _vm._v(". Paris: Gabalda, 1954.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Vriezen, T. C. "), _c('em', [_vm._v("Hoofdlijnen der Theologie van het Oude Testament")]), _vm._v(". 3rd ed. Wageningen: Veenman, 1966.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Watts, J. W., ed. "), _c('em', [_vm._v("Persia and Torah: The Theory of Imperial Authorization of the Pentateuch")]), _vm._v(". SymS 17. Atlanta: SBL Press, 2001.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Weitzman, S. "), _c('em', [_vm._v("Surviving Sacrilege: Cultural Persistence in Jewish Antiquity")]), _vm._v(". Cambridge, MA: Harvard University Press, 2005.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Werline, R. A. "), _c('em', [_vm._v("Penitential Prayer in Second Temple Judaism: The Development of a Religious Institution")]), _vm._v(". Atlanta: Scholars Press, 1998.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Whitley, C. F. “The Term Seventy Years Captivity.” "), _c('em', [_vm._v("VT")]), _vm._v(" 4 (1954): 60–72.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Williamson, H. G. M. “The Aramaic Documents in Ezra Revisited.” "), _c('em', [_vm._v("JTS")]), _vm._v(" 59 (2008): 41–68.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. "), _c('em', [_vm._v("Ezra, Nehemiah")]), _vm._v(". WBC 16. Waco: Word, 1985.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. “More Unity Than Diversity.” Pages 329–43 in "), _c('em', [_vm._v("Unity and Disunity in Ezra-Nehemiah: Redaction, Rhetoric and Reader")]), _vm._v(". Edited by M. Boda and P. Redditt. Sheffield: Sheffield Phoenix, 2008.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. "), _c('em', [_vm._v("Studies in Persian Period History and Historiography")]), _vm._v(". FAT. Tübingen: Mohr Siebeck, 2004.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Woolley, C. L. "), _c('em', [_vm._v("Ur of the Chaldees")]), _vm._v(". New York: Norton, 1965.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Wright, J. "), _c('em', [_vm._v("Rebuilding Identity: The Nehemiah-Memoir and Its Earliest Readers")]), _vm._v(". BZAW 348. Berlin: de Gruyter, 2004.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. “Seeking, Finding and Writing in Ezra-Nehemiah.” Pages 277–304 in "), _c('em', [_vm._v("Unity and Disunity in Ezra-Nehemiah: Redaction, Rhetoric and Reader")]), _vm._v(". Edited by M. Boda and P. Redditt. Sheffield: Sheffield Phoenix, 2008.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Yamauchi, E. “Ezra-Nehemiah.” Pages 563–771 in vol. 4 of "), _c('em', [_vm._v("The Expositor’s Bible Commentary")]), _vm._v(". Edited by F. E. Gaebelein. Grand Rapids: Zondervan, 1988.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Zar-Kavod, M. "), _c('em', [_vm._v("Ezra and Nehemiah")]), _vm._v(" (Hebrew). Jerusalem: Mossad Harav Kook, 1991.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Zevit, Z. “Is There an Archaeological Case for Phantom Settlements in the Persian Period?” "), _c('em', [_vm._v("PEQ")]), _vm._v(" 141 (2009): 124–37.")])])])
}]}

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(84),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter-title",
    attrs: {
      "id": "ch-1"
    }
  }, [_vm._v("Introduction to Ezra and Nehemiah")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The events behind Ezra-Nehemiah are situated at a watershed in Jewish history and, consequently, at a turning point in the story of the people of God. Landless and templeless, Jewish exiles experienced the trauma of loss of autonomy due to the Babylonian exile; however, they survived against heavy odds. Their very identity hung in the balance, but they forged new associations while retaining ties to their ancient past. The light of hope shone in the darkness of exile from the unexpected orders of a Persian emperor who allowed Jews to return to their homeland. This is the story of a new Israel forged out of the old. It is the text of a people clinging to its genealogical past and attempting to preserve its heritage while walking forward into uncharted territory. It is also the perennial story of God’s providence and guidance of his people through unusual leaders in times of crisis. The impact of the decisions they made on the subsequent community of faith cannot be overestimated.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("This commentary seeks to bring into relief the Second Temple context in which Ezra-Nehemiah was written. Certain concepts, such as institutional penitential prayer and the holiness of the city of Jerusalem, begin in this period, and their embryonic stage is reflected in Ezra-Nehemiah. These and other important religious notions are present in the textual seedbed of Ezra-Nehemiah and continue among later Jewish communities of this era. Some of this development stems from the impact of the text of Ezra-Nehemiah, while some is simply an outgrowth of the times and circumstances of the exilic and postexilic Jewish situation. Whatever the trajectory, Ezra-Nehemiah provides an early repository of valuable information regarding key concepts in Second Temple Judaism. These ideas surface in texts from a variety of Jewish communities, including, but not limited to, the Dead Sea Scrolls and the New Testament.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1c",
    attrs: {
      "id": "sec-1"
    }
  }, [_vm._v("I. THE TEXT")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The original text of Ezra-Nehemiah was not in two books, as in the current version, but was written on one scroll. The language reflects the languages in current use by Jews during the Persian period: Hebrew and Aramaic. Scholars continue to debate the nature of the original version of the text and its underlying sources. The work was copied by the writers of the Dead Sea Scrolls and the Septuagint (LXX) and was included in the early Jewish canon of Scripture.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-1"
    }
  }, [_vm._v("A. LANGUAGE")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The language of Ezra-Nehemiah is predominantly Hebrew, but two substantial sections of Ezra—largely accounts from official documents—are written in Imperial Aramaic (Ezra 4:8–6:18; 7:12–26). This dialect of Aramaic was first internationalized by the Assyrians and remained in use between 700 and 200 BCE."), _c('a', {
    attrs: {
      "href": "#/#foot-note-969",
      "id": "footnote-969"
    }
  }, [_c('sup', [_vm._v("1")])]), _vm._v(" Since Aramaic was the official language of the Babylonian Empire, it became the spoken language of the Jews during the period of their exile in Babylon. Many Jewish names of this period reflect direct Babylonian influence (e.g., Zerubbabel, “seed of Babylon”). Isolated Aramaic phrases occur in various parts of the Bible (see Gen 31:47; Jer 10:11), but only the books of Ezra and Daniel contain large sections in the language.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Elephantine documents of the late fifth century BCE also attest to Imperial Aramaic. The Jewish community in Elephantine, an island of the Nile called Yeb in Aramaic, appears to have been a colony of mercenaries founded sometime in the sixth century BCE, after the destruction of Jerusalem."), _c('a', {
    attrs: {
      "href": "#/#foot-note-968",
      "id": "footnote-968"
    }
  }, [_c('sup', [_vm._v("2")])]), _vm._v(" By the time of Ezra and Nehemiah, this was a community of families with property. The Elephantine papyri, which include over a hundred documents and many ostraca representing correspondence between this Jewish colony in Egypt and the governors of Samaria and Yehud, reveal much regarding the politics, laws, and customs of the time, in particular the syncretistic character of the community’s religion. A Jewish temple was built there, where pagan deities were worshiped alongside Yahweh."), _c('a', {
    attrs: {
      "href": "#/#foot-note-967",
      "id": "footnote-967"
    }
  }, [_c('sup', [_vm._v("3")])]), _vm._v(" One Elephantine letter refers to Sanballat, governor of Samaria (cf. Neh 2:10). Another letter, addressed to the Jews at Elephantine, reveals a Persian attempt to enforce laws regarding the Jewish feasts of Unleavened Bread and Passover.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-2"
    }
  }, [_vm._v("B. SOURCES")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Many of the sources of Ezra-Nehemiah are easy to identify. These include official documents, letters, memoirs, and lists (e.g., genealogies, lists of priests, lists of villages). About 70 percent of the book is made up of lists and other archival material."), _c('a', {
    attrs: {
      "href": "#/#foot-note-966",
      "id": "footnote-966"
    }
  }, [_c('sup', [_vm._v("4")])]), _vm._v(" Below is a list of the most obvious sources under each of the three major sections of the work: Prologue, Ezra Memoir, Nehemiah Memoir.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Prologue: (1) the decree of Cyrus (Ezra 1:2–4); (2) an inventory of temple articles (Ezra 1:9–11); (3) a list of returnees (Ezra 2:1–3:1); (4) two letters of opposition noted (Ezra 4:6–7); (5) the accusation of Rehum against the Jews (Ezra 4:11–16); (6) the reply of Artaxerxes I (Ezra 4:17–22); (7) a report from Tattenai (Ezra 5:7–17); (8) Darius’s reply to Tattenai, including a memorandum of Cyrus’s decree (Ezra 6:2b–22).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Ezra Memoir: (1) a copy of Artaxerxes’s letter to Ezra (Ezra 7:12–26); (2) a list of the returnees with Ezra (Ezra 8:1–14); (3) an inventory of vessels (Ezra 8:26–27); (4) Ezra’s prayer (Ezra 9:6–15); (5) a list of those who had intermarried with foreigners (Ezra 10:18–44). Some scholars place the sources found in Nehemiah 8–10 within the Ezra Memoir, but this is not necessary (see "), _c('span', {
    attrs: {
      "href": "#/014_Chapter03a#exc17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excursus 17, “Should Nehemiah 8 follow Ezra 8?,” pp. 355–57")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Nehemiah Memoir: (1) a list of returnees (Neh 7:6–72a); (2) the reading of the Law (Neh 7:73b–8:18); (3) Nehemiah’s prayer of confession (Neh 9:6–37); (4) the list of covenant signatories (Neh 10:1–28); (5) the covenant itself (Neh 10:28–39); (6) a list of the residents of Jerusalem (Neh 11:3–24); (7) a list of villages of Judah and Benjamin (Neh 11:25–36); and (8) a list of priests and Levites (Neh 12:1–26). Genealogies and lists of names and towns were important in this period when people were returning to their ancestral homes and needed to prove their claims and status in the new community.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The language and style of Ezra-Nehemiah’s sources reflect that of the Persian period. C. Hensley compared these sources with thirty-two Persian documents known to date and concluded that, linguistically, stylistically, and historically, the Ezran documents correspond to the non-biblical documents of the Achaemenid period."), _c('a', {
    attrs: {
      "href": "#/#foot-note-965",
      "id": "footnote-965"
    }
  }, [_c('sup', [_vm._v("5")])]), _vm._v(" K. Hoglund, too, claims “general authenticity” for these citations based on comparison with Achaemenid documents."), _c('a', {
    attrs: {
      "href": "#/#foot-note-964",
      "id": "footnote-964"
    }
  }, [_c('sup', [_vm._v("6")])]), _vm._v(" S. Mowinckel argued that the Nehemiah Memoir reveals parallels with ancient Near Eastern royal inscriptions that commemorate achievements. Others have compared the “remember” sections to votive inscriptions in various Aramaic documents."), _c('a', {
    attrs: {
      "href": "#/#foot-note-963",
      "id": "footnote-963"
    }
  }, [_c('sup', [_vm._v("7")])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-3"
    }
  }, [_vm._v("C. SECTIONS")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The book of Ezra-Nehemiah contains three large sections: the Prologue (Ezra 1–6), the Ezra Memoir (Ezra 7–10), and the Nehemiah Memoir (Nehemiah 1–13). All three sections are written in a straightforward narrative style rather than in the mythical, epic, or annalistic styles of the ancient Near East."), _c('a', {
    attrs: {
      "href": "#/#foot-note-962",
      "id": "footnote-962"
    }
  }, [_c('sup', [_vm._v("8")])]), _vm._v(" The text moves from narrative prose in Ezra 1–6 to partly autobiographical narrative in the Ezra Memoir to mostly autobiographical narrative in the Nehemiah Memoir. The sections of Ezra (Ezra 1–6 and Ezra 7–10) transition more smoothly than those in Nehemiah, which is sometimes disjunct in subject, literary style, and story line."), _c('a', {
    attrs: {
      "href": "#/#foot-note-961",
      "id": "footnote-961"
    }
  }, [_c('sup', [_vm._v("9")])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-1"
    }
  }, [_vm._v("1. Ezra Memoir")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The last four chapters of Ezra are often known as the Ezra Memoir. Some of the material represents a memoir style (Ezra 7:27–9:15) while the rest is written in third person (Ezra 7:1–26; 10). The latter may reflect the hand of an editor, or it may derive from an independent source."), _c('a', {
    attrs: {
      "href": "#/#foot-note-960",
      "id": "footnote-960"
    }
  }, [_c('sup', [_vm._v("10")])]), _vm._v(" It is also possible that the change of form is just stylistic (cf. Isa 6–7; Hos 1, 3). Elias Bickerman compares the change of person to other ancient Near Eastern texts and concludes that it is a device which “served to authenticate the narrative and came into historical writing from the diplomatic style, where exactness of quotation was absolutely necessary.” He points to the Cyrus Cylinder, where the author recounts the poor reign of Nabonidus and Cyrus’s subsequent conquest of the city of Babylon and then abruptly changes from third person to first with “I am Cyrus …” and continues with Cyrus’s personal account of the events."), _c('a', {
    attrs: {
      "href": "#/#foot-note-959",
      "id": "footnote-959"
    }
  }, [_c('sup', [_vm._v("11")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Ezra Memoir chronicles the second return of a large group of Jews from exile in Babylonia under the leadership of Ezra, who is both priest and scribe. Ezra is distinguished by his dedication to study the Torah, observe it, and teach it to the people of Israel (Ezra 7:10). Artaxerxes I, the Persian king, supports Ezra’s mission with financial aid and provisions for the temple service. He also issues a royal edict to Ezra to appoint judges and teach Jewish law (Ezra 7:12–26). The remainder of the Ezra Memoir is devoted to the crisis of intermarriage with those outside of the community. Apparently, Ezra had taught the law sufficiently that by this point the officers understood that certain restrictions applied to intermarriage. Conflating verses from Deuteronomy (e.g., Ezra 9:1–2; Deut 7:1–3; 23:1–9), the officers report to Ezra that there was a large number of intermarriages within the community. Appalled, Ezra applies an unusually strict interpretation of the law to prohibit all forms of intermarriage, and he even orders the dissolution of existing unions with foreigners (Ezra 10:11).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Most scholars think that Neh 8, an account of Ezra reading the Torah to the people, was originally included in the Ezra Memoir (see "), _c('span', {
    attrs: {
      "href": "#/014_Chapter03a#exc17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excursus 17, “Should Nehemiah 8 follow Ezra 8?,” pp. 355–57")]), _vm._v("). Although this suggestion has been the reigning theory, recently several scholars have argued that there are better reasons to leave Nehemiah 8 in its present location. This commentary follows that view.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("It is curious that the Ezra Memoir (without the addition of Neh 8) does not mention Nehemiah. Williamson suggests that the Ezra Memoir was compiled from temple archives by circles that were favorable to the reforms themselves but less supportive of Nehemiah. He claims that Ezra wrote the original narrative to “show as nearly as possible how his activity conformed to his commission.”"), _c('a', {
    attrs: {
      "href": "#/#foot-note-958",
      "id": "footnote-958"
    }
  }, [_c('sup', [_vm._v("12")])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-2"
    }
  }, [_vm._v("2. Nehemiah Memoir")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The Nehemiah Memoir, a first-person account by Nehemiah or at his direction, includes, according to most scholars, Neh 1:1–7:5 and large parts of chs. 12–13."), _c('a', {
    attrs: {
      "href": "#/#foot-note-957",
      "id": "footnote-957"
    }
  }, [_c('sup', [_vm._v("13")])]), _vm._v(" The author, either Nehemiah or a later compiler, utilizes lists of cities, inhabitants, builders, signatories, and cultic personnel throughout the work. The long section of Neh 7:5–10:40(39) has been spliced into the Nehemiah Memoir. The first seam is evident at the end of Neh 7:4, where the text raises the issue of repopulating Jerusalem but is interrupted by the presentation of a list of first returnees from exile under Zerubbabel (Neh 7:5–72) and a narrative section reporting Ezra’s public reading of the Torah along with the covenant renewal (Nehemiah 8–10). The author does not resume discussion of the city of Jerusalem until the second seam at the beginning of Neh 11:1."), _c('a', {
    attrs: {
      "href": "#/#foot-note-956",
      "id": "footnote-956"
    }
  }, [_c('sup', [_vm._v("14")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Nehemiah Memoir was probably originally a report from Nehemiah on his commission as governor and especially on the commission to rebuild the wall of Jerusalem. As Williamson notes, however, it could not have been the original document, since that would have been in Aramaic and probably would not have included the prayers. Nehemiah’s achievements and defense against the neighboring leaders’ criticisms, however, would have been vital for the report to the king."), _c('a', {
    attrs: {
      "href": "#/#foot-note-955",
      "id": "footnote-955"
    }
  }, [_c('sup', [_vm._v("15")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("It is interesting to compare the Nehemiah Memoir with other ancient Near Eastern texts. Egyptian votive texts emphasize prayers and donations to temples. Nehemiah reminds the reader of Udjahorresnet, a pious Egyptian under the rules of Cambyses and Darius I. Both Nehemiah and Udjahorresnet adopt an apologetic tone in telling the deity of their goals and the difficulties they have overcome in achieving them."), _c('a', {
    attrs: {
      "href": "#/#foot-note-954",
      "id": "footnote-954"
    }
  }, [_c('sup', [_vm._v("16")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Nehemiah 1–6 has much in common with Ezra 1–6. Both begin with a construction project (temple or wall) inspired and facilitated by the hand of God. Janzen gives an account of the similarities: In both,")]), _vm._v(" "), _c('p', {
    staticClass: "quotes_bq"
  }, [_vm._v("a Persian king commissions the work; returnees carry it out; they are opposed by neighbors, at least some of whom worship Yahweh [in some way]; but are successful. In both cases, the community leaders inform their adversaries that they have no right to participate in the building project (Ezra 4.1–3 and Neh 2.20). And to emphasize this statement in the context of the wall construction, Neh 3.1–32 gives a list of the Israelites who build the wall, marking them out as ones who, unlike their enemies, do have shares and rights and historical claims in the city (cf. Neh 2.20). In this story the wall, like the city and temple, is for Israel and by Israel. It marks them out and constructs a boundary around them."), _c('a', {
    attrs: {
      "href": "#/#foot-note-953",
      "id": "footnote-953"
    }
  }, [_c('sup', [_vm._v("17")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The central focus of the Nehemiah Memoir as it stands in the full text of Ezra-Nehemiah, however, is not the wall but the rebuilding of the community by means of the Torah and covenant renewal."), _c('a', {
    attrs: {
      "href": "#/#foot-note-952",
      "id": "footnote-952"
    }
  }, [_c('sup', [_vm._v("18")])]), _vm._v(" After Nehemiah secures the city with the wall (Neh 1–6), Israel can then focus on the more significant matter of rededication to keeping God’s law (Neh 8–10). It is only after the reading of the Torah (Neh 8) and the people’s promise to keep it (Neh 9–10) that the people are fit to move in and repopulate the holy city of Jerusalem (Neh 11:1).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Nehemiah Memoir contains a long gap between the wall building and the events of ch. 13. Nehemiah was apparently governor of Jerusalem for twelve years, after which he went back to Babylon and then returned later to Jerusalem. Similarly, Arsames, satrap of Egypt, took a three-year leave of absence from his duties."), _c('a', {
    attrs: {
      "href": "#/#foot-note-951",
      "id": "footnote-951"
    }
  }, [_c('sup', [_vm._v("19")])]), _vm._v(" The Nehemiah Memoir describes approximately one year of Nehemiah’s governorship and then treats several isolated topics from as many as fifteen years later during his “second term.” A lay reformer, Nehemiah mobilizes the lower class into a stable society by instituting various reforms reminiscent of the work of Solon of Athens a century earlier."), _c('a', {
    attrs: {
      "href": "#/#foot-note-950",
      "id": "footnote-950"
    }
  }, [_c('sup', [_vm._v("20")])]), _vm._v(" While the particular reforms do not appear long-lived, the stability Nehemiah afforded the Jews at this point made it possible for the Torah to develop and become the guiding authority for the entire Second Temple period and beyond."), _c('a', {
    attrs: {
      "href": "#/#foot-note-949",
      "id": "footnote-949"
    }
  }, [_c('sup', [_vm._v("21")])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-3"
    }
  }, [_vm._v("3. Prologue")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The first six chapters of Ezra are an account of the earliest return from exile under the policy of Cyrus II, the Persian king. The events described occurred decades before the ministry of Ezra. According to the narrative, Cyrus decides to rebuild the temple at Jerusalem in gratitude for divine aid in establishing his empire, and he encourages the Jews in exile to return and fulfill this desire. In response, the Jewish leaders Sheshbazzar and Zerubbabel facilitate a massive return of Jews to Jerusalem in order to rebuild the temple and resettle the land. The text describes the opposition this group faced from the local population in Judah, whom they refused to include in the project (Ezra 4:1–5). The text also records similar kinds of opposition in later years (Ezra 4:6–24a). The Prologue concludes with the resurgence of building activity inspired by the prophets Haggai and Zechariah, its endorsement by Darius I, and finally the completion of the temple in 515/516 BCE.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("H. G. M. Williamson has argued persuasively that the author of Ezra-Nehemiah composed Ezra 1–6 after the rest of the book."), _c('a', {
    attrs: {
      "href": "#/#foot-note-948",
      "id": "footnote-948"
    }
  }, [_c('sup', [_vm._v("22")])]), _vm._v(" According to Williamson, the purpose of the addition was, first, “concerned to trace lines of continuity between the restored community and the Israel of preexilic times, between the second and first temples, and so on. Legitimacy is clearly a fundamental issue.” Second, it was “to justify the rejection of the offer of northern participation in the restoration itself.”"), _c('a', {
    attrs: {
      "href": "#/#foot-note-947",
      "id": "footnote-947"
    }
  }, [_c('sup', [_vm._v("23")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Ezra, Nehemiah, or someone else combined these three sections (Prologue, Ezra Memoir, and Nehemiah Memoir) into one document. Williamson’s theory, which has had a large following among scholars, traces three stages of writing: (1) the primary sources contemporary with the events; (2) the compilation of the Ezra Memoir, the Nehemiah Memoir, and other sources to form most of Ezra 7–10 and Neh 1–13 (11:21–12:26 were added separately); and (3) the later addition of the Prologue in Ezra 1–6."), _c('a', {
    attrs: {
      "href": "#/#foot-note-946",
      "id": "footnote-946"
    }
  }, [_c('sup', [_vm._v("24")])]), _vm._v(" For Williamson, the author’s purpose in composing the work was to countermand the claims of the Samaritans who had recently built a temple on Mt. Gerizim (in ca. 300 BCE), as well as to demonstrate, by the story of Ezra and Nehemiah, the continuity between the author’s community and that of the First Temple period. Alternatively, some scholars are using a less documentary approach and adopting, as T. C. Eskenazi puts it, “a more gradual, incremental process in which scribal activities responded in a continuous fashion to issues internal to the text and those external, historical circumstances that unfolded.”"), _c('a', {
    attrs: {
      "href": "#/#foot-note-945",
      "id": "footnote-945"
    }
  }, [_c('sup', [_vm._v("25")])]), _vm._v(" In any case, the concerns of the temple and the continuity of the holy people are central in Ezra-Nehemiah; but, just as importantly and maybe more so, rebuilding the community by means of the Torah is a primary emphasis (for further discussion, see "), _c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec2-19"
    }
  }, [_vm._v("“Torah,”")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec2-20"
    }
  }, [_vm._v("“Sanctuary: The Second Temple,”")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec2-21"
    }
  }, [_vm._v("“Holy People,” pp. 62–88")]), _vm._v(").")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-4"
    }
  }, [_vm._v("D. CANONICITY")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Ezra-Nehemiah was apparently held in high regard among Second Temple Jews long before the traditional canon was determined. The work is included in LXX and the Dead Sea Scrolls, and it is alluded to in the writings of Josephus.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("First Esdras, the version of Ezra included in LXX, is a divergent account of Ezra-Nehemiah written in eloquent Greek of the same era as Judith, Sirach and Maccabees—probably the late second or early first century BCE."), _c('a', {
    attrs: {
      "href": "#/#foot-note-944",
      "id": "footnote-944"
    }
  }, [_c('sup', [_vm._v("26")])]), _vm._v(" The compilation is primarily the book of Ezra but also draws from parts of Chronicles and Nehemiah. Chronology is sometimes confused in the book; for example, the author presents the Persian emperor Artaxerxes as the successor to Cyrus. He also places Neh 8 after Ezra 10.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In a striking addition to the biblical text, the author recounts a story about a contest at the court of Darius where Zerubbabel and two other bodyguards of the king are asked the question, “What is the strongest thing?” Zerubbabel wins by stating that women are stronger even than the king because men owe their lives to women and make fools of themselves for them. He also gives another answer suggesting that Truth is the strongest thing of all. Darius is so impressed with the second answer that he gives Zerubbabel his request. Zerubbabel reminds the king of his vow to give permission for the Jews to return to their homeland and restore their temple. Contrary to the biblical text, in which the beneficence of the Persians is stressed, 1 Esdras gives credit to the wisdom of Zerubbabel. T. C. Eskenazi claims that the story’s purpose was to exalt Zerubbabel and to encourage the rebuilding of the new community under a Davidic descendant."), _c('a', {
    attrs: {
      "href": "#/#foot-note-943",
      "id": "footnote-943"
    }
  }, [_c('sup', [_vm._v("27")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("First Esdras is important for translators of Ezra-Nehemiah. It supports the canonical Masoretic Text (MT) over LXX in all but one case (1 Esd. 2:25; Ezra 4:23). It also reveals an attempt to put in order the seemingly mislocated account of Torah reading in Neh 7:72–8:12. The author places this section in 1 Esd 8:88–9:36, thereby closing the thirteen-year gap between Ezra’s commission and his partnership with Nehemiah. Other than this section, 1 Esdras ignores Nehemiah completely.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-parab"
  }, [_vm._v("Ezra-Nehemiah is one book, Esdras B, in LXX; 1 Esdras is Esdras A. The table below sets forth the variety of texts and titles.")]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid25"
  }, [_c('p', {
    staticClass: "t-header"
  }, [_vm._v("Text Type")])]), _vm._v(" "), _c('td', {
    staticClass: "wid70"
  }, [_c('p', {
    staticClass: "t-header"
  }, [_vm._v("Book")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid25"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("MT")])]), _vm._v(" "), _c('td', {
    staticClass: "wid70"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ezra")]), _vm._v(" "), _c('p', {
    staticClass: "t-left"
  }, [_vm._v("Nehemiah")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid25"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("LXX")])]), _vm._v(" "), _c('td', {
    staticClass: "wid70"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Esdras A (noted as 1 Esdras in this commentary)")]), _vm._v(" "), _c('p', {
    staticClass: "t-left"
  }, [_vm._v("Esdras B (including all of Ezra-Nehemiah and noted as LXX in this commentary)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid25"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Vulg.")])]), _vm._v(" "), _c('td', {
    staticClass: "wid70"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("1 Esdras (Ezra)")]), _vm._v(" "), _c('p', {
    staticClass: "t-left"
  }, [_vm._v("2 Esdras (Nehemiah)")]), _vm._v(" "), _c('p', {
    staticClass: "t-left"
  }, [_vm._v("3 Esdras (1 Esdras)")]), _vm._v(" "), _c('p', {
    staticClass: "t-left"
  }, [_vm._v("4 Esdras (a noncanonical apocalypse in the Protestant Apocrypha)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para1"
  }, [_vm._v("Four fragments of Ezra-Nehemiah (Ezra 4:2–6, 9–11; Ezra 5:17; Ezra 6:1–5; Neh 3:14–15) are extant in the Dead Sea Scrolls. Most of them contain text from Ezra and are labeled 4QEzra. Comparison of the traditional text with that of the Scrolls reveals a faithful preservation of the canonical text. As E. Ulrich puts it, “4QEzra again simply demonstrates that the Masoretic "), _c('em', [_vm._v("textus receptus")]), _vm._v(" of each of the books has been very faithfully preserved from one of the plural forms of the text which circulated in the Second Temple period.”"), _c('a', {
    attrs: {
      "href": "#/#foot-note-942",
      "id": "footnote-942"
    }
  }, [_c('sup', [_vm._v("28")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The fragment of Nehemiah (4QNeh) has been only recently identified, and although similar to 4QEzra’s handwriting in some ways, it is clearly from a separate scroll."), _c('a', {
    attrs: {
      "href": "#/#foot-note-941",
      "id": "footnote-941"
    }
  }, [_c('sup', [_vm._v("29")])]), _vm._v(" 4QNeh indicates that Malchijah repaired the Dung Gate with the help of his sons (Neh 3:14). The text reflects a proto-Masoretic type but preserves the reading “and his sons” (Neh 3:14), which is found in LXX but not in MT. There is evidence on the scroll, however, that a scribe changed the reading to “he built it” perhaps to bring it into line with the proto-Masoretic tradition. The spelling of these terms in Hebrew could be easily confused and interchanged (see the commentary on Neh 3:14).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Ezra-Nehemiah apparently made an impact on the sectarian writers of the Scrolls. Language from the book surfaces in some sectarian works, especially in the matter of intermarriage. Ezra’s narrow interpretation of the Torah, which rejects all forms of intermarriage as acts of “sacrilege” because of the character of God’s people as “holy seed” (Ezra 9:2), is reflected in several works (e.g., 4QMMT"), _c('sup', [_vm._v("b")]), _vm._v(" 75–82; 4Q418 101 ii 5; 4QALD i 17–18; see T. Levi 9:9–10)."), _c('a', {
    attrs: {
      "href": "#/#foot-note-940",
      "id": "footnote-940"
    }
  }, [_c('sup', [_vm._v("30")])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "sec-2"
    }
  }, [_vm._v("II. DATE")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Any good hypothesis regarding the final date of Ezra-Nehemiah hinges on answers to the following questions: (1) the order and date of the memoirs of Ezra and Nehemiah; (2) the date of the final compilation of Ezra-Nehemiah; (3) the relationship of this work to Chronicles; and (4) the relationship of this work to the Pentateuch.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-5"
    }
  }, [_vm._v("A. ORDER")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("One major issue dividing scholars on the dating of Ezra and Nehemiah is the chronological order in which they lived. While there is general agreement that Nehemiah worked under Artaxerxes I, the jury is still out on the placement of Ezra. The text states that he began his ministry during the seventh year of Artaxerxes, but it is unclear if Artaxerxes I or II is intended. If he began to work under Artaxerxes I, his ministry would begin in 458 BCE; if under Artaxerxes II, then it would start in 398 BCE.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The clearest reading of the Scripture without emendation indicates that Ezra and Nehemiah were not only contemporaries but worked together (Neh 8:9; 12:26, 36), thus, a joint career under Artaxerxes I is most likely. Nevertheless, not all scholars agree. Some claim that the compiler placed Ezra in a few places in the text of Nehemiah in order to give the two leaders the same level of honor and that they were not, in fact, contemporaries."), _c('a', {
    attrs: {
      "href": "#/#foot-note-939",
      "id": "footnote-939"
    }
  }, [_c('sup', [_vm._v("31")])]), _vm._v(" Arguments for both sides are compelling and have been published repeatedly; thus, only the most significant ones will be presented below."), _c('a', {
    attrs: {
      "href": "#/#foot-note-938",
      "id": "footnote-938"
    }
  }, [_c('sup', [_vm._v("32")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-parab"
  }, [_vm._v("First, the correlation of Ezra and Nehemiah with the list of high priests recorded in Neh 12:10–12:22 is argued in opposite ways. According to the text, the following priests held office in the order listed below:"), _c('a', {
    attrs: {
      "href": "#/#foot-note-937",
      "id": "footnote-937"
    }
  }, [_c('sup', [_vm._v("33")])])]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid30"
  }, [_c('p', {
    staticClass: "t-header"
  }, [_vm._v("High Priests in Jerusalem")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30"
  }, [_c('p', {
    staticClass: "t-header"
  }, [_vm._v("Governors of Yehud"), _c('a', {
    attrs: {
      "href": "#/#foot-note-936",
      "id": "footnote-936"
    }
  }, [_c('sup', [_vm._v("34")])])])]), _vm._v(" "), _c('td', {
    staticClass: "wid30"
  }, [_c('p', {
    staticClass: "t-header"
  }, [_vm._v("Emperors over Persia")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Jeshua/Joshua (533–ca. 500 BCE)")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Sheshbazzar (ca. 538–? BCE); Zerubbabel (ca. 536?–ca. 515 BCE); Elnathan (late sixth century BCE)")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Cyrus the Great (538–530 BCE); Cambyses (529–522 BCE); Darius I (521–486 BCE)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Joiakim (ca. 500–470 BCE)")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Yehoezer (early fifth century BCE); Ahzai (early fifth century BCE)")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Darius I (521–486 BCE); Xerxes/Ahasuerus (485–465 BCE)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Eliashib (ca. 470–433 BCE)")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Nehemiah (445–432 BCE; 429/8–? BCE)")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Artaxerxes I (464–24 BCE)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Joiada (ca. 433–410 BCE)")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Nehemiah (445–432; 429/8–? BCE); Bagohi/Bagoas (ca. 407 BCE)")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Artaxerxes I (464–24 BCE); Darius II (423–405 BCE)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Johanan/Jehohanan"), _c('a', {
    attrs: {
      "href": "#/#foot-note-935",
      "id": "footnote-935"
    }
  }, [_c('sup', [_vm._v("35")])]), _vm._v("/Jonathan (Neh 12:11) (ca. 410–370 BCE)")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Nehemiah (445–432; 429/8–? BCE)")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Darius II (423–405 BCE); Artaxerxes II (404–359 BCE)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Jaddua (ca. 370–330 BCE)")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Hezekiah (330 BCE)")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Artaxerxes II (404–359 BCE); Artaxerxes III (358–338 BCE); Arses (337–336 BCE); Darius III (335–331 BCE); Alexander the Great (336–323 BCE)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para1"
  }, [_vm._v("The list of priests in Neh 12:22 substitutes Johanan for Jonathan (Neh 12:11). Indeed, the Elephantine papyri (410 BCE) also include a letter addressed to Jehohanan as high priest ("), _c('em', [_vm._v("TAD")]), _vm._v(" 1:68–75). Furthermore, a recently discovered coin from the Persian period gives further evidence of a Johanan who was the high priest in the early fourth century BCE. An inscription on the coin reads, “Yo"), _c('span', {
    staticClass: "chari-r"
  }, [_vm._v("ḥ")]), _vm._v("anan the priest.”"), _c('a', {
    attrs: {
      "href": "#/#foot-note-934",
      "id": "footnote-934"
    }
  }, [_c('sup', [_vm._v("36")])]), _vm._v(" Among the priests, only the high priest would have had the authority to issue coins.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Proponents of a late date for Ezra note that he visits the room of “Jehohanan, the son of Eliashib” (Ezra 10:6) and thus argue that Ezra’s ministry occurs in the early fourth century."), _c('a', {
    attrs: {
      "href": "#/#foot-note-933",
      "id": "footnote-933"
    }
  }, [_c('sup', [_vm._v("37")])]), _vm._v(" However, the names “Eliashib” and “Johanan” were popular during this period and do not necessarily indicate a relationship with the high priest. Johanan (also called Jonathan), who served as the high priest from ca. 410 BCE–ca. 370 BCE, was the son of Joiada (Neh 12:11).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Some scholars suggest that the lists of Neh 12 are incomplete. Rather than emending them to agree with each other and trying to cover 200 years with six high priests, Frank Cross notes that papponymy, or the practice of naming a son after his grandfather, was popular and thus that more than one Eliashib and Johanan probably served as high priest during this time."), _c('a', {
    attrs: {
      "href": "#/#foot-note-932",
      "id": "footnote-932"
    }
  }, [_c('sup', [_vm._v("38")])]), _vm._v(" This would account for the different referents in Ezra-Nehemiah bearing the same name but having different fathers. In fact, Josephus refers to five Johanans, some of whom may be the same person. In the same vein, Josephus’s reference to a high priest named Jaddua, who was a contemporary of Alexander the Great, may be to a later Jaddua than the one referred to in Neh 12."), _c('a', {
    attrs: {
      "href": "#/#foot-note-931",
      "id": "footnote-931"
    }
  }, [_c('sup', [_vm._v("39")])]), _vm._v(" This understanding of the list, while possible, is not necessary. The terms of the six high priests, who are installed in the office for life, could have spanned the entire two hundred years."), _c('a', {
    attrs: {
      "href": "#/#foot-note-930",
      "id": "footnote-930"
    }
  }, [_c('sup', [_vm._v("40")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("A second issue that is often raised is that if Ezra began his ministry in 458 BCE, there would be a thirteen-year gap before his public reading of the law (Neh 8:1–8). Would this mean that Ezra waited thirteen years before going public with the Torah reading? Proponents of an Ezra who postdates Nehemiah take him out of Neh 8, but this emendation is not necessary either. Ezra could have still been teaching the law during the thirteen-year period before Neh 8. The reading of the law in Neh 8 could have been the climax, not the beginning, of a sustained program of education in the law."), _c('a', {
    attrs: {
      "href": "#/#foot-note-929",
      "id": "footnote-929"
    }
  }, [_c('sup', [_vm._v("41")])]), _vm._v(" Others point out that Ezra may have returned to Mesopotamia during this gap due to his position as a sort of foreign minister for Jewish affairs."), _c('a', {
    attrs: {
      "href": "#/#foot-note-928",
      "id": "footnote-928"
    }
  }, [_c('sup', [_vm._v("42")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Third, the mixed-marriage crisis also raises an issue regarding the chronology. Ezra calls for dissolution of mixed marriages (Ezra 10), but Nehemiah simply calls for doing it right in the future (Neh 13). Some argue that the most logical order is the less severe decree before the more extreme one. According to this reasoning, Ezra’s harsh injunction follows the failure of Nehemiah’s milder approach. Also, one wonders how the children in Nehemiah’s time could be raised by foreign mothers when Ezra had just dissolved mixed marriages, unless his measure simply failed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Nehemiah’s approach to those who had intermarried with foreigners, however, is not gentle. Rather, he becomes physical in his opposition by beating and cursing the offenders (Neh 13:25). It is unknown whether he dissolves the marriages or not. In any case, as the text stands, there is a gap of several years between Ezra’s initial return (458 BCE) and the second tenure of Nehemiah, when he deals with intermarriage (see Neh 13:6, 23–30). The intermarriage problem under Nehemiah was probably at least twenty-six years after Ezra’s decree, in ca. 432 BCE. This calculation allows time for Nehemiah to return to the Persian king for a while and then take on another term of office in Yehud, correcting several other social and religious problems that had occurred in his absence. The matter of intermarriage, often an issue in the Second Temple period, may have simply cropped up again. Nehemiah may have reassessed Ezra’s response as too drastic and not as successful in the long term.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The major difficulty with dating Ezra at 398 BCE is that Ezra would have had no contact with Nehemiah, a contradiction of the text as it stands. Ezra and Nehemiah are mentioned together in Neh 8:9 at the reading of law and in Neh 12:26, 36 at the dedication of the wall. Apparently, they worked together. Since Nehemiah’s name is missing in the 1 Esd 9:49 parallel, some think it is a gloss in Neh 8:9, but that still leaves two references in Neh 12 unaccounted for. The reference to Ezra in Neh 12:36 is clearly not a gloss since deleting Ezra’s name would leave one of the processions without a leader. It is curious that Nehemiah is not mentioned in the book of Ezra, but a similar situation exists in the writings of Haggai and Zechariah. Although the two prophets worked together (Ezra 5:1), neither mentions the other in the separate works attributed to them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In this commentary, I take the commission of Ezra as predating Nehemiah and adopt the simplest reading of the texts, which presents them as contemporaries with overlapping ministries. It would appear that both worked under Artaxerxes I."), _c('a', {
    attrs: {
      "href": "#/#foot-note-927",
      "id": "footnote-927"
    }
  }, [_c('sup', [_vm._v("43")])]), _vm._v(" As Hoglund points out, the juridical role of Ezra in establishing legal reforms more likely precedes the administrative role of Nehemiah."), _c('a', {
    attrs: {
      "href": "#/#foot-note-926",
      "id": "footnote-926"
    }
  }, [_c('sup', [_vm._v("44")])]), _vm._v(" Ezra brings the law formally to the people and teaches them to observe it in practice. Nehemiah builds upon this effort, assuming the authority of the law as he works to strengthen the community. To argue otherwise requires emendations that prove to be unnecessary. In sum, there are good reasons for placing Nehemiah before Ezra. The majority of scholars continue to support the traditional order."), _c('a', {
    attrs: {
      "href": "#/#foot-note-925",
      "id": "footnote-925"
    }
  }, [_c('sup', [_vm._v("45")])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-6"
    }
  }, [_vm._v("B. EZRA-NEHEMIAH AND CHRONICLES")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("As to the relationship between Ezra-Nehemiah and Chronicles, scholars are again divided. Some see Ezra-Nehemiah as part of a larger work including Chronicles, while others regard Ezra-Nehemiah as a separate compilation, and still others regard all three as separate books with different authors."), _c('a', {
    attrs: {
      "href": "#/#foot-note-924",
      "id": "footnote-924"
    }
  }, [_c('sup', [_vm._v("46")])]), _vm._v(" In the literature regarding authorship of Ezra-Nehemiah, many of the arguments focus on language and theme."), _c('a', {
    attrs: {
      "href": "#/#foot-note-923",
      "id": "footnote-923"
    }
  }, [_c('sup', [_vm._v("47")])]), _vm._v(" Language experts have made lists of parallel and dissimilar vocabulary between the books, and literary scholars have tried to uncover underlying themes that connect the books or to argue that the agenda of each book is too different for single authorship.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Following the Talmud (b. B. Bat. 15a), Albright and Bright argued that Ezra was the Chronicler, but few scholars today follow this view."), _c('a', {
    attrs: {
      "href": "#/#foot-note-922",
      "id": "footnote-922"
    }
  }, [_c('sup', [_vm._v("48")])]), _vm._v(" Arguments supporting this notion include (1) the common verses at the end of 2 Chronicles and the beginning of Ezra; (2) the common words (e.g"), _c('em', [_vm._v(".")]), _vm._v(", “Netinim,” “singer,” “gatekeeper,” “father’s houses” (for families), and “house of God,” which is Late Hebrew language); and (3) the common themes (e.g., emphasis on the temple with a similar description of its music, sacrifices, sacred vessels, Levitical personnel, and religious festivals; also, endowment is by ancestral house rather than just the royal house as in Kings). Joseph Blenkinsopp explains that the “author” may stand for “a plurality or school rather than an individual, that is, a group sharing the same concerns, convictions, and idioms, perhaps active over several generations.”"), _c('a', {
    attrs: {
      "href": "#/#foot-note-921",
      "id": "footnote-921"
    }
  }, [_c('sup', [_vm._v("49")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The purpose of the supposed compilation of Chronicles-Ezra-Nehemiah has been discussed as well. According to Jacob Myers, “The purpose of the Chronicler was to present the history of Israel (Judah) from a cultic point of view, showing how the nation prospered when the cultus was maintained in purity and vitality and how it fared when that was not the case.”"), _c('a', {
    attrs: {
      "href": "#/#foot-note-920",
      "id": "footnote-920"
    }
  }, [_c('sup', [_vm._v("50")])]), _vm._v(" Indeed, the cult, with its emphasis on the priesthood, Levites, ritual, holiness, and worship, plays a strong role in both Ezra-Nehemiah and Chronicles.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Nevertheless, the view that Chronicles and Ezra-Nehemiah share the same author or editor has been strongly contested in recent years, especially by S. Japhet and H. G. M. Williamson."), _c('a', {
    attrs: {
      "href": "#/#foot-note-919",
      "id": "footnote-919"
    }
  }, [_c('sup', [_vm._v("51")])]), _vm._v(" Japhet points out that many words used in Ezra-Nehemiah are not found in Chronicles and that some that are in both works are used differently."), _c('a', {
    attrs: {
      "href": "#/#foot-note-918",
      "id": "footnote-918"
    }
  }, [_c('sup', [_vm._v("52")])]), _vm._v(" Theophoric names are used in short form in Ezra-Nehemiah (e.g., Joram) but both short and long forms in Chronicles (e.g., Joram/Jehoram). The separatist theology so obvious in Ezra-Nehemiah is absent in Chronicles, which has an international flavor with a much more open attitude toward the Northern tribes."), _c('a', {
    attrs: {
      "href": "#/#foot-note-917",
      "id": "footnote-917"
    }
  }, [_c('sup', [_vm._v("53")])]), _vm._v(" While the mixed-marriage issue is life-threatening in Ezra-Nehemiah, Chronicles downplays its effect, mentioning only one of Solomon’s foreign marriages (2 Chr 8:11). This stands in contrast to the accusation of 1 Kings that Solomon’s efforts to please his pagan wives brought about Solomon’s own apostasy (1 Kgs 11:1–13); Nehemiah repeats the view of Kings (Neh 13:26). Prophecy is more emphasized in Chronicles than in Ezra-Nehemiah, although it is present in both works. The Sabbath is important to Nehemiah but noticeably absent in Chronicles (see 2 Chr 36:11–16). Furthermore, the prominent emphasis on David and his royal dynasty in Chronicles is absent in Ezra-Nehemiah and, conversely, the prominent exodus traditions in Ezra-Nehemiah are lacking in Chronicles. Finally, the Chronicler’s sense of immediate retribution is lacking in Ezra-Nehemiah."), _c('a', {
    attrs: {
      "href": "#/#foot-note-916",
      "id": "footnote-916"
    }
  }, [_c('sup', [_vm._v("54")])]), _vm._v(" Overall, the disparity of vision between the two works is too great for them to derive from the same author.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The book of Chronicles was probably penned later than Ezra-Nehemiah, following the order of the Hebrew canon. Steinmann argues on orthographic grounds that 2 Chr 36:22–23 is copied from Ezra 1:1–3."), _c('a', {
    attrs: {
      "href": "#/#foot-note-915",
      "id": "footnote-915"
    }
  }, [_c('sup', [_vm._v("55")])]), _vm._v(" This would place the redaction of Chronicles after the Prologue of Ezra, which, according to many scholars, was the last section to be included in the book of Ezra-Nehemiah (see "), _c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec3-3"
    }
  }, [_vm._v("“Prologue,” pp. 7–9")]), _vm._v(").")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-7"
    }
  }, [_vm._v("C. SEPARATE AUTHORSHIP THEORY")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A current trend on the thorny subject of authorship is simply to separate all three books, giving each its own author."), _c('a', {
    attrs: {
      "href": "#/#foot-note-914",
      "id": "footnote-914"
    }
  }, [_c('sup', [_vm._v("56")])]), _vm._v(" J. VanderKam offers a list of linguistic differences between Ezra and Nehemiah and posits a different perspective for each, such as is found in the four Gospels. Moreover, David Kraemer points out ideological differences between the two books. His main thesis is that “the book of Ezra is a priestly book; its concerns are the Temple, the priesthood and Levites, and purity—that is, the cult. The book of Nehemiah, in contrast, is a lay book, sometimes exhibiting antagonism to priestly concerns and supporting, instead, what might be called scribal values.”"), _c('a', {
    attrs: {
      "href": "#/#foot-note-913",
      "id": "footnote-913"
    }
  }, [_c('sup', [_vm._v("57")])]), _vm._v(" He also notes different motifs. Ezra is more concerned with the temple-building project and Nehemiah with the wall; Ezra emphasizes the holiness of lineage, and Nehemiah enacts Torah observance. According to Kraemer, in Ezra, governors and scribes serve priestly purposes; in Nehemiah, priests serve the governors and scribes."), _c('a', {
    attrs: {
      "href": "#/#foot-note-912",
      "id": "footnote-912"
    }
  }, [_c('sup', [_vm._v("58")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Other features of the separate authorship view include: (1) Nehemiah’s introduction, which suggests an independent composition;"), _c('a', {
    attrs: {
      "href": "#/#foot-note-911",
      "id": "footnote-911"
    }
  }, [_c('sup', [_vm._v("59")])]), _vm._v(" (2) the identical lists of returnees that appear in Ezra 2 and Neh 7 (this argument can go both ways); (3) that it is easier to explain the absence of Ezra in Neh 1–7 if one does not attach Ezra 1–10 to Nehemiah (this argument, too, can be reversed, since Ezra’s presence in Neh 8 is better understood with Ezra 1–10 attached); (4) stylistic differences such as Ezra, but not Nehemiah, including Aramaic and the Ezra Memoir being primarily written in first person, whereas Ezra material in Neh 8 is presented in third person; and (5) the opinion of some (at least by Origen’s time) that they should be two books.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Nevertheless, Jewish tradition supports the notion that Ezra and Nehemiah were originally one work separate from Chronicles. The earliest roster of the Hebrew Bible composed by Melito of Sardis in the second century CE regards Ezra and Nehemiah as one unit, as does LXX."), _c('a', {
    attrs: {
      "href": "#/#foot-note-910",
      "id": "footnote-910"
    }
  }, [_c('sup', [_vm._v("60")])]), _vm._v(" The Masoretes give their traditional paragraph count only at the end of Nehemiah, and it includes both Ezra and Nehemiah; their midpoint is at Neh 3:32, not at the end of Ezra. Josephus ("), _c('em', [_vm._v("Against Apion")]), _vm._v(" 1.40) and the Talmud (b. B. Bat. 15a) refer only to one work (i.e., Ezra). L. S. Fried expresses the implausibility of one of these books without the other: “Moreover, it is inconceivable that a story of Ezra would have been complete without an account of Ezra reading the law to the gathered populace. That story is told only in the book of Nehemiah. Nor could the story of Ezra’s reading the Torah have been told in the book of Nehemiah without an account of Ezra’s coming to Jerusalem. That story is not in Nehemiah, but only in the book of Ezra.”"), _c('a', {
    attrs: {
      "href": "#/#foot-note-909",
      "id": "footnote-909"
    }
  }, [_c('sup', [_vm._v("61")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Thus, each book is needed in order to understand the other. Ezra and Nehemiah were originally simply “Ezra” in the earliest Hebrew manuscripts from the tenth century. Origen distinguishes between 1 Ezra and 2 Ezra but says that in Hebrew they are one book. Jerome, too, separates Nehemiah, “the liber secundus Esdrae,” from Ezra. Thus, the division apparently begins with the church fathers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In a monograph on Levitical authorship of both Ezra and Nehemiah, Kyung-Jin Min skillfully argues against the separate books view."), _c('a', {
    attrs: {
      "href": "#/#foot-note-908",
      "id": "footnote-908"
    }
  }, [_c('sup', [_vm._v("62")])]), _vm._v(" He points out that, as it stands, part of the story is in one book and part in the other. The introduction in Neh 1:1 is paralleled by subheadings in the Psalms, and in fact the second half of 1:1 is a defective date with no mention of the king, which must be assumed from Ezra. Also, the heading indicates the following first-person material will now be given by Nehemiah, not Ezra. Min endorses two scholarly views for the repetition of the lists. First, “repetition of the lists was devised to show the continuity between the community which first returned and built the temple (Ezra 2) and the purified community (Nehemiah 7).” Second, the lists provide authorization for those who would rebuild the temple (Ezra 2) as well as supply a genealogical register for those who would take up residence in Jerusalem and other cities of Judah (Neh 7). Against VanderKam’s different word lists, Min notes that the two books share technical terms too—for example, “Temple Servants” or “Netinim” ("), _c('em', [_vm._v("n")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ə")]), _c('em', [_vm._v("tînîm")]), _vm._v(") and “the hand of God upon” ("), _c('em', [_vm._v("yad-’elōhîm ‘āl")]), _vm._v(") a person; both are rarely found elsewhere in the Hebrew Bible."), _c('a', {
    attrs: {
      "href": "#/#foot-note-907",
      "id": "footnote-907"
    }
  }, [_c('sup', [_vm._v("63")])]), _vm._v(" Also, while the house of God is a less-emphasized "), _c('em', [_vm._v("fait accompli")]), _vm._v(" in Nehemiah, the theme of the restoration of the community is shared by both books.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Other scholars, too, have argued for the connection of Ezra and Nehemiah in one compilation based on narrative integrity."), _c('a', {
    attrs: {
      "href": "#/#foot-note-906",
      "id": "footnote-906"
    }
  }, [_c('sup', [_vm._v("64")])]), _vm._v(" The inclusion of an Ezra story within Nehemiah, by its assumption that the reader is familiar with Ezra, supports the idea that Nehemiah and Ezra are a unitary compilation. Eskenazi uncovers underlying themes throughout the two books. Throntveit’s work on literary devices (“concentricity, parallel panels, and repetitive resumptions”) has also further demonstrated the link between the two books (see "), _c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec3-5"
    }
  }, [_vm._v("“Literary Techniques,” pp. 29–30")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The two books use parallel collocations as well. For instance, the use of “the hand of Yahweh my God was upon me” (Ezra 7:28) parallels “the good hand of my God that was upon me” (Neh 2:8). Other hand imagery in both books includes stretching out the hand in force against someone ("), _c('em', [_vm._v("dî yiśla")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ḥ")]), _vm._v(" "), _c('em', [_vm._v("y")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ə")]), _c('em', [_vm._v("dēh")]), _vm._v(", “will stretch out his hand,” Ezra 6:12; "), _c('em', [_vm._v("yād")]), _vm._v(" "), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ʾ")]), _c('em', [_vm._v("ešla")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ḥ")]), _vm._v(" "), _c('em', [_vm._v("bākem")]), _vm._v(", “I will stretch out a hand against you,” Neh 13:21) and efforts to “strengthen hands” or “weaken” them (i.e., encourage or discourage; Ezra 4:4; 6:22; Neh 6:9).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In addition to the above arguments for the compilation of Ezra-Nehemiah without Chronicles, the priestly material of the Bible uses technical language that conveys specific meanings in the context of the Israelite cult. In Ezra-Nehemiah, this vocabulary is used quite differently than in earlier Jewish traditions, and this distinct usage is shared between both books."), _c('a', {
    attrs: {
      "href": "#/#foot-note-905",
      "id": "footnote-905"
    }
  }, [_c('sup', [_vm._v("65")])]), _vm._v(" One concept shared by both but otherwise unique in the Hebrew Bible is the sacrilege of intermarriage (see Ezra 9:2; 10:2; Neh 13:27; see "), _c('span', {
    attrs: {
      "href": "#/012_Chapter02c#exc9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excursus 9, “The Sacrilege of Intermarriage,” pp. 244–54")]), _vm._v("). The root "), _c('em', [_vm._v("qdš")]), _vm._v(", “to be holy,” is used in an expansive way. Ezra represents the holiness of the entire community of returned exiles, not just the priests, as biological by the reference to "), _c('em', [_vm._v("the holy seed")]), _vm._v(" ("), _c('em', [_vm._v("zera")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ʿ")]), _vm._v(" "), _c('em', [_vm._v("haqqōdeš")]), _vm._v(", Ezra 9:2), and Nehemiah corroborates this outlook (Neh 9:2). Like the holiness of the priests, the “holy seed” can be desecrated ("), _c('em', [_vm._v("ma")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("al")]), _vm._v("; Ezra 9:2; 10:2, 10; Neh 1:8; 13:27), an innovation over against earlier norms. Ezra records the dimensions of the temple as larger than Solomon’s (Ezra 6:3). Over the course of the two books, the holiness of the temple reaches out to encompass the entire city of Jerusalem, requiring purification of its walls (Neh 7:1; 13:22). The people find themselves “in the house of God,” although they are merely within the walls of the city, not the sanctuary itself (Neh 12:40). More striking than earlier traditions, the label of impurity is applied directly to outsiders. Unlike the purity system of Lev 11–15, separating ("), _c('em', [_vm._v("bādal")]), _vm._v(") from impurity in both Ezra and Nehemiah usually means disassociating from “foreigners” or “people of the land(s)” (Ezra 6:21; 9:11; 10:11; Neh 10:28; 13:26, 30). Furthermore, the term "), _c('em', [_vm._v("gā")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ʾ")]), _c('em', [_vm._v("al")]), _vm._v(" (“nauseating, revolting, defiling”) describes the defilement of the priests by intermarriage (Ezra 2:61–62; Neh 7:64; 13:29).")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-8"
    }
  }, [_vm._v("D. COMPILATION")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The date of the final compilation of Ezra-Nehemiah continues to trouble scholars. The matter revolves, to a great extent, around the genealogical lists of Neh 12. Jaddua of Neh 12:10–11 may be the same Jaddua, known from Josephus, who came into contact with Alexander the Great. Further support for a Hellenistic context may come from the word used for coins in Ezra 2:69; 8:27 and Neh 7:70–72, which may refer to the Greek drachma."), _c('a', {
    attrs: {
      "href": "#/#foot-note-904",
      "id": "footnote-904"
    }
  }, [_c('sup', [_vm._v("66")])]), _vm._v(" From a philosophical perspective, the tone of Ezra-Nehemiah ends with greater skepticisim than the earlier optimism under Cyrus and Darius and may reflect a Hellenistic rather than a Persian context."), _c('a', {
    attrs: {
      "href": "#/#foot-note-903",
      "id": "footnote-903"
    }
  }, [_c('sup', [_vm._v("67")])]), _vm._v(" On the other hand, there is no mention in Ezra-Nehemiah of Alexander’s conquest or even the suffering of the mid-fourth century BCE, when Judah joined the Phoenician rebellion and was harshly put down by Artaxerxes III."), _c('a', {
    attrs: {
      "href": "#/#foot-note-902",
      "id": "footnote-902"
    }
  }, [_c('sup', [_vm._v("68")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The redaction and final compilation of Ezra-Nehemiah remains a matter of debate among scholars. According to some, large identifiable sources were compiled at different times during the fifth to fourth centuries BCE; others regard the process as incremental, arguing that there was a continual process of editing as scribes responded to various issues of the community."), _c('a', {
    attrs: {
      "href": "#/#foot-note-901",
      "id": "footnote-901"
    }
  }, [_c('sup', [_vm._v("69")])]), _vm._v(" In my view, an early editor combined material regarding Ezra and Nehemiah (of whom Nehemiah lived later) no earlier than 430 BCE and no later than the death of Artaxerxes in 424 BCE. One example of an early setting for this material is its emphasis on Judah and Benjamin, a postexilic rather than a Hellenistic issue."), _c('a', {
    attrs: {
      "href": "#/#foot-note-900",
      "id": "footnote-900"
    }
  }, [_c('sup', [_vm._v("70")])]), _vm._v(" Nevertheless, later editing is also discernible (e.g., Neh 12:10). The lists of the high priests of Neh 12 discussed above reveals that the book’s final compilation could not have been before “Darius the Persian”—most likely Darius III (335–331 BCE).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The motive for this compilation revolves around matters of identity and ethnicity. In the Persian period, and even more so in the Hellenistic period, Jews were increasingly concerned with legitimacy and continuity. “Who is a Jew?” becomes a key question, and Ezra-Nehemiah provides the earliest narrative dealing with the matter. Ezra and Nehemiah are heroes who maintain an ethnically pure Jewish community that is legitimately linked to the Israelite past, attestable by genealogy, and guided by the Torah in the present despite persecution and the dominance of a foreign regime.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "sec-3"
    }
  }, [_vm._v("III. METHODOLOGY")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The increasing frustration with a diachronic approach to Ezra-Nehemiah has led many scholars to examine other methodologies. The diachronic method views the writing of Ezra-Nehemiah as a process with many stages of adding or editing literary sources. This long-standing method is helpful in that it often provides an answer for internal inconsistencies by pointing to various sources, text layers, and editing. However, the disadvantage of the diachronic method is that emendations and large rearrangements of the text are often subjective, as the scholar tries to create a smooth, chronological narrative from a modern point of view.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "sec-4"
    }
  }, [_vm._v("IV. SETTING")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The narrative of Ezra-Nehemiah takes place primarily within the Persian province of Yehud (= Judah, Judea). The geographical boundaries and population of this province, especially that of its central city Jerusalem, continue to be a matter of debate among scholars. According to O. Lipschits, Yehud lost about 60 percent of its population in the Babylonian deportations of the sixth century BCE. Compared with about 110,000 before the Babylonian conquest, Yehud in the time of Zerubbabel contained only about 60,000 persons."), _c('a', {
    attrs: {
      "href": "#/#foot-note-899",
      "id": "footnote-899"
    }
  }, [_c('sup', [_vm._v("71")])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-9"
    }
  }, [_vm._v("A. YEHUD")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The Persians organized Yehud as part of a huge administrative district, or satrapy, that included Babylon and all of the Near East west of the Euphrates River. The satrapy was given the name, "), _c('em', [_vm._v("Babili-Ebirnari")]), _vm._v(", “Babylon and Across the River” (i.e., the River Euphrates; see Ezra 8:36; Neh 2:7, 9; 3:7). Herodotus describes it as “the Fifth Satrapy,” which included the nations of Syria, Phoenicia, Cyprus, and Israel to the border of Egypt ("), _c('em', [_vm._v("Histories")]), _vm._v(" 1.114). According to Ezra-Nehemiah, Judah was surrounded by hostile enemies: Samaria to the north, governed by Sanballat; Ammon-Gilead on the east, governed by Tobiah; and Arabia-Idumea in the south, where Geshem was in control. To the west lay the province of Ashdod."), _c('a', {
    attrs: {
      "href": "#/#foot-note-898",
      "id": "footnote-898"
    }
  }, [_c('sup', [_vm._v("72")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Yehud was much smaller than the Judah of the Babylonian period, encompassing approximately 800 square miles. Its boundaries, according to the biblical rosters of place names, are confirmed to a large degree by the presence of (1) forts on the southern and western boundaries, and (2) coins and seal impressions stamped with the name “Yehud.” E. Stern states the boundaries as follows: “The southern border of this area of distribution would appear to be at Beth-Zur; the northern limit is at Tell en-Nasbeh; the eastern limit is a line extending from Jericho to En-Gedi; in the west, some seal impressions were recovered at Gezer, which is definitely located in the district of Lod, and at Tel Harasim, which belonged to the Keilah district. Thus, the distribution of coins and impressions of the Judaean province encompasses the entire area mentioned in the Bible.”"), _c('a', {
    attrs: {
      "href": "#/#foot-note-897",
      "id": "footnote-897"
    }
  }, [_c('sup', [_vm._v("73")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The expanded version of Yehud’s boundaries has been contested. O. Lipschits estimates a somewhat smaller area of settlement in Persian Yehud, especially on the western extent."), _c('a', {
    attrs: {
      "href": "#/#foot-note-896",
      "id": "footnote-896"
    }
  }, [_c('sup', [_vm._v("74")])]), _vm._v(" Admittedly, archaeological remains do not establish clear boundaries of the province of Yehud but simply provide isolated pieces of evidence."), _c('a', {
    attrs: {
      "href": "#/#foot-note-895",
      "id": "footnote-895"
    }
  }, [_c('sup', [_vm._v("75")])]), _vm._v(" (See the "), _c('a', {
    attrs: {
      "href": "#/010_Chapter01#m1"
    }
  }, [_vm._v("map on p. 96")]), _vm._v(".)")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Discussion continues regarding the status of Yehud as a province. A. Alt believed that Yehud was under the rulership of the province of Samaria and that the establishment of Yehud as an independent province was a new idea which began with the appointment of Nehemiah as governor."), _c('a', {
    attrs: {
      "href": "#/#foot-note-894",
      "id": "footnote-894"
    }
  }, [_c('sup', [_vm._v("76")])]), _vm._v(" This would explain the hostility of the Samarians during this time. However, Scripture refers to both Sheshbazzar (Ezra 5:14) and Zerubbabel (Hag 1:1, 14; 2:2, 21) as “governors” and Yehud as some kind of independent province ("), _c('em', [_vm._v("m")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ə")]), _c('em', [_vm._v("dînâ")]), _vm._v("; see Esth 1:1)."), _c('a', {
    attrs: {
      "href": "#/#foot-note-893",
      "id": "footnote-893"
    }
  }, [_c('sup', [_vm._v("77")])]), _vm._v(" In addition, over seventy bullae (clay seal impressions) were found in a jar near Jerusalem made from twelve seals, with the name of the province Yehud. Several of them contain the name of a Jew who was designated “governor.” Also, two seals, possibly from the sixth century BCE, were discovered, one of which belonged to “Shelomith, maidservant of Elnathan the Governor.”"), _c('a', {
    attrs: {
      "href": "#/#foot-note-892",
      "id": "footnote-892"
    }
  }, [_c('sup', [_vm._v("78")])]), _vm._v(" Nehemiah also points to governors prior to him that, unlike himself, took the “governor’s allowance of food,” and “laid a heavy burden on the people” (Neh 5:14–15). Thus, it appears Yehud was an independent province as early as the late sixth century BCE.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-10"
    }
  }, [_vm._v("B. JERUSALEM")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("There was a large difference in the impact of the deportations on residents of the hill country and of Jerusalem. While large estates in the rural areas were relatively untouched, Jerusalem and its environs were devastated. Nehemiah describes such ruin that his animal can barely find footing while he investigates the site (Neh 2:14). It was his vision and self-imposed mission to repopulate and secure the city with a defensive wall.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Scripture gives some hint as to the extent of Jerusalem in its description of the city’s repopulation under Nehemiah’s administration (Neh 11:1–24). One out of ten Judean settlers volunteer to move into its borders. Steinmann, pointing out that the total of those associated with the city’s government in Neh 11 comes to 3,044, estimates a total population of between 10,000 and 15,000 persons, which allows for the families of these men and for others who were not leaders."), _c('a', {
    attrs: {
      "href": "#/#foot-note-891",
      "id": "footnote-891"
    }
  }, [_c('sup', [_vm._v("79")])]), _vm._v(" On the other hand, Broshi, on the basis of the area of Jerusalem being 120 dunams, estimates its population at 40 persons a dunam to a total of about 4,800 people in Jerusalem in Nehemiah’s time."), _c('a', {
    attrs: {
      "href": "#/#foot-note-890",
      "id": "footnote-890"
    }
  }, [_c('sup', [_vm._v("80")])]), _vm._v(" In either case, the population of Jerusalem is drastically less than during the time of the first return. According to the earlier lists of Ezra-Nehemiah, the number of men alone whose ancestry is associated with Jerusalem in Zerubbabel’s day was around 16,000 (Ezra 2:3–20; Neh 7:8–25). (See the image of "), _c('a', {
    attrs: {
      "href": "#/#fig1"
    }
  }, [_vm._v("Nehemiah’s Jerusalem on p. 97")]), _vm._v(".)")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("A large factor in determining the population of Jerusalem is the extent of its area in early Persian times. A few scholars place the wall in the late Hellenistic period and identify it with the Hasmonean city wall. However, this view runs into difficulty because the various toponyms described in the text (e.g., the temple with an adjacent royal palace, the upper king’s house, the courtyard of the guard, the Horse Gate) reflect the layout of the city in early Second Temple, not Hasmonean, times (see Neh 3:25–28)."), _c('a', {
    attrs: {
      "href": "#/#foot-note-889",
      "id": "footnote-889"
    }
  }, [_c('sup', [_vm._v("81")])]), _vm._v(" According to the “minimalists,” who are the majority of scholars, the area of Jerusalem in the Persian period was limited to the eastern hill."), _c('a', {
    attrs: {
      "href": "#/#foot-note-888",
      "id": "footnote-888"
    }
  }, [_c('sup', [_vm._v("82")])]), _vm._v(" They note that excavations of the Jewish Quarter on the western hill reveal Hellenistic remains directly on top of First Temple finds. Most buildings in this period were constructed in an open-court style—that is, as a courtyard with rooms surrounding it on all or most sides, a typical design for the Assyrian, Babylonian, and Persian periods."), _c('a', {
    attrs: {
      "href": "#/#foot-note-887",
      "id": "footnote-887"
    }
  }, [_c('sup', [_vm._v("83")])]), _vm._v(" Along with the lack of archaeological finds from the Persian period on the southwestern hill, the description of the wall building also supports the minimalist position. The list of task forces is roughly equal on both sides of the wall, divided on a north/south axis from the Sheep Gate in the north to the Dung Gate in the south, with nineteen crews on the west side of the city and twenty-two crews on the east side. Many more crews would have been needed on the west side if it included the southwestern hill."), _c('a', {
    attrs: {
      "href": "#/#foot-note-886",
      "id": "footnote-886"
    }
  }, [_c('sup', [_vm._v("84")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The matter of Jerusalem’s physical size, however, is not a closed case. The scholars referred to as “maximalists” argue that the borders of the preexilic city included not only the eastern hill with its Temple Mount and City of David but the southwestern hill as well."), _c('a', {
    attrs: {
      "href": "#/#foot-note-885",
      "id": "footnote-885"
    }
  }, [_c('sup', [_vm._v("85")])]), _vm._v(" Proponents of this view point out that there is not sufficient evidence for a wall on the western side of the City of David dating to Nehemiah’s period. David Ussishkin explains that there is evidence in the southern section of the western boundary of the City of David that it was fortified in the Middle Bronze II period but that it was not fortified at all in later times."), _c('a', {
    attrs: {
      "href": "#/#foot-note-884",
      "id": "footnote-884"
    }
  }, [_c('sup', [_vm._v("86")])]), _vm._v(" Rather, the preexilic size of Jerusalem, from the eighth century forward, included the southwestern hill. He also points to the large number of gates in the wall described in Nehemiah, which makes better sense for a larger perimeter. Also, the biblical description of the site before Jerusalem’s repopulation seems to fit better with a settlement larger than the eastern hill, “The city was wide and spacious but the people in it were few and the houses had not been rebuilt” (Neh 7:4). According to Nehemiah 11, one-tenth of the Jewish population moved inside the city walls (Neh 11:1–2).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The crux remains that archaeologists have not uncovered clear evidence of Jewish settlement on the southwestern hill during the Persian period. Whether or not Nehemiah’s wall extended to the western hill, the population of the city was still concentrated on the eastern hill. The city, even at the minimalist size, could have easily accommodated one to two thousand people."), _c('a', {
    attrs: {
      "href": "#/#foot-note-883",
      "id": "footnote-883"
    }
  }, [_c('sup', [_vm._v("87")])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-11"
    }
  }, [_vm._v("C. LITERARY CRITICISM")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Literary criticism goes beyond historical concerns and begs for the rationale behind the work as a whole. It asks why the book exists in its present form. The work is not just the next stop on a train of sources that were compiled and edited at different moments in history. Instead, like scholars of other literatures, literary critics take note of literary conventions in the text, seeking undergirding themes as well as overarching frameworks and plots. They are also sensitive to symbols and their meanings, which highlight key values of these early Jewish communities."), _c('a', {
    attrs: {
      "href": "#/#foot-note-882",
      "id": "footnote-882"
    }
  }, [_c('sup', [_vm._v("88")])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-4"
    }
  }, [_vm._v("1. Themes and Purpose")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Literary critics differ regarding what the major themes are in Ezra-Nehemiah and what the overall purpose of the book is. Eskenazi, in a ground-breaking monograph, "), _c('em', [_vm._v("In an Age of Prose")]), _vm._v(", concluded that the three major parts of Ezra-Nehemiah were intentionally composed and sequenced to make a point: the extension of holiness in Israel from the establishment of the holy house to the sanctification of the entire city."), _c('a', {
    attrs: {
      "href": "#/#foot-note-881",
      "id": "footnote-881"
    }
  }, [_c('sup', [_vm._v("89")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Sara Japhet, too, urges that chronology in Ezra-Nehemiah is tied to composition. According to Japhet, the author is making a historical statement by sequencing key events in a particular way. In each of the three major events of the book, the restoration begins with Persian authorization and continues with a group of returnees from exile. Japhet states: “By the means of this time-structuring, the author expresses his historical view—which he also expresses in other ways—that change and renewal in the life of Judah were the result of initiative on the part of the Persian kings and the Jews of Babylonia rather than any action in Judah itself, whether political or spiritual. God extended grace to Israel—that is to those who returned from exile—by means of the kings of Persia.”"), _c('a', {
    attrs: {
      "href": "#/#foot-note-880",
      "id": "footnote-880"
    }
  }, [_c('sup', [_vm._v("90")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Throntveit suggests a paradigm that focuses on the “crucial theological moments of the restoration as three parallel returns”—those led by Zerubbabel, Ezra, and Nehemiah, each of whom fulfilled his own mission: the reconstruction of the temple, community, and walls. In each case, there was a return from exile prompted by God and authorized by the Persian emperor, opposition from the local authorities, and a meeting of the challenge with God’s help."), _c('a', {
    attrs: {
      "href": "#/#foot-note-879",
      "id": "footnote-879"
    }
  }, [_c('sup', [_vm._v("91")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Shemaryahu Talmon notes that all three narrative blocks display a similar structure and, with one exception, are composed of the same types of subunits: (1) royal documents worded in Aramaic or in Hebrew (Ezra only); (2) letters in a common epistolary style, written in Aramaic by Persian officials to the king and in Hebrew between Nehemiah and Sanballat; (3) diverse lists of returnees, inhabitants, builders, and signatories, as well as inventories."), _c('a', {
    attrs: {
      "href": "#/#foot-note-878",
      "id": "footnote-878"
    }
  }, [_c('sup', [_vm._v("92")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Several scholars have noticed the recollection of the exodus narrative in the language and themes of Ezra-Nehemiah."), _c('a', {
    attrs: {
      "href": "#/#foot-note-877",
      "id": "footnote-877"
    }
  }, [_c('sup', [_vm._v("93")])]), _vm._v(" The writer views the return from exile as a second exodus from slavery. The giving of the law and the journey to the land of promise are central in both stories, and Ezra’s part in these endeavors puts him forward as a sort of second Moses. Blenkinsopp refers to this use of Israelite history in a contemporary way as a trend in the “second historical corpus” (Chronicles-Ezra-Nehemiah) of “gathering up of the past and reshaping it in such a way as to allow for a future.”"), _c('a', {
    attrs: {
      "href": "#/#foot-note-876",
      "id": "footnote-876"
    }
  }, [_c('sup', [_vm._v("94")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("There are other suggestions for the text’s main themes and purpose. Some scholars regard Ezra-Nehemiah as establishing a line of continuity with the First Temple period, its royalty, and its priesthood. Others view its purpose as a corrective to overly liberal, inclusive prophets like Isaiah, instead promoting a hardline approach toward outsiders, especially with regard to the cult. According to Lester Grabbe, one of the book’s main messages is that “eternal vigilance is required to keep outsiders from leading the community astray,” and he notes the unsettling ending of the book, which “leaves in the mind of the reader the open-ended danger that remains against which one must be constantly vigilant.”"), _c('a', {
    attrs: {
      "href": "#/#foot-note-875",
      "id": "footnote-875"
    }
  }, [_c('sup', [_vm._v("95")])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-5"
    }
  }, [_vm._v("2. Literary Techniques")]), _vm._v(" "), _c('p', {
    staticClass: "parab"
  }, [_vm._v("Various literary conventions are employed in Ezra-Nehemiah that delineate the structure of the text. Two of the most obvious of these are concentricity and resumptive repetition. Concentricity, or chiastic structure—sometimes referred to as staircase parallelism or ring composition—refers to the arrangement of a section of the text (whether a verse or a group of chapters) in which “the members of the second half of a bicolon, sentence, or other literary unit echo, repeat, or recall the members of the first half in inverted order, in the form AB … B′A′.”"), _c('a', {
    attrs: {
      "href": "#/#foot-note-874",
      "id": "footnote-874"
    }
  }, [_c('sup', [_vm._v("96")])]), _vm._v(" As an example, Ezra 9:3–10:1 records in a chiastic structure Ezra’s intercessory prayer for the community that has intermarried with outsiders:")]), _vm._v(" "), _c('p', {
    staticClass: "chiasm"
  }, [_vm._v("A Narrative action: Ezra’s mourning (9:3–5)")]), _vm._v(" "), _c('p', {
    staticClass: "chiasm1"
  }, [_vm._v("B General confession (9:6–7)")]), _vm._v(" "), _c('p', {
    staticClass: "chiasm2"
  }, [_vm._v("C Present evidence of divine mercy (9:8–9)")]), _vm._v(" "), _c('p', {
    staticClass: "chiasm3"
  }, [_vm._v("X Specific confession (9:10–12)")]), _vm._v(" "), _c('p', {
    staticClass: "chiasm2"
  }, [_vm._v("C′ Questioned continuance of divine mercy (9:13–14)")]), _vm._v(" "), _c('p', {
    staticClass: "chiasm1"
  }, [_vm._v("B′ General confession (9:15)")]), _vm._v(" "), _c('p', {
    staticClass: "chiasm"
  }, [_vm._v("A′ Narrative action: Ezra’s mourning (10:1a)"), _c('a', {
    attrs: {
      "href": "#/#foot-note-873",
      "id": "footnote-873"
    }
  }, [_c('sup', [_vm._v("97")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para1"
  }, [_vm._v("The most significant part of the confession, that the community has violated divine laws against intermarriage, appears at the center of the passage (X). This is framed by the supporting parts of Ezra’s prayer: his affirmation of divine mercy both currently (C, C′) and historically (B, B′). Further out (A, A′), the unit begins and ends by setting forth the narrative details of the context: the mourning posture of Ezra and those who gathered around him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Noss and Thomas focus on the phenomenon of concentricity on a macro scale, which they refer to as “expanded chiasmus” or “mirror image” in which “one set of paragraphs or lines builds up toward a climax from which a second set of paragraphs or lines moves away in opposite fashion (see Neh 3:3–32).”"), _c('a', {
    attrs: {
      "href": "#/#foot-note-872",
      "id": "footnote-872"
    }
  }, [_c('sup', [_vm._v("98")])]), _vm._v(" Often the main point of the passage is highlighted by its placement at the center of one of these chiasms. For Throntveit too, concentricity is the “primary structural device employed in Ezra-Nehemiah, appearing at every level of the text.”"), _c('a', {
    attrs: {
      "href": "#/#foot-note-871",
      "id": "footnote-871"
    }
  }, [_c('sup', [_vm._v("99")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The presence of resumptive repetition and summaries in Ezra-Nehemiah was first brought into relief by Shemaryahu Talmon."), _c('a', {
    attrs: {
      "href": "#/#foot-note-870",
      "id": "footnote-870"
    }
  }, [_c('sup', [_vm._v("100")])]), _vm._v(" Resumptive repetition is a technique by which an earlier phrase is repeated or continued after the interruption of other material. A good example is Ezra 2:1b (= Neh 7:6b): "), _c('em', [_vm._v("These are the people of the province who came up from the captivity")]), _vm._v(" … "), _c('em', [_vm._v("[and] returned to Jerusalem and Judah, each to his own city")]), _vm._v(". Here it breaks off for the list of people but summarizes and resumes at Ezra 2:70 (= Neh 7:73) with "), _c('em', [_vm._v("So the priests, Levites, some of the people")]), _vm._v(" … "), _c('em', [_vm._v("settled in their cities.")]), _vm._v("” More pointedly, Ezra 4:6–24a is framed by 4:5b (“until the reign of King Darius of Persia”) and 4:24b (“until the second year of the reign of King Darius of Persia”). This framing of material by a similar phrase at its beginning and end is also called an inclusio or envelope. Thus, rather than insisting that Ezra-Nehemiah is wrong historically in introducing Artaxerxes in the time of Cyrus and Darius, the readers realize that by describing local opposition to the Jews under Darius, the author reminds them of a more recent, similar experience in more recent times under Artaxerxes. The theme of overcoming opposition by local authorities who complain to the emperor, not the chronology, is the organizing factor here."), _c('a', {
    attrs: {
      "href": "#/#foot-note-869",
      "id": "footnote-869"
    }
  }, [_c('sup', [_vm._v("101")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("It is possible to identify particular textual units in Ezra-Nehemiah based on summaries. For example, Ezra 4:4–5 summarizes the preceding chapter, relating the troubles of rebuilding the temple."), _c('a', {
    attrs: {
      "href": "#/#foot-note-868",
      "id": "footnote-868"
    }
  }, [_c('sup', [_vm._v("102")])]), _vm._v(" Ezra 6:13–14 summarizes 5:1–6:12, recounting the progress and completion of the temple. Nehemiah 12:26 concludes the list of priests in 12:10–25, and, similarly, Neh 12:47 refers back to 12:44–46. Significantly, Neh 13:29b–31a only summarizes Neh 10–13, marking this section off as a separate source from the rest of the Nehemiah Memoir (see also summaries in Neh 12:26, 47; Ezra 6:13–14)."), _c('a', {
    attrs: {
      "href": "#/#foot-note-867",
      "id": "footnote-867"
    }
  }, [_c('sup', [_vm._v("103")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Prayers too are used to mark off structure. For example, at the end of ch. 5 Nehemiah prays, “Remember for my good, O my God, all that I have done for this people.” This concludes the previous section, and a new episode is begun in ch. 6. Other invocations follow in Neh 6:14; 13:14, 22, 29, and, finally bringing closure to the book, 31."), _c('a', {
    attrs: {
      "href": "#/#foot-note-866",
      "id": "footnote-866"
    }
  }, [_c('sup', [_vm._v("104")])]), _vm._v(" As this discussion demonstrates, the techniques of literary criticism can work in tandem with those of source criticism.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-6"
    }
  }, [_vm._v("3. Literature and History")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Focus on Ezra-Nehemiah as a stylized literary presentation has led some scholars to regard it as fiction, simply motivated by an ideology rather than reality. Derek Kidner argues strongly against the notion that Ezra-Nehemiah is literary fiction or simply a polemic against universalist or messianic parties. He says, rather, that the principal aim of the writer was “to record the rebuilding of Israel’s life and institutions in the first century after the exile in the midst of a gentile world which was part enemy, part protector and governor, part seducer, and to show God’s providence in raising up the leaders who would hold her to her vocation as a people apart, centred on God’s Temple and city and law.”"), _c('a', {
    attrs: {
      "href": "#/#foot-note-865",
      "id": "footnote-865"
    }
  }, [_c('sup', [_vm._v("105")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Literary critics caution that indications of time in Ezra-Nehemiah should not be expected to be precise time indicators, as that was not the author’s intent."), _c('a', {
    attrs: {
      "href": "#/#foot-note-864",
      "id": "footnote-864"
    }
  }, [_c('sup', [_vm._v("106")])]), _vm._v(" Still, the large number of dates and times expressions in the book do give the sense of historical concern. The audience of the book, especially its earliest sources, was not far removed from the actual events and would know when they occurred."), _c('a', {
    attrs: {
      "href": "#/#foot-note-863",
      "id": "footnote-863"
    }
  }, [_c('sup', [_vm._v("107")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("It appears that both diachronic and literary approaches to the study of Ezra-Nehemiah are valuable but limited in specific ways. Although fraught with unresolved difficulties, historical parallels ascertaining the decidedly Persian context of the drama have been identified, and thus attempts to locate it more precisely are valuable. At the same time, the narrative is not simply an incomplete catalog of data regarding Jews under the Persians but certainly entails a theological agenda that is presented carefully using recognizable literary methods. Thus, a critical reconstruction of the narrative in light of both its historical context and the literary forms imposed on it by later editors is necessary for a balanced viewpoint.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-12"
    }
  }, [_vm._v("D. SOCIAL SCIENCE")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Another modern tool for analyzing Ezra-Nehemiah comes from the Social Sciences. The main value of this approach is that it helps to “bridge the gap between the modern interpreter and the text.”"), _c('a', {
    attrs: {
      "href": "#/#foot-note-862",
      "id": "footnote-862"
    }
  }, [_c('sup', [_vm._v("108")])]), _vm._v(" D. Janzen builds upon the work of social anthropologist M. Douglas to explain the insulated communities of Ezra-Nehemiah that erected strong barriers against intermarriage. Douglas’s fieldwork among tribal communities in Africa revealed certain norms that resonate cross-culturally. She produced a system for describing social action within a community with the terms “group,” the barriers the community erects to preserve its identity vis-à-vis the outside world, and “grid,” the level of regulation within the community itself."), _c('a', {
    attrs: {
      "href": "#/#foot-note-861",
      "id": "footnote-861"
    }
  }, [_c('sup', [_vm._v("109")])]), _vm._v(" Janzen characterizes the edicts of Ezra-Nehemiah as coming from a community with strong external boundaries (“high group”) and a fluid internal structure (“weak grid”)."), _c('a', {
    attrs: {
      "href": "#/#foot-note-860",
      "id": "footnote-860"
    }
  }, [_c('sup', [_vm._v("110")])]), _vm._v(" He describes the expulsion of foreign women as the witchhunt of a community that is over-sensitive to foreign elements. D. Moffat, similarly, regards the women as symbolic of non-absorbable impurity, but he does not see them as the target. Rather, the text blames the men for their inclusion and requires reparation rituals of them. In contrast to Janzen, Moffat regards the women as truly outsiders, “resistant to Yahwism and affiliated outside the community,” not as insiders who have been ostracized and labeled as outsiders."), _c('a', {
    attrs: {
      "href": "#/#foot-note-859",
      "id": "footnote-859"
    }
  }, [_c('sup', [_vm._v("111")])]), _vm._v(" Moffat, too, uses Douglas’s group/grid model to explain Ezra’s actions, but he labels the community as a “mid group” (i.e., one with a weakening external boundary because of the infiltration of these foreign women) and a “strong grid” (i.e., one with strict internal conformity, represented by the authoritarian leadership of Ezra)."), _c('a', {
    attrs: {
      "href": "#/#foot-note-858",
      "id": "footnote-858"
    }
  }, [_c('sup', [_vm._v("112")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Douglas’s work on ritual pollution has been most helpful to unlock the social dynamics within Ezra-Nehemiah. She defines ritual pollution behavior as “the reaction which condemns any object or idea likely to confuse or contradict cherished classifications.”"), _c('a', {
    attrs: {
      "href": "#/#foot-note-857",
      "id": "footnote-857"
    }
  }, [_c('sup', [_vm._v("113")])]), _vm._v(" Impurity in ancient Israel was a malevolent force that threatened the holiness of the temple, its gifts, and the people. The antonym of impurity is holiness, which is equated with the divine presence, spirit, and power. Purity is the state of being, achieved by requisite purifications, that is necessary for holiness to be active. Profanity is a neutral, or inert, status that is not susceptible to impurity and does not carry any holy power either. Although the categories are somewhat inadequate, and certainly not used in Scripture, the terms “moral” and “ritual” impurity still serve to characterize the two main types of impurity: one due to sin and the other simply to the human condition. The latter can be discussed in three groups: impurity related to (1) death, (2) skin diseases, and (3) sexual processes. There is ample attestation throughout Scripture that these ritual impurities were obstacles to contact with holy things and that an impure person or item had to perform ablutions as prescribed in the Torah. Unlike ritual impurities, moral impurities were voluntary acts of transgression that carried severe penalties—even death, in some cases. In particular, idolatry, murder, and sexual sins were all referred to as moral impurities.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The major innovation in the Second Temple period with regard to impurity is that it is no longer caused just by certain bodily processes or the behavior of human beings, whether sinful acts like murder or biological actions like sexual intercourse. For the first time, it is attached as an adjective to certain types of people. In particular, gentiles, as well as Jews who do not conform to the group’s definition of Israel, are labeled “impure” (see "), _c('span', {
    attrs: {
      "href": "#/014_Chapter03c#exc23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excursus 23, “Gentile Impurity,” pp. 469–77")]), _vm._v("). The sinner, not just the sin, is impure."), _c('a', {
    attrs: {
      "href": "#/#foot-note-856",
      "id": "footnote-856"
    }
  }, [_c('sup', [_vm._v("114")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Conversely, ritual purity is a label that communicates and reinforces the boundaries of a particular group; it expresses the group’s desire to preserve its integrity and marks off symbolically where its borders lie."), _c('a', {
    attrs: {
      "href": "#/#foot-note-855",
      "id": "footnote-855"
    }
  }, [_c('sup', [_vm._v("115")])]), _vm._v(" Its goal is to exclude some people from others, creating clear insider and outsider groups. This seems to be exactly the goal of Ezra and Nehemiah. Thus, ritual purity is not the end in itself, but it is a separation tool by which the group condemns and removes itself from contact with its enemy. As Saul Olyan says, “In Ezra-Nehemiah, struggle over defining the boundaries of the people itself leads to the employment of the rhetoric of impurity to justify exclusion from the community of all individuals classed as alien” (Ezra 9:1–2; Neh 13:4–9, 28–30)."), _c('a', {
    attrs: {
      "href": "#/#foot-note-854",
      "id": "footnote-854"
    }
  }, [_c('sup', [_vm._v("116")])]), _vm._v(" Thus, impurity labels are used in Ezra-Nehemiah as accusatory labels that mark a person as an intruder in the group. Nevertheless, the fundamental reason for their undesirability lies elsewhere.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The work of social anthropologist Victor Turner has been influential in the study of Ezra-Nehemiah."), _c('a', {
    attrs: {
      "href": "#/#foot-note-853",
      "id": "footnote-853"
    }
  }, [_c('sup', [_vm._v("117")])]), _vm._v(" Scholars have applied his work on ritual, symbols, and root paradigms to Ezra-Nehemiah in an effort to see how the material logically resonates with social habits in other cultures. Frank Gorman explains that the purpose of ritual is to maintain or restore order in society; it “is a way of construing, actualizing, realizing, and bringing into being a world of meaning and ordered existence. Ritual is, thus, seen as a means of enacting one’s theology.”"), _c('a', {
    attrs: {
      "href": "#/#foot-note-852",
      "id": "footnote-852"
    }
  }, [_c('sup', [_vm._v("118")])]), _vm._v(" Ritual action emphasizes the norms and beliefs important to a society and thus keeps them alive for the group. Rituals such as the purification rites required in Ezra-Nehemiah emphasize the bond between the insiders of the group and their shared commitment to holiness as they define it. Ritual can also be a means of restoring order in society after norms have been breached in some way by disruptive actions. A good example of this is the guilt offering, which was brought by those confessing their wrongful intermarriage, as a ritual intended to repair the relationship of the community with its God (Ezra 10:19).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Donald Moffat applies Turner’s work on social drama to Ezra-Nehemiah. Turner illustrates social drama with a model of four phases (breach, mounting crisis, redressive action, and reintegration), and Moffat, with small changes based on the work of more recent social theorists, applies these phases to the crisis of Ezra’s community over intermarriage."), _c('a', {
    attrs: {
      "href": "#/#foot-note-851",
      "id": "footnote-851"
    }
  }, [_c('sup', [_vm._v("119")])]), _vm._v(" The breach was created by the intermarriage of members of the community with outsiders (Ezra 9:2). The breach became a crisis when the matter was handed over to Ezra, who responded publicly, treating the matter as a grave crisis and placing the community in a liminal state requiring ritual actions of mourning and prayer (Ezra 9:3–10a). Redressive action was initiated by the assembly, which evaluated each case of intermarriage, and included a ceremony of recommitment to the covenant. This redress included a sacrifice that also marked the reintegration of the offenders back into the community and the restoration of its relationship with Yahweh.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("To my mind, the success of a sociological approach to Ezra lies with the ability of the interpreter not only to create valid sociological paradigms but also to combine these constructions with sound biblical exegesis. For example, during the intermarriage crisis, the biblical writer uses special terms (e.g., "), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ə")]), _c('em', [_vm._v("hošib,")]), _vm._v(" “to settle,” and "), _c('em', [_vm._v("l")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ə")]), _c('em', [_vm._v("hô")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ṣ")]), _c('em', [_vm._v("î")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ʾ")]), _c('em'), _vm._v(", “to expel,” for marriage and divorce respectively) that carry sociological weight and indicate that there was indeed disagreement over the legitimacy of mixed marriages within this community.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Thus, a sociological perspective can bring into relief aspects of the text that would not be obvious in a traditional historical-critical approach. The cultic nature of the narrative—especially the marriage crisis and its reparation rituals—might be otherwise lost. Admittedly, a common complaint against social science methodology is that it tends to oversimplify and reduce the complexities of the biblical text to generalized social models. Nevertheless, with the caution that one should use social science paradigms as hypothetical models rather than as a substitute for textual data, the social science approach can be fruitful."), _c('a', {
    attrs: {
      "href": "#/#foot-note-850",
      "id": "footnote-850"
    }
  }, [_c('sup', [_vm._v("120")])]), _vm._v(" In many cases, because of the resonance of the text with the social dynamics of other communities, the sociological method challenges the reader to view the Ezra 9–10 crisis as heavily rooted in reality rather than as literary fiction.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "sec-5"
    }
  }, [_vm._v("V. PERSIAN RULE")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The Persians established an extensive empire that was larger than any of its predecessors in the Near East, along with an efficient organization to garnish taxes, draft soldiers, and conscript laborers. They did not consider foreign religions a threat unless they subverted the goals of the regime. Rather, they were a tool that provided a way to secure dominance and trust by supporting local culture.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-13"
    }
  }, [_vm._v("A. HISTORY VS. HISTORICITY")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The Persian period of Jewish history is admittedly one of the most elusive. Scholars often complain that the text of Ezra-Nehemiah has been accepted at face value and that difficulties in the text have too often been ignored."), _c('a', {
    attrs: {
      "href": "#/#foot-note-849",
      "id": "footnote-849"
    }
  }, [_c('sup', [_vm._v("121")])]), _vm._v(" Some doubt the coherence of the story completely."), _c('a', {
    attrs: {
      "href": "#/#foot-note-848",
      "id": "footnote-848"
    }
  }, [_c('sup', [_vm._v("122")])]), _vm._v(" Others recognize some history in the story but discount certain parts, especially its chronological framework."), _c('a', {
    attrs: {
      "href": "#/#foot-note-847",
      "id": "footnote-847"
    }
  }, [_c('sup', [_vm._v("123")])]), _vm._v(" The beneficence of the Persians, too, in financing the rebuilding of the temple and the restoration of its cult is surprising (Ezra 6:3–4), as is the remittance of taxes on the returning Jews."), _c('a', {
    attrs: {
      "href": "#/#foot-note-846",
      "id": "footnote-846"
    }
  }, [_c('sup', [_vm._v("124")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Nevertheless, scholars agree that Ezra-Nehemiah is the main source for information regarding Jewish experience in this era. Several texts from the Achaemenid period support its historical value. For example, Near Eastern documents attest to an imperial concern for the continuance of local cults as long as the adherents prayed for the royal family."), _c('a', {
    attrs: {
      "href": "#/#foot-note-845",
      "id": "footnote-845"
    }
  }, [_c('sup', [_vm._v("125")])]), _vm._v(" In addition, the Persepolis Fortification Tablets (PFT) reveal a strong correspondence to Ezra-Nehemiah in terms of support for local religion. Williamson points out PFT 40: “Here we have Persian, Elamite and Babylonian gods all being honoured by their separate devotees within a circumscribed area, and all being supported equally by funds from the imperial treasury. Viewed in this light, the addition of another god to whatever list may have been supported by the treasury of ‘Beyond the River,’ specifying the quantities to be supplied, need have surprised nobody.”"), _c('a', {
    attrs: {
      "href": "#/#foot-note-844",
      "id": "footnote-844"
    }
  }, [_c('sup', [_vm._v("126")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Williamson also discusses parallels between the PFT and Ezra-Nehemiah in the area of accounting for and delivery of goods. He notes the minute accounting of goods (sometimes with inaccurate tabulations) to be used in various cults and their method and schedule of delivery to particular religious officials. According to the PFT, a leader of a group of travelers, authorized by a royal official, would draw out daily rations from one of the supply stations along his route. The official at the station would record the debit and send the document to Persepolis for a refund. There, the debit would have been applied to the account of the official who had authorized the travel leader and the account of the waystation would have been resupplied."), _c('a', {
    attrs: {
      "href": "#/#foot-note-843",
      "id": "footnote-843"
    }
  }, [_c('sup', [_vm._v("127")])]), _vm._v(" Williamson concludes that these supply stations must have been a single day’s journey apart along the major imperial highways.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In the discussion of biblical historiography, one does well to remember that the biblical books were written by authors who worked with layers of traditions and, as M. Jaffee notes, they “regarded themselves as mere ‘arrangers’ or ‘retellers’ who organized and recounted what they had received as ancient tradition.”"), _c('a', {
    attrs: {
      "href": "#/#foot-note-842",
      "id": "footnote-842"
    }
  }, [_c('sup', [_vm._v("128")])]), _vm._v(" The worldview of the narrative is apparent throughout. The material is not archival but literary, and not only is this evident in the author’s selection of events, but his whole presentation is embedded in a particular ideology. In fact, the sources he uses also reveal particular agendas."), _c('a', {
    attrs: {
      "href": "#/#foot-note-841",
      "id": "footnote-841"
    }
  }, [_c('sup', [_vm._v("129")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Faithful readers of Ezra-Nehemiah do not need to despair over discrepancies that exist in the text—for example, the inaccurate numbers in the lists of Ezra 2 and Neh 7. This work was considered sacred by the Jews not because it was perfect in the sense of lacking any error, however small, but because it was believed to carry divinely inspired traditions that could sustain the faith and life of their community. Indeed, the inclusion of frail human beings, however devoted, in the transmission of material, however sacred, introduces an imperfect element into the process.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-parab"
  }, [_vm._v("Thus, the goal here is to utilize all of the available data to present as complete a picture of Jewish history during this period as possible. To this end, the major sources available are as follows:"), _c('a', {
    attrs: {
      "href": "#/#foot-note-840",
      "id": "footnote-840"
    }
  }, [_c('sup', [_vm._v("130")])])]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "t-header"
  }, [_vm._v("Category")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-header"
  }, [_vm._v("Sources")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid47-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Hebrew Bible")])]), _vm._v(" "), _c('td', {
    staticClass: "wid47-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ezra-Nehemiah, Haggai, Zechariah, Esther, Malachi, parts of Isaiah and Chronicles")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid47-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Postbiblical Jewish Literature")])]), _vm._v(" "), _c('td', {
    staticClass: "wid47-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("1 Esdras, Judith, Tobit, Susanna, Josephus")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid47-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Greek Historians")])]), _vm._v(" "), _c('td', {
    staticClass: "wid47-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Herodotus, Xenophon, Pseudo-Scylax, Diodorus Siculus")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid47-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ancient Papyri")])]), _vm._v(" "), _c('td', {
    staticClass: "wid47-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Elephantine and Wadi Daliyeh papyri")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid47-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Epigraphic Documents")])]), _vm._v(" "), _c('td', {
    staticClass: "wid47-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Royal inscriptions (e.g., Nabonidus Chronicle, Cyrus Cylinder, Darius I inscriptions), clay tablets (e.g., PFT), ostraca")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid47-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Seals")])]), _vm._v(" "), _c('td', {
    staticClass: "wid47-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Seals, seal impressions on pottery, and bullae that sealed written papyri")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid47-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Numismatic Evidence")])]), _vm._v(" "), _c('td', {
    staticClass: "wid47-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Coins from Judah and Samaria")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para1"
  }, [_vm._v("With a sensitive handling of these sources, a sketch of the Jewish situation in Yehud under Persian rule begins to emerge.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-14"
    }
  }, [_vm._v("B. CYRUS II (559–530 BCE)")]), _vm._v(" "), _c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-7"
    }
  }, [_vm._v("1. The Conquests of Cyrus")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The narrative of Ezra 1–6 takes as its starting point the accession of Cyrus to the throne of Persia and his conquest of the Near East. Cyrus came from the Achaemenid family of kings, Achaemenes being his grandfather. In 559 BCE, Cyrus began to reign as king of Anshan, later called Persis, an area in the southern part of Media which can be identified with the plain of Marv Dasht in modern Iran. With the defection of the Median army from the tyrant king Astyages, Cyrus laid claim to the entire Median Empire in 550 BCE."), _c('a', {
    attrs: {
      "href": "#/#foot-note-839",
      "id": "footnote-839"
    }
  }, [_c('sup', [_vm._v("131")])]), _vm._v(" Cyrus moved eastward to conquer Croesus, king of Lydia, and gain control of the Greek cities of western Asia Minor along with various areas of central Asia and the Iranian plateau.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("With the north and west firmly under his control, Cyrus turned south to confront his strongest opponent, Babylonia. According to the Nabonidus Chronicle, a Babylonian text, the people hated their rulers, Nabonidus and his son, Bel-shar-usur (= Belshazzar, Dan 5:1), for their inefficient rule, and they welcomed Cyrus and his army into the city of Babylon. The Chronicle claims that Nabonidus hoarded various cult statues within the city, no doubt to protect the city, and that upon his accession, Cyrus returned these idols to their owners. The explanation for Cyrus’s conquest of Babylonia propagated by the Cyrus Cylinder, a first-person proclamation attributed to Cyrus himself, is even more dramatic. According to this text, the gods appointed Cyrus to take over the nation because of the current rulers’ neglect of the cult of Marduk:")]), _vm._v(" "), _c('p', {
    staticClass: "quotes_bq"
  }, [_vm._v("Marduk … scanned and looked (through) all the countries, searching for a righteous ruler willing to lead him (i.e., Marduk) (in the annual procession). (Then) he pronounced the name of Cyrus, king of Anshan, declared him … to be(come) the ruler of all the world. ("), _c('em', [_vm._v("ANET")]), _vm._v(", 315)")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("According to these texts, both the people of Babylonia and their chief god endorsed Cyrus’s rule over their country.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("According to both the Cyrus Cylinder and the Nabonidus Chronicle, the conquest of Babylon (539 BCE) was peaceful. This is also the impression of the Greek historians (Xenophon, "), _c('em', [_vm._v("Cyropaedia")]), _vm._v(" 1.1.4; see Diodorus Siculus 9.24). On the other hand, these sources may attest to the power of Persian propaganda, since Nabonidus had built up troops to withstand the Persians at the Tigris River, and Cyrus not only conquered but massacred a host of these soldiers."), _c('a', {
    attrs: {
      "href": "#/#foot-note-838",
      "id": "footnote-838"
    }
  }, [_c('sup', [_vm._v("132")])]), _vm._v(" In any case, Cyrus’s triumphant procession into the city sealed the claim of Persian ownership.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Persian conquest of Babylon was undertaken during a Babylonian festival. Daniel describes the sudden death of Belshazzar and defeat of the Babylonian Empire after a banquet for one thousand guests, who observed an unattached hand write a prophecy of doom on the walls of the chamber (Dan 5:1–30). Greek historians confirm this view. Xenophon says the Persians attacked during a night-long festival of drinking and debauchery ("), _c('em', [_vm._v("Cyropaedia")]), _vm._v(" 7.5.15). Herodotus adds:")]), _vm._v(" "), _c('p', {
    staticClass: "quotes_bq"
  }, [_vm._v("The Babylonians themselves say that owing to the great size of the city the outskirts were captured without the people in the centre knowing anything about it; there was a festival going on, and even while the city was falling they continued to dance and enjoy themselves, until hard facts brought them to their senses. ("), _c('em', [_vm._v("Histories")]), _vm._v(" 1.191)")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("With the takeover of Babylon, the entire Transeuphrates region soon surrendered to the Persians. The Cylinder proclaims,")]), _vm._v(" "), _c('p', {
    staticClass: "quotes_bq"
  }, [_vm._v("All the kings of the entire world from the Upper [Mediterranean] Sea to the Lower Sea [Persian Gulf], those who are seated in throne rooms, all the kings of Amurru living in tents, brought their heavy tribute and kissed my feet in Babylon.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Cyrus created a huge satrapy that included Babylonia and the Transeuphrates.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-8"
    }
  }, [_vm._v("2. The Jews under Cyrus’s Rule")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Under Cyrus, Jews taken captive from the time of Nebuchadrezzar (= Nebuchadnezzar) King of Babylon in 586/587 BCE were now given the opportunity to return to Yehud and restore their traditional religion and form of local government. According to Ezra-Nehemiah, it was Yahweh himself who “stirred up the heart of Cyrus” to allow the exiled Jews to return to Jerusalem and rebuild their temple (Ezra 1:1).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The recent discovery of fifty-one tablets in a rural area near Nippur confirms that there was a Jewish presence in Babylonia during the sixth century BCE. The name of the town was called Al-Yahadu, “Judahtown,” giving evidence of the people’s identification with their Jewish homeland although on foreign soil. In addition, of the four hundred names on the tablets, over one-third carry Yahwistic features (see "), _c('span', {
    attrs: {
      "href": "#/012_Chapter02a#exc2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excursus 2, “Bloodlines,” pp. 137–41")]), _vm._v(")."), _c('a', {
    attrs: {
      "href": "#/#foot-note-837",
      "id": "footnote-837"
    }
  }, [_c('sup', [_vm._v("133")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Cyrus Cylinder reveals that restoration of captives and their sanctuaries was not restricted to the Jews but applied to other foreign exiles as well:")]), _vm._v(" "), _c('p', {
    staticClass: "quotes_bq"
  }, [_vm._v("I returned to (these) sacred cities on the other side of the Tigris [i.e., to the east], the sanctuaries of which have been ruins for a long time, the images which (used) to live therein and established for them permanent sanctuaries. I (also) gathered all their (former) inhabitants and returned (to them) their habitations. Furthermore, I resettled upon the command of Marduk, the great lord, all the gods of Sumer and Akkad whom Nabonidus has brought into Babylon to the anger of the lord of the gods, unharmed, in their (former) chapels, the places which make them happy. ("), _c('em', [_vm._v("ANET")]), _vm._v(", 315–16)")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Although the Persians were adherents of Ahura Mazda, the god of Zoroastrianism, Cyrus not only allowed foreign captives to return to their homelands, but he even helped to finance the restoration of gods and temples. In return, he asked that the various peoples pray for him: “May all the gods whom I have resettled in their sacred cities ask daily Bel and Nebo for a long life for me” ("), _c('em', [_vm._v("ANET")]), _vm._v(", 316). In the case of the Jews, who had no images, Cyrus restored the valuable temple vessels, stolen by the Babylonians, to the returning exiles (Ezra 1) and subsidized the temple rebuilding along with its cult (Ezra 1:1–4; 6:3–5; cf. Ezra 7:23b). This policy of religious support was certainly unique in the ancient world, where gods boasted of vanquishing other gods in battle."), _c('a', {
    attrs: {
      "href": "#/#foot-note-836",
      "id": "footnote-836"
    }
  }, [_c('sup', [_vm._v("134")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The prophets extol Cyrus as the Jews’ deliverer, even their “messiah” (i.e., “anointed one,” Isa 45:1), an agent of God’s plan to restore Israel to her homeland: “He is my [Yahweh’s] shepherd and shall fulfill my purpose fully” (Isa 44:28a; cf. 45:4). Nowhere in Scripture do the exilic or postexilic prophets pronounce judgment on the Persian Empire."), _c('a', {
    attrs: {
      "href": "#/#foot-note-835",
      "id": "footnote-835"
    }
  }, [_c('sup', [_vm._v("135")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Jews returning from exile were not simply adventurers looking for another chance at life, but, like Cyrus, were stirred by the Spirit, in their case to make the long trek to a neglected homeland (Ezra 1:5). These Jews had maintained a fervent hope for the future that was fueled by their prophets. Just as the fall of Jerusalem was predicted, so was a return to the homeland and a brighter future for the faithful remnant (Jer 3:14–17; 23:3–8; 30:1–33:26; Ezek 34:11–16; 36–37).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Many of the returnees were not poor. They brought servants and animals with them and made sizeable contributions to the religious services (Ezra 2:65–69; 8:26; Neh 7:67–72). At the same time, as Josephus says, “Many remained in Babylon, being unwilling to leave their possessions” ("), _c('em', [_vm._v("Antiquities")]), _vm._v(" 11.8–9, tr. Marcus, LCL). The Murashu tablets, 730 business records from the time of Artaxerxes I and Darius II, tell of Murashu and his sons, who were bankers and brokers. They are said to have “loaned out almost anything for a price.” Approximately sixty Jewish names are listed among their customers in the roles of “contracting parties, agents, witnesses, collectors of taxes, and royal officials.”"), _c('a', {
    attrs: {
      "href": "#/#foot-note-834",
      "id": "footnote-834"
    }
  }, [_c('sup', [_vm._v("136")])]), _vm._v(" These cuneiform tablets were found near Nippur, sixty miles southeast of Babylon near the Kebar River, an area that the prophet Ezekiel identified as the settlement of the Jewish exiles (Ezek 1:1).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Upon their arrival in Jerusalem, the returnees, under the leadership of Sheshbazzar, succeeded by Zerubbabel, began to resettle their homes and rebuild the temple. The land had been devastated by the earlier Babylonian conquest, and according to some archaeologists, left half empty by the deportations."), _c('a', {
    attrs: {
      "href": "#/#foot-note-833",
      "id": "footnote-833"
    }
  }, [_c('sup', [_vm._v("137")])]), _vm._v(" Accordingly, the revitalization of the ancient capital took years as the population strove to overcome economic and social challenges.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("At first, the local population, seeing the authority and resources available to the newcomers, asked to help with the building project (Ezra 4:2). However, the returning Jews, who had renounced idolatry during the exile and recognized it as the reason for the captivity in the first place, were wary of any pagan influences. Apparently, they did not regard the religion of their neighbors to be pure. Even though the locals argued that they worshiped the same God as the returnees, Zerubbabel and the other leaders refused to let these "), _c('em', [_vm._v("adversaries")]), _vm._v(" join in the rebuilding project (Ezra 4:1–3), probably due to their religious syncretism. The returning Jews had retained their ethnic and cultural identity throughout the exile, and they were unwilling to place it at risk now by allowing a different “Israel” into their ranks."), _c('a', {
    attrs: {
      "href": "#/#foot-note-832",
      "id": "footnote-832"
    }
  }, [_c('sup', [_vm._v("138")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The local Israelites who had maintained continuous residence in Yehud since preexilic times had mixed with other peoples brought in by the Assyrians from foreign lands, and this created a mixture of both ethnicity and culture (2 Kgs 17:25–33). Their claim to worship the same God as the returnees has some validity, although their mixed identity would undoubtedly have produced a mixture of religious traditions as well. According to Jeremiah, the locals continued to visit the temple site after its destruction by the Babylonians and offer sacrifices there (Jer 41:4–8)."), _c('a', {
    attrs: {
      "href": "#/#foot-note-831",
      "id": "footnote-831"
    }
  }, [_c('sup', [_vm._v("139")])]), _vm._v(" Nevertheless, there is ample evidence of the tendency of ancient Israel to religious syncretism, a criticism of many of the prophets of the past (e.g., 1 Sam 7:3; Jer 44:15–19; Ezek 8:14–16). Archaeological and epigraphical evidence in preexilic Palestine reveal different forms of Yahwisms, from an aniconic monotheism to a Yahwism that included a female consort."), _c('a', {
    attrs: {
      "href": "#/#foot-note-830",
      "id": "footnote-830"
    }
  }, [_c('sup', [_vm._v("140")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Papyri from Wadi Daliyeh and Elephantine evince a diluted Yahwism in these communities during the Persian period. The Wadi Daliyeh papyri, mainly legal documents and letters in Aramaic dating from 375 to 335 BCE, were found in a cave north of Jericho, where they were apparently left by Samaritan refugees fleeing Alexander’s army. The names recorded in these texts reflect some version of Yahwism."), _c('a', {
    attrs: {
      "href": "#/#foot-note-829",
      "id": "footnote-829"
    }
  }, [_c('sup', [_vm._v("141")])]), _vm._v(" They occur with various combinations of pagan gods, as Frank Cross has noted, including Qos (Edomite), Sahar (Aramaic), Kemosh (Moabite), Ba‘al (Phoenician), and Nabu (Baylonian)."), _c('a', {
    attrs: {
      "href": "#/#foot-note-828",
      "id": "footnote-828"
    }
  }, [_c('sup', [_vm._v("142")])]), _vm._v(" The conflict of religion between the returnees and the local Samarians came to a head by the end of the fourth century BCE, when there is clear archaeological evidence of a temple in Samaria on Mt. Gerizim (2 Macc 6:2; Sir 50:25–26; cf. Josephus, "), _c('em', [_vm._v("Antiquities")]), _vm._v(" 11.8; see "), _c('span', {
    attrs: {
      "href": "#/014_Chapter03a#exc12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excursus 12, “Samarians and Samaritans,” pp. 294–96")]), _vm._v(")."), _c('a', {
    attrs: {
      "href": "#/#foot-note-827",
      "id": "footnote-827"
    }
  }, [_c('sup', [_vm._v("143")])]), _vm._v(" Also, the names of the Jewish colonists at Elephantine often contained abbreviations of both pagan and Hebrew deities, and there is reference to the worship of both Yahu (Yahweh) and the Egyptian god Khnum."), _c('a', {
    attrs: {
      "href": "#/#foot-note-826",
      "id": "footnote-826"
    }
  }, [_c('sup', [_vm._v("144")])]), _vm._v(" Thus, it is not too surprising that the returning Jewish exiles insisted on separating themselves from the local population and maintaining the purity of their traditions (Ezra 4:3; cf. Neh 2:20).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The economic situation of the local population is hard to ascertain. For sure, the Babylonian conquest of the early sixth century BCE had left a devastated community, which was subject to looting, rape, and starvation (see Lam 5:1–18). The puppet governor, Gedaliah, was soon assassinated, and political chaos reigned for a while. During this period, the province of Samaria to the north probably increased in power over its Judean counterpart."), _c('a', {
    attrs: {
      "href": "#/#foot-note-825",
      "id": "footnote-825"
    }
  }, [_c('sup', [_vm._v("145")])]), _vm._v(" A few hundred Samarian coins, as well as bullae, have come to light from the city of Samaria, and these together with the Wadi Daliyeh papyri reveal a wealthy community in Samaria under Persian rule."), _c('a', {
    attrs: {
      "href": "#/#foot-note-824",
      "id": "footnote-824"
    }
  }, [_c('sup', [_vm._v("146")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The returning Jews experienced opposition in various ways and eventually stopped work on the temple. First, when they were rebuffed from participating in the project, the local Samarians became antagonistic. Second, the heavy taxes of the Persian government drained their finances (see the commentary on Ezra 4:13). Not only the emperor but the governors taxed the people (Neh 5:15; cf. Mal 1:8). This pressure, as well as the difficulty of surviving a drought, which Haggai states was divine punishment for their skewed priorities (Hag 1:2–11), soon brought discouragement to the returnees and eventually a standstill to the temple project until the reign of Darius I.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-15"
    }
  }, [_vm._v("C. DARIUS I (522–485 BCE)")]), _vm._v(" "), _c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-9"
    }
  }, [_vm._v("1. The Reign of Darius I")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("After Cyrus and Cambyses, his son, had expanded the empire to include Egypt, the family almost lost control of the empire. Nevertheless, Darius I, who descended from a different branch of the Achaemenids, was able to gain control of the throne and put to death the usurper Gaumata and his followers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The iron fist of Darius’s rule is legendary. The Behistun Inscription, a tri-lingual account of Darius’s military exploits, is etched into a rock cliff overlooking the main trade route between Mesopotamia and Persia. At the top of the inscription, a representation of the Zoroastrian god Ahura Mazda endorses the titulare of Darius: “I am Darius the Great King, King of Kings, King in Persia, king of countries, the son of Hystaspes, grandson of Arsames, an Achaemenian.” The inscription depicts Darius facing a line of subject kings tied together by a rope behind Gaumata, who is lying on his back. Darius, standing about 50 percent taller than these “liar kings,” rests his foot on Gaumata’s stomach.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Darius I was an accomplished king, and under his rule the Persian Empire reached its zenith. Darius was noted for the efficient organization of his empire, which was divided into twenty satrapies, or large administrative districts."), _c('a', {
    attrs: {
      "href": "#/#foot-note-823",
      "id": "footnote-823"
    }
  }, [_c('sup', [_vm._v("147")])]), _vm._v(" The duties of the satrap, the officer in charge of the satrapy, were to maintain order, extend Persian power, draft an army as needed, and collect tribute and gifts."), _c('a', {
    attrs: {
      "href": "#/#foot-note-822",
      "id": "footnote-822"
    }
  }, [_c('sup', [_vm._v("148")])]), _vm._v(" In his efforts to establish and maintain control of the empire, Darius placed imperial troops under the authority of royal inspectors, who checked on the satraps and reported directly to him. The Greeks called these officers the king’s “Eye” and “Ear” (Herodotus, "), _c('em', [_vm._v("Histories")]), _vm._v(" 1.114; Xenophon, "), _c('em', [_vm._v("Cyropaedia")]), _vm._v(" 8.2.10–12).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Taxes are a difficult issue to analyze. The imperial account is one of moderation, but the Greek historians complain that they were an unbearable burden that reduced the Greeks (and others) to slaves."), _c('a', {
    attrs: {
      "href": "#/#foot-note-821",
      "id": "footnote-821"
    }
  }, [_c('sup', [_vm._v("149")])]), _vm._v(" Subject peoples were obliged to pay imperial taxes as well as providing hospitality for the king and his troops. Herodotus describes it so:")]), _vm._v(" "), _c('p', {
    staticClass: "quotes_bq"
  }, [_vm._v("Apart from the normal tribute, the whole Persian empire is divided into regions for the purpose of furnishing supplies for the king and his army, and for four months out of the twelve the supplies come from the Babylonian territory, the whole of the rest of Asia being responsible for the remaining eight."), _c('a', {
    attrs: {
      "href": "#/#foot-note-820",
      "id": "footnote-820"
    }
  }, [_c('sup', [_vm._v("150")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Evidence of Jews paying taxes in kind comes from a jar from Yehud found in Babylon with the stamp, "), _c('em', [_vm._v("l")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ḥ")]), _c('em', [_vm._v("nwnh yhwd")]), _vm._v(" (“belonging to "), _c('span', {
    staticClass: "chari-r"
  }, [_vm._v("Ḥ")]), _vm._v("anûnā, Yehûd”), similar to one for tribute from the governor in Byblos."), _c('a', {
    attrs: {
      "href": "#/#foot-note-819",
      "id": "footnote-819"
    }
  }, [_c('sup', [_vm._v("151")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In addition to imperial taxes, the satrap imposed taxes for the upkeep of his own house and entourage. The “Satrap’s table” was the food tax for the satrap. Plutarch says that the reason for a certain satrap’s rebellion was that he did not receive enough for his daily meals ("), _c('em', [_vm._v("Artaxerxes")]), _vm._v(" 4.1). Herodotus states that the Satrap of Babylonia received 800 stallions and 16,000 brood mares and numerous Indian dogs, but the most coveted position was that of the Satrap of Assyria ("), _c('em', [_vm._v("Histories")]), _vm._v(" 1.192)."), _c('a', {
    attrs: {
      "href": "#/#foot-note-818",
      "id": "footnote-818"
    }
  }, [_c('sup', [_vm._v("152")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The satrapies were divided into provinces that could be run by local governors who also demanded tribute."), _c('a', {
    attrs: {
      "href": "#/#foot-note-817",
      "id": "footnote-817"
    }
  }, [_c('sup', [_vm._v("153")])]), _vm._v(" Xenophon says the Persians never sent a Persian governor into Cilicia and Cyprus but were always happy with the local governors (Xenophon, "), _c('em', [_vm._v("Cyropaedia")]), _vm._v(" 7.4.2). This appears to be the case also with Zerubbabel and Nehemiah. It is noteworthy that Nehemiah disclaims his right for this support and instead feeds 150 laborers at his own expense (Neh 5:14–18). Darius also promoted the function of local governments and published a decree that the Egyptians write their laws down."), _c('a', {
    attrs: {
      "href": "#/#foot-note-816",
      "id": "footnote-816"
    }
  }, [_c('sup', [_vm._v("154")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Persians were not so magnanimous as to allow locals to rule without imperial interference, and, of course, they could not decide an issue contrary to the wishes of the satrap. Even temples were not self-governing, but the Persians utilized them as sources of satrapal income. They functioned not only as religious shrines but as locally validated economic centers for the collection of goods and taxes throughout the empire. According to L. Fried, “Except in special cases, priests were available as corvée labor anywhere in the realm.”"), _c('a', {
    attrs: {
      "href": "#/#foot-note-815",
      "id": "footnote-815"
    }
  }, [_c('sup', [_vm._v("155")])]), _vm._v(" The satrap, and even a governor, could control the appointment of a high priest. Josephus reports that the priest Yohanan murdered his brother Yeshua because Bagoses (= Bagohi or Bagavahya), the governor of Yehud, promised Yeshua the high priesthood ("), _c('em', [_vm._v("Antiquities")]), _vm._v(" 11.297).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Both satraps and governors commanded garrisons of soldiers. This is clear from data from Babylon, Egypt, and Asia Minor but also from the text of Nehemiah. “King’s men” were sent with Nehemiah to man the citadel of Jerusalem (Neh 2:9)."), _c('a', {
    attrs: {
      "href": "#/#foot-note-814",
      "id": "footnote-814"
    }
  }, [_c('sup', [_vm._v("156")])]), _vm._v(" According to Carter, there were fifteen Persian garrisons and administrative centers in Yehud."), _c('a', {
    attrs: {
      "href": "#/#foot-note-813",
      "id": "footnote-813"
    }
  }, [_c('sup', [_vm._v("157")])]), _vm._v(" Nehemiah placed his brother Hanani over the garrison in Jerusalem (Neh 7:2). Fried claims that, under Nehemiah, the populace at large was not armed but only the Persians whom he brought with him (Neh 4:16–23[10–17])."), _c('a', {
    attrs: {
      "href": "#/#foot-note-812",
      "id": "footnote-812"
    }
  }, [_c('sup', [_vm._v("158")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Darius also standardized the money of the empire and introduced coinage with the royal image."), _c('a', {
    attrs: {
      "href": "#/#foot-note-811",
      "id": "footnote-811"
    }
  }, [_c('sup', [_vm._v("159")])]), _vm._v(" He was interested in exploration and expanded the empire into India in the east and dug a canal from the Red Sea to the Nile to facilitate trade with his southwestern frontier, Egypt. By the fourth century BCE, Yehud had a fair amount of autonomy and even created its own money system. Archaeologists have found a large number of coins and seal impressions inscribed with the word “Yehud.”"), _c('a', {
    attrs: {
      "href": "#/#foot-note-810",
      "id": "footnote-810"
    }
  }, [_c('sup', [_vm._v("160")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Another important achievement of the Persians was a, by ancient standards, state-of-the-art transportation and communication system. Royal roads were marked in stages with postal stations, inns, and storehouses."), _c('a', {
    attrs: {
      "href": "#/#foot-note-809",
      "id": "footnote-809"
    }
  }, [_c('sup', [_vm._v("161")])]), _vm._v(" The Via Maris, the main road running north-south along the coast of Palestine, was dotted with forts and granaries for the needs of the Persian administration. A system of aural and visual relays provided additional communication across parts of the empire. The common language of Aramaic was standardized throughout the Persian Empire."), _c('a', {
    attrs: {
      "href": "#/#foot-note-808",
      "id": "footnote-808"
    }
  }, [_c('sup', [_vm._v("162")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("An official east-west road from Susa to Sardis connected 1,677 post offices. According to Herodotus, the royal mail took only one week from anywhere in the empire on swift horses (see the king’s “mounted couriers riding swift horses,” Esth 8:10); commoners were served by a slower system. The inscription on the General Post Office building in New York City (now renamed the James A. Farley Building) “Neither snow nor rain nor heat nor gloom of night stays these couriers from the swift completion of their appointed rounds” is taken from Herodotus’s description of the Persian mail service (Herodotus, "), _c('em', [_vm._v("Histories")]), _vm._v(" 8.98: “These are stopped neither by snow nor rain nor heat nor darkness from accomplishing their appointed course with all speed” [Godley, LCL]). On the royal roads, the king’s men were expected to protect travelers and goods and enforce severe laws against robbers."), _c('a', {
    attrs: {
      "href": "#/#foot-note-807",
      "id": "footnote-807"
    }
  }, [_c('sup', [_vm._v("163")])]), _vm._v(" In the same vein, Xenophon claims that Cyrus the Younger ensured safe travel throughout the realm by punishing robbers with the excision of hands, feet, or eyes (Xenophon, "), _c('em', [_vm._v("Anabasis")]), _vm._v(" 1.9.13).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Persian policy encouraged local populations to codify and practice their own laws and customs as long as they did not interfere with the administration of the Persian government. Once local laws were given the status of royal law, they could be implemented with the authority and muscle of the empire. Udjahorresnet, for example, says he was sent back to Egypt to put its scribal system in order (Inscription of Udjahorresnet 7). About 519 BCE, Darius ordered his satrap in Egypt to assemble Egyptian sages (priests, warriors, and scribes) to collect all the old laws of Egypt from the time of Pharaoh Amasis’s forty-fourth year, 526 BCE, the time of the Achaemenid conquest. This was done in two copies, Aramaic and demotic. The text distinguishes “public,” “temple,” and “private” law."), _c('a', {
    attrs: {
      "href": "#/#foot-note-806",
      "id": "footnote-806"
    }
  }, [_c('sup', [_vm._v("164")])]), _vm._v(" Thus, Darius I funded the codification of a province’s laws, making local customs official rather than micro-managing the provinces by imposing his own traditions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Darius is also famous as a master builder. He is responsible for the reconstruction of Susa as well as the new capital at Persepolis while continuing to maintain the older capitals of Pasargadae, Babylon, and Ecbatana."), _c('a', {
    attrs: {
      "href": "#/#foot-note-805",
      "id": "footnote-805"
    }
  }, [_c('sup', [_vm._v("165")])]), _vm._v(" Inscriptions and art on his buildings attempt to confirm the overall imperial image of Darius as beneficent, restoring order, building up cities, pacifying quarrelsome peoples, and, in general, maintaining the "), _c('em', [_vm._v("pax persica.")]), _vm._v(" Most importantly, these edifices attest to Darius’s autocratic status as the “king of kings” who commands unquestioning loyalty, service, and tribute from his subjects."), _c('a', {
    attrs: {
      "href": "#/#foot-note-804",
      "id": "footnote-804"
    }
  }, [_c('sup', [_vm._v("166")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Darius was instrumental in preserving and restoring temples throughout his empire. He provided the operating income not only for the Jerusalem temple but for various Egyptian temples which he had rebuilt."), _c('a', {
    attrs: {
      "href": "#/#foot-note-803",
      "id": "footnote-803"
    }
  }, [_c('sup', [_vm._v("167")])]), _vm._v(" According to Udjahorresnet, “His Majesty did this … to preserve the names of all the gods, their temples, the income from their "), _c('em', [_vm._v("wakf")]), _vm._v(" properties, and the observances of their festivals, for all time” (Inscription of Udjahorresnet 7)."), _c('a', {
    attrs: {
      "href": "#/#foot-note-802",
      "id": "footnote-802"
    }
  }, [_c('sup', [_vm._v("168")])]), _vm._v(" The classical sources note Darius’s respect of Egyptian shrines and customs in contrast to the damage done to them by his predecessor, Cambyses (e.g., Diodorus Siculus 1.95.5)."), _c('a', {
    attrs: {
      "href": "#/#foot-note-801",
      "id": "footnote-801"
    }
  }, [_c('sup', [_vm._v("169")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Darius’s many reconstructions of sacred sites served a political end as well. The emperor could be included in the local cult in some way and thereby reinforce his honor and authority."), _c('a', {
    attrs: {
      "href": "#/#foot-note-800",
      "id": "footnote-800"
    }
  }, [_c('sup', [_vm._v("170")])]), _vm._v(" Darius’s image figures prominently among the artistic representations of the Egyptian gods, even as the pharaoh of Egypt, and thus Persian imperial power penetrated into Egyptian religion and was reinforced at every level of the population. The goddess Neith is portrayed as nursing the young Darius; Isis embraces him, and Hathor holds him by the arms. In another place, Mut nurses Darius, conferring upon him divine status.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-10"
    }
  }, [_vm._v("2. The Jews under Darius I")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("During the time of Darius the Great, God called the prophets Haggai and Zechariah to encourage the people to take up the task of rebuilding the temple once again (Ezra 5:1). Cutting through indifference and discouragement, Haggai accuses the people of managing to build their own houses while leaving God’s house in ruins (Hag 1:4). The Jews took up the challenge, and in a matter of weeks the foundations of the new house were laid and some kind of dedication service conducted (Hag 1:14–2:3). The rebuilding effort of the Jewish temple was not without opposition. Tattenai, a local authority, demanded to see a building permit and a list of the names of the workers (Ezra 5:3–4)."), _c('a', {
    attrs: {
      "href": "#/#foot-note-799",
      "id": "footnote-799"
    }
  }, [_c('sup', [_vm._v("171")])]), _vm._v(" After investigating the matter, Darius I found the original edict of Cyrus authorizing the work, and he not only allowed the work to go forward but subsidized it out of the royal treasury.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("According to John Berquist, Darius mandated the construction of the temple and paid for it not only as a religious center but as a “base of operations for the political administration (cf. Neh 13); and it would also serve as storage for grain.”"), _c('a', {
    attrs: {
      "href": "#/#foot-note-798",
      "id": "footnote-798"
    }
  }, [_c('sup', [_vm._v("172")])]), _vm._v(" This would meet his need for food and supplies as he was bringing his army through the area on its way to Egypt in 519 BCE. Whatever the imperial reasoning, it was providential for the Jews who lived in Jerusalem. Darius not only supplied authorization for the temple’s continued rebuilding; he also provided operating expenses for the cult. According to Ezra-Nehemiah, he asked only that the Jews pay tribute to him and pray for the protection of his family (Ezra 6:6–12). Work on the temple was begun in 520 BCE and completed by March 515 BCE, and the Jews immediately celebrated the Passover on its completion.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Darius I apparently respected the rights of sacred personnel and did not, as a rule, subject them to taxation. In the Letter of Darius to Gadatas, one of the royal gardeners in charge of a park close to Magnesia on the Maeander (an ancient city on the west coast of modern Turkey), Darius commends Gadatas for his horticulture but accuses him of subjecting the sacred gardeners of Apollo to tribute and to work on profane lands. Apparently, the royal garden of which Gadatas was in charge abutted a Greek sanctuary and Gadatas took advantage of the sacred gardeners. The document is an example of the fiscal immunity of sanctuaries and cultic personnel under the Persians (see also Ezra 7:24; Neh 2:8)."), _c('a', {
    attrs: {
      "href": "#/#foot-note-797",
      "id": "footnote-797"
    }
  }, [_c('sup', [_vm._v("173")])]), _vm._v(" This was probably not just Persian strategy or beneficence at work, for the sanctuary and its priests played a role in the collection of revenue for the treasury of the king."), _c('a', {
    attrs: {
      "href": "#/#foot-note-796",
      "id": "footnote-796"
    }
  }, [_c('sup', [_vm._v("174")])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-16"
    }
  }, [_vm._v("D. ARTAXERXES I (465–424 BCE)")]), _vm._v(" "), _c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-11"
    }
  }, [_vm._v("1. Artaxerxes Longimanus I")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Artaxerxes I, son of Xerxes, came to power in the mid-fifth century BCE. He was called Longimanus (“Long-handed”) because his right hand was longer than his left. Plutarch describes him as a man of a “gentle and noble spirit” ("), _c('em', [_vm._v("Artaxerxes")]), _vm._v(" 1.1). Artabanus, Xerxes’s vizier, had assassinated the king and tried to take over the government, but the plot failed. Although he was not Xerxes’s eldest son and heir, Artaxerxes managed to take the throne.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Like his predecessors, Artaxerxes had to deal with revolts against his rule in various parts of his large empire. His brother, Hystaspes, for example, instigated a revolt in Bactria; and Inarus, a Libyan aided by a large Athenian fleet, instigated an Egyptian uprising. The Persians persisted for four years in a war against the Athenians (459–454 BCE), and under the leadership of Megabyzus they finally trapped and destroyed the Athenian fleet. Later, however, Megabyzus himself supposedly revolted, but the king granted him pardon."), _c('a', {
    attrs: {
      "href": "#/#foot-note-795",
      "id": "footnote-795"
    }
  }, [_c('sup', [_vm._v("175")])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-12"
    }
  }, [_vm._v("2. Artaxerxes and Ezra")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Ezra, a Jewish priest and scribe living in exile, was given permission by Artaxerxes I in 458 BCE to travel to the province of Yehud and teach the inhabitants the law of Yahweh. It may have been due to the difficulty of maintaining Persian control at the western end of the empire, and especially to trouble holding onto Egypt, that Artaxerxes supported Ezra’s journey to Yehud. It is worthy of note that in their report to the king, the enemies of the Jews accuse them of sedition and rebellion (Ezra 4:7–23). By endorsing a Jewish leader in Yehud, the Persians may have hoped to secure a loyal buffer state on the border of Egypt."), _c('a', {
    attrs: {
      "href": "#/#foot-note-794",
      "id": "footnote-794"
    }
  }, [_c('sup', [_vm._v("176")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The biblical sources paint a bleak picture of the local population in Yehud at this time. The region had not recovered from the destruction, depopulation, and loss of the upper echelons of society, including skilled artisans, that occurred during the Babylonian invasions. This negative situation was compounded for the mostly agrarian society by several bad harvests and droughts (Hag 1:6–11; 2:16–17). Economically, the empire was on the decline beginning with the reign of Xerxes. Taxes increased throughout the empire, except on Persians, as focus remained fixed on the Greek wars, and taxes were a burden in Yehud."), _c('a', {
    attrs: {
      "href": "#/#foot-note-793",
      "id": "footnote-793"
    }
  }, [_c('sup', [_vm._v("177")])]), _vm._v(" The Judeans engaged in trade with surrounding areas, selling olives and oil, but were at times forced to borrow at excessive interest rates, to mortgage their farms, and even to sell their children (Neh 5:3–5)."), _c('a', {
    attrs: {
      "href": "#/#foot-note-792",
      "id": "footnote-792"
    }
  }, [_c('sup', [_vm._v("178")])]), _vm._v(" Like the Greek descriptions, Ezra-Nehemiah portrays the people as “slaves” (Neh 9:36–37) of rulers who caused them great distress.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Approximately three thousand to five thousand Jews returned with Ezra to the land of their ancestors in the seventh year of Artaxerxes I. Ezra held the authority of the Persian crown to establish Jewish law in the province, and he was also given provisions for sacrifices at the temple."), _c('a', {
    attrs: {
      "href": "#/#foot-note-791",
      "id": "footnote-791"
    }
  }, [_c('sup', [_vm._v("179")])]), _vm._v(" Similar to Udjahorresnet in Egypt, Ezra is told:")]), _vm._v(" "), _c('p', {
    staticClass: "quotes_bq"
  }, [_vm._v("And as for you, Ezra, according to the wisdom of your God which you possess, appoint judges and magistrates who will judge all the people who live in Across the River, that is, all those who know the law of your God; and teach those who do not know it. And whoever will not obey the law of your God and the law of the king must surely be punished, whether by death, banishment, confiscation of property, or imprisonment. (Ezra 7:25–26)")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("As long as they did not conflict with Persian interests and order in the western region of the empire, the king protected and guaranteed the lawgiver’s orders. Persian interest in local traditions and law, reflected in Ezra-Nehemiah, stems from imperial Persian policy, not from special interest in the Jews."), _c('a', {
    attrs: {
      "href": "#/#foot-note-790",
      "id": "footnote-790"
    }
  }, [_c('sup', [_vm._v("180")])]), _vm._v(" In fact, the Jews in Ezra-Nehemiah express a negative attitude toward the Persians at times (e.g., Neh 9:36–37)."), _c('a', {
    attrs: {
      "href": "#/#foot-note-789",
      "id": "footnote-789"
    }
  }, [_c('sup', [_vm._v("181")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Artaxerxes gave Ezra not only royal authority but also materials and provisions for the temple and its offerings. Following the biblical text, the amounts are astronomical: 100 talents of silver (= 3.75 tons); 100 kors of wheat (= ca. 650 bushels); 100 baths (= 607 gallons) each of oil and wine; and unlimited salt (Ezra 7:22). This support of the sanctuary seems to be a reversal of the policy of Xerxes, who did not fund local temples, but may be a way in which Artaxerxes exerted control on the affairs and revenues of the province of Yehud and thereby strengthened his presence on the Mediterranean frontier. As John Berquist explains, “It strengthened the temple system for funneling taxation revenues through the colony and into the larger imperial system.” It would also increase the loyalty and wealth of the aristocracy in charge of these revenues."), _c('a', {
    attrs: {
      "href": "#/#foot-note-788",
      "id": "footnote-788"
    }
  }, [_c('sup', [_vm._v("182")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Ezra holds the genealogical credentials of a priest (Ezra 7:1), but his expertise rests in studying and teaching Jewish law (Ezra 7:10). Nehemiah 8 describes Ezra reading the law to the whole community, who had gathered to hear it with their families (Neh 8:1–8), and then organizing a further study session with the leaders on the next day (Neh 8:13). He also leads worship (Neh 8:6) and heads one of the two processions celebrating the dedication of the wall (Neh 12:36). His greatest challenge was dealing with the mixed marriages crisis. Over a hundred Jews, including many of the leaders, had married foreign women (Ezra 10:17–43). After much fasting, weeping, and praying, Ezra orders the offenders to divorce their wives—even those with children (Ezra 10:5, 44).")]), _vm._v(" "), _c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-13"
    }
  }, [_vm._v("3. Artaxerxes and Nehemiah")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Nehemiah, Artaxerxes’s royal cupbearer, came to Jerusalem at the request of his brother, Hanani, after hearing his distressing story of the city’s ruin and lack of security. Artaxerxes granted Nehemiah permission to leave his post and take on the governorship of Judah with the special mission of rebuilding the city’s walls. Unlike Ezra, Nehemiah held an official position as governor of the region. Although he was subordinate to the satrap of the Transeuphrates, he had authority over the five districts of the province of Yehud: Jerusalem, Beth-haccerem, Mizpah, Beth-zur, and Keilah."), _c('a', {
    attrs: {
      "href": "#/#foot-note-787",
      "id": "footnote-787"
    }
  }, [_c('sup', [_vm._v("183")])]), _vm._v(" Like satraps, governors received a special tax (“the governor’s bread”) that provided for everyone at their table, but Nehemiah did not impose it and instead supported 150 men plus guests at his own expense (Neh 5:14–18). Still, he levied taxes and imposed a state of military readiness (Neh 4:17; 5:4)."), _c('a', {
    attrs: {
      "href": "#/#foot-note-786",
      "id": "footnote-786"
    }
  }, [_c('sup', [_vm._v("184")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Nehemiah insisted on the strict observance of Jewish law and corrected such abuses as profanation of the Sabbath, lack of tithes for the Levites, and lack of support for those involved in the building project. He organized the collection of various offerings for the temple, including a one-third shekel head tax, firstfruits, tithes, and salaries for the cantors and gatekeepers (Neh 13:12).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Three provincial leaders vigorously opposed Nehemiah and accused him of sedition and rebellion: Sanballat, governor of Samaria; Tobiah, an Ammonite leader; and Geshem (or Gashmu), the Arab."), _c('a', {
    attrs: {
      "href": "#/#foot-note-785",
      "id": "footnote-785"
    }
  }, [_c('sup', [_vm._v("185")])]), _vm._v(" Like Nehemiah in Yehud, Sanballat was subject to the governor of the Transeuphrates; the other two leaders were apparently wealthy landowners. Curiously, they never appeal to the Persian emperor but instead try to neutralize Nehemiah’s purposes with threats and trickery (Neh 6:10–19). Despite their machinations, Nehemiah successfully secures Jerusalem with a wall in fifty-two days (Neh 6:15)."), _c('a', {
    attrs: {
      "href": "#/#foot-note-784",
      "id": "footnote-784"
    }
  }, [_c('sup', [_vm._v("186")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Sanballat is known from the Elephantine papyri as the governor of Samaria, succeeded by his sons Delaiah and Shelemaiah, who were in charge around 407 BCE. At that time, the colonists sent a letter to Bagohi, governor of Judah, requesting support for the rebuilding of their temple, which was destroyed in a riot incited by the Egyptian priests of the god Khnum with the aid of the Persian commander. They complain that their appeals to Johanan, the high priest in Jerusalem, have been ignored (possibly due to the syncretism of their religion) and that they have also written to Delaiah and Shelemaiah, sons of Sanballat, governor of Samaria (see CAP, nos. 30, 108–19). They also appeal to prior authorization from Cambyses, who had apparently endorsed their temple while destroying many others; but, perhaps because they had nothing in writing, their petition was rejected by the local Egyptian governor."), _c('a', {
    attrs: {
      "href": "#/#foot-note-783",
      "id": "footnote-783"
    }
  }, [_c('sup', [_vm._v("187")])]), _vm._v(" The Persian satrap overturned the decision in their favor and granted them permission to rebuild the temple, which they completed around 402 BCE."), _c('a', {
    attrs: {
      "href": "#/#foot-note-782",
      "id": "footnote-782"
    }
  }, [_c('sup', [_vm._v("188")])]), _vm._v(" The Samarian papyri found at Wadi Daliyeh reveal that the family of Sanballat was still in power a half century later.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Not only the Samarians but also the Tobiads gave Nehemiah grief, trying to intimidate him and neutralize his efforts to reconstruct Jerusalem’s walls. Although Nehemiah refers to him as “the Ammonite,” Tobiah considers himself an Israelite. In fact, many of the descendants of Tobiah are listed among the returning exiles; however, they cannot prove their Israelite descent (Neh 7:61–62). Tobiah’s name is Yahwist, and his family had risen to wealth and power during the exilic period, owning estates in the Transjordan."), _c('a', {
    attrs: {
      "href": "#/#foot-note-781",
      "id": "footnote-781"
    }
  }, [_c('sup', [_vm._v("189")])]), _vm._v(" Many Jews of Nehemiah’s community had borrowed money from Tobiah, and they are in his debt. Nehemiah works to remove the debts of the people to the greedy landowners and make the temple the center of the economy through the collection of tithes. Upon his return to Jerusalem, Nehemiah discovers that Tobiah has taken up rooms in the temple court, and he expels him (see the commentary on Neh 13:9; for more discussion on Tobiah, see commentary on Neh 6:17–19; 13:1–9).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Information on Geshem the Arab is negligible. Dedications inscribed on silver vessels found at Tell el-Maskhuta in Egypt may include a reference to him. One vessel is inscribed with the name “Qaynu, son of Gashmu, king of Qedar.”"), _c('a', {
    attrs: {
      "href": "#/#foot-note-780",
      "id": "footnote-780"
    }
  }, [_c('sup', [_vm._v("190")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Like Ezra, Nehemiah engaged in social and religious reform by opposing marriages between Jews of his community and outsiders. He regards the genealogical purity of the community as essential to the continuance of Israelite religion according to the law. (See "), _c('span', {
    attrs: {
      "href": "#/012_Chapter02c#exc9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excursus 9, “The Sacrilege of Intermarriage,” pp. 244–54")]), _vm._v(".)")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-17"
    }
  }, [_vm._v("E. INTERNAL JEWISH LEADERSHIP")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Israel’s political and religious institutions, which supported the community during monarchical times, were dealt a shattering blow by the exile. The tripod of king, priest, and prophet as the leadership of Israel had collapsed."), _c('a', {
    attrs: {
      "href": "#/#foot-note-779",
      "id": "footnote-779"
    }
  }, [_c('sup', [_vm._v("191")])]), _vm._v(" Indeed, the king was no longer Israelite but Persian, and Zerubbabel, although a Davidic descendant and local leader, was subject to the Persian crown. After him, Davidic leadership all but vanishes in the Second Temple period, although the genealogical line is still tracked (see Matt 1:1–17).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The authority of the priests became stronger in Second Temple Judaism as they subsumed the vacuum of power left by the absence of a Jewish monarch. Even though the sanctuary was destroyed, they still retained their position among the Jews. According to Ezra-Nehemiah, in the first return there were only three priestly families in charge of the temple service (Neh 10:33–40).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Working alongside the priests, Levites take on a prominent role as one of the three major categories of the community: Priests, Levites, and Israel (see Ezra 7:7; 9:1; 10:5; Neh 11:3; 12:47). According to the Torah, Levites who are not of the Aaronic line are not qualified to officiate at the altar, but they may assist the priests (Num 18:1–6)."), _c('a', {
    attrs: {
      "href": "#/#foot-note-778",
      "id": "footnote-778"
    }
  }, [_c('sup', [_vm._v("192")])]), _vm._v(" In Ezra-Nehemiah, Levites slaughter, but do not offer, the Passover offering for the people (Ezra 6:20), and they assist in purifying the people for the festival (Neh 12:30). Levites also assist the priests in teaching the law, explaining difficult matters to the congregation (Ezra 8:18; Neh 8:7–8). Levites are listed in Ezra-Nehemiah among the officials of the governor (Neh 3:17–18), and they also serve as temple musicians, clerks of the temple storeroom, and gatekeepers of both the temple and the wall of Jerusalem (see Neh 12:44–47). Correcting the neglect of the past, Nehemiah expressly orders the people to contribute tithes for the Levites (Neh 13:10–11).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The authority of the priesthood and the Levites in Ezra-Nehemiah, while a strong force, gave way in part to a new kind of leadership: the scholar."), _c('a', {
    attrs: {
      "href": "#/#foot-note-777",
      "id": "footnote-777"
    }
  }, [_c('sup', [_vm._v("193")])]), _vm._v(" The scribe Ezra is not simply one who records laws and memoranda, but he is a scholar and teacher of the Word of God. According to his memoir, Ezra devoted himself to the study and observance of the Torah. Ezra 7:10 explains that Ezra’s commitment to studying the law was aimed at its practice within the community."), _c('a', {
    attrs: {
      "href": "#/#foot-note-776",
      "id": "footnote-776"
    }
  }, [_c('sup', [_vm._v("194")])]), _vm._v(" In his position as an emissary of the Persians, he had the authority to enforce it. In fact, the importance of the Torah lies in its revelation of God’s wisdom to humanity, including but not limited to law. “The wisdom of God which is in your hand” (Ezra 7:25; cf. v. 14) describes the Torah of Ezra. Ezra equates “wisdom” with the Torah, and in this regard he is the forerunner of Ben Sirach and later Pharisaic Judaism (cf. Sir 24:1–22). New Testament authors take the notion a step farther by associating divine wisdom with Christ (1 Cor 1:30; Col 2:3; cf. John 1:3).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The result of Ezra’s teaching is twofold. On the one hand, there is joy among the congregation just for the fact that they have understood the Word of God (Neh 8). On the other hand, however, there is an evocation of guilt at the recognition that much of the lifestyle of the people does not match the expectations of God. For example, in the matter of mixed marriages, it becomes painfully clear that this is an impediment to holiness, for the lack of which the people incurred the wrath of Yahweh and lost their possession of the promised land (see Lev 26:31–35; Deut 7:1–6; 30:18).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The tension between these leadership roles is evident in Ezra-Nehemiah. For example, Ezra, who is both priest and scribe, is not in the list of current high priests, but he is certainly in charge of the entire community, including the high priesthood. Nehemiah is even more powerful as the authorized Persian governor. Both leaders encounter opposition from the local priesthood, although it is muted and does not lead to outright rebellion. Leaders intermarry, the high priest does not participate in Ezra’s divorce action, and some elders have reservations (Ezra 10:15). The officials of Judah have dealings with the local populations against Nehemiah’s wishes (Neh 6:17); the high priest does not sign Nehemiah’s list of signatories, and when Nehemiah takes a leave of absence, the high priest installs Tobiah the Ammonite in the temple court (Neh 13:5).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The third leg of the preexilic leadership tripod, the prophet, is muted in Ezra-Nehemiah apart from the ministries of Haggai and Zechariah, who supported Zerubbabel and the community of the first return (Ezra 5:1–2). The prophet Malachi later explains that monarchy and prophecy are not dead but that they have to await the coming of Elijah and the Messiah (Malachi 3–4 [3])."), _c('a', {
    attrs: {
      "href": "#/#foot-note-775",
      "id": "footnote-775"
    }
  }, [_c('sup', [_vm._v("195")])]), _vm._v(" Nevertheless, while playing a minor role in Ezra-Nehemiah, the prophetic hope of full restoration under a messiah figure is alive and well during this period, as is clear from the texts of Haggai and Zechariah.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "sec-6"
    }
  }, [_vm._v("VI. SECOND TEMPLE JUDAISM")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Several ideological norms and currents of Second Temple Judaism had their source in the period described in Ezra-Nehemiah. The early Persian period marks a turning point in Jewish faith and practice. Returning exiles proudly linked themselves with the grand past of the Israelite and Judean monarchies through genealogical lines and religious heritage, but their community had changed irreparably as the result of foreign dominance and exile. Their priorities and issues were somewhat different. Nevertheless, certain strengths emerged that continued in the various forms of Judaism of the next several centuries and even to this day. This is the period that spawned the courageous Maccabees, who fought for religious freedom against the hordes of the Greek king Antiochus IV and succeeded with the help of divine intervention (167 BCE). Furthermore, it was during Second Temple times that Jews dedicated to the Torah wrote the Dead Sea Scrolls, preserving the sacred text for posterity.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Second Temple Judaism was also the environment that gave birth to Christianity. Faithful Jews of this period retained their hope in the Messiah, who would relieve oppression and bring the kingdom of God to fruition on earth. It was to expectant and observant Jews serving in the Second Temple that God revealed the birth of his Son (e.g., Simeon, Anna, Zechariah, and Elizabeth). Most importantly, it was faithful Jews who were entrusted with the birth of Jesus and who became his disciples and apostles. The often-expressed evaluation of ancient Judaism as trite legalism or ritualism is not a fair assessment of the community of faith during this period."), _c('a', {
    attrs: {
      "href": "#/#foot-note-774",
      "id": "footnote-774"
    }
  }, [_c('sup', [_vm._v("196")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The experience of exile away from the land of promise led to a definite change in the self-image and thought of Israel. Much has been written on the “axial transformation” or “fundamental change” among the people."), _c('a', {
    attrs: {
      "href": "#/#foot-note-773",
      "id": "footnote-773"
    }
  }, [_c('sup', [_vm._v("197")])]), _vm._v(" In terms of population alone, the difference is staggering (see "), _c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec-4"
    }
  }, [_vm._v("“Setting,” pp. 22–26")]), _vm._v("). Not only were they under foreign domination, but they were a subgroup of the population in Yehud. Having lost political control of the land, their residence in it was tentative.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Many debates have centered on the nature of the development from early Second Temple Judaism to later forms of Judaism. E. P. Sanders suggests that throughout the entire period from Persian hegemony to the rabbinic period, there was a nucleus of religion that did not change, and this became the core of rabbinic Judaism."), _c('a', {
    attrs: {
      "href": "#/#foot-note-772",
      "id": "footnote-772"
    }
  }, [_c('sup', [_vm._v("198")])]), _vm._v(" L. Schiffman rejects this underlying stability of Judaism and argues for a variety of Jewish religious traditions that evolved over the centuries, “each period and approach bequeathed to that which came after”; over time, diverse ideas synthesized into a mainstream tradition."), _c('a', {
    attrs: {
      "href": "#/#foot-note-771",
      "id": "footnote-771"
    }
  }, [_c('sup', [_vm._v("199")])]), _vm._v(" D. Edelman insists that “early Judaism” emerged only from the Hasmoneans onward (ca. 143 BCE)."), _c('a', {
    attrs: {
      "href": "#/#foot-note-770",
      "id": "footnote-770"
    }
  }, [_c('sup', [_vm._v("200")])]), _vm._v(" J. Neusner refuses to accept any core to ancient Judaism. Rather, he sees fragmentation: a number of Judaisms existing in history, each being a competitor to the others."), _c('a', {
    attrs: {
      "href": "#/#foot-note-769",
      "id": "footnote-769"
    }
  }, [_c('sup', [_vm._v("201")])]), _vm._v(" G. Boccaccini rejects this model because it assumes impermeable systems of Judaism and thus ignores the interaction among Jews in this period."), _c('a', {
    attrs: {
      "href": "#/#foot-note-768",
      "id": "footnote-768"
    }
  }, [_c('sup', [_vm._v("202")])]), _vm._v(" Surely we cannot roll up all of the various aspects of Jewish religion in the Second Temple period into one synthesis, but Ezra-Nehemiah is an early treasure trove of religious elements that make a strong cross-sector impact on various groups of early Judaism and, through them, on Christianity, which was planted in Jewish soil. Scholars are responsible to try to discern the antecedents and prehistory of these groups, and Ezra-Nehemiah provides fertile ground.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("It is a goal of this commentary to highlight the seeds of later Judaism in Ezra-Nehemiah. Several notions either come to light for the first time (e.g., the role of the scribe who teaches the Torah) or take on a new emphasis (e.g., genealogical credentials). To be sure, not all later concepts originate here (e.g., covenant). Many find their origins in preexilic traditions, while other ideas (e.g., belief in an end time, ultimate retribution, and a cosmic Torah) come to fruition much later. Nevertheless, seeds of certain later ideas germinate in Ezra-Nehemiah, and they change the future of Judaism in all of its forms in irrevocable ways. Several of the excurses at the end of each chapter are dedicated to these innovative beliefs and practices.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Four “pillars” of Second Temple Judaism are emphasized in Ezra-Nehemiah, and they continued to undergird the faith and practice of Jews across sectors during this period: (1) Yahweh is the only true God of Israel; (2) Yahweh’s law, the Torah, is authoritative; (3) Jerusalem and its sanctuary is “the place of his holiness” (Ezra 9:8); and (4) the community of Israel is holy (Ezra 9:2). In all four of these areas, there are signs in Ezra-Nehemiah of both heritage and innovation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("All four of these “pillars” are treated as holy in Second Temple Judaism. In the technical texts of the priestly material of Leviticus and Numbers, “holy” ("), _c('em', [_vm._v("qādôš")]), _vm._v(") stands for God, the Holy One, and by extension those who represent him, the priests of Israel. In the holiness traditions of Leviticus and in Deuteronomy, holiness applies to all of Israel. In Leviticus, it is framed as a commandment (Lev 11:44; 19:2), and in Deuteronomy it is considered an "), _c('em', [_vm._v("a priori")]), _vm._v(" fact of the nation of Israel by virtue of election (Deut 7:6)."), _c('a', {
    attrs: {
      "href": "#/#foot-note-767",
      "id": "footnote-767"
    }
  }, [_c('sup', [_vm._v("203")])]), _vm._v(" The temple and its environs are Yahweh’s personal sanctuary and as such are imbued with his holiness. Even those Jews in Second Temple times who rejected the current value of the temple (e.g., authors of some Dead Sea Scrolls and the book of Hebrews) still had to deal with its centrality in Judaism and reinterpret it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In Ezra-Nehemiah, three of these “pillars” are explicitly labeled “holy”: Yahweh (Ezra 9:8), Jerusalem and its temple (Ezra 9:8; Neh 11:1, 18), and the people of Israel (Ezra 9:2)."), _c('a', {
    attrs: {
      "href": "#/#foot-note-766",
      "id": "footnote-766"
    }
  }, [_c('sup', [_vm._v("204")])]), _vm._v(" According to priestly definitions, being holy signifies that an item is set apart by Yahweh and belongs to him. As such, it benefits from his protection and blessing but is also governed by certain restrictions."), _c('a', {
    attrs: {
      "href": "#/#foot-note-765",
      "id": "footnote-765"
    }
  }, [_c('sup', [_vm._v("205")])]), _vm._v(" In addition to the three “pillars” listed above, several other things are emphasized as holy in Ezra-Nehemiah. The full list of sancta encompasses persons, space, time, and more: Yahweh (Ezra 9:8), priests (Ezra 8:28), Israel as “holy seed” (Ezra 9:2), Jerusalem (Ezra 9:8, "), _c('em', [_vm._v("māqôm")]), _vm._v("; Neh 11:1, 18), the wall of Jerusalem (Neh 3:1), the Sabbath (Neh 9:14; 13:22), festivals (Ezra 3:5; Neh 8:9–11; 10:32), sacrifices (Ezra 2:63; Neh 7:65; 10:34). Also, Levites are “sanctified, set apart” to assist the priests (Neh 12:47).")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-18"
    }
  }, [_vm._v("A. MONOTHEISM")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The book of Ezra-Nehemiah records a transformation in the popular religion of Yehud as a result of the returning exiles under the leadership of Zerubbabel, Ezra, and Nehemiah. Although worship of Yahweh is a tenet of Israelite thought from earliest times (see Exod 20:1–3), most scholars agree that in Second Temple times, the Jewish community, across sects, began to affirm monotheism in a stronger way, even to the denial of the existence of any other god.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Yahweh’s distinctive identity, as opposed to pagans’ worship of their deities, lay primarily in his identity as the sole Creator and Ruler of all things."), _c('a', {
    attrs: {
      "href": "#/#foot-note-764",
      "id": "footnote-764"
    }
  }, [_c('sup', [_vm._v("206")])]), _vm._v(" This belief was affirmed by the recitation of the Shema, an ancient practice still observed twice daily in modern Judaism: “Hear ["), _c('em', [_vm._v("š")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ə")]), _c('em', [_vm._v("ma")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ʿ")]), _c('em'), _vm._v("], O Israel, Yahweh is our God; Yahweh is one” (Deut 6:4; cf. Exod 20:2–6; Deut 5:6–10; Mark 12:29). The distinctive identity of Yahweh as supreme over all realities separates his worship from pagan notions of the divine, but this is coupled in Israel with adoration of Yahweh because of his goodness, especially his election of Israel."), _c('a', {
    attrs: {
      "href": "#/#foot-note-763",
      "id": "footnote-763"
    }
  }, [_c('sup', [_vm._v("207")])]), _vm._v(" This idea is taken up by Jesus, who includes the Shema in his answer to the Pharisees about which is the greatest commandment (Mark 12:29) and explains that he and the Father are “one” (John 10:30).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Ezra-Nehemiah reflects an early stage in the development of this view of monotheism in Second Temple Judaism. The book emphasizes the sole jurisdiction of Yahweh, the God of Judah, who lives in Jerusalem. Even the Persian emperors confess this to be true and support the restoration of his temple and cult there. When the returnees are approached by the local people in Ezra 4, they are confronted with a mixture of Yahwism and paganism. This explains their rejection of help from the locals and the tension between them. Later, those who do not subscribe to the unadulterated religion of the returnees are excluded from observing the Passover (Ezra 6:19–21), and the community is eventually “purged” of foreign mixture and intermarriage (Neh 13:30).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Indeed, religious syncretism was the main reason for the exile in the first place (Jer 7:18; 25:4–14; Hos 11:2; Judg 10:6; Lev 26:31–33). The punishment that was the conquest of Jerusalem and the Kingdom of Judah and the ensuing exile in a foreign land made it all too apparent that Yahweh, the God of the Jews, would not share worship with any other gods. Whether in the form of golden calves, pagan symbols in the temple, or sacrifices to various Baalim, religious syncretism simply was not compatible with the worship of Yahweh, the God of Abraham, Isaac, and Jacob. Although the prophets had repeated this theme throughout the monarchic period, warning the people of impending destruction, it was now a past reality. In the wake of these events, the worship of Yahweh to the exclusion of all other gods became a central tenet of the returning exiles."), _c('a', {
    attrs: {
      "href": "#/#foot-note-762",
      "id": "footnote-762"
    }
  }, [_c('sup', [_vm._v("208")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Archaeological evidence confirms a radical reduction in the number of figurines in Persian Yehud compared with those in Judah of the earlier period, as well as reduction of images between Yehud and other parts of Palestine. In particular, the Judahite pillar figurine disappears in Yehud in this period."), _c('a', {
    attrs: {
      "href": "#/#foot-note-761",
      "id": "footnote-761"
    }
  }, [_c('sup', [_vm._v("209")])]), _vm._v(" E. Stern remarks that there is “not a single piece of evidence” of any pagan cults in Judah and Samaria in this period, including sanctuaries, figurines, and other pagan cult objects."), _c('a', {
    attrs: {
      "href": "#/#foot-note-760",
      "id": "footnote-760"
    }
  }, [_c('sup', [_vm._v("210")])]), _vm._v(" This is in sharp contrast to other areas of Palestine as well as the earlier, Assyrian and Babylonian, periods of Israel’s history for which pagan cult objects are easily documented. The only exceptions to this rule are apotropaeic cults (e.g., rituals to ward off demons) and some pagan designs on coins, which may simply be borrowed motifs rather than rituals of cultic significance. Apparently, Judeans and Samarians went through a reversal in attitude toward pagan cults in this period.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Furthermore, Ezra-Nehemiah regards the jurisdiction of Yahweh as not just Jerusalem and Judah; Yahweh is not just the Jewish god within the ranks of polytheism but the God who is the eternal Creator and Sustainer of everything. The Levites’ prayer of Neh 9 begins with this invocation:")]), _vm._v(" "), _c('p', {
    staticClass: "quotes_bq"
  }, [_vm._v("“Arise, bless Yahweh, your God who is from everlasting to everlasting. May they bless your glorious name, which is exalted above all blessing and praise. You alone are Yahweh. You made the heavens, the highest heavens, and their entire army; the earth, and all that is on it; the seas, and all that is in them. You give life to everything, and the army of heaven bows down to you.” (Neh 9:5b–6)")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Typical of Jewish worship practice, the prayer then moves on to a recital of Yahweh’s election, nurture, and care of Israel throughout her past (Neh 9:7–35).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("By the Hellenistic period, Judaism’s most defining feature was its fiercely monotheistic stance."), _c('a', {
    attrs: {
      "href": "#/#foot-note-759",
      "id": "footnote-759"
    }
  }, [_c('sup', [_vm._v("211")])]), _vm._v(" One main factor was Antiochus Epiphanes’s coercion with its violent backlash by the Maccabees. In Second Temple Judaism, much thought centered on the heavenly abode of Yahweh and the celestial beings that resided there (e.g., angels), but all of these supernatural beings (even those in the realm of evil, such as fallen angels, demons, and Satan) were under his power. Yahweh’s retinue served to accentuate his greatness like one of the emperors and their courts or even like the myths surrounding pagan deities. However, only the invisible, aniconic Yahweh was worthy of worship. The Roman historian Tacitus reports, “the Jews conceive of one god only, and that with the mind alone” ("), _c('em', [_vm._v("Histories")]), _vm._v(" 5.5, tr. Moore, LCL). Monotheism continues to be a foundational pillar of Jewish identity even after the fracture into various sects in late Second Temple Judaism. Josephus emphasizes the unity both of Israel and her God: “For God is one, and the Hebrew race is one” ("), _c('em', [_vm._v("Antiquities")]), _vm._v(" 4.201, tr. Marcus, LCL).")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-19"
    }
  }, [_vm._v("B. TORAH")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Torah” ("), _c('em', [_vm._v("tôrâ")]), _vm._v("; lit. “instruction, teaching”) refers to the Pentateuch, or the Five Books of Moses, and became an important identifying factor for all forms of Judaism in the Second Temple period. The centrality of the written Torah for the people of Israel in the Second Temple period cannot be overestimated."), _c('a', {
    attrs: {
      "href": "#/#foot-note-758",
      "id": "footnote-758"
    }
  }, [_c('sup', [_vm._v("212")])]), _vm._v(" In fact, when the Maccabees rallied the Jews to fight off their Hellenistic overlords, the battle slogan was, “For the Temple and the Torah!”"), _c('a', {
    attrs: {
      "href": "#/#foot-note-757",
      "id": "footnote-757"
    }
  }, [_c('sup', [_vm._v("213")])]), _vm._v(" The law is central in both Ezra and Nehemiah. Ezra’s teaching becomes pivotal for the community because he taught “the law of Moses, which Yahweh, the God of Israel, had given” (Ezra 7:6; cf. 3:2; Neh 9:3; 13:1). The written word is powerful, and the people realize that they must behave in accordance with it to maintain their relationship with God (e.g., “in accordance with what is written,” Ezra 3:2–4; 6:18; Neh 8:14–15)."), _c('a', {
    attrs: {
      "href": "#/#foot-note-756",
      "id": "footnote-756"
    }
  }, [_c('sup', [_vm._v("214")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The book of Ezra-Nehemiah reflects a shift from earlier traditions that emphasized “seeking Yahweh” ("), _c('em', [_vm._v("lidrôš et-Yahweh")]), _vm._v("; e.g., Gen 25:22). Ancient Israelites would seek Yahweh directly in prayer or through the prophet, his representative. The process of seeking and finding in Ezra-Nehemiah, however, refers at least ten times to the searching out of information in authoritative written records."), _c('a', {
    attrs: {
      "href": "#/#foot-note-755",
      "id": "footnote-755"
    }
  }, [_c('sup', [_vm._v("215")])]), _vm._v(" This emphasis on the written word starts already in Ezra 1 with the edicts of the Persian emperors. Also, priestly validity is established only by supplying written genealogical registers (Ezra 2). Darius orders a search for the actual text of the earlier Persian decree (Ezra 6). This focus on written texts sets the reader up for introducing the Torah, the most important document since it is the Word of God.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Persians seem obsessed with law. The term "), _c('em', [_vm._v("dāt")]), _vm._v(" (“law”) used in late Biblical Hebrew is a Persian loanword that refers to right and order—to everything being in its rightful place (i.e., the natural law). According to Fried, “Laws were collected for scientific and antiquarian purposes. They were also collected and published as abstract instances of justice to reassure the populace that the new king was concerned to install right order in the land.”"), _c('a', {
    attrs: {
      "href": "#/#foot-note-754",
      "id": "footnote-754"
    }
  }, [_c('sup', [_vm._v("216")])]), _vm._v(" The main point to the public was that justice and law stemmed from the god Ahura Mazda through the agency of the Persian king.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-14"
    }
  }, [_vm._v("1. Torah for Everyone")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Ezra became a new role model in Judaism of a teacher and scribe of the law. Ezra 7 provides the first record of the development of written Scripture and its interpreters in Second Temple times. Ezra is an “expert scribe” ("), _c('em', [_vm._v("sôpēr māhîr")]), _vm._v(", Ezra 7:6). Other biblical scribes tend to be educated officials and copyists in the royal service (2 Kgs 12:10–12; 18:18, 37; 22:3, 12; Jer 36). Ezra, on the other hand, combines skill, divine wisdom, and knowledge of Jewish law with devotion to the God of Israel. He strives to understand the text in order to observe it and provide guidance to the community. Ezra is no prophet, yet he is able to guide the people, even under a foreign monarch, by his expertise in interpreting the Torah and thus connecting his people to Yahweh through understanding of his word. Divine revelation and guidance in the time of the monarchy tended to come through a prophet to the king on behalf of the nation (see Jeremiah, Isaiah), but in Ezra-Nehemiah, there is a strong emphasis on the democratization of this process. Ezra teaches the people by reading them the Torah (Neh 8:8) with great success. They are excited because they understand what God is saying to them. The elders return for further study on the next day and, a chapter later, laypersons are reading the Torah for themselves (Neh 9:3)!"), _c('a', {
    attrs: {
      "href": "#/#foot-note-753",
      "id": "footnote-753"
    }
  }, [_c('sup', [_vm._v("217")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The importance of studying the Torah with a teacher continued in Second Temple times and became a hallmark of Judaism. Ezra served as the role model for later scribes of this period. Ben Sirach ran a school for boys, teaching them wisdom through the Torah (Sir 38–39). The Dead Sea Scrolls describe students searching for divine wisdom by studying texts (4Q415–418, 423). Members of the Qumran sect organized themselves into shifts for continuous study and copying of the Torah, always in search of further divine revelation (1QS vi 6–8). The early rabbinic sages stated that the Torah was the first pillar of three upon which the world rests: Torah, temple, and deeds of loving-kindness (m. "), _c('span', {
    staticClass: "chari-r"
  }, [_vm._v("ʾ")]), _vm._v("Abot 1:1). Torah learning was handed down from teacher to student in a sort of academic genealogy that was honored and recorded. A student’s words were often evaluated based on his teacher. Today, Jews are still sometimes referred to as “the people of the book.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Early Christianity, beginning as a Jewish sect, continued this reverence for Scripture (see 2 Tim 3:16) but also began to describe the person of Jesus Christ as “the word becoming flesh” (John 1:14). The idea, according to John, is that God’s word becomes incarnate in the life of Jesus, who fulfills its expectations perfectly among his people and ultimately connects them to the Father by his atoning death and resurrection.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-15"
    }
  }, [_vm._v("2. Heritage: What Was Ezra’s Torah?")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Some form of the Pentateuch was available to Ezra. Blenkinsopp has traced a number of traditions from the books of the Pentateuch that are evident in Ezra-Nehemiah, and I have added to this list in the table on "), _c('a', {
    attrs: {
      "href": "#/#tab1"
    }
  }, [_vm._v("pp. 70–71")]), _vm._v(". What was Ezra’s book of the law? The whole Pentateuch? Random legal material? Some form of Deuteronomy? Blenkinsopp opts for a Deuteronomic legal core supplemented by priestly traditions."), _c('a', {
    attrs: {
      "href": "#/#foot-note-752",
      "id": "footnote-752"
    }
  }, [_c('sup', [_vm._v("218")])]), _vm._v(" Others claim that the Pentateuch was in the process of compilation during the time of Ezra and Nehemiah and that some of it was written in response to their exclusionary attitude."), _c('a', {
    attrs: {
      "href": "#/#foot-note-751",
      "id": "footnote-751"
    }
  }, [_c('sup', [_vm._v("219")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In my view, the Pentateuch was known to the community in some form. First, the people accepted the authority of the law immediately; no convincing seems to have been necessary. And as Derek Kidner points out, Malachi (usually dated between 450 and 425 BCE) places the trouble with a priesthood who knew the law but did not teach or observe it faithfully (Mal 2:6–9): “Ezra’s law book … owed its power not to its being new, but precisely to its being old and rediscovered, brought and expounded to the whole people, and treated as an authority which judged the very priests themselves (cf. e.g., Ezra 9:1ff.; 10:1ff.; Neh 8:1ff.).”"), _c('a', {
    attrs: {
      "href": "#/#foot-note-750",
      "id": "footnote-750"
    }
  }, [_c('sup', [_vm._v("220")])]), _vm._v(" Indeed, the law was known and practiced before the fall of Jerusalem because the prophets held the people responsible for it and explained that it was disobedience to the law that had landed them in the unfortunate state of exile.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The authors are familiar with all parts of the Pentateuch."), _c('a', {
    attrs: {
      "href": "#/#foot-note-749",
      "id": "footnote-749"
    }
  }, [_c('sup', [_vm._v("221")])]), _vm._v(" Scholars have demonstrated that Ezra-Nehemiah is working with an established legal tradition that reaches back into the Pentateuch. The author refers several times to practices that are “written in the law” (Ezra 3:2; Neh 8:15; 10:34, 36; cf. Neh 13:1, the "), _c('em', [_vm._v("Book of Moses")]), _vm._v("). Prescriptions for the offerings are understood in detail: for example, the guilt offering, which is brought for sacrilege (Ezra 10:19) and the various needs of the temple cult (see Neh 10:31–39)."), _c('a', {
    attrs: {
      "href": "#/#foot-note-748",
      "id": "footnote-748"
    }
  }, [_c('sup', [_vm._v("222")])]), _vm._v(" The writer understands the defiling threat of illicit sexual relations and describes it as an abomination and pollution using language from Lev 18 (Ezra 9:10–11; cf. Lev 18:24–27). Regarding the laws of Sukkot, Ezra-Nehemiah “facilitates” the text, to use Clines’s term, by specifying what materials and fruit are to be included in the observance of the festival (Neh 8:13–18; cf. Lev 23:40)."), _c('a', {
    attrs: {
      "href": "#/#foot-note-747",
      "id": "footnote-747"
    }
  }, [_c('sup', [_vm._v("223")])]), _vm._v(" Nehemiah 5 may reflect knowledge of the Jubilee laws of Lev 25, according to which property must be returned to its original clan (see "), _c('span', {
    attrs: {
      "href": "#/014_Chapter03a#exc15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excursus 15, “The Jubilee and Sabbatical Years,” pp. 328–33")]), _vm._v("). Thus, although scholars argue over the date of Leviticus, it appears that the writers of Ezra-Nehemiah were familiar with some form of the work.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The author of Ezra-Nehemiah also cites several passages from Deuteronomy. The intermarriage prohibition is prominent in this regard (Deut 7:3//Ezra 9:2; Neh 10:31[32]; 13:25; Deut 23:4–5[3–4]//Neh 13:1–2). Several cultic traditions in Ezra-Nehemiah are influenced by Deuteronomy, including sanctifying the Sabbath and Sabbatical Year, setting aside firstlings and firstfruits, refusing interest on loans, and observing sacred forfeiture (the table on "), _c('a', {
    attrs: {
      "href": "#/#tab1"
    }
  }, [_vm._v("pp. 70–71")]), _vm._v("). Even the divine promise to return a repentant Israel to her land even though she may be scattered among the nations (Deut 30:1–5) resonates in Nehemiah’s prayer (Neh 1:8–9). Titus Reinmuth demonstrates an especially close connection between Ezra-Nehemiah and Deuteronomy 31:9–13, which treats several of the topics found in Nehemiah, including debt relief, Torah reading, and the Festival of Sukkot."), _c('a', {
    attrs: {
      "href": "#/#foot-note-746",
      "id": "footnote-746"
    }
  }, [_c('sup', [_vm._v("224")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Not only is the redactor of Ezra-Nehemiah familiar with the general laws and practices of the Pentateuch, but he uses specific terminology from both priestly and Deuteronomic traditions."), _c('a', {
    attrs: {
      "href": "#/#foot-note-745",
      "id": "footnote-745"
    }
  }, [_c('sup', [_vm._v("225")])]), _vm._v(" Ezra 9:10–11, for example, refers to impure "), _c('em', [_vm._v("abominable practices")]), _vm._v(" ("), _c('em', [_vm._v("tô")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("ēbôt")]), _vm._v(") of the local population that are denounced in earlier traditions. These probably refer to a catalog of sexual sins found in Lev 18 that defile sinners irrevocably and are punishable by expulsion and extirpation (Lev 18:24–30). The author of Ezra-Nehemiah uses the root "), _c('em', [_vm._v("bādal")]), _vm._v(" to emphasize the need to “separate” from impure outsiders (Ezra 9:1; 10:11; Neh 9:2; 10:28). The original priestly mandate to distinguish between “pure and impure” and “holy and profane” comes from Leviticus (see Lev 10:10; 11:44–47; 20:25–26). According to Leviticus, the very purpose of Israel’s purity system is to reflect and reinforce her separation from other people:")]), _vm._v(" "), _c('p', {
    staticClass: "quotes_bq"
  }, [_vm._v("I, Yahweh, am your God who has set you apart ["), _c('em', [_vm._v("bādal")]), _vm._v("] from other peoples. So you shall set apart ["), _c('em', [_vm._v("bādal")]), _vm._v("] the clean beast from the unclean, the unclean bird from the clean…. You shall be holy to me, for I, Yahweh, am holy, and I have set you apart ["), _c('em', [_vm._v("bādal")]), _vm._v("] from other peoples to be mine. (Lev 20:24–26)")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Thus, Israel is to eat by a unique standard of food laws so that she will not share meals with her pagan neighbors. In this way, the law limits social contact between Israel and her neighbors and reduces the possibility that she will be entrapped by intermarriage with idolaters (see Exod 34:15–16; Num 16:21).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The notion that Leviticus in some form stands behind Ezra-Nehemiah is evident in other terms as well. While "), _c('em', [_vm._v("niddâ")]), _vm._v(" refers only to menstrual impurity in Leviticus with one exception for incest (Lev 20:21), Ezra-Nehemiah uses the term more broadly in the phrases “impure land” and “impurity of the peoples of the land” (Ezra 9:11). Ezra-Nehemiah follows exilic and postexilic usage in using "), _c('em', [_vm._v("niddâ")]), _vm._v(" as a metaphor for sin (Ezek 7:19–20; Lam 1:17; 2 Chr 29:5). Additionally, the root "), _c('em', [_vm._v("gā")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ʾ")]), _c('em', [_vm._v("al")]), _vm._v(" (with "), _c('em', [_vm._v("aleph")]), _vm._v(": “nauseating, revolting, defiling”) is introduced to describe the defilement of the priesthood by intermarriage (Neh 13:29). This root is a later form of "), _c('em', [_vm._v("gā")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("al")]), _vm._v(" (with "), _c('em', [_vm._v("ayin")]), _vm._v("), a pollution term found in Leviticus (e.g., Lev 26:11, 43)."), _c('a', {
    attrs: {
      "href": "#/#foot-note-744",
      "id": "footnote-744"
    }
  }, [_c('sup', [_vm._v("226")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("So who is borrowing from whom? Mary Douglas argues that Leviticus is a response to the harsh decrees of Ezra-Nehemiah toward outsiders."), _c('a', {
    attrs: {
      "href": "#/#foot-note-743",
      "id": "footnote-743"
    }
  }, [_c('sup', [_vm._v("227")])]), _vm._v(" I argue the opposite. The answer lies in the language itself, with many technical cultic terms in Ezra-Nehemiah assumed to be common knowledge and the concepts expanded in new ways. The term "), _c('em', [_vm._v("ma")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("al")]), _vm._v(" has moved from the “sacrilege” of holy items to the desecration of all Jewish persons. The label of "), _c('em'), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ṭ")]), _c('em', [_vm._v("um")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ʾ")]), _c('em', [_vm._v("â")]), _vm._v(" (“impurity”) refers not only to a status (usually temporary) antithetic to the sacred but also permanently labels those outside of the community of Israel. The scope of separation indicated by "), _c('em', [_vm._v("bādal")]), _vm._v(" extends to these ethnically unauthorized persons. A term from earlier traditions, "), _c('em'), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("am hā")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ʾ")]), _c('em', [_vm._v("ārets")]), _vm._v(" or "), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ʾ")]), _c('em', [_vm._v("ammê hā")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ʾ")]), _c('em', [_vm._v("ărātsôt")]), _vm._v(" (“the people of the land[s]”), which referred to the population of Israel who supported the traditions and laws of the cult (Lev 4:27; 20:2, 4), now refers derogatorily to outsiders (Ezra 4:4; 9:1, 11). Ezra-Nehemiah employs the term "), _c('em', [_vm._v("niddâ")]), _vm._v(", which in Leviticus refers to menstrual impurity, as a metaphor to illustrate moral impurity. As noted above, the term "), _c('em', [_vm._v("gā")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ʾ")]), _c('em', [_vm._v("al")]), _vm._v(" (“nauseating, revolting, defiling”) is employed to increase the disgust for the genealogical pollution of the priesthood.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Mary Douglas argues that the progressive notions of Leviticus about impurity follow Ezra-Nehemiah rather than precede them. However, if this were the case, why is there no overt polemic in Leviticus and instead a neutral sense of teaching the particulars of the laws of purity and pollution (see Lev 11:1–2; 12:1–2; 14:1–2; 15:1–2)? Also, it makes more sense to see the generous attitude in Leviticus to the "), _c('em', [_vm._v("gēr")]), _vm._v(" as having roots in an Israel from preexilic times that is in charge of its own destiny and land, no matter when one dates its final redaction. Ezra-Nehemiah, on the other hand, reveals the constraints of invasion, deportation, and return as a threatened minority group.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Although when the final form of the Pentateuch was redacted remains a matter of debate—whether during, before, or after the period of Ezra-Nehemiah—it is clear that Ezra-Nehemiah draws on earlier Pentateuchal traditions. Indeed, the law was a force throughout the history of ancient Israel from earliest times, but it was often neglected."), _c('a', {
    attrs: {
      "href": "#/#foot-note-742",
      "id": "footnote-742"
    }
  }, [_c('sup', [_vm._v("228")])]), _vm._v(" At times, new laws and interpretations are put forward in Ezra-Nehemiah. For example, the tithing laws (see Num 18:21) assume a 1-10 ratio of priests to Levites, which is contradicted by the lack of Levites in Ezra-Nehemiah, the ratio being closer to 12-1. Thus, the priestly tithing regulations must precede the time of Ezra-Nehemiah."), _c('a', {
    attrs: {
      "href": "#/#foot-note-741",
      "id": "footnote-741"
    }
  }, [_c('sup', [_vm._v("229")])]), _vm._v(" Intermarriage is allowed in the earlier Pentateuchal period. Moses marries a Midianite and allows his soldiers to do so as well (Exod 2:1–21; Num 31:18; Deut 21:10–14). The Deuteronomic laws are clearly known to the author of Ezra-Nehemiah (see Ezra 9:1–2; Deut 7:1–6; 23:1–9), but they are applied in more stringent terms.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Nevertheless, some scholars challenge the undergirding of the Pentateuch in Ezra-Nehemiah based on a “paucity of evidence that Ezra’s law bears close resemblance to the law now in Ex, Lev and Deut.”"), _c('a', {
    attrs: {
      "href": "#/#foot-note-740",
      "id": "footnote-740"
    }
  }, [_c('sup', [_vm._v("230")])]), _vm._v(" One major contention is that the fast of Yom Kippur is not mentioned, although there is a strong emphasis on the other sacred assemblies of the seventh month.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("To be sure, the process of the formation of the Pentateuchal text was ongoing to some degree during Ezra’s time, as is apparent in the differences in text types (i.e., LXX, the Samaritan Pentateuch, and the proto-MT found among the Dead Sea Scrolls). For example, early Greek versions of antediluvian chronology (Gen 5) and the tabernacle narratives in LXX differ markedly from those in MT."), _c('a', {
    attrs: {
      "href": "#/#foot-note-739",
      "id": "footnote-739"
    }
  }, [_c('sup', [_vm._v("231")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Even if the new code of Ezra is the entire Pentateuch, this does not mean the end of interpretation. Quite the contrary, the system of laws provided in the Pentateuch cannot be understood let alone implemented without considerable interpretation and oral tradition."), _c('a', {
    attrs: {
      "href": "#/#foot-note-738",
      "id": "footnote-738"
    }
  }, [_c('sup', [_vm._v("232")])]), _vm._v(" Furthermore, there were competing notions of how to observe the law: Sabbath restrictions that Nehemiah implemented were stricter than the prevailing interpretation, and Nehemiah’s covenant renewal ceremony probably created some new laws (see below)."), _c('a', {
    attrs: {
      "href": "#/#foot-note-737",
      "id": "footnote-737"
    }
  }, [_c('sup', [_vm._v("233")])]), _vm._v(" Also, Ezra’s new definition of intermarriage, which required the exclusion of all foreign wives, qualifies as a new law.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Another point to consider is that while laws may have ancient origins, their codification is often much later. Thus, the book of the Torah in the form we have it may have been compiled in the Persian period, but its laws represent an ongoing sacred tradition of interpretation and practice reaching further back into antiquity. It is probably correct to say with Albertz and Becking that the end of the monarchy and temple, as well as the subsequent return and restoration, “started a process of reflection and reformulation of Israel’s religious tradition ending in the re-edition—and in some cases first edition—of religious texts.”"), _c('a', {
    attrs: {
      "href": "#/#foot-note-736",
      "id": "footnote-736"
    }
  }, [_c('sup', [_vm._v("234")])]), _vm._v(" As Jaffee puts it, “The literary strands of the Hebrew Bible were contributed in large measure by ancient Israel, but the weaving was done on a Persian loom.”"), _c('a', {
    attrs: {
      "href": "#/#foot-note-735",
      "id": "footnote-735"
    }
  }, [_c('sup', [_vm._v("235")])])]), _vm._v(" "), _c('p', {
    staticClass: "table_title",
    attrs: {
      "id": "tab1"
    }
  }, [_vm._v("Pentateuchal Traditions Reflected in Ezra-Nehemiah"), _c('a', {
    attrs: {
      "href": "#/#foot-note-734",
      "id": "footnote-734"
    }
  }, [_c('sup', [_vm._v("236")])])]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid30"
  }, [_c('p', {
    staticClass: "t-header"
  }, [_vm._v("Tradition")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30"
  }, [_c('p', {
    staticClass: "t-header"
  }, [_vm._v("Pentateuch")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30"
  }, [_c('p', {
    staticClass: "t-header"
  }, [_vm._v("Ezra-Nehemiah")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Holy people; no intermarriage with local Canaanites")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Deut 7:3")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ezra 9:2; Neh 10:30(31); 13:25")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Prohibition of Ammonites/Moabites in the assembly")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Deut 23:4–5(3–4)")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Neh 13:1–2")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Divine promise to return penitent Israelites from diaspora")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Deut 30:1–5 paraphrase")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Neh 1:8–9")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Constructing booths for the Festival of Sukkot")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Lev 23:42–43")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Neh 8:14–15")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Solemn assembly on Sukkot, day 8")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Lev 23:36, 39")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Neh 8:14–15")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Festival sacrifices")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Num 29:12–38")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ezra 3:4")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Passover and Feast of Unleavened Bread; participation regulations regarding strangers and ritual purification")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Exod 12:43–49; Lev 23:4–5; Num 9:1–14")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ezra 6:19–22; Neh 12:30")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Annual temple tax")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Exod 30:11–16 (half shekel)")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Neh 10:32(33)")]), _vm._v(" "), _c('p', {
    staticClass: "t-left"
  }, [_vm._v("(one-third shekel)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Purification of rooms")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Lev 14:34–45; Num 19:18")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Neh 13:8–9")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Daily burnt offering")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Exod 29:38–42; Num 28:3–8")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ezra 3:3, 5")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Sanctifying the Sabbath")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Exod 16:23; 20:8–11; 31:14; Deut 5:12–15")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Neh 13:15–22")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Tithes for priests and Levites")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Num 18:25–32")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Neh 10:37–38(38–39)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Firstlings and firstfruits")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Lev 23:14; Num 18:15–16; Deut 15:19–20; 26:1–4")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Neh 10:35–37(36–38)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("No lending at interest")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Lev 25:36–37; Deut 23:19–20")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Neh 5:7–13")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Sabbatical Year brings debt release and fallow land")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Deut 15:1–3; Lev 25:1–7, 18–24")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Neh 10:31b(32b)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Confessing sins ("), _c('em', [_vm._v("hitwaddâ")]), _vm._v("), as a ritual act in the atonement process")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Lev 5:5; 16:20–22; 26:40; Num 5:7")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ezra 10:1; Neh 1:6; 9:2–3")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Separating ("), _c('em', [_vm._v("bādal")]), _vm._v(") from impurity")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Lev 10:10; 11:44–47; 20:25–26")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ezra 6:21; Neh 9:2; 13:3")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Sacrilege ("), _c('em', [_vm._v("ma")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("al")]), _vm._v(")")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Lev 5:15–26; 26:40; Num 5:6")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ezra 9:2, 4; 10:2, 10; Neh 13:27")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Guilt offering ("), _c('em'), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ʾ")]), _c('em', [_vm._v("āšām")]), _vm._v(")")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Lev 5:15–26; 7:1; 19:20–22")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ezra 10:10")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Sacred forfeiture ("), _c('em'), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ḥ")]), _c('em', [_vm._v("erem")]), _vm._v(")")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Lev 27:28; Deut 13:16–17; 20:16–17")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ezra 10:8")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Abominable practices ("), _c('em', [_vm._v("tô")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("ēbôt")]), _vm._v(")")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Lev 18:24–30")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ezra 9:11, 14")])])])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-16"
    }
  }, [_vm._v("3. Legacy")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Ezra-Nehemiah not only reflects a heritage from the Torah, but it represents an ongoing, innovative tradition of interpretation. The people not only come to appreciate the Torah, but they observe it in new ways as they face new challenges. As Eskenazi points out, Ezra-Nehemiah transforms most of its inherited material and traditions. In fact, that is often a main reason for producing any new text; observing Torah is both a receptive and a creative process."), _c('a', {
    attrs: {
      "href": "#/#foot-note-733",
      "id": "footnote-733"
    }
  }, [_c('sup', [_vm._v("237")])]), _vm._v(" For example, Ezra-Nehemiah’s attitude to outsiders is more stringent than Torah law, but it is in keeping with a new social context—one over which the Jews have little control. The threat of idolatry and syncretism, which are strong Pentateuchal concerns and had landed the Jews in exile, must be avoided at all costs, and thus greater stricture in the areas of marriage and outsiders was enforced. The law does not remain static but is engaged to meet challenges unprecedented in Israelite history.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("There are strong links between the legal innovations of Ezra-Nehemiah and the development of Jewish law in later Judaism. Schiffman speaks of “extrapolating forward” the laws of Ezra-Nehemiah and other biblical Second Temple texts as well as attempting to “extrapolate back” traditions enmeshed in later Second Temple texts and the Mishnah."), _c('a', {
    attrs: {
      "href": "#/#foot-note-732",
      "id": "footnote-732"
    }
  }, [_c('sup', [_vm._v("238")])]), _vm._v(" Complicating the process is the fact that the law was not a simple chronological development in this period but was interpreted differently by competing groups of Jewish sages and priests. To be sure, the Torah was not the sole influence in the development of these new ideas: some simply reflect ancient custom (one-third shekel), others are new applications of the Torah in response to current issues (intermarriage, genealogical purity), and some refer to the treatment and method of interpretation of the Torah itself (midrash, synagogue practice). Moreover, some innovations are simply a matter of emphasis rather than new practices (Sabbath, correct priesthood). The following are nine areas of Jewish religion and law apparent in Ezra-Nehemiah that represent new directions in Second Temple Judaism."), _c('a', {
    attrs: {
      "href": "#/#foot-note-731",
      "id": "footnote-731"
    }
  }, [_c('sup', [_vm._v("239")])]), _vm._v(" Several points of ideology go on to become standard practice among all Jews, while others represent pivotal issues separating Jews from each other. The advent of Hellenism often exacerbated this tension.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("1. "), _c('em', [_vm._v("Intermarriage")]), _vm._v(". Through a stringent interpretation of Torah law, Ezra and Nehemiah both forbid intermarriage with non-Jews and even consider the latter impure (Ezra 9:1–2; Neh 10:31[32]). Deuteronomy forbids Israel to intermarry with the seven Canaanite nations and even requires their complete annihilation because of their pagan influence on Israel (Deut 7:1–6; cf. Exod 34:15–16). However, the Torah also allows for inclusion of the resident alien (see Deut 16:14; 29:11) and marriage with a foreign captive bride through a process of inculturation (Deut 21:10–14; cf. the marriage of Moses to a foreigner, Num 12:1). These texts were undoubtedly known to Ezra and Nehemiah, but they chose to ignore this flexibility. Instead, they ban all marriages with non-Jews on both religious and genealogical grounds, giving no recourse to a gentile who wishes to take up residence with the community and commit to its religious practice. By sending away foreign wives along with their children, Ezra-Nehemiah also supply the earliest source for the Jewish law that the ethnicity of a child is based on the race of its mother."), _c('a', {
    attrs: {
      "href": "#/#foot-note-730",
      "id": "footnote-730"
    }
  }, [_c('sup', [_vm._v("240")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Several other Jewish texts in Second Temple times follow Ezra-Nehemiah by banning intermarriage. Aramaic Levi (ca. 300 BCE), Jubilees (ca. 150 BCE), and several other texts found among the Dead Sea Scrolls (e.g., 4QMMT) refer to intermarriage as "), _c('em', [_vm._v("z")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ə")]), _c('em', [_vm._v("nût")]), _vm._v(", sexual impurity."), _c('a', {
    attrs: {
      "href": "#/#foot-note-729",
      "id": "footnote-729"
    }
  }, [_c('sup', [_vm._v("241")])]), _vm._v(" Paul warns against intermarriage based on religious but not ethnic concerns. He exhorts the Corinthian church not to be “unequally yoked with unbelievers” (2 Cor 6:14 ESV).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("2. "), _c('em', [_vm._v("Temple practice")]), _vm._v(". Several practices connected to the temple cult known to be critical to later Judaism are found in Ezra-Nehemiah. Some of these are not mentioned in the Pentateuch, but Ezra-Nehemiah confirms their early antiquity. For example, the rabbis consider a donation of one-third shekel annually to the temple to be legally binding, and they also give evidence of a collection of wood for the altar. Furthermore, the rotation of shifts of priests and Levites is not spelled out in the Pentateuch, but it is in effect in Ezra-Nehemiah (see the commentary on Ezra 6:18; Neh 12:9). Several cultic practices that are described in the Torah and present in Ezra-Nehemiah continue to be obligatory even after the demise of the temple. These include firstfruits offerings, the redemption of the firstborn, the temple tax, eating of firstborn male animals by priests, an agricultural offering for the priests ("), _c('em', [_vm._v("t")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ə")]), _c('em', [_vm._v("rûmâ")]), _vm._v("), the dough offering ("), _c('em'), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ḥ")]), _c('em', [_vm._v("allâ")]), _vm._v("), and tithes for priests and Levites (see Neh 10:35–40)."), _c('a', {
    attrs: {
      "href": "#/#foot-note-728",
      "id": "footnote-728"
    }
  }, [_c('sup', [_vm._v("242")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In addition, the pilgrimage festivals, which hold a prominent role in Ezra-Nehemiah (e.g., Passover), continue in Judaism to this day. While these celebrations stem from the Torah, they take on new details of interpretation and customary practice throughout Second Temple Judaism. This process is evident in Nehemiah 8:13–15 (see the commentary there) regarding the Festival of Sukkot, which provides a biblical example of interpretation of Lev 23:40–42.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("3. "), _c('em', [_vm._v("Sabbath")]), _vm._v(". The effort to stop others from doing business on the Sabbath becomes a key issue in Second Temple Judaism. Nehemiah raises the bar on Sabbath observance when he bans foreigners from trading in a market on the outskirts of Jerusalem and even locks the door of the holy city (Neh 13:15–22). This assumes the addition of Isa 58:13 and Jer 17:21–22, 24, 27 to the Torah Sabbath prohibitions. This attitude is also reflected in the Damascus Document from Qumran, but rabbinic law considers this interpretation a non-biblical injunction (see CD x 14–xii 6)."), _c('a', {
    attrs: {
      "href": "#/#foot-note-727",
      "id": "footnote-727"
    }
  }, [_c('sup', [_vm._v("243")])]), _vm._v(" Sabbath law becomes a marker in Second Temple Judaism dividing observant Jews from those who would compromise due to Hellenistic pressure.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("4. "), _c('em', [_vm._v("Torah reading and interpretation")]), _vm._v(". Nehemiah 8–10, with its public Torah reading and covenant renewal ceremony, provides the model for later Torah study and ritual. Ezra reads the Torah to the assembly supported by other leaders of the community. Then the Levites help him explain the text to the people so that they can understand its meaning (Neh 8:7–8).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Ezra-Nehemiah records the earliest mention of the root "), _c('em', [_vm._v("dāraš")]), _vm._v(" in the sense of studying and interpreting the Torah (Ezra 7:10). According to later usages, the noun "), _c('em', [_vm._v("midrash")]), _vm._v(" refers to interpreting a passage of the Torah in light of another passage. In this way, the rabbis were able to harmonize Torah passages that seem to be disparate using linguistic connections to other biblical passages, and this became the dominant method of rabbinic exegesis.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Although Ezra-Nehemiah does not refer to any specific interpretation of the Torah as midrash, it gives some evidence of this process in embryo. For example, J. Milgrom argues that Ezra has “spun a midrash” between Deuteronomy’s description of Israel as “a holy people” and Jer 2:3, which uses the priestly doctrine of sacrilege metaphorically to invoke destruction on Israel’s enemies (i.e., by their invasion, they have desecrated a sanctum, Israel, and must be punished)."), _c('a', {
    attrs: {
      "href": "#/#foot-note-726",
      "id": "footnote-726"
    }
  }, [_c('sup', [_vm._v("244")])]), _vm._v(" Ezra-Nehemiah redirects the metaphor against Israel, who has desecrated and endangered herself by intermarriage with unholy outsiders. Israel’s holy status was conferred on her by Yahweh at Sinai, but, according to Ezra 9:1–2, this status was now breached and the “holy seed” profaned by marriage with “unholy” gentiles.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Although this style of studying the Bible would become the dominant form of exegesis in rabbinic literature, it is already evident at Qumran with less sophistication and without reference to the formal types of techniques known later."), _c('a', {
    attrs: {
      "href": "#/#foot-note-725",
      "id": "footnote-725"
    }
  }, [_c('sup', [_vm._v("245")])]), _vm._v(" Among the Dead Sea Scrolls, the term "), _c('em', [_vm._v("midrash")]), _vm._v(" can carry the general meaning of inquiry (1QS vi 24); studying and interpreting the Torah (1QS viii 15, 26; 4Q270 7 ii 15; cf. 4QpNah i 3–4); and even the more particular method of interpreting one passage of Scripture in light of another (4Q174 i 14).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("5. "), _c('em', [_vm._v("Ransom of captives")]), _vm._v(". The Jewish duty to buy back other Jews who have been sold to foreigners or otherwise been forcibly detained by them is called "), _c('em', [_vm._v("pidyôn š")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ə")]), _c('em', [_vm._v("bûyîm")]), _vm._v(" (“the ransom of the captives,” m. Ketub. 4:8–9; m. Gi"), _c('span', {
    staticClass: "chari-r"
  }, [_vm._v("ṭ")]), _vm._v(". 4:6, 9; b. B. Bat. 8ab). The requirement begins in Leviticus, in which family members are obliged to redeem those of the clan who have fallen into foreign hands (Lev 25:47–55), but Nehemiah interprets the requirement as a duty of not only the clan but the entire Jewish community (Neh 5:5–12; see the commentary there). Further evidence of this cultural norm in Second Temple times comes from King Herod, who considered selling Jewish criminals to foreigners but was told that this action would only increase the Jews’ hatred of him (Josephus, "), _c('em', [_vm._v("Antiquities")]), _vm._v(" 16.1–4).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("6. "), _c('em', [_vm._v("Synagogue practice")]), _vm._v(". The synagogue practice of later Judaism is reflected to some degree as early as Ezra-Nehemiah. In fact, several aspects of synagogue practice known in the modern world are reflected here for the first time together: (1) the assembly of the people; (2) the request for reading the Torah; (3) the opening of the scroll while the people stand; (4) Ezra’s blessing; (5) the congregation’s response with “Amen”; (6) sermon instruction; (7) Torah reading; (8) oral explanation and exhortation; and a (9) fellowship meal (Neh 8:4–7)."), _c('a', {
    attrs: {
      "href": "#/#foot-note-724",
      "id": "footnote-724"
    }
  }, [_c('sup', [_vm._v("246")])]), _vm._v(" It is hard to know when public Torah reading became fully institutionalized, but by the first century CE, it was a common practice among Jews to hold weekly sessions to read and study the Torah."), _c('a', {
    attrs: {
      "href": "#/#foot-note-723",
      "id": "footnote-723"
    }
  }, [_c('sup', [_vm._v("247")])]), _vm._v(" It was unique in the ancient world for an entire community to devote itself to reading a sacred text as an act of worship. Also, lifting one’s hands in prayer is an ancient Jewish custom that expresses worship to God and demonstrates need (see Pss 28:2; 134:2; 1 Tim 2:8), and one could add the use of a raised platform or lectern for the Torah reader."), _c('a', {
    attrs: {
      "href": "#/#foot-note-722",
      "id": "footnote-722"
    }
  }, [_c('sup', [_vm._v("248")])]), _vm._v(" Even the practice of assembling the people at the “gate,” a location outside the temple precincts, for Torah study (see Neh 8:1) may be a precursor to synagogue practice."), _c('a', {
    attrs: {
      "href": "#/#foot-note-721",
      "id": "footnote-721"
    }
  }, [_c('sup', [_vm._v("249")])]), _vm._v(" Many of these elements have found their way in various forms into Christian ecclesiastical practice as well. This is unsurprising, since the earliest church assemblies consisted of Jewish Christians.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("7. "), _c('em', [_vm._v("Priesthood")]), _vm._v(". The tension between lay authorities (scribe, governor) and priests is prominent in Ezra-Nehemiah. Ezra, who is not the high priest, wields authority over all the priests in the matter of intermarriage, and he is challenged by some (Ezra 10:15). Nehemiah takes upon himself to purge the priesthood from foreign mixture as well, albeit in opposition to the measures of the ruling high priest (Neh 13:4–5, 28, 30). The emphasis on the correct genealogy of the priesthood with supporting credentials becomes an issue in Ezra-Nehemiah (Ezra 2:62–63; Neh 7:64–65) that continues in Second Temple Judaism. One text fragment from Qumran records the case of a priest who had been taken captive into a gentile area; upon his return, he was no longer accepted to serve as a priest (4Q266 5 ii 5–7).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The corruption of the priesthood noted by Nehemiah had a legacy. The high priest’s office was often granted or sold to the highest bidder in the Second Temple period. According to Josephus ("), _c('em', [_vm._v("Antiquities")]), _vm._v(", book 11), the governor Bagohi (= Bagoses), perhaps Nehemiah’s successor, offered the high priesthood to a friend, Jeshua, who was the brother of the reigning high priest, Johanan. This scandal ended in the murder of Jeshua within the temple precincts. Another story is told of Manasseh, brother of the high priest Jaddua, whose marriage to the daughter of Sanballat, governor of Samaria, caused a scandal. The elders of Jerusalem forced him to choose between his priesthood and his wife. Manasseh rejected the elders and joined Sanballat, who offered to build him a temple on Mt. Gerizim, where he could be the priest in charge. Whether or not these stories are true, the notion that the priesthood’s genealogy must be protected from intermarriage became more pronounced as the Jews moved from the time of Ezra into the Hellenistic period."), _c('a', {
    attrs: {
      "href": "#/#foot-note-720",
      "id": "footnote-720"
    }
  }, [_c('sup', [_vm._v("250")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("8. "), _c('em', [_vm._v("Holiness")]), _vm._v(". The expansion of the label of holiness in physical ways beyond the priests and the temple is evident in Ezra-Nehemiah. This is most apparent with regard to the holy people (see "), _c('span', {
    attrs: {
      "href": "#/012_Chapter02c#exc9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excursus 9, “The Sacrilege of Intermarriage,” pp. 244–54")]), _vm._v(") and the city of Jerusalem (see "), _c('span', {
    attrs: {
      "href": "#/014_Chapter03b#exc21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excursus 21, “Jerusalem, the Holy City,” pp. 428–38")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("9. "), _c('em', [_vm._v("Purity")]), _vm._v(". Although not a major theme in Ezra-Nehemiah, ritual purification does surface in a few places. Jews must purify themselves before participating in the sacred festivals (Ezra 6:21; Neh 13:9). Even the wall and gates are ritually purified as part of its dedication (Neh 12:30).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The "), _c('em', [_vm._v("gēr")]), _vm._v(" (a gentile who wishes to live among the community and subscribe to its regulations) and even some Jews are excluded and referred to as impure. Nowhere in the Pentateuch are gentiles viewed as a source of pollution specifically because they are gentiles."), _c('a', {
    attrs: {
      "href": "#/#foot-note-719",
      "id": "footnote-719"
    }
  }, [_c('sup', [_vm._v("251")])]), _vm._v(" Like Leviticus, Ezra-Nehemiah uses purity rhetoric for social ends, but unlike Leviticus, Ezra-Nehemiah does not allow for permeability in this boundary."), _c('a', {
    attrs: {
      "href": "#/#foot-note-718",
      "id": "footnote-718"
    }
  }, [_c('sup', [_vm._v("252")])]), _vm._v(" Building on the Levitical concept that Yahweh wants a distinction between his people and others (see Lev 20:24–26), Ezra-Nehemiah moves to labeling those others as impure and separating them."), _c('a', {
    attrs: {
      "href": "#/#foot-note-717",
      "id": "footnote-717"
    }
  }, [_c('sup', [_vm._v("253")])]), _vm._v(" In contrast to earlier law, Nehemiah finds it imperative to purify rooms in the temple occupied by a man of mixed ancestry, Tobiah the Ammonite (cf. Neh 4:3; 13:9). While this man is a Yahwist, he is not accepted into the group, and his residence in the temple precincts, although apparently sanctioned by the reigning high priest, is considered a pollution by Nehemiah.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Despite the universalist vision of the prophets for the end times (e.g., Isa 49:6), the application of ritual impurity to outsiders, which is attested as early as Ezra-Nehemiah, continues in many Second Temple texts (e.g., 2 Macc 5:27; Mal 2:11–12)."), _c('a', {
    attrs: {
      "href": "#/#foot-note-716",
      "id": "footnote-716"
    }
  }, [_c('sup', [_vm._v("254")])]), _vm._v(" In the same vein, the New Testament too indicates that many Jews considered it necessary to wash themselves after contact with gentiles (Acts 10:28; cf. Mark 7:3–4). Josephus in fact points out that accusations regarding impure food or violating the Sabbath were a prominent way of ostracizing fellow Jews from the community ("), _c('em', [_vm._v("Antiquities")]), _vm._v(" 11.346–347).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The idea that even Jews can be labeled with ritual impurity because they do not follow a community’s interpretation of the Torah is brought to its most extreme expression in the Dead Sea Scrolls, where not only certain bodily conditions but also moral violations bring about ritual impurity."), _c('a', {
    attrs: {
      "href": "#/#foot-note-715",
      "id": "footnote-715"
    }
  }, [_c('sup', [_vm._v("255")])]), _vm._v(" The Community Rule states that new members are purified by their humble repentance as well as the cleansing waters (1QS iii 6–9). According to the Damascus Document, the word of a transgressor is not believed until the person has been ritually purified (CD x 2). Violators of any of the sect’s laws become impure and are excluded from handling or eating the “purity” ("), _c('em'), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ṭ")]), _c('em', [_vm._v("ohŏrâ")]), _vm._v("; i.e., ritually pure items, especially food), lest they pollute it (1QS v 14).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("According to several scrolls, gentile impurity is ritually contagious to persons and food. Initiates to the sect must undergo a two-year trial period before being fully accepted to the communal table (1QS vi 17–21; cf. “three years” in Josephus, "), _c('em', [_vm._v("War")]), _vm._v(" 2.138). The phrase “impurity of the gentiles,” reminiscent of Ezra-Nehemiah, is applied in 4Q266 to priests who have returned from captivity among gentiles and so may not enter the inner sanctuary because they have been defiled (4Q266 5 ii 7)."), _c('a', {
    attrs: {
      "href": "#/#foot-note-714",
      "id": "footnote-714"
    }
  }, [_c('sup', [_vm._v("256")])]), _vm._v(" The Temple Scroll author forbids a woman taken as a captive bride (Deut 21:10–14) to eat her Jewish husband’s pure food for seven years (11Q19 lxiii 14–15). (For further discussion, see "), _c('span', {
    attrs: {
      "href": "#/014_Chapter03c#exc23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excursus 23, “Gentile Impurity,” pp. 469–77.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The table below outlines traditions that are in Ezra-Nehemiah but not evident in the Pentateuch and gives references to the continuity of these notions in later Jewish literature. Further discussion and references are included in several of the notes and excurses throughout the commentary.")]), _vm._v(" "), _c('p', {
    staticClass: "table_title"
  }, [_vm._v("Traditions Reflected in Ezra-Nehemiah and in Other Second Temple Literature but Not in the Pentateuch")]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid30"
  }, [_c('p', {
    staticClass: "t-header"
  }, [_vm._v("Tradition")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30"
  }, [_c('p', {
    staticClass: "t-header"
  }, [_vm._v("Ezra-Nehemiah")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30"
  }, [_c('p', {
    staticClass: "t-header"
  }, [_vm._v("Second Temple Literature")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Wood offering for the temple")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Neh 10:34(35); 13:31")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("4Q365 23; Josephus, "), _c('em', [_vm._v("War")]), _vm._v(" 2.425; b. Ta"), _c('span', {
    staticClass: "chari-r"
  }, [_vm._v("ʿ")]), _vm._v("an"), _c('em', [_vm._v(".")]), _vm._v(" 28a")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Expansion of “holy house” to “holy city”")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Neh 3:1; 11:1, 18")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Isa 48:2; 52:1; Dan 9:24; 11Q19 xlvi 9–12; 4QMMT"), _c('sup', [_vm._v("b")]), _vm._v(" 59–62; 2 Macc 1:7; Josephus, "), _c('em', [_vm._v("Antiquities")]), _vm._v(" 9.10; Wis 12:3; 2 Bar 71:1; 84:8")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Stricter Sabbath law than Pentateuch imposed on business and trade")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Neh 13:16–22; cf. Jer 17:21–27; Amos 8:5")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("CD xi 16–17; Jub 2:17–33; 50:6–13")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Fasting during a crisis (not the Day of Atonement)")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ezra 8:21–23; 9:5–10:6; Neh 1:4; 9:1")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Zech 7:3, 5; 8:19; Esth 4:3, 16; Dan 9:3; 10:2–3; Tob 12:8; Jdt 8:6; Matt 17:21; Acts 14:23; cf. m. Ta"), _c('span', {
    staticClass: "chari-r"
  }, [_vm._v("ʿ")]), _vm._v("an. 4:6")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Minimum age for Levites")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ezra 3:8, fixed at 20 (cf. age 25 in Num 8:24)")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("1 Chr 23:24, 27")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("All intermarriage with non-Jews forbidden based on ethnicity")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ezra 9:1; 10:11–12; Neh 13:23–25")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("4QMMT"), _c('sup', [_vm._v("b")]), _vm._v(" 75–76, 81–82; Aramaic Levi Document 6.4; T. Levi 9:9–10; 14:6; Tg. Ps.-J. on Lev 18:21; Jub. 30:13–15; m. Meg. 4:9")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Midrash Torah")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ezra 7:10; cf. Neh 8:13; 9:3")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Sir 3:20–22; 24:33; 1 QS viii 15, 26; 4Q270 7 ii 15; cf. 4QpNah i 3–4; 4Q174 i 14")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ransom of captives ("), _c('em', [_vm._v("pidyôn š")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ə")]), _c('em', [_vm._v("bûyîm")]), _vm._v(")")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Neh 5:5–12; cf. Lev 25:47–55")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Josephus, "), _c('em', [_vm._v("Antiquities")]), _vm._v(" 16.1–4; m. Ket. 4:8–9; m. Gi"), _c('span', {
    staticClass: "chari-r"
  }, [_vm._v("ṭ")]), _c('em', [_vm._v(".")]), _vm._v(" 4:6, 9; cf. b. B. Bat. 8ab")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Gentile impurity")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ezra 6:21; 9:11; Neh 13:9")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Jub. 22:16–17; 3 Macc. 33:3–7; 1QS v 14–20; m. Pesa"), _c('span', {
    staticClass: "chari-r"
  }, [_vm._v("ḥ")]), _vm._v(". 8:8; t. Zavim 2:1; Acts 10:28")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Rotating shifts of priests and Levites")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Neh 12:24–25; 13:30")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("1 Chr 24:3; 25:1; Josephus, "), _c('em', [_vm._v("Antiquities")]), _vm._v(" 7.365; Luke 1:8")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Genealogical records for priesthood")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ezra 2:62–63; 7:1–5; Neh 7:64–65; 12")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("1 Chr 24:7; Josephus, "), _c('em', [_vm._v("Apion")]), _vm._v(" 1.35–36; 1 Macc 2:1")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Standing before public Torah reading, using a platform/lectern, and other elements of synagogue/early church practice")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Neh 8:4–7")])]), _vm._v(" "), _c('td', {
    staticClass: "wid30-bort"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("1 Macc 3:48; Philo, "), _c('em', [_vm._v("Every Good Person Is Free")]), _vm._v(" 81–82; Luke 4:16–30; Acts 13:15–16; Theodotus; m. Ta"), _c('span', {
    staticClass: "chari-r"
  }, [_vm._v("ʿ")]), _vm._v("an. 2:2; b. Meg"), _c('em', [_vm._v(".")]), _vm._v(" 21a")])])])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-20"
    }
  }, [_vm._v("C. SANCTUARY: THE SECOND TEMPLE")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("J. Blenkinsopp has aptly referred to the Jerusalem temple as the “Center of Gravity” for the ancient Jewish community."), _c('a', {
    attrs: {
      "href": "#/#foot-note-713",
      "id": "footnote-713"
    }
  }, [_c('sup', [_vm._v("257")])]), _vm._v(" It was the nexus of heaven and earth connecting Israel with her God. This was no mere theological principle but a reality graphically demonstrated on occasion by a cloud of God’s glory within the temple (1 Kgs 8:10–11; 2 Chr 5:13–14; Isa 6:4; Ezek 10:4). The prophets report visions of Yahweh’s presence with his angels hovering over the sanctuary (Ezek 9:3; 10:3–4) and speaking to them from within its walls (Isa 6:1–4). These moments were not sterile either but accompanied by earthquakes or other miraculous signs (Isa 6:4–7). Several priests witnessed the glory of God in the temple (1 Kgs 8:11; 2 Chr 5:14; 26:19–20) and received angelic visitors there (Luke 1:11). (See the image of the Second Temple on "), _c('a', {
    attrs: {
      "href": "#/#fig1"
    }
  }, [_vm._v("p. 97")]), _vm._v(".)")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("According to Ezra-Nehemiah, rebuilding the temple was the principal mandate initiated by Yahweh and handed down by Cyrus the Great. The temple became the focal point of Judaism, giving religious identity to the postexilic Jewish community."), _c('a', {
    attrs: {
      "href": "#/#foot-note-712",
      "id": "footnote-712"
    }
  }, [_c('sup', [_vm._v("258")])]), _vm._v(" The author wants to emphasize that the Second Temple cult is a secure home for the unadulterated worship of Yahweh and the only legitimate continuation of Solomon’s temple cult. To this end, the author emphasizes not only the rebuilding effort but also cultic personnel, vessels, and religious festivals. Unlike Solomon’s temple cult, which according to 1 Kgs 8:41–43 welcomed foreigners to come and pray toward the temple, Ezra-Nehemiah makes no provision for them to join in Israelite worship.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The construction and dedication of the First Temple is instructive for understanding the significance of the Second Temple. Yahweh commends David for his desire to build him a house “to his name”—that is, for his honor (1 Kgs 8:19). Furthermore, by placing his name on his house, Yahweh affirms both his ownership of the house and his residence there. This in turn emphasizes the access God’s people can have to him at his house. This point is made especially on the occasion of the dedication of the First Temple, when Yahweh promises Solomon, “I have sanctified this house which you have built, to put my name there forever, and my eyes and my heart will be there perpetually” (1 Kgs 9:3). Solomon reminds Yahweh of these words and his promise that “My name shall be there, that you may listen unto the prayer which your servant will make toward this place” (1 Kgs 8:29; cf. 2 Sam 7:13). Indeed, worshipers are invited to entreat Yahweh for help during crises by repenting and confessing his name at his house (1 Kgs 8:33). Placing the divine name on the temple thus not only indicates that Yahweh is great because he has a house of worship but also proclaims that people have access to him at his house. This biblical concept still supports the assembly of believers at the church, which stands as a beacon of hope to those who would enter, turn to God, and confess his name (see "), _c('span', {
    attrs: {
      "href": "#/014_Chapter03a#exc14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excursus 14, “The Name Yahweh,” pp. 314–17")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Second Temple is presented as the legitimate successor to Solomon’s Temple in several ways. Parallels between the accounts of both temple-building processes present the new temple as a restoration of the old one, not a completely new one (see the commentary on Ezra 3:7). The original temple vessels are restored completely, counted out, and brought back."), _c('a', {
    attrs: {
      "href": "#/#foot-note-711",
      "id": "footnote-711"
    }
  }, [_c('sup', [_vm._v("259")])]), _vm._v(" Also, the genealogies of the builders go back to First Temple times. Some of those who attended the First Temple are present at the dedication of the new altar (Ezra 3:12), which is built right on the original spot (Ezra 3:3). The building process is comparable to that of Solomon’s Temple (see Ezra 3:7 with 1 Chr 22); similar categories of builders are hired, including Sidonians and Tyrians who are commissioned to bring cedars from Lebanon through Joppa (2 Chr 2:16). Also, Levites are mustered for both occasions (1 Chr 23:4; Ezra 3:9).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Using ancient sources, Schiffman provides a description of Zerubbabel’s temple:")]), _vm._v(" "), _c('p', {
    staticClass: "quotes_bq"
  }, [_vm._v("It had two courtyards. One report suggests dimensions of 500 by 100 cubits (about 750 by 150 feet) for the inner courtyard. There were at least four gates in the wall of the outer courtyard, and at least one of them faced a street. There were at least two gates to the inner courtyard. Various chambers surrounded the Temple in both courtyards. Most of these were in the outer courtyard, and were used for the storage of tithes, equipment, and vessels. Certain high officials apparently merited private chambers within the Temple precincts. The returnees constructed their altar on the site of the altar of the First Temple. The Temple building was of hewn stone, with wooden beams reinforcing the walls from within. The Temple itself was 60 cubits (approximately 90 feet) high. The Holy of Holies was empty, as there was no ark and no cherubim."), _c('a', {
    attrs: {
      "href": "#/#foot-note-710",
      "id": "footnote-710"
    }
  }, [_c('sup', [_vm._v("260")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Although it was refurbished by Simon the Just (ca. 200 BCE) and to a greater extent by Herod the Great (20/19 BCE), the Second Temple was to stand at the center of Judaism for the entire period from Zerubbabel to its destruction by the Romans in 70 CE. Even the sectarian community reflected in Qumran texts never freed itself from the temple entirely but expected to one day renovate its cult."), _c('a', {
    attrs: {
      "href": "#/#foot-note-709",
      "id": "footnote-709"
    }
  }, [_c('sup', [_vm._v("261")])]), _vm._v(" Jewish Christians, and the author of Hebrews in particular, who regarded the work of Jesus Christ as supererogatory to the temple, still felt compelled to reinterpret it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The daily sacrifice ("), _c('em', [_vm._v("tāmîd")]), _vm._v("), offered every morning and afternoon, was essential to the temple cult. At these times, a lamb was offered in order to keep the holy fire on the altar burning and thus maintain the means of atonement in Israel (see Lev 6:2–6, 8–13). The sacrifices were accompanied by meal and drink offerings (Exod 29:38–43; Num 28:1–8). Incense was offered (Exod 30:7–8), and apparently psalms were sung (1 Chr 23:30–31). These two daily worship services marked the beginning and end of the day’s cultic activities, and together they validated the rest of the sacrifices which might be offered as well as worship in general. P. Trudinger describes it: “As breathing is a sign of a living body, so the performance of the Tamid service was a sign of a living cult, without which no other cultic practice had meaning.”"), _c('a', {
    attrs: {
      "href": "#/#foot-note-708",
      "id": "footnote-708"
    }
  }, [_c('sup', [_vm._v("262")])]), _vm._v(" Nehemiah orders the people to pay one-third of a shekel as a tax for the maintenance of the "), _c('em', [_vm._v("tāmîd")]), _vm._v(" and other temple sacrifices (Neh 10:32–33[33–34]; cf. Ezek 46:13–15, who places this obligation on the ruler).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The origins of the Second Temple were not, as some might suppose, the beginnings of ritualism and legalism. Rather, Ezra-Nehemiah emphasizes the vitality of worship throughout. The first act the community undertakes upon the first return under Zerubbabel is to immediately rebuild the altar of the temple on the same spot as the old altar and begin worshiping Yahweh (Ezra 3:2–3). Temple Servants, gatekeepers, and musicians returned from exile ready to enhance the worship of the soon-to-be-restored temple, along with over four thousand priests and hundreds of Levites (Ezra 2:36–61).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("This focus on the cult is not limited to the restored operations of the temple but emphasizes the worship of the entire community offering collective praise to Yahweh. Kidner describes it so:")]), _vm._v(" "), _c('p', {
    staticClass: "quotes_bq"
  }, [_vm._v("colour and movement of the great occasions of worship, with instrumentalists and antiphonal singers, with the congregation’s shouts of joy or lamentation … with morning and evening sacrifices and with choirs which had their named leaders (cf. Neh 11:17, 23; 12:8f., 24). All this was intensified at festivals, which added the dimension of a vivid commemoration of God’s saving acts—whether with the passover lamb and the unleavened bread (Ezra 6:20ff.) or with the home-made arbours that turned all Jerusalem into an Exodus encampment (Neh 8:14ff.)."), _c('a', {
    attrs: {
      "href": "#/#foot-note-707",
      "id": "footnote-707"
    }
  }, [_c('sup', [_vm._v("263")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The author of Ezra-Nehemiah makes repeated references to priests, Levites, singers and celebrations (Ezra 3:10–13; 6:16–22; Neh 12:27–43), emphasizing the timeless conviction that "), _c('em', [_vm._v("the joy of Yahweh is your strength")]), _vm._v(" (Neh 8:10).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Jewish tradition of the afternoon prayer ("), _c('em', [_vm._v("min")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ḥ")]), _c('em', [_vm._v("â")]), _vm._v("; see m. Ber. 4:1; m. Pesa"), _c('span', {
    staticClass: "chari-r"
  }, [_vm._v("ḥ")]), _vm._v(". 10:1; b. Ta"), _c('span', {
    staticClass: "chari-r"
  }, [_vm._v("ʿ")]), _vm._v("an. 12b; m. Ma"), _c('span', {
    staticClass: "chari-r"
  }, [_vm._v("ʿ")]), _vm._v("aś. Š. 5:10) dates back at least to the time of Ezra, who offered his penitential prayer at the time of the perpetual evening sacrifices (Ezra 9:5). The term "), _c('em', [_vm._v("min")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ḥ")]), _c('em', [_vm._v("â")]), _vm._v(" technically refers to the fragrant grain offering that often accompanied an animal sacrifice, but it came to be associated especially with the evening incense offering (see Ps 141:2). This was a time of heightened spiritual sensitivity. Several revelations of the angel Gabriel occurred at the time of the evening "), _c('em', [_vm._v("min")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ḥ")]), _c('em', [_vm._v("â")]), _vm._v(", including the revelations to Daniel (Dan 9:21), Zechariah (Luke 1:9f), and the high priest, John Hyrcanus (Josephus, "), _c('em', [_vm._v("Antiquities")]), _vm._v(" 13.282–283). The custom was that the priest entered the temple at this time and offered incense to God while the people prayed in the outer court. No one was allowed to enter the inner court (between the porch and the altar) during this time (m. Kelim 1:9).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("There is an expanded sense of holy space within Ezra-Nehemiah. Like the democratization of the Torah, so, on a certain level, there is a democratization of holiness. According to T. C. Eskenazi, one of the three main themes in Ezra-Nehemiah is “the expansion of the house of God to encompass the city.”"), _c('a', {
    attrs: {
      "href": "#/#foot-note-706",
      "id": "footnote-706"
    }
  }, [_c('sup', [_vm._v("264")])]), _vm._v(" She sees holiness confined to the altar and temple in Ezra 1–6, transferred to all Israel in Ezra 7–10 (the leadership in Ezra 8:28; the laity in Ezra 9:2), and finally to the city of Jerusalem in Nehemiah (Neh 3:1–32; 11:1, 18; 12:27–47). In the summary of Cyrus’s decree (Ezra 6:3), the temple is larger than Solomon’s Temple, and no dimensions are given for the altar area and courts. Eskenazi thinks this is because Ezra 6 is the beginning of the project, which is not completed until Nehemiah finishes and consecrates it (Neh 3:1), conducts a cultic celebration (Neh 7:1; 13:22), and extends the sacred area all the way to the city walls."), _c('a', {
    attrs: {
      "href": "#/#foot-note-705",
      "id": "footnote-705"
    }
  }, [_c('sup', [_vm._v("265")])]), _vm._v(" In the processions to the temple, the laity find themselves “in the house of God” (Neh 12:40), although they are merely within the walls of the city, not the sanctuary itself."), _c('a', {
    attrs: {
      "href": "#/#foot-note-704",
      "id": "footnote-704"
    }
  }, [_c('sup', [_vm._v("266")])]), _vm._v(" Indeed, some level of purity and holiness has been extended beyond the area of the temple to the entire city.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Ezra-Nehemiah builds upon the expansion of holy space already present in some psalms and prophets. The psalmist refers to the city of Jerusalem as the “holy mountain” (Ps 48:1–2). Jeremiah foresees a time when the city will include valleys and fields, all of which will be holy (Jer 31:38–40; see also Isa 52:1; Ezek 48:35; Joel 3:17; Zech 2:11; 14:20). This idea gains further momentum in later Second Temple Judaism. Josephus states that under Antiochus III, only purified Jews could enter the temple complex, and unclean animals, including skins and carcasses, were not allowed into Jerusalem ("), _c('em', [_vm._v("Antiquities")]), _vm._v(" 12.145–146). Some texts from Qumran expand the limits of sacred space to include the entire city of Jerusalem and require greater purity than the Torah on all who enter. 4QMMT refers to all of Jerusalem as the “camp of holiness” (4Q394 iii 10–13; see 11Q19 xlvii 4). In the same vein, the Damascus Document bans sexual relations within the city limits (CD xii 1–2)."), _c('a', {
    attrs: {
      "href": "#/#foot-note-703",
      "id": "footnote-703"
    }
  }, [_c('sup', [_vm._v("267")])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-21"
    }
  }, [_vm._v("D. HOLY PEOPLE")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Ezra 9:2 refers to Israel as “holy seed.” The idea that Israel is supposed to be a holy nation is not new (Exod 19:6; Deut 7:6; Lev 19:2), but the particular phrase “holy seed,” with its emphasis on biological transmission of holiness, is an innovation."), _c('a', {
    attrs: {
      "href": "#/#foot-note-702",
      "id": "footnote-702"
    }
  }, [_c('sup', [_vm._v("268")])]), _vm._v(" The notion of holy people began much earlier than Ezra-Nehemiah. God’s name is on his people, even before the restoration of the temple. The name theology referring to the temple discussed above can also apply to the people. The people belong to God and are given access to him, even without the building. Indeed, the ancient priestly benediction affirms, “I will place my name on the Israelites, and I will bless them” (Num 6:27). Thus, God’s people belong to him, and he takes responsibility for their welfare. At the divine revelation to all Israel at Mt. Sinai, Yahweh promises to establish Israel as a “royal priesthood and a holy nation ("), _c('em', [_vm._v("gôy qādôš")]), _vm._v(")” if she is obedient to him (Exod 19:6). Deuteronomy states that the whole of Israel is a “holy people” ("), _c('em'), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("am qādôš")]), _vm._v(") and is required to destroy seven Canaanite nations lest they intermarry with Israel and influence them to sin (Deut 7:1–6; Ezra 9:1).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Leviticus sets forth what is involved in being Yahweh’s “holy people.” The command to Israel “Be holy as the Lord your God is holy” is found in two contexts: one is ritual, after a catalog of laws regarding impure foods (11:44; cf. 20:26), and the other is moral, coming after a list of sexual impurities and preceding various ethical commands (19:2). Jewish rituals (e.g., circumcision, kosher food laws and ritual purification after contact with impurity) physically enforced Israel’s separation from other nations who, as a rule, would not engage in social intercourse or marriage with such a different culture. This seems to be the intent of the laws in the first place (Lev 20). Notions of purity and impurity surface in Ezra-Nehemiah as a way of reinforcing group identity—the distinction of the holy people vis-à-vis all outsiders."), _c('a', {
    attrs: {
      "href": "#/#foot-note-701",
      "id": "footnote-701"
    }
  }, [_c('sup', [_vm._v("269")])]), _vm._v(" The second aspect of Israel’s holiness is her reflection of Yahweh’s ethical goodness. The second command to be holy in Leviticus comes between a list of laws regulating sexual behavior and a catalog of ethical laws that instill moral integrity. By keeping these laws, Israel reflects the character of Yahweh and begins to fulfill the law “Be holy as I am holy” by imitating him ("), _c('em', [_vm._v("imitatio Dei")]), _vm._v(")."), _c('a', {
    attrs: {
      "href": "#/#foot-note-700",
      "id": "footnote-700"
    }
  }, [_c('sup', [_vm._v("270")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Torah’s “holy people” ("), _c('em'), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("am qādôš")]), _vm._v(", Deut 7:6) becomes Ezra-Nehemiah’s “holy seed” ("), _c('em', [_vm._v("zera")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ʿ")]), _vm._v(" "), _c('em', [_vm._v("haqqōdeš")]), _vm._v(", Ezra 9:2). The identity of “seed” becomes an issue for some of the priests who were unable to verify their descent, “their seed” (Neh 7:61; Ezra 2:59). Unlike the Pentateuch, which grants some latitude with regard to neighboring Moabites, Ammonites, Edomites, and Egyptians (Deut 23), the author adds these groups to the list of Canaanites in Deut 7."), _c('a', {
    attrs: {
      "href": "#/#foot-note-699",
      "id": "footnote-699"
    }
  }, [_c('sup', [_vm._v("271")])]), _vm._v(" Indeed, the Pentateuch’s flexibility on the subject of intermarriage stands in stark contrast to Ezra-Nehemiah. Deuteronomy 21:10–14 outlines a procedure whereby a foreign captive can be taken as a wife by an Israelite. According to Numbers, even Moses married someone who was not of the people of Israel (Num 12:1). By contrast, Ezra expelled 113 foreign women, along with their children, who were married to Jewish men. As Kaufman points out, there is no indication in the text that these women were outright idolaters, but apparently absorption into Israel was not seen as an option for them."), _c('a', {
    attrs: {
      "href": "#/#foot-note-698",
      "id": "footnote-698"
    }
  }, [_c('sup', [_vm._v("272")])]), _vm._v(" The reality behind this new emphasis on holy seed, however it was derived, is that people of other races are simply not eligible for Israel’s holy status even if they renounce their own religion and adopt the worship of Yahweh. The measure seems drastic, but apparently, for this community, a minority group under Persian control, purity of religion could only be entrusted to those who shared its genealogical heritage.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Eskenazi charts the emphasis on holiness in Ezra-Nehemiah from the temple, its altar, and its priests (Ezra 1–6) to the leader and priest Ezra (8:28) to Israel as a community (Ezra 9–10) and finally to the entire city (Neh 3:1–32; 11:2; 12:27–47)."), _c('a', {
    attrs: {
      "href": "#/#foot-note-697",
      "id": "footnote-697"
    }
  }, [_c('sup', [_vm._v("273")])]), _vm._v(" She regards the central matter in Ezra-Nehemiah to be the community, with purity and separation as by-products."), _c('a', {
    attrs: {
      "href": "#/#foot-note-696",
      "id": "footnote-696"
    }
  }, [_c('sup', [_vm._v("274")])]), _vm._v(" In fact, the emphasis on the cult comes to the foreground as an attempt to unify the people into a new community. Still, the parameters of the community were understood to be fixed by the Torah. The cult is subservient to whatever is dictated by what is written as law (Ezra 3:2, 3; 6:14). In Ezra 7–10, separation follows the dictates of the Torah; the goal is reached in Neh 8–10 (or 8–12). At this point, there are clear guidelines as to who is “in” and who is “out” both physically and symbolically. Ezra-Nehemiah turns Jerusalem into a Jewish city, not just a city with some Jewish residents."), _c('a', {
    attrs: {
      "href": "#/#foot-note-695",
      "id": "footnote-695"
    }
  }, [_c('sup', [_vm._v("275")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Thus, the label of holiness in Ezra-Nehemiah is expanded beyond that of earlier texts. It includes an inherent holiness of Israel and her descendants by race, which can be impaired by intermarriage. The exclusion of non-Israelites (no matter which race) is clear from the writer’s emphasis on “holy seed.” Holiness becomes biological, thus disallowing any conversion opportunity. In fact, any mixture of holy seed with nonholy seed results in impairment (see below); only the unadulterated remnant (i.e., the returnees) is “holy seed.” Within Israel, holiness is maintained not only by keeping away from the “abominable practices” of the local population but also by ritual purification before entering sacred time (Ezra 6:19–21) and space (Neh 12:30; 13:22).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The emphasis on holiness in Ezra-Nehemiah extends beyond people and space to other items as well. For example, one of the reforms Nehemiah is especially proud of is the reassignment of the holy portions of crops to the Levites and priests (Neh 12.47; cf. 13:10–14). Apparently, Jews were not “setting aside as holy” agricultural gifts for the Levites. Conversely, priests who were not qualified to receive these gifts were barred from the sacred perquisites (Ezra 2:63; Neh 7:65). Also, Nehemiah puts into place firm measures to guard the holiness of the Sabbath (Neh 10:31[32]; 13:22). In another expansion of laws regarding sancta, several Qumran texts, as well as Josephus’s Essenes, extend the requirement of purity for eating sacred offerings to ordinary food. Thus, an expanded concept of holiness, similar to what is known from later sources, is already in embryo in Ezra-Nehemiah.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The expansion of holiness restricted by purity rituals from the arena of the priests to the laity is a trend among Jewish groups of the Second Temple period. Jubilees claims priestly status for all Israel in line with the Exod 19:6 mandate of the nation to be a royal priesthood. Like Ezra-Nehemiah, this priestly status is based on Israel maintaining sexual purity. Sexual impurity is defined in Jubilees’ retelling of the rape of Dinah as marriage to a gentile. In fact, Jubilees decrees that any Jewish woman who marries a gentile should be burned and the father or brother who arranged the marriage should be stoned (Jub. 30:5–26). This represents a more stringent position than even Ezra-Nehemiah envisioned. 4QFlorilegium describes a “human sanctuary,” a reference to the holiness of its community into which no foreigner is allowed (4Q174 i 4).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The idea develops in Second Temple times that God’s name is on his people even as it is on his house, as is evident in many texts of the Dead Sea Scrolls and the New Testament, whose writers functioned sometimes without a temple building. The writer of 4QFlorilegium regards the community as a human temple that offers up praise to the Creator (4Q174 i 4; cf. “Sanctify yourselves like the holy place,” Aramaic Levi Document 6.4)."), _c('a', {
    attrs: {
      "href": "#/#foot-note-694",
      "id": "footnote-694"
    }
  }, [_c('sup', [_vm._v("276")])]), _vm._v(" Apparently, while the Second Temple stood, the notion that the bodies of Jews were containers of God’s presence was already in place (see "), _c('span', {
    attrs: {
      "href": "#/012_Chapter02c#exc9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excursus 9, “The Sacrilege of Intermarriage,” pp. 244–54")]), _vm._v("). Paul, in fact, in an argument for sexual purity, considers this common knowledge: “Don’t you know that you are a temple of the Holy Spirit?” (1 Cor 6:19). Thus, the bodies of the people of God, selected by him and labeled with his name, become repositories for the Holy Spirit.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "sec-7"
    }
  }, [_vm._v("VII. CHRISTIAN APPLICATION")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("As the exiles return to a changed reality in Yehud, new issues emerge that turn out to be significant in the further course of the history of the Jewish people but also continue to be relevant for Christian believers today. Two basic problems emerge: How does the community adapt to the changed reality described above and still maintain its sense of heritage and continuity with the past? And what should be the relationship of God’s people to the outside world, whether foreign authorities, Jews with different religious practices, or outsiders seeking membership in the community?")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In short, how do God’s people maintain a holy community within a society that applies pressure according to a different value system? On the one hand, Jews found themselves in a completely different social matrix than in the preexilic monarchy: a people without national independence, sharing its homeland with antagonists, with little control over its destiny, paying harsh taxes to a foreign emperor who could as easily destroy as support them, at the whim of local officials too who vilify when they are rebuffed. At the same time, the attraction of the local population is not to be denied, and this comes as an even more difficult issue. How are God’s people supposed to identify and reject the harmful practices and idolatry of the mainstream culture while still seeking to advance themselves in society? In a pluralistic culture, how is one supposed to find a suitable spouse and sustain relations among kin of diverse points of view? The threat of deteriorating faith through assimilation was real, and extinction was a strong possibility. Moreover, internal dissension within the community is frequently a greater threat than external forces.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Ezra and Nehemiah deal with the problem on three levels: education in the Torah as the written Word of God, restoration of temple worship, and maintenance of the daily lives of the community by separation from foreigners with pagan influences. This focus on the Word of God, assembly and worship at his house, and the definition and protection of the community proved to be providential for Jewish survival. The political world would break apart more than once as Jews exchanged their Persian overlords for Greek conquerors and Roman emperors, but their “religious and spiritual cohesion remained firmly established on the foundations laid down during the Persian age by Ezra and Nehemiah, King Darius and King Artaxerxes.”"), _c('a', {
    attrs: {
      "href": "#/#foot-note-693",
      "id": "footnote-693"
    }
  }, [_c('sup', [_vm._v("277")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Like Zerubbabel and Joshua, Christians in the modern world face the temptation of adopting a pluralistic or relativistic attitude toward religion. Christian faith, with its emphasis on faith in Christ’s death and resurrection as the key to acceptance by God, is often considered a primitive alternative to more intelligent ways of thinking. Rationalism is viewed as contrary to biblical faith rather than supporting it."), _c('a', {
    attrs: {
      "href": "#/#foot-note-692",
      "id": "footnote-692"
    }
  }, [_c('sup', [_vm._v("278")])]), _vm._v(" And it is fashionable to accept all forms of belief as valid practice rather than to evaluate them according to the message of Scripture. Tolerance, while a cardinal virtue in any community, must not be confused with affirmation and adoption of religious practice that is contrary to the Word of God.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Torah was the standard Ezra taught and, together with Nehemiah, enforced among the community. The uncompromising stance these leaders adopted against what they viewed as a threat to the continuance of God’s people has drawn much fire from those who view them as unnecessarily harsh. To be sure, their interpretation of the Torah on the matter of intermarriage represents a stringent approach heretofore unknown in Jewish texts. Nevertheless, the community’s status as a minority group without political autonomy makes the measures of Ezra and Nehemiah understandable as the survival of Jewish ethno-religious identity into the next generations took precedence over all other concerns.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Worship at God’s house, an overriding first mission of the returnees, should inspire the Christian as well. The desire to return and rebuild the temple, fueled by the Holy Spirit, was the first goal of the returning exiles. In fact, they could not wait for the completion of the building but began to worship on the quickly built altar set up on its original site (Ezra 3:2–3). The accompaniment of music enhanced the worship on more than one occasion in the narrative, and the writer emphasizes the joy with which the people celebrated the goodness of Yahweh (see the translation note on Ezra 3:12–13; see also "), _c('span', {
    attrs: {
      "href": "#/014_Chapter03c#exc22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excursus 22, “Music and Worship,” pp. 452–55")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The writer reports that, even in times of sorrow and distress, the people worship Yahweh as the Creator and Sustainer of life. In fact, it is in these times that the faithful petitioner confidently challenges Yahweh to act on his behalf. This affirmation is expressed in the prayers of Ezra, Nehemiah, and the Levites. God exists, creates and sustains life, intervenes in human affairs, and cares for his people. As such, he not only is worthy of praise but is the only source of blessing. Thus, the righteous make their petitions to him because he is able to help them, and he has promised to be committed to those who love him (Neh 1:5).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Finally, the community of faith must be protected in every way possible: spiritually, financially, and physically. The leaders must be sensitive to threats to the welfare of the people of God. In Ezra-Nehemiah, prophets encouraged the people to begin anew their efforts to build the temple so as to complete the vision the Spirit had inspired (Ezra 5:1). In an unprecedented and much-criticized decree, both clergy and laity are ordered to divorce foreign wives in order to maintain community solidarity (Ezra 10:5). Nehemiah supervises the building of a new wall to protect the community and organizes its defense under physical attack.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Ezra-Nehemiah is a testimony to God’s willingness to assist leaders in their efforts on behalf of his people. Sheshbazzar plays a passive role in collecting the returnees for the journey to the homeland. Rather, it is the Spirit of God that inspires both the foreign king to support and the Babylonian Jews to make the journey to Jerusalem (Ezra 1:1, 5). Ezra is not significantly challenged despite his harsh decree for men to divorce their foreign wives. Rather, the suggestion to enforce such an edict comes from a member of the community following Ezra’s prayer to God (Ezra 10:1–2). Later, the people rally around him to learn more of the message of God’s Word. After Nehemiah’s fast and prayer for God’s help, he receives divine favor that causes the king to accede to his requests for a furlough and imperial aid (Neh 2:8). Nehemiah is then able to protect the community by organizing the building of a wall around Jerusalem. Authorized by the king as governor of Yehud, he later insists on and receives without question further financial assistance for the beleaguered workers who have become prey to creditors (Neh 5:12). In fact, all of the leaders of the return are granted favor and finances from the Persian authorities (Ezra 1:7; 6:8–9; 7:15; Neh 2:8–9).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("God’s people are holy—that is, they carry his name and are agents of his will. It is through them that the divine will is accomplished in the world. They can take courage from the fact they are in his hand no matter the circumstances. His favor will support every task he inspires. Christians are not on their own in this endeavor. They are linked to one another in the present community of faith, but also to the “great cloud of witnesses” of the past (Heb 12:1)—the generations of the faithful extending all the way back into biblical times. With such a heritage, today’s Christians can find the strength to stand as faithful role models and teachers of the next generation, and the next after that.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "sec-8"
    }
  }, [_vm._v("VIII. OUTLINE")]), _vm._v(" "), _c('p', {
    staticClass: "outline_1"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I. From Babylonian exiles to temple community (Ezra 1:1–6:22)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_2"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec2-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Return to Jerusalem (1:1–2:70)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec3-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Preparation for return (1:1–11)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec4-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a. Imperial authorization (1:1–4)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec4-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b. Enthusiastic response and financial support (1:5–6)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec4-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c. Return of the sacred vessels (1:7–11)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec3-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Genealogical record of returnees (2:1–70)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec4-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a. Returnees by descent (2:1–20)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec4-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b. Returnees by city (2:21–35)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec4-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c. Temple and related personnel (2:36–58)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec4-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("d. Undocumented Israelites/priests (2:59–63)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec4-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("e. Total returnees and animals (2:64–67)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec4-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("f. Financial donations and conclusion (2:68–70)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_2"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec2-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Rebuilding the temple (3:1–6:22)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec3-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Rebuilding the foundations (3:1–13)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec4-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a. Rebuilding and dedicating the altar (3:1–6)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec4-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b. Laying the temple foundations (3:7–13)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_5"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec5-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("i. Requisition of materials (3:7)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_5"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec5-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ii. Commencement of the work (3:8–9)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_5"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec5-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("iii. Laying the foundations amid worship (3:10–11)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_5"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec5-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("iv. Mixed emotional reactions (3:12–13)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec3-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Opposition to the building effort (4:1–6:22)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec4-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a. The local population rejected (4:1–3)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec4-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b. Opposition begins (4:4–6)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec4-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c. Aramaic letters of opposition and suspension during the time of Artaxerxes I (4:7–24)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_5"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec5-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("i. The letter of Bishlam, Mithredath, and Tabeel (4:7)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_5"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec5-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ii. The letter of Rehum and Shimshai (4:8–16)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_5"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec5-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("iii. Artaxerxes’s response (4:17–24)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec4-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("d. Encouragement of the prophets (5:1–2)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec4-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("e. Tattenai’s opposition (5:3–17)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_5"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec5-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("i. Interrogation of the builders (5:3–5)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_5"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec5-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ii. Letter to Darius requesting an investigation (5:6–17)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec4-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("f. Darius’s decrees (6:1–12)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_5"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec5-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("i. Cyrus’s edict is found in the archives (6:1–5)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_5"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec5-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ii. Order to complete the temple with imperial aid (6:6–10)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_5"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec5-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("iii. Threats for neglecting or changing the decree (6:11–12)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec4-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("g. Completion and dedication of the temple (6:13–18)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec4-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("h. Celebration of the Passover and the Festival of Unleavened Bread (6:19–22)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_1"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II. The ministry of Ezra (Ezra 7:1–10:44)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_2"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec2-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Ezra’s authorization (7:1–28)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec3-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Introduction to Ezra (7:1–10)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec4-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a. Ezra’s genealogy (7:1–5)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec4-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b. Ezra’s mission (7:6–10)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec3-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Commission of Ezra by Artaxerxes I (7:11–26)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec3-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Ezra’s praise to Yahweh (7:27–28)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_2"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec2-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Ezra’s journey to Jerusalem (8:1–36)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec3-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. List of returning families (8:1–14)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec3-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Assembly of the people and search for Levites (8:15–20)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec3-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Fasting and prayer (8:21–23)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec3-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Commissioning the priests and Levites with sacred valuables (8:24–30)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec3-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. The journey from the river Ahava to Jerusalem (8:31–34)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec3-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Worship at the temple and delivery of the imperial orders (8:35–36)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_2"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec2-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C. The intermarriage crisis (9:1–10:44)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec3-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Ezra’s trauma (9:1–15)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec4-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a. Elders inform Ezra of the sacrilege of “holy seed” (9:1–2)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec4-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b. Ezra’s horrified reaction (9:3–5)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02c#sec4-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c. Ezra’s prayer (9:6–15)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02c#sec3-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Ezra’s action (10:1–44)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02c#sec4-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a. Confession (10:1–4)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02c#sec4-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b. Oath (10:5–8)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02c#sec4-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c. Assembly in the rain (10:9–15)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02c#sec4-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("d. Investigation of intermarriage cases and expulsion (10:16–17)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02c#sec4-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("e. List of offenders and expulsion of wives (10:18–44)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_5"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02c#sec5-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("i. Temple personnel (10:18–24)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_5"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02c#sec5-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ii. Laity (10:25–44)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_1"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III. Nehemiah rebuilds the wall of Jerusalem (Neh 1:1–6:19)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec2-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Report of Jerusalem in distress (1:1–3)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec2-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Nehemiah’s reaction (1:4–11)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Mourning (1:4)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Prayer (1:5–11)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec2-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C. Artaxerxes commissions Nehemiah (2:1–10)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Nehemiah blurts out his problem to the king (2:1–3)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. The king approves and supports Nehemiah’s journey to Jerusalem (2:4–9)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Opposition from Sanballat and Tobiah (2:10)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec2-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D. Nehemiah surveys the wall (2:11–20)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Private inspection by night (2:11–15)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Meeting with local Jewish leaders (2:16–18)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Dealing with opposition (2:19–20)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec2-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E. The leaders and their crews rebuild the wall in sections (3:1–32)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Priests rebuild the northern end (3:1)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Reconstruction of the northern and western sections (3:2–15)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Reconstruction of the eastern section (3:16–27)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Further repairs to the eastern section (3:28–32)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec2-32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("F. External opposition to the building project (4:1–23)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Scoffing from Sanballat and Tobiah (4:1–3)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Nehemiah’s prayer and enclosure of the wall (4:4–6)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Threats and discouragement (4:7–12)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Nehemiah provides military protection, and the builders bear arms (4:13–23)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec2-33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("G. Internal oppression (5:1–19)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Complaint of oppression by fellow Jews (5:1–5)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Nehemiah accuses creditors of abusing kinship bonds and orders restoration (5:6–11)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Creditors swear to obey Nehemiah’s order in a public ceremony (5:12–13)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Nehemiah’s selfless devotion to the project and the people (5:14–19)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec2-34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("H. Sanballat, Tobiah, and Geshem attempt to destroy Nehemiah (6:1–19)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. A plot to lure Nehemiah away from the jobsite (6:1–9)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. An attempt to lock Nehemiah in the temple by engaging false prophecy (6:10–14)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Completion of the wall despite opposition (6:15–16)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Intimidation through Tobiah’s family network (6:17–19)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_1"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV. Restoring the holy community (Nehemiah 7:1–13:31)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec2-35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Setting a guard for Jerusalem (7:1–3)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec2-36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Registering the people (7:4–72a)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Planning for the repopulation of Jerusalem (7:4–5)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Returnees by descent (7:6–25)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Returnees by city (7:26–38)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Temple and related personnel (7:39–60)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Undocumented Israelites/priests (7:61–65)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Total returnees and animals (7:66–69)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Financial donations and conclusion (7:70–72a)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#sec2-37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C. Teaching, celebrating, and observing the law (7:72b–8:18)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#sec3-63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Ezra reads the law (7:72b–8:4)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#sec3-64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. People worship (8:5–6)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#sec3-65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Levites teach the law (8:7–8)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#sec3-66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. People celebrate (8:9–12)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#sec3-67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Festival of Booths (8:13–18)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#sec2-38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D. Covenant renewal (9:1–10:39)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#sec3-68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Confession (9:1–3)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#sec3-69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. The Levites’ penitential prayer on behalf of the community (9:4–37)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#sec3-70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Solemn oath (9:38–10:39)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_4"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#sec4-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a. Introduction (9:38)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_4"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#sec4-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b. Signatories (10:1–27)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_4"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#sec4-32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c. Stipulations (10:28–39)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#sec2-39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E. Resettlement of Jerusalem (11:1–36)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#sec3-71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Casting lots to repopulate the city (11:1–2)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#sec3-72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. List of residents (11:3–36)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_4"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#sec4-33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a. Lay families (11:3–9)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_4"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#sec4-34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b. Priestly families (11:10–14)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_4"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#sec4-35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c. Levites and gatekeepers (11:15–24)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_4"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#sec4-36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("d. Residents outside of Jerusalem (11:25–36)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_5"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#sec5-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("i. Judah (11:25–30)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_5"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#sec5-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ii. Benjamin (11:31–36)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03c#sec2-40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("F. Temple personnel (12:1–26)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03c#sec3-73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Priests and Levites during Zerubbabel’s time (12:1–9)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03c#sec3-74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Line of high priests (12:10–11)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03c#sec3-75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Priests in Joiakim’s day (12:12–21)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03c#sec3-76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Leaders of families of Levites (12:22–26)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03c#sec2-41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("G. Dedication of the wall of Jerusalem (12:27–47)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03c#sec3-77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Preparation (12:27–30)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03c#sec3-78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Processions (12:31–43)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03c#sec3-79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Worship (12:44–47)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03c#sec2-42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("H. Nehemiah’s reforms (13:1–31)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03c#sec3-80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Excluding foreigners (13:1–3)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03c#sec3-81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Expelling Tobiah from the temple (13:4–9)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03c#sec3-82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Reinstating tithes for Levites (13:10–14)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03c#sec3-83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Sanctifying the Sabbath (13:15–22)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03c#sec3-84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Dealing with intermarriage (13:23–29)")])]), _vm._v(" "), _c('p', {
    staticClass: "outline_3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03c#sec3-85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Nehemiah’s summary and prayer (13:30–31)")])]), _vm._v(" "), _c('p', {
    staticClass: "image-f"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/foot.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-969",
      "id": "foot-note-969"
    }
  }, [_vm._v("1")]), _vm._v(". E. M. Yamauchi, “Ezra-Nehemiah,” in "), _c('em', [_vm._v("The Expositor’s Bible Commentary")]), _vm._v(", ed. F. E. Gaebelein (Grand Rapids: Zondervan, 1984), 4:586.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-968",
      "id": "foot-note-968"
    }
  }, [_vm._v("2")]), _vm._v(". But see S. Talmon and J. Ben-Dov, “Calendrical Documents and Mišmarot,” in "), _c('em', [_vm._v("Calendrical Texts")]), _vm._v(", vol. 16 of "), _c('em', [_vm._v("Qumran Cave 4")]), _vm._v(", ed. S. Talmon, J. Ben-Dov, and U. Glessmer, DJD 21 (Oxford: Clarendon, 2001), 120–21, who suggest that the founders may have been remnants of the Assyrian conquest of Israel, finding support in Isa 11:1; 19:18–22 for a possible eighth-century Israelite settlement in Egypt.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-967",
      "id": "foot-note-967"
    }
  }, [_vm._v("3")]), _vm._v(". M. Breneman, "), _c('em', [_vm._v("Ezra, Nehemiah, Esther")]), _vm._v(", NAC 10 (Nashville: Broadman & Holman, 1993), 30.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-966",
      "id": "foot-note-966"
    }
  }, [_vm._v("4")]), _vm._v(". J. Blenkinsopp, “Ezra-Nehemiah: Unity or Disunity?,” in "), _c('em', [_vm._v("Unity and Disunity in Ezra-Nehemiah: Redaction, Rhetoric and Reader")]), _vm._v(", ed. M. Boda and P. Redditt (Sheffield: Sheffield Phoenix, 2008), 310.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-965",
      "id": "foot-note-965"
    }
  }, [_vm._v("5")]), _vm._v(". C. L. V. Hensley, “The Official Persian Documents in the Book of Ezra” (PhD diss., University of Liverpool, 1977).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-964",
      "id": "foot-note-964"
    }
  }, [_vm._v("6")]), _vm._v(". K. Hoglund, "), _c('em', [_vm._v("Achaemenid Imperial Administration in Syria-Palestine and the Missions of Ezra and Nehemiah")]), _vm._v(" (Atlanta: Scholars Press, 1992), 47.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-963",
      "id": "foot-note-963"
    }
  }, [_vm._v("7")]), _vm._v(". Breneman, "), _c('em', [_vm._v("Ezra, Nehemiah, Esther")]), _vm._v(", 36.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-962",
      "id": "foot-note-962"
    }
  }, [_vm._v("8")]), _vm._v(". S. Talmon, “Ezra and Nehemiah (Books and Men),” in "), _c('em', [_vm._v("Interpreter’s Dictionary of the Bible: Supplementary Volume")]), _vm._v(", ed. Keith Crim (Nashville: Abingdon, 1976), 361.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-961",
      "id": "foot-note-961"
    }
  }, [_vm._v("9")]), _vm._v(". S. Japhet, “Composition and Chronology in the Book of Ezra-Nehemiah,” in "), _c('em', [_vm._v("Temple and Community in the Persian Period")]), _vm._v(", vol. 2 of "), _c('em', [_vm._v("Second Temple Studies")]), _vm._v(", ed. T. C. Eskenazi and K. H. Richards (Sheffield: Sheffield Academic, 1994), 196.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-960",
      "id": "foot-note-960"
    }
  }, [_vm._v("10")]), _vm._v(". P. A. Noss and K. J. Thomas, "), _c('em', [_vm._v("A Handbook on Ezra and Nehemiah")]), _vm._v(", UBS Handbook Series (New York: United Bible Societies, 2005), 3.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-959",
      "id": "foot-note-959"
    }
  }, [_vm._v("11")]), _vm._v(". E. Bickerman, "), _c('em', [_vm._v("From Ezra to the Last of the Maccabees: Foundations of Post-Biblical Judaism")]), _vm._v(" (New York: Schocken, 1962), 28–29. In the Egyptian account of the Victory of Rameses II at Kadesh, a third-person section that “objectively” praises the king for his heroic acts follows the king’s first-person account of his victory.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-958",
      "id": "foot-note-958"
    }
  }, [_vm._v("12")]), _vm._v(". Williamson, "), _c('em', [_vm._v("Ezra, Nehemiah")]), _vm._v(", WBC 16 (Waco: Word, 1985), xxxi.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-957",
      "id": "foot-note-957"
    }
  }, [_vm._v("13")]), _vm._v(". Williamson, "), _c('em', [_vm._v("Ezra, Nehemiah")]), _vm._v(", xxiv.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-956",
      "id": "foot-note-956"
    }
  }, [_vm._v("14")]), _vm._v(". J. Blenkinsopp, "), _c('em', [_vm._v("Ezra-Nehemiah")]), _vm._v(", OTL (Philadelphia: Westminster, 1988), 46.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-955",
      "id": "foot-note-955"
    }
  }, [_vm._v("15")]), _vm._v(". Williamson, "), _c('em', [_vm._v("Ezra, Nehemiah")]), _vm._v(", xxviii.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-954",
      "id": "foot-note-954"
    }
  }, [_vm._v("16")]), _vm._v(". Blenkinsopp, "), _c('em', [_vm._v("Ezra-Nehemiah")]), _vm._v(", 47.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-953",
      "id": "foot-note-953"
    }
  }, [_vm._v("17")]), _vm._v(". D. Janzen, “The Cries of Jerusalem: Ethnic, Cultic, Legal, and Geographic Boundaries in Ezra-Nehemiah,” in "), _c('em', [_vm._v("Unity and Disunity in Ezra-Nehemiah: Redaction, Rhetoric and Reader")]), _vm._v(", ed. M. Boda and P. Redditt (Sheffield: Sheffield Phoenix, 2008), 129–30.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-952",
      "id": "foot-note-952"
    }
  }, [_vm._v("18")]), _vm._v(". Cf. T. C. Eskenazi, “Unity and Disunity in Ezra-Nehemiah: Responses and Reflections,” in Boda and Redditt, "), _c('em', [_vm._v("Unity and Disunity in Ezra-Nehemiah")]), _vm._v(", 323.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-951",
      "id": "foot-note-951"
    }
  }, [_vm._v("19")]), _vm._v(". H. G. M. Williamson, "), _c('em', [_vm._v("Studies in Persian Period History and Historiography")]), _vm._v(", FAT (Tübingen: Mohr Siebeck, 2004), 4–5, 19; G. R. Driver, "), _c('em', [_vm._v("Aramaic Documents of the Fifth Century BC")]), _vm._v(" (Oxford: Clarendon, 1965). Williamson also notes that Elisahib’s activities in Nehemiah’s absence may suggest that he was not expecting him to return.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-950",
      "id": "foot-note-950"
    }
  }, [_vm._v("20")]), _vm._v(". Williamson, "), _c('em', [_vm._v("Studies in Persian Period History and Historiography")]), _vm._v(", 20; E. Yamauchi, “Two Reformers Compared: Solon of Athens and Nehemiah of Jerusalem,” in "), _c('em', [_vm._v("The Bible World: Essays in Honor of Cyrus H. Gordon")]), _vm._v(", ed. G. Rendsburg et al. (New York, 1980), 269–92.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-949",
      "id": "foot-note-949"
    }
  }, [_vm._v("21")]), _vm._v(". Williamson, "), _c('em', [_vm._v("Studies in Persian Period History and Historiography")]), _vm._v(", 20.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-948",
      "id": "foot-note-948"
    }
  }, [_vm._v("22")]), _vm._v(". Williamson, "), _c('em', [_vm._v("Ezra, Nehemiah")]), _vm._v(", xxxiv.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-947",
      "id": "foot-note-947"
    }
  }, [_vm._v("23")]), _vm._v(". Williamson, "), _c('em', [_vm._v("Ezra, Nehemiah")]), _vm._v(", xxxiv–xxxv.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-946",
      "id": "foot-note-946"
    }
  }, [_vm._v("24")]), _vm._v(". Williamson, "), _c('em', [_vm._v("Ezra, Nehemiah")]), _vm._v(", xxxv. Williamson is supported by M. A. Throntveit, "), _c('em', [_vm._v("Ezra-Nehemiah")]), _vm._v(", Interpretation (Louisville: Westminster John Knox, 1992), 10.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-945",
      "id": "foot-note-945"
    }
  }, [_vm._v("25")]), _vm._v(". T. C. Eskenazi, “Unity and Disunity in Ezra-Nehemiah,” 317. For a good example of the incremental approach, cf. J. Wright, "), _c('em', [_vm._v("Rebuilding Identity: The Nehemiah-Memoir and Its Earliest Readers")]), _vm._v(", BZAW 348 (Berlin: de Gruyter, 2004).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-944",
      "id": "foot-note-944"
    }
  }, [_vm._v("26")]), _vm._v(". Blenkinsopp, "), _c('em', [_vm._v("Ezra-Nehemiah")]), _vm._v(", 70.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-943",
      "id": "foot-note-943"
    }
  }, [_vm._v("27")]), _vm._v(". T. C. Eskenazi, "), _c('em', [_vm._v("In an Age of Prose: A Literary Approach to Ezra-Nehemiah")]), _vm._v(", SBLMS 36 (Atlanta: Scholars Press, 1988), 155–74.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-942",
      "id": "foot-note-942"
    }
  }, [_vm._v("28")]), _vm._v(". E. Ulrich, “Ezra and Qohelet Manuscripts from Qumran (4QEzra and 4QQoh"), _c('sup', [_vm._v("a, b")]), _vm._v("),” in "), _c('em', [_vm._v("Priests, Prophets, and Scribes: Essays on the Formation and Heritage of Second Temple Judaism in Honour of Joseph Blenkinsopp")]), _vm._v(", ed. E. Ulrich et al., JSOTSup 149 (Sheffield: Sheffield Academic, 1992), 153.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-941",
      "id": "foot-note-941"
    }
  }, [_vm._v("29")]), _vm._v(". J. H. Charlesworth, “Announcing a Dead Sea Scrolls Fragment of Nehemiah,” Institute for Judaism and Christian Origins (webpage archived on "), _c('a', {
    attrs: {
      "href": "http://Archive.org",
      "target": "_blank"
    }
  }, [_vm._v("Archive.org")]), _vm._v(", captured October 26, 2008, "), _c('a', {
    attrs: {
      "href": "https://www.web.archive.org/web/20081026024708/",
      "target": "_blank"
    }
  }, [_vm._v("https://web.archive.org/web/20081026024708/")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://http://www.ijco.org/?categoryId=28681",
      "target": "_blank"
    }
  }, [_vm._v("http://www.ijco.org/?categoryId=28681")]), _vm._v("). It should be noted that the authenticity of the Nehemiah fragment is presently under dispute due to provenance and scribal issues. K. Davis et al., “Nine Dubious ‘Dead Sea Scrolls’ Fragments from the Twenty-First Century,” "), _c('em', [_vm._v("DSD")]), _vm._v(" 24 (2017): 189–228; K. Davis, “Caves of Dispute,” "), _c('em', [_vm._v("DSD")]), _vm._v(" 24 (2017): 229–70.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-940",
      "id": "foot-note-940"
    }
  }, [_vm._v("30")]), _vm._v(". Cf. H. K. Harrington, “Intermarriage in Qumran Texts: The Legacy of Ezra-Nehemiah,” in "), _c('em', [_vm._v("Mixed Marriages: Intermarriage and Group Identity in the Second Temple Period")]), _vm._v(", ed. Christian Frevel, LHBOTS 547 (New York: T&T Clark, 2011), 251–79; Carolyn Sharp, “Phinehan Zeal and Rhetorical Strategy in 4QMMT,” "), _c('em', [_vm._v("RevQ")]), _vm._v(" 18 (1997): 211.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-939",
      "id": "foot-note-939"
    }
  }, [_vm._v("31")]), _vm._v(". P. Sacchi, "), _c('em', [_vm._v("The History of the Second Temple Period")]), _vm._v(" (Sheffield: Sheffield Academic, 2000), 135.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-938",
      "id": "foot-note-938"
    }
  }, [_vm._v("32")]), _vm._v(". J. Myers gives various alternatives for the literary and historical order of Ezra and Nehemiah and adopts the view that Nehemiah precedes Ezra ("), _c('em', [_vm._v("Ezra, Nehemiah: A New Translation with Introduction and Commentary")]), _vm._v(", AB 14 [Garden City, NY: Doubleday, 1965], xxxviii–xlviii). From a different angle, L. Fried, argues that if Ezra actually released the priests from corvée labor, it would have been impossible for Nehemiah to rescind this decree and reinstate a priestly corvée later; thus Ezra’s action must have post-dated Nehemiah’s administration ("), _c('em', [_vm._v("The Priest and the Great King: Temple-Palace Relations in the Persian Empire")]), _vm._v(", BJSUCSD 10 [Winona Lake, IN: Eisenbrauns, 2004], 223). U. Kellerman has written one of the best refutations of Ezra preceding Nehemiah (“Erwägungen zum Problem der Ezradatierung,” "), _c('em', [_vm._v("ZAW")]), _vm._v(" 80 [1968]: 55–87).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-937",
      "id": "foot-note-937"
    }
  }, [_vm._v("33")]), _vm._v(". Dates follow the suggestions of A. E. Steinmann, "), _c('em', [_vm._v("Ezra and Nehemiah")]), _vm._v(", Concordia Commentary (St. Louis: Concordia, 2010), 55–58.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-936",
      "id": "foot-note-936"
    }
  }, [_vm._v("34")]), _vm._v(". These governorships are based on the following attestations: Sheshbazzar (Ezra 1:8, 11; 5:14); Zerubbabel (Ezra 3:8; Hag 1:1, 14; Zech 4:6–10); Elnathan (bulla and seal); Yehoezer (jar impression); Ahzai (jar impression); Nehemiah (Neh 5:14; 12:26); Bagohi/Bagoas (Aramaic Papyri); Hezekiah (coins).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-935",
      "id": "foot-note-935"
    }
  }, [_vm._v("35")]), _vm._v(". “Jo-” and “Jeho-” represent short and long forms of the Yahweh prefix. Names differing only in these forms refer to Emperors over Persia.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-934",
      "id": "foot-note-934"
    }
  }, [_vm._v("36")]), _vm._v(". L. Fried, “A Silver Coin of Yo"), _c('span', {
    staticClass: "chari-r"
  }, [_vm._v("ḥ")]), _vm._v("anan Hakkôhēn,” "), _c('em', [_vm._v("Transeuphratène")]), _vm._v(" 25 (2003): 65–66.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-933",
      "id": "foot-note-933"
    }
  }, [_vm._v("37")]), _vm._v(". Proponents of a late Ezra sometimes translate “grandson of Eliashib.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-932",
      "id": "foot-note-932"
    }
  }, [_vm._v("38")]), _vm._v(". Papponymy is attested among the Sanballats (cf. the Wadi Daliyeh Papyri), the Oniads, and the Tobiads; F. M. Cross, “Aspects of Samaritan and Jewish History in Late Persian and Hellenistic Times,” in "), _c('em', [_vm._v("Emerging Judaism")]), _vm._v(", ed. Michael Stone and David Satran (Minneapolis: Fortress, 1989), 49–59; B. Mazar, “The Tobiads,” "), _c('em', [_vm._v("IEJ")]), _vm._v(" 7 (1957): 235, 235n73.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-931",
      "id": "foot-note-931"
    }
  }, [_vm._v("39")]), _vm._v(". But cf. Fried, "), _c('em', [_vm._v("Priest and the Great King")]), _vm._v(", 227–31, who sees no need for another Johanan-Jaddua pair, arguing that the Johanan of the Elephantine papyri (ca. 410 BCE) was beginning his career of forty years (evidenced by a coin minted in 370 BCE) and that his son Jaddua continued with an equally long career and met Alexander in 333 BCE as Josephus states ("), _c('em', [_vm._v("Jewish Antiquities")]), _vm._v(" 11.326).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-930",
      "id": "foot-note-930"
    }
  }, [_vm._v("40")]), _vm._v(". J. VanderKam, “Jewish High Priests of the Persian Period: Is the List Complete?,” in "), _c('em', [_vm._v("From Joshua to Caiaphas: High Priests after the Exile")]), _vm._v(" (Minneapolis: Fortress, 2004), 43–111.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-929",
      "id": "foot-note-929"
    }
  }, [_vm._v("41")]), _vm._v(". See Yamauchi, “Ezra-Nehemiah,” 584; Breneman, "), _c('em', [_vm._v("Ezra, Nehemiah, Esther")]), _vm._v(", 44; D. Kidner, "), _c('em', [_vm._v("Ezra and Nehemiah: An Introduction and Commentary")]), _vm._v(", TOTC (Leicester: Inter-Varsity, 1979), 152; cf. B. Childs"), _c('em', [_vm._v(", Introduction to the Old Testament as Scripture")]), _vm._v(" (Philadelphia: Fortress, 1979), 636.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-928",
      "id": "foot-note-928"
    }
  }, [_vm._v("42")]), _vm._v(". R. K. Harrison, "), _c('em', [_vm._v("Introduction to the Old Testament")]), _vm._v(" (Grand Rapids: Eerdmans, 1969), 148–49.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-927",
      "id": "foot-note-927"
    }
  }, [_vm._v("43")]), _vm._v(". Some scholars have kept the contemporaneity of Ezra and Nehemiah but emended Artaxerxes’s “seventh year” to “thirty-seventh,” keeping Ezra after Nehemiah. Both numbers begin with the Hebrew letter "), _c('em', [_vm._v("shin")]), _vm._v(". See J. Bright, "), _c('em', [_vm._v("History of Israel")]), _vm._v(" (London: SCM, 1977), 391–402; W. F. Albright, “The Biblical Period,” in "), _c('em', [_vm._v("The Jews: Their History, Culture, and Religion")]), _vm._v(", ed. L. Finkelstein (New York: Harper, 1949), 3–69; cf. E. Yamauchi, “Ezra-Nehemiah,” 585–86.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-926",
      "id": "foot-note-926"
    }
  }, [_vm._v("44")]), _vm._v(". Hoglund ("), _c('em', [_vm._v("Achaemenid Imperial Administration")]), _vm._v(", 236) supports this conclusion by explaining that it is in the best interest of the Persian emperors to secure a law-abiding Jewish community.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-925",
      "id": "foot-note-925"
    }
  }, [_vm._v("45")]), _vm._v(". Talmon, “Ezra and Nehemiah (Books and Men),” 317–28, esp. 324–28.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-924",
      "id": "foot-note-924"
    }
  }, [_vm._v("46")]), _vm._v(". Yamauchi (“Ezra-Nehemiah,” 575–80) suggests that the Chronicler was an editor of the separate sources of Ezra-Nehemiah and Chronicles, a later follower of Ezra’s circle, or even Ezra himself. He places Ezra-Nehemiah first at 440 BCE and then Chronicles at ca. 400 BCE. Williamson places Chronicles at ca. 350 BCE and the final version of Ezra-Nehemiah at 300 BCE. Because of Greek words for coins in Ezra, Torrey thinks it could be as late as 250 BCE (see Yamauchi, “Ezra-Nehemiah,” 577).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-923",
      "id": "foot-note-923"
    }
  }, [_vm._v("47")]), _vm._v(". S. Japhet, “The Relationship between Chronicles and Ezra-Nehemiah,” in "), _c('em', [_vm._v("Congress Volume: Leuven 1989")]), _vm._v(", ed. J. A. Emerton, VTSup 43 (1991), 301–4; J. C. VanderKam, following S. R. Driver, organizes parallel word lists (“Ezra-Nehemiah or Ezra and Nehemiah?,” in Ulrich et al., "), _c('em', [_vm._v("Priests, Prophets and Scribes")]), _vm._v(", 55–75); T. C. Eskenazi ("), _c('em', [_vm._v("In an Age of Prose")]), _vm._v(") focuses on themes.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-922",
      "id": "foot-note-922"
    }
  }, [_vm._v("48")]), _vm._v(". See a full discussion in Williamson, "), _c('em', [_vm._v("Ezra, Nehemiah")]), _vm._v(", xxii. Since the genealogical data places the complete work of Chronicles no earlier than 400 BCE, after Ezra’s death (on the traditional dating), some suggest that a close disciple of Ezra wrote Chronicles (Yamauchi, “Ezra-Nehemiah,” 577–78).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-921",
      "id": "foot-note-921"
    }
  }, [_vm._v("49")]), _vm._v(". Blenkinsopp, "), _c('em', [_vm._v("Ezra-Nehemiah")]), _vm._v(", 48; see his forceful arguments, 47–54.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-920",
      "id": "foot-note-920"
    }
  }, [_vm._v("50")]), _vm._v(". Myers, "), _c('em', [_vm._v("Ezra, Nehemiah")]), _vm._v(", li–lii.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-919",
      "id": "foot-note-919"
    }
  }, [_vm._v("51")]), _vm._v(". See Yamauchi, “Ezra-Nehemiah,” 577.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-918",
      "id": "foot-note-918"
    }
  }, [_vm._v("52")]), _vm._v(". Cited in Blenkinsopp, "), _c('em', [_vm._v("Ezra-Nehemiah")]), _vm._v(", 49. For example, Chronicles favors "), _c('em', [_vm._v("qdš")]), _vm._v(" while Ezra-Nehemiah uses "), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ṭ")]), _c('em', [_vm._v("hr")]), _vm._v(" for purification.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-917",
      "id": "foot-note-917"
    }
  }, [_vm._v("53")]), _vm._v(". J. D. Newsome, as cited in Yamauchi, “Ezra-Nehemiah,” 578.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-916",
      "id": "foot-note-916"
    }
  }, [_vm._v("54")]), _vm._v(". Throntveit, "), _c('em', [_vm._v("Ezra-Nehemiah")]), _vm._v(", 9.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-915",
      "id": "foot-note-915"
    }
  }, [_vm._v("55")]), _vm._v(". Steinmann, "), _c('em', [_vm._v("Ezra and Nehemiah")]), _vm._v(", 132–33. Steinmann cites Marcus, the editor of "), _c('em', [_vm._v("BHQ")]), _vm._v(" for Ezra and Nehemiah, who says that the Chronicles version explicates the Ezran verses. S. Japhet dates Chronicles after Ezra-Nehemiah, well into the fourth century BCE ("), _c('em', [_vm._v("1 and 2 Chronicles: A Commentary")]), _vm._v(" [Louisville: Westminster, 1993), 27; so also I. Kalimi, "), _c('em', [_vm._v("The Reshaping of Ancient Israelite History in Chronicles")]), _vm._v(" (Winona Lake, IN: Eisenbrauns, 2005), 9.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-914",
      "id": "foot-note-914"
    }
  }, [_vm._v("56")]), _vm._v(". Cf. VanderKam, “Ezra-Nehemiah or Ezra and Nehemiah?,” 55–75; D. Kraemer, “On the Relationship of the Books of Ezra and Nehemiah,” "), _c('em', [_vm._v("JSOT")]), _vm._v(" 59 (1993): 73–92.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-913",
      "id": "foot-note-913"
    }
  }, [_vm._v("57")]), _vm._v(". Kraemer, “Relationship of the Books of Ezra and Nehemiah,” 77.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-912",
      "id": "foot-note-912"
    }
  }, [_vm._v("58")]), _vm._v(". Kraemer, “Relationship of the Books of Ezra and Nehemiah,” 84–89.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-911",
      "id": "foot-note-911"
    }
  }, [_vm._v("59")]), _vm._v(". See Talmon, “Ezra and Nehemiah (Books and Men),” 318.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-910",
      "id": "foot-note-910"
    }
  }, [_vm._v("60")]), _vm._v(". S. Talmon, “Ezra and Nehemiah,” in "), _c('em', [_vm._v("Literary Guide to the Bible")]), _vm._v(", ed. R. Alter and F. Kermode (London: Collins: 1987), 357–58.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-909",
      "id": "foot-note-909"
    }
  }, [_vm._v("61")]), _vm._v(". L. S. Fried, “Who Wrote Ezra-Nehemiah—and Why Did They?,” in Boda and Redditt, "), _c('em', [_vm._v("Unity and Disunity in Ezra-Nehemiah")]), _vm._v(", 75.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-908",
      "id": "foot-note-908"
    }
  }, [_vm._v("62")]), _vm._v(". K. Min, "), _c('em', [_vm._v("The Levitical Authorship of Ezra-Nehemiah")]), _vm._v(", JSOTSup 409 (London: T&T Clark, 2004), 27. See also T. C. Eskenazi, “The Structure of Ezra-Nehemiah and the Integrity of the Book,” "), _c('em', [_vm._v("JBL")]), _vm._v(" 107 (1988): 641–56, who considers the repetition of the people lists as integral to the structure of the book. She explains that the material between Ezra 1:5 and Neh 7:72 is intentionally bracketed by the lists to emphasize the people, not just the leaders, who actualized Cyrus’s decree to rebuild the temple; see 647–50.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-907",
      "id": "foot-note-907"
    }
  }, [_vm._v("63")]), _vm._v(". The term "), _c('em', [_vm._v("n")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ə")]), _c('em', [_vm._v("tînîm")]), _vm._v(" is found outside of Ezra-Nehemiah only in 1 Chr 9:2. For the collocation, “the hand of Yahweh was upon me,” see Ezek 37:1.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-906",
      "id": "foot-note-906"
    }
  }, [_vm._v("64")]), _vm._v(". Min ("), _c('em', [_vm._v("Levitical Authorship of Ezra-Nehemiah")]), _vm._v(", 2–30) surveys the scholarly literature on this, including the work of L. Batten and H. G. M. Williamson. See Eskenazi, "), _c('em', [_vm._v("In an Age of Prose")]), _vm._v(", 37–126; and Mark A. Throntveit, "), _c('em', [_vm._v("Ezra-Nehemiah")]), _vm._v(", Interpretation (Louisville: John Knox, 1992), 4–8.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-905",
      "id": "foot-note-905"
    }
  }, [_vm._v("65")]), _vm._v(". H. K. Harrington, “Holiness and Purity in Ezra-Nehemiah,” in Boda and Redditt, "), _c('em', [_vm._v("Unity and Disunity in Ezra-Nehemiah")]), _vm._v(", 98–116.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-904",
      "id": "foot-note-904"
    }
  }, [_vm._v("66")]), _vm._v(". Yamauchi, “Ezra-Nehemiah,” 579.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-903",
      "id": "foot-note-903"
    }
  }, [_vm._v("67")]), _vm._v(". A. Siedlecki suggests a compilation date of 300 BCE (“Contextualizations of Ezra-Nehemiah,” in Boda and Redditt, "), _c('em', [_vm._v("Unity and Disunity in Ezra-Nehemiah")]), _vm._v(", 263–76), following H. G. M. Williamson.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-902",
      "id": "foot-note-902"
    }
  }, [_vm._v("68")]), _vm._v(". For more on issues of dating and sequence, see Blenkinsopp, "), _c('em', [_vm._v("Ezra-Nehemiah")]), _vm._v(", 139–44.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-901",
      "id": "foot-note-901"
    }
  }, [_vm._v("69")]), _vm._v(". Eskenazi (“Unity and Disunity in Ezra-Nehemiah,” 316–17) describes these two trends in scholarship: (1) “free standing documents were combined at some specific, definable junctures” (e.g., H. G. M. Williamson, "), _c('em', [_vm._v("Ezra, Nehemiah")]), _vm._v(" [1985]); or (2) there was an “incremental process in which scribal activities responded in a continuous fashion to issues internal to the text and those external, historical circumstances that unfolded” (e.g., J. Wright [2004]). For a full discussion of recent theories regarding redactional layers in Ezra-Nehemiah, see the collected essays in Boda and Redditt, "), _c('em', [_vm._v("Unity and Disunity in Ezra-Nehemiah")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-900",
      "id": "foot-note-900"
    }
  }, [_vm._v("70")]), _vm._v(". T. C. Eskenazi, “Reflections on Oded Lipschits: The Fall and Rise of Jerusalem,” "), _c('em', [_vm._v("JHS")]), _vm._v(" 7 (2006).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-899",
      "id": "foot-note-899"
    }
  }, [_vm._v("71")]), _vm._v(". O. Lipschits, "), _c('em', [_vm._v("The Fall and Rise of Jerusalem: Judah under Babylonian Rule")]), _vm._v(" (Winona Lake, IN: Eisenbrauns, 2005). For other estimates, see C. E. Carter, "), _c('em', [_vm._v("The Emergence of Yehud in the Persian Period: A Social and Demographic Study")]), _vm._v(", JSOTSup 294 (Sheffield: Sheffield Academic, 1999), 200–205; a more generous estimate is provided by M. Broshi, “La population de l’ancienne Jérusalem,” "), _c('em', [_vm._v("RB")]), _vm._v(" 82 (1975): 5–14.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-898",
      "id": "foot-note-898"
    }
  }, [_vm._v("72")]), _vm._v(". Sanballat, governor of Samaria, and his dynasty are recorded in several sources, including a bulla inscribed with “belonging to Isaiah, son of Sanballat, governor of Samaria”; the Wadi Daliyeh papyri; and some coins. See E. Stern, "), _c('em', [_vm._v("The Assyrian, Babylonian, and Persian Periods (732–332 B.C.E.)")]), _vm._v(", vol. 2 of "), _c('em', [_vm._v("Archaeology of the Land of the Bible")]), _vm._v(" (New York: Doubleday, 2001), 552.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-897",
      "id": "foot-note-897"
    }
  }, [_vm._v("73")]), _vm._v(". So also Bickerman, "), _c('em', [_vm._v("From Ezra to the Last of the Maccabees")]), _vm._v(", 11; E. Stern, "), _c('em', [_vm._v("Assyrian, Babylonian, and Persian Periods")]), _vm._v(", 430–31, explains the differences between the biblical rosters according to the purpose of each list. For a view which excludes Lod and Ono from Yehud, see D. Moffat, "), _c('em', [_vm._v("Ezra’s Social Drama")]), _vm._v(", 31; Moffat refers to the funerary inscription of the Sidonian King Eshmunezer II, who claimed to receive this area from the Persians ("), _c('em', [_vm._v("ANET")]), _vm._v(", 662) and also notes that Neh 6:2 seems to depict Ono as neutral territory.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-896",
      "id": "foot-note-896"
    }
  }, [_vm._v("74")]), _vm._v(". E.g., see Map 6 in Lipschits, "), _c('em', [_vm._v("Fall and Rise of Jerusalem")]), _vm._v(", 183; cf. C. E. Carter, "), _c('em', [_vm._v("Emergence of Yehud")]), _vm._v(", 82–90, for a slightly smaller estimate of Yehud’s area. Moffat ("), _c('em', [_vm._v("Ezra’s Social Drama")]), _vm._v(", 40) surveys the views of Carter and Lipschits and concludes, “Territorial boundaries are better regarded as vague and permeable frontiers rather than hard lines of demarcation.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-895",
      "id": "foot-note-895"
    }
  }, [_vm._v("75")]), _vm._v(". As Moffat ("), _c('em', [_vm._v("Ezra’s Social Drama")]), _vm._v(", 37) points out, a Yehud seal impression has been found at a Persian-era fortress in Kadesh-Barnea, an area far south of Judean control.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-894",
      "id": "foot-note-894"
    }
  }, [_vm._v("76")]), _vm._v(". A. Alt, “Die Rolle Samarias bei der Entstehung des Judentums,” in "), _c('em', [_vm._v("Kleine Schriften zur Geschichte Volkes Israels")]), _vm._v(", vol. 2 (Munich: Beck, 1953), 316–37.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-893",
      "id": "foot-note-893"
    }
  }, [_vm._v("77")]), _vm._v(". P. Briant, "), _c('em', [_vm._v("From Cyrus to Alexander: A History of the Persian Empire")]), _vm._v(", trans. P. T. Daniels (Winona Lake, IN: Eisenbrauns, 2002), 488; translation of "), _c('em', [_vm._v("Histoire de l’Empire perse")]), _vm._v(" (Paris: Librairie Arthème Fayard, 1996).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-892",
      "id": "foot-note-892"
    }
  }, [_vm._v("78")]), _vm._v(". N. Avigad identifies this Shelomith with the daughter of Zerubbabel of 1 Chr 3:19 and dates the seals to the sixth century BCE ("), _c('em', [_vm._v("Bullae and Seals from a Postexilic Judean Archive")]), _vm._v(" [Jerusalem: Institute of Archaeology of the Hebrew University, 1976], 35). See also the discussion in S. Japhet, “Sheshbazzar and Zerubbabel: Against the Background of the Historical and Religious Tendencies of Ezra-Nehemiah, Part 1,” "), _c('em', [_vm._v("ZAW")]), _vm._v(" 94 (1982): 80. For a complete list of the governors over Yehud in the Persian period, see Fried, "), _c('em', [_vm._v("Priest and the Great King")]), _vm._v(", 183–88, who notes continuous rule. She notes that even though most of the governors had Yahwist names, they were Persian officials ruling at the discretion of the Persian satrap and king.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-891",
      "id": "foot-note-891"
    }
  }, [_vm._v("79")]), _vm._v(". Steinmann, "), _c('em', [_vm._v("Ezra and Nehemiah")]), _vm._v(", 573; cf. Yamauchi, “Ezra-Nehemiah,” 745.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-890",
      "id": "foot-note-890"
    }
  }, [_vm._v("80")]), _vm._v(". Broshi, “La population de l’ancienne Jérusalem,” 5–14; cf. Levine (“Jerusalem,” "), _c('em', [_vm._v("DEJ")]), _vm._v(", 797), who estimates about 5,000 people in the city. For lower estimates of Jerusalem’s population in the Persian period, see Lipschits ("), _c('em', [_vm._v("Fall and Rise of Jerusalem")]), _vm._v(") at 1,000 to 1,250 persons and I. Finkelstein with an even lower number (“Jerusalem in the Persian (and Early Hellenistic) Period and the Wall of Nehemiah,” JSOT 32 [2008]).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-889",
      "id": "foot-note-889"
    }
  }, [_vm._v("81")]), _vm._v(". The main proponent of the Hellenistic context is Finkelstein, “Jerusalem in the Persian (and Early Hellenistic) Period,” 504–7. See counterarguments in D. Ussishkin, “Nehemiah’s City Wall and the Size of Jerusalem,” in "), _c('em', [_vm._v("New Perspectives on Ezra-Nehemiah: History and Historiography, Text, Literature, and Interpretation")]), _vm._v(", ed. I. Kalimi (Winona Lake, IN: Eisenbrauns, 2012), 118–19.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-888",
      "id": "foot-note-888"
    }
  }, [_vm._v("82")]), _vm._v(". Proponents of this view include Avi-Yonah, Tsafrir, Avigad, Williamson, Eshel, Stern, Ritmeyer and Ritmeyer, Geva, Steiner, and Na’aman; see Ussishkin, “Nehemiah’s City Wall and the Size of Jerusalem”; H. Geva, “Small City, Few People,” "), _c('em', [_vm._v("BAR")]), _vm._v(" 32 (2006): 66–68; H. G. M. Williamson, “Nehemiah’s Wall Revisited,” "), _c('em', [_vm._v("PEQ")]), _vm._v(" 116 (1984): 81–88; Y. Tzafrir, “The Walls of Jerusalem in the Period of Nehemiah,” "), _c('em', [_vm._v("Cathedra")]), _vm._v(" 4 (1977): 31–42.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-887",
      "id": "foot-note-887"
    }
  }, [_vm._v("83")]), _vm._v(". Stern, "), _c('em', [_vm._v("Assyrian, Babylonian, and Persian Periods")]), _vm._v(", 468.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-886",
      "id": "foot-note-886"
    }
  }, [_vm._v("84")]), _vm._v(". Steinmann, "), _c('em', [_vm._v("Ezra and Nehemiah")]), _vm._v(", 414.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-885",
      "id": "foot-note-885"
    }
  }, [_vm._v("85")]), _vm._v(". J. Simons, "), _c('em', [_vm._v("Jerusalem in the Old Testament: Researches and Theories")]), _vm._v(" (Leiden: Brill, 1952); H. Vincent and A. Steve, "), _c('em', [_vm._v("Jerusalem de l’Ancien Testament: Recherches d’archéologie et d’histoire")]), _vm._v(" (Paris: Gabalda, 1954). This view has been championed in recent times by Ussishkin, “Nehemiah’s City Wall and the Size of Jerusalem,” 101–30.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-884",
      "id": "foot-note-884"
    }
  }, [_vm._v("86")]), _vm._v(". Ussishkin, “Nehemiah’s City Wall and the Size of Jerusalem,” 109, 122.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-883",
      "id": "foot-note-883"
    }
  }, [_vm._v("87")]), _vm._v(". See Lipschits, “Persian Period Finds from Jerusalem,” who estimates the population of Jerusalem at this time to be about 1,000–1,250 persons.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-882",
      "id": "foot-note-882"
    }
  }, [_vm._v("88")]), _vm._v(". Japhet, “Composition and Chronology,” 215.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-881",
      "id": "foot-note-881"
    }
  }, [_vm._v("89")]), _vm._v(". Eskenazi, "), _c('em', [_vm._v("In an Age of Prose")]), _vm._v(". A similar conclusion was reached by R. J. Coggins, "), _c('em', [_vm._v("The Books of Ezra and Nehemiah")]), _vm._v(" (Cambridge: Cambridge University Press, 1976), 107, who stated that the author of Ezra-Nehemiah used theological rather than historical criteria: The most important matter is first the rebuilding of the temple, and then the purifying of the people, and then the walls of the city, the “grand climax” being the reading of the law.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-880",
      "id": "foot-note-880"
    }
  }, [_vm._v("90")]), _vm._v(". Japhet, “Composition and Chronology,” 210.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-879",
      "id": "foot-note-879"
    }
  }, [_vm._v("91")]), _vm._v(". Throntveit ("), _c('em', [_vm._v("Ezra-Nehmiah")]), _vm._v(", 4) divides the book into two large sections (Ezra 1:1–Neh 7:3; Neh 7:4–12:43; and a “coda,” 12:44–13:31). The first large section links the community with the Israelite past, and the second seeks “renewal and reform.” The coda simply illustrates the “tension between reform and subsequent relapse” and “invites the reader to contemplate the continuing need for present commitment in the life of faith.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-878",
      "id": "foot-note-878"
    }
  }, [_vm._v("92")]), _vm._v(". S. Talmon, “Ezra and Nehemiah,” in Alter and Kermode, "), _c('em', [_vm._v("Literary Guide to the Bible")]), _vm._v(", 358.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-877",
      "id": "foot-note-877"
    }
  }, [_vm._v("93")]), _vm._v(". L. Fried (“Who Wrote Ezra-Nehemiah?,” 94–95) notes that Ezra seems like a second Moses not only as a lawgiver but also as the central character in a certain sequence of events; cf. T. Reinmuth, “Nehemiah 8 and the Authority of Torah in Ezra-Nehemiah,” in Boda and Redditt, "), _c('em', [_vm._v("Unity and Disunity in Ezra-Nehemiah")]), _vm._v(", 247, who identifies parallels between Exodus and Nehemiah: the people believed the word of God to Moses and fell down on their faces and worshiped (Exod 4:30–31 // Neh 8:6; cf. Exod 24:7 // Neh 8:3).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-876",
      "id": "foot-note-876"
    }
  }, [_vm._v("94")]), _vm._v(". Blenkinsopp, "), _c('em', [_vm._v("Ezra-Nehemiah")]), _vm._v(", 37. Also, the language of the early prophets is used to highlight the return as a fulfillment of prophecy (cf. Jer 31 with Ezra 7–9 for their use of similar themes); see J. G. McConville, “Ezra-Nehemiah and the Fulfillment of Prophecy,” "), _c('em', [_vm._v("VT")]), _vm._v(" 36 (1986): 216, 220; cited in Breneman, "), _c('em', [_vm._v("Ezra, Nehemiah, Esther")]), _vm._v(", 57, who thinks the word “remnant” in Ezra 9:14–15 is influenced by Isaiah and Jeremiah.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-875",
      "id": "foot-note-875"
    }
  }, [_vm._v("95")]), _vm._v(". L. Grabbe, “‘Mind the Gaps’: Ezra, Nehemiah and the Judean Restoration,” in "), _c('em', [_vm._v("Restoration: Old Testament, Jewish, and Christian Perspectives")]), _vm._v(", ed. J. M. Scott (Leiden: Brill, 2001), 84.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-874",
      "id": "foot-note-874"
    }
  }, [_vm._v("96")]), _vm._v(". Throntveit, "), _c('em', [_vm._v("Ezra-Nehemiah")]), _vm._v(", 4.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-873",
      "id": "foot-note-873"
    }
  }, [_vm._v("97")]), _vm._v(". This analysis comes from Throntveit, "), _c('em', [_vm._v("Ezra-Nehemiah")]), _vm._v(", 52.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-872",
      "id": "foot-note-872"
    }
  }, [_vm._v("98")]), _vm._v(". Noss and Thomas, "), _c('em', [_vm._v("Handbook on Ezra and Nehemiah")]), _vm._v(", 14.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-871",
      "id": "foot-note-871"
    }
  }, [_vm._v("99")]), _vm._v(". Throntveit, "), _c('em', [_vm._v("Ezra-Nehemiah")]), _vm._v(", 6. Throntveit claims that, in Ezra, both the three major units (Ezra 1–6; 7–8; 9–10) and the majority of their subunits (1:7–11; 4:8–23; 5:1–6:22; 7:1b–5; 7:11–26; 9:1–10:1a; 10:1b–44) are structured chiastically.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-870",
      "id": "foot-note-870"
    }
  }, [_vm._v("100")]), _vm._v(". S. Talmon, “Presentation of Synchroneity and Simultaneity in Biblical Narrative,” in "), _c('em', [_vm._v("Studies in Hebrew Narrative Art Throughout the Age")]), _vm._v("s, ed. J. Heinemann and S. Werses, ScrHier 27 (Jerusalem: Magnes, 1978), 9–26, esp. 17.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-869",
      "id": "foot-note-869"
    }
  }, [_vm._v("101")]), _vm._v(". Breneman ("), _c('em', [_vm._v("Ezra, Nehemiah, Esther")]), _vm._v(", 38) claims that the reappearance of Ezra in Neh 8 and the way the author inserts Neh 8–10 between Neh 7:73 and 11:1 in a parenthetical manner are typical of the overall style.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-868",
      "id": "foot-note-868"
    }
  }, [_vm._v("102")]), _vm._v(". Talmon, “Ezra and Nehemiah (Books and Men),” 322.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-867",
      "id": "foot-note-867"
    }
  }, [_vm._v("103")]), _vm._v(". Talmon, “Ezra and Nehemiah,” 359–60.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-866",
      "id": "foot-note-866"
    }
  }, [_vm._v("104")]), _vm._v(". Noss and Thomas, "), _c('em', [_vm._v("Handbook on Ezra and Nehemiah")]), _vm._v(", 14.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-865",
      "id": "foot-note-865"
    }
  }, [_vm._v("105")]), _vm._v(". Kidner, "), _c('em', [_vm._v("Ezra and Nehemiah")]), _vm._v(", 169–70.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-864",
      "id": "foot-note-864"
    }
  }, [_vm._v("106")]), _vm._v(". Talmon (“Ezra and Nehemiah,” 363) suggests that many of these phrases are not dates or even sequences but formulaic literary devices creating an impression rather than an accurate time. Phrases of this nature include, “Now after these things” (Ezra 7:1), “Now when these things were done” (Ezra 9:1), and “And before this” (Neh 13:4).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-863",
      "id": "foot-note-863"
    }
  }, [_vm._v("107")]), _vm._v(". Talmon (“Ezra and Nehemiah,” 364) posits compilation in 400 BCE. Another criticism against this literary method is registered by those who feel that literary critics have sidestepped the responsibility of attempting to reconstruct biblical history. As Blenkinsopp ("), _c('em', [_vm._v("Ezra-Nehemiah")]), _vm._v(", 42) says, it has “a tendency to circumvent the tension between confessional and critically reconstructed history. This tension seems to be inescapable, and it is difficult to see how theology can maintain its integrity, or avoid degenerating into ideology in the pejorative sense, if it is avoided.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-862",
      "id": "foot-note-862"
    }
  }, [_vm._v("108")]), _vm._v(". D. P. Moffat, "), _c('em', [_vm._v("Ezra’s Social Drama: Identity Formation, Marriage and Social Conflict in Ezra 9 and 10")]), _vm._v(" (New York: Bloomsbury, 2013), 7.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-861",
      "id": "foot-note-861"
    }
  }, [_vm._v("109")]), _vm._v(". M. Douglas, "), _c('em', [_vm._v("Natural Symbols: Explorations in Cosmology")]), _vm._v(" (London: Routledge, 1996), 54–68.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-860",
      "id": "foot-note-860"
    }
  }, [_vm._v("110")]), _vm._v(". D. Janzen, “Scholars, Witches, Ideologues, and What the Text Said: Ezra 9–10 and Its Interpretation,” in "), _c('em', [_vm._v("Approaching Yehud: New Approaches to the Study of the Persian Period")]), _vm._v(", ed. J. L. Berquist, Semeia Studies 50 (Atlanta: SBL Press; Leiden: Brill, 2007), 64–66; D. Janzen, "), _c('em', [_vm._v("Witch-hunts, Purity and Social Boundaries: The Expulsion of the Foreign Women in Ezra 9–10")]), _vm._v(" (Sheffield: Sheffield Academic, 2002), 57–62.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-859",
      "id": "foot-note-859"
    }
  }, [_vm._v("111")]), _vm._v(". Moffat, "), _c('em', [_vm._v("Ezra’s Social Drama")]), _vm._v(", 186.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-858",
      "id": "foot-note-858"
    }
  }, [_vm._v("112")]), _vm._v(". Moffat, "), _c('em', [_vm._v("Ezra’s Social Drama")]), _vm._v(", 186.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-857",
      "id": "foot-note-857"
    }
  }, [_vm._v("113")]), _vm._v(". M. Douglas, "), _c('em', [_vm._v("Purity and Danger")]), _vm._v(" (London: Routledge, 1966), 124–25.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-856",
      "id": "foot-note-856"
    }
  }, [_vm._v("114")]), _vm._v(". P. Sacchi ("), _c('em', [_vm._v("History of the Second Temple Period")]), _vm._v(", 453–54) sees the foreigner as “manifestly impure” already with Ezekiel, based on Ezek 44:6–9: “No foreigner, uncircumcised in heart and flesh, of all the foreigners who are among the people of Israel, shall enter my sanctuary.” But other scholars consider this text an allusion to the practice of using foreign slaves to serve the priesthood (cf. Ezra 8:20). Sacchi argues that the universalistic trend in the time before Ezra and Nehemiah that allowed gentiles to offer sacrifices and be a part of Israelite society (Isa 56:3–6; Lev 17:8; Num 15:14) was truncated due to Ezra and Nehemiah’s reforms but resurfaced later. Sacchi claims that the impoverishment of the priests in the sixth century BCE (cf. Mal 1:8) led to their linkage with the powerful families of Samaria and Ammon and thus prepared the way for Trito-Isaiah (late sixth century BCE) to claim that all people can worship Yahweh (119–21). Ruth and Jonah are to be set against the backdrop of the segregationist-integrationist discussion as well.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-855",
      "id": "foot-note-855"
    }
  }, [_vm._v("115")]), _vm._v(". D. L. Smith, “The Politics of Ezra: Sociological Indicators of Postexilic Judaean Society,” in "), _c('em', [_vm._v("Persian Period")]), _vm._v(", vol. 1 of "), _c('em', [_vm._v("Second Temple Studies")]), _vm._v(", ed. P. R. Davies, JSOTSup 117 (Sheffield: JSOT Press, 1991), 84–85.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-854",
      "id": "foot-note-854"
    }
  }, [_vm._v("116")]), _vm._v(". S. Olyan, "), _c('em', [_vm._v("Rites and Rank: Hierarchy in Biblical Representations of Cult")]), _vm._v(" (Princeton: Princeton University Press, 2000), 60; see also S. Olyan, “Purity Ideology in Ezra-Nehemiah as a Tool to Reconstitute the Community,” "), _c('em', [_vm._v("JSJ")]), _vm._v(" 35 (2004): 1–16.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-853",
      "id": "foot-note-853"
    }
  }, [_vm._v("117")]), _vm._v(". See V. Turner, "), _c('em', [_vm._v("Dramas, Fields, and Metaphors: Symbolic Action in Human Society")]), _vm._v(" (Ithaca, NY: Cornell University Press, 1974).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-852",
      "id": "foot-note-852"
    }
  }, [_vm._v("118")]), _vm._v(". F. Gorman, "), _c('em', [_vm._v("The Ideology of Ritual: Space, Time and Status in the Priestly Theology")]), _vm._v(", JSOTSup 91 (Sheffield: JSOT Press, 1990), 28, 29, 232.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-851",
      "id": "foot-note-851"
    }
  }, [_vm._v("119")]), _vm._v(". For a full explanation of the intermarriage crisis in light of Turner’s work, see Moffat, "), _c('em', [_vm._v("Ezra’s Social Drama")]), _vm._v(", 155–63.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-850",
      "id": "foot-note-850"
    }
  }, [_vm._v("120")]), _vm._v(". The work of D. Moffat is a good example of this combination; see Moffat, "), _c('em', [_vm._v("Ezra’s Social Drama")]), _vm._v(", 6.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-849",
      "id": "foot-note-849"
    }
  }, [_vm._v("121")]), _vm._v(". Grabbe, “Mind the Gaps,” 83–104. Grabbe sees the story constructed around three “Foundation Legends,” each centering on the restoration and accomplishments of key leaders (102).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-848",
      "id": "foot-note-848"
    }
  }, [_vm._v("122")]), _vm._v(". C. C. Torrey, for example, believes that Ezra-Nehemiah, except for Neh 1–6, is total fiction ("), _c('em', [_vm._v("The Composition and Historical Value of Ezra-Nehemiah")]), _vm._v(", BZAW [Giessen: J. Ricker, 1896], 65). Grabbe (“Mind the Gaps,” 92) states that Ezra seems to carry out some of the foundational activities that one would have assumed were already accomplished by Joshua, Zerubbabel, or Sheshbazzar, including bringing temple vessels back from exile (Ezra 8:26–28, 33; cf. Ezra 1:8–11) and getting Levites to return with him (Ezra 8:15–20; cf. 2:40–58). Also, Grabbe (90) questions Ezra’s authority over all of the Transeuphrates (Ezra 4:20), since he only exercises religious authority and is not very assertive with that (see Ezra 10:1ff.). Grabbe thinks that the Persian sources embedded in the narrative sound like Jewish propaganda and considers their Aramaic later than the Achaemenid period. He is also uncomfortable with Ezra’s presentation of the “law of God” in Neh 8, when the law has been to a large degree in practice before his coming (e.g., Ezra 3:1–4; 6:19–22). Grabbe has more respect for the Nehemiah Memoir, which describes a man with faults, in conflict with the locals, and with a difficult personality; although it is biased, it does seem to him like an autobiographical perspective.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-847",
      "id": "foot-note-847"
    }
  }, [_vm._v("123")]), _vm._v(". Williamson, "), _c('em', [_vm._v("Studies in Persian Period History and Historiography")]), _vm._v(", 4–5.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-846",
      "id": "foot-note-846"
    }
  }, [_vm._v("124")]), _vm._v(". Grabbe (“Mind the Gaps,” 85, 99–100) doubts the amount of 750 talents of silver and 100 talents of gold as well as other precious items (more than 25 tons) that the Persian king and others reputedly contributed to the return, in view of the statement of Herodotus that all of the Transeuphrates produced only 350 talents of silver annually ("), _c('em', [_vm._v("Histories")]), _vm._v(" 3.91) and of Ezra’s cavalier protection of it without an armed escort.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-845",
      "id": "foot-note-845"
    }
  }, [_vm._v("125")]), _vm._v(". See CAP, no. 30, ll. 25–26; Cyrus Cylinder, "), _c('em', [_vm._v("ANET")]), _vm._v(", 316. R. de Vaux, “The Decrees of Cyrus and Darius on the Rebuilding of the Temple,” in "), _c('em', [_vm._v("The Bible and the Ancient Near East")]), _vm._v(", ed. R. de Vaux and D. McHugh (Garden City, NY: Doubleday, 1971), 63–96.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-844",
      "id": "foot-note-844"
    }
  }, [_vm._v("126")]), _vm._v(". Williamson, "), _c('em', [_vm._v("Studies in Persian Period History and Historiography")]), _vm._v(", 221.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-843",
      "id": "foot-note-843"
    }
  }, [_vm._v("127")]), _vm._v(". Williamson, "), _c('em', [_vm._v("Studies in Persian Period History and Historiography")]), _vm._v(", 223–31, esp. 227.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-842",
      "id": "foot-note-842"
    }
  }, [_vm._v("128")]), _vm._v(". M. Jaffee, "), _c('em', [_vm._v("Dynamics of Texts and Traditions")]), _vm._v(" (Upper Saddle River, NJ: Prentice-Hall, 1997), 56.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-841",
      "id": "foot-note-841"
    }
  }, [_vm._v("129")]), _vm._v(". Williamson, "), _c('em', [_vm._v("Studies in Persian Period History and Historiography")]), _vm._v(", 10–11.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-840",
      "id": "foot-note-840"
    }
  }, [_vm._v("130")]), _vm._v(". For a complete list with explanatory details, see Stern, "), _c('em', [_vm._v("Assyrian, Babylonian, and Persian Periods")]), _vm._v(", 360–66.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-839",
      "id": "foot-note-839"
    }
  }, [_vm._v("131")]), _vm._v(". Curiously, Cyrus left Astyages alive and even married his daughter; see Briant, "), _c('em', [_vm._v("Cyrus to Alexander")]), _vm._v(", 17, 32.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-838",
      "id": "foot-note-838"
    }
  }, [_vm._v("132")]), _vm._v(". Briant, "), _c('em', [_vm._v("Cyrus to Alexander")]), _vm._v(", 42–43.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-837",
      "id": "foot-note-837"
    }
  }, [_vm._v("133")]), _vm._v(". Laurie E. Pearce, “Identifying Judeans and Judean Identity in the Babylonian Evidence,” in "), _c('em', [_vm._v("Exile and Return: The Babylonian Context")]), _vm._v(", ed. Jonathan Stokl and Caroline Waerzeggers, BZAW 478 (Berlin: de Gruyter, 2015), 20.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-836",
      "id": "foot-note-836"
    }
  }, [_vm._v("134")]), _vm._v(". Cf. M. Stone, "), _c('em', [_vm._v("Scriptures, Sects and Visions: A Profile of Judaism from Ezra to the Jewish Revolts")]), _vm._v(" (Philadelphia: Fortress, 1980), 14.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-835",
      "id": "foot-note-835"
    }
  }, [_vm._v("135")]), _vm._v(". Myers, "), _c('em', [_vm._v("Ezra, Nehemiah")]), _vm._v(", xxv.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-834",
      "id": "foot-note-834"
    }
  }, [_vm._v("136")]), _vm._v(". Yamauchi, “Ezra-Nehemiah,” 569; Bickerman, "), _c('em', [_vm._v("From Ezra to the Last of the Maccabees")]), _vm._v(", 33.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-833",
      "id": "foot-note-833"
    }
  }, [_vm._v("137")]), _vm._v(". E. Stern ("), _c('em', [_vm._v("Assyrian, Babylonian, and Persian Periods")]), _vm._v(", 350) states that under the Babylonians, “almost no material finds remain.” While the country was populated, the numbers were very small, with large parts of towns completely or partially destroyed. Only in the northern part of Judah and probably Ammon were the populations relatively untouched. Stern refers to the “half-empty land” based on the excavations of Y. Shiloh, N. Avigad, and B. Mazar (580–81).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-832",
      "id": "foot-note-832"
    }
  }, [_vm._v("138")]), _vm._v(". Yamauchi (“Ezra-Nehemiah,” 568) notes that the Babylonians apparently did not share the Assyrian policy of mixing captives in order to break down ethnic loyalties and the possibility of rebellion.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-831",
      "id": "foot-note-831"
    }
  }, [_vm._v("139")]), _vm._v(". Breneman, "), _c('em', [_vm._v("Ezra, Nehemiah, Esther")]), _vm._v(", 29.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-830",
      "id": "foot-note-830"
    }
  }, [_vm._v("140")]), _vm._v(". R. Albertz and B. Becking, “Problems and Possibilities: Perspectives on Postexilic Yahwism,” in "), _c('em', [_vm._v("Yahwism after the Exile: Perspectives on Israelite Religion in the Persian Era: Papers Read at the First Meeting of the European Association for Biblical Studies, Utrecht, 6–9 August, 2000")]), _vm._v(", ed. R. Albertz and B. Becking (Assen: Van Gorcum, 2003), xi–xxi, esp. xi; E. Stern, “What Happened to the Cult Figurines? Israelite Religion Purified after the Exile,” "), _c('em', [_vm._v("BAR")]), _vm._v(" 15 (1989): 22–29, 53; U. Hübner, “Das Fragment einer Tonfigurine vom Tell el-Milh: Überlegungen zur Funktion der sog. Pfeiler-figurinen in der israelitischen Volksreligion,” "), _c('em', [_vm._v("ZDPV")]), _vm._v(" 105 (1989): 47–55.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-829",
      "id": "foot-note-829"
    }
  }, [_vm._v("141")]), _vm._v(". Kidner, "), _c('em', [_vm._v("Ezra and Nehemiah")]), _vm._v(", 16; Stern, "), _c('em', [_vm._v("Assyrian, Babylonian, and Persian Periods")]), _vm._v(", 424.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-828",
      "id": "foot-note-828"
    }
  }, [_vm._v("142")]), _vm._v(". F. Cross, “Personal Names in the Samaria Papyri,” "), _c('em', [_vm._v("BASOR")]), _vm._v(" 344 (November 2006): 75–90.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-827",
      "id": "foot-note-827"
    }
  }, [_vm._v("143")]), _vm._v(". E. Stern and Y. Magen, “Archaeological Evidence for the First Stage of the Samaritan Temple on Mount Gerizim,” "), _c('em', [_vm._v("IEJ")]), _vm._v(" 52 (2002): 49–57.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-826",
      "id": "foot-note-826"
    }
  }, [_vm._v("144")]), _vm._v(". Bickerman, "), _c('em', [_vm._v("From Ezra to the Last of the Maccabees")]), _vm._v(", 36.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-825",
      "id": "foot-note-825"
    }
  }, [_vm._v("145")]), _vm._v(". Myers, "), _c('em', [_vm._v("Ezra, Nehemiah")]), _vm._v(", xxi.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-824",
      "id": "foot-note-824"
    }
  }, [_vm._v("146")]), _vm._v(". Stern, "), _c('em', [_vm._v("Assyrian, Babylonian, and Persian Periods")]), _vm._v(", 426–27.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-823",
      "id": "foot-note-823"
    }
  }, [_vm._v("147")]), _vm._v(". However, the institution of satrapies did not begin with Darius and is firmly attested in the time of Cyrus (Briant, "), _c('em', [_vm._v("Cyrus to Alexander")]), _vm._v(", 64).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-822",
      "id": "foot-note-822"
    }
  }, [_vm._v("148")]), _vm._v(". See Briant, "), _c('em', [_vm._v("Cyrus to Alexander")]), _vm._v(", 68–69, for the difference between the two types of contributions.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-821",
      "id": "foot-note-821"
    }
  }, [_vm._v("149")]), _vm._v(". Both versions carry a polemic, Briant, "), _c('em', [_vm._v("Cyrus to Alexander")]), _vm._v(", 388. “Gifts” are suspect, too, and “voluntary tax” is no doubt according to the desires of the king and not just a loving subject population (Briant, 395). The Murashu family in Babylonia is still thriving under Darius II; they were given lands as payment for collecting the royal taxes and gifts, which were more like fees (Briant, 398).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-820",
      "id": "foot-note-820"
    }
  }, [_vm._v("150")]), _vm._v(". Briant, "), _c('em', [_vm._v("Cyrus to Alexander")]), _vm._v(", 404–5.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-819",
      "id": "foot-note-819"
    }
  }, [_vm._v("151")]), _vm._v(". J. Naveh, “Gleanings of Some Pottery Inscriptions,” "), _c('em', [_vm._v("IEJ")]), _vm._v(" 46 (1996): 44–51.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-818",
      "id": "foot-note-818"
    }
  }, [_vm._v("152")]), _vm._v(". Briant, "), _c('em', [_vm._v("Cyrus to Alexander")]), _vm._v(", 404–5.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-817",
      "id": "foot-note-817"
    }
  }, [_vm._v("153")]), _vm._v(". Briant, "), _c('em', [_vm._v("Cyrus to Alexander")]), _vm._v(", 64.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-816",
      "id": "foot-note-816"
    }
  }, [_vm._v("154")]), _vm._v(". Demotic Papyrus 215 of the Bibliotheque Nationale of Paris; cf. Artaxerxes’s later authorization of Ezra to teach the law of the Jews (Ezra 7:25).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-815",
      "id": "foot-note-815"
    }
  }, [_vm._v("155")]), _vm._v(". Fried, "), _c('em', [_vm._v("Priest and the Great King")]), _vm._v(", 156.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-814",
      "id": "foot-note-814"
    }
  }, [_vm._v("156")]), _vm._v(". According to Fried ("), _c('em', [_vm._v("Priest and the Great King")]), _vm._v(", 194–95), this escort did not come to provide safety on the roads, which was a feature of Persian highways (see Herodotus, "), _c('em', [_vm._v("Histories")]), _vm._v(" 5.52), but to man the citadel. Cf. Ezra 8:21–23, where Ezra is embarrassed to ask for an armed escort from the king.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-813",
      "id": "foot-note-813"
    }
  }, [_vm._v("157")]), _vm._v(". Carter, "), _c('em', [_vm._v("Emergence of Yehud")]), _vm._v(", 284; this is a large number of garrisons for a province slightly more than fifty kilometers square.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-812",
      "id": "foot-note-812"
    }
  }, [_vm._v("158")]), _vm._v(". Fried ("), _c('em', [_vm._v("Priest and the Great King")]), _vm._v(", 200) notes that the presence of foreign troops alone would have brought distress among the local Jewish population (cf. 1 Macc 1:33–36).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-811",
      "id": "foot-note-811"
    }
  }, [_vm._v("159")]), _vm._v(". But the latter was primarily a matter of prestige rather than economics (Briant, "), _c('em', [_vm._v("Cyrus to Alexander")]), _vm._v(", 409). Through the fifth century BCE, Judeans and most of the realm, the Greek cities of Asia Minor being a notable exception, still used weight instead of coinage (Briant, "), _c('em', [_vm._v("Cyrus to Alexander")]), _vm._v(", 406; see Neh 5:4–6).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-810",
      "id": "foot-note-810"
    }
  }, [_vm._v("160")]), _vm._v(". Stern ("), _c('em', [_vm._v("Assyrian, Babylonian, and Persian Periods")]), _vm._v(", 567, 582) explains that although the Persians had an official coinage, by the end of the fifth century, the satrapies could mint their own money for local business. He also thinks that the local mint was probably connected to the Jerusalem Temple since several Judean coins have the names of various priests on them, but these coins do not predate the fourth century BCE.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-809",
      "id": "foot-note-809"
    }
  }, [_vm._v("161")]), _vm._v(". Briant, "), _c('em', [_vm._v("Cyrus to Alexander")]), _vm._v(", 364.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-808",
      "id": "foot-note-808"
    }
  }, [_vm._v("162")]), _vm._v(". Briant, "), _c('em', [_vm._v("Cyrus to Alexander")]), _vm._v(", 371. Stone ("), _c('em', [_vm._v("Scriptures, Sects and Visions")]), _vm._v(", 13) explains that, heretofore, the Mesopotamian empires had written various languages in cuneiform, but the Persians made Aramaic the actual lingua franca of the east.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-807",
      "id": "foot-note-807"
    }
  }, [_vm._v("163")]), _vm._v(". Briant, "), _c('em', [_vm._v("Cyrus to Alexander")]), _vm._v(", 368–69; see Neh 2:9; Ezra 8:22, 31.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-806",
      "id": "foot-note-806"
    }
  }, [_vm._v("164")]), _vm._v(". Briant, "), _c('em', [_vm._v("Cyrus to Alexander")]), _vm._v(", 474.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-805",
      "id": "foot-note-805"
    }
  }, [_vm._v("165")]), _vm._v(". Briant, "), _c('em', [_vm._v("Cyrus to Alexander")]), _vm._v(", 169–70.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-804",
      "id": "foot-note-804"
    }
  }, [_vm._v("166")]), _vm._v(". Cf. Briant, "), _c('em', [_vm._v("Cyrus to Alexander")]), _vm._v(", 171.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-803",
      "id": "foot-note-803"
    }
  }, [_vm._v("167")]), _vm._v(". Myers, "), _c('em', [_vm._v("Ezra, Nehemiah")]), _vm._v(", xxix.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-802",
      "id": "foot-note-802"
    }
  }, [_vm._v("168")]), _vm._v(". Briant, "), _c('em', [_vm._v("Cyrus to Alexander")]), _vm._v(", 473. The term "), _c('em', [_vm._v("wakf")]), _vm._v(" refers to property that the owner has relinquished and dedicated to temple authorities, who must use its income for charitable purposes. Briant describes Darius’s patronage of the interment of an Apis bull (479–80). The satrap was also influential; see the satrap’s naming of a temple administrator for the temple of Khnum at Elephantine (492–491 BCE) (474).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-801",
      "id": "foot-note-801"
    }
  }, [_vm._v("169")]), _vm._v(". A. Finitsis, "), _c('em', [_vm._v("Visions and Eschatology: A Socio-Historical Analysis of Zechariah 1–6")]), _vm._v(", LSTS (London: T & T Clark, 2011), 79–80.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-800",
      "id": "foot-note-800"
    }
  }, [_vm._v("170")]), _vm._v(". J. Blenkinsopp, “Temple and Society in Achaemenid Judah,” in "), _c('em', [_vm._v("Persian Period")]), _vm._v(", vol. 1 of "), _c('em', [_vm._v("Second Temple Studies")]), _vm._v(", ed. P. R. Davies, JSOTSup 117 (Sheffield: JSOT Press, 1991), 26.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-799",
      "id": "foot-note-799"
    }
  }, [_vm._v("171")]), _vm._v(". Although the term “satrap” is used in Ezra 5:3 to designate Tattenai’s position, he was clearly not in control of his own satrapy but subject to the satrap of Babylonia and the Transeuphrates. Nevertheless, tribute must have been organized by subregion, since Tattenai is expected to manage the “royal revenue—that is, from the tribute of Transeuphrates ["), _c('em', [_vm._v("Ebir Nari")]), _vm._v("]” (Ezra 6:8); see Briant, "), _c('em', [_vm._v("Cyrus to Alexander")]), _vm._v(", 487, who suggests that Tattenai’s residence was in Damascus.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-798",
      "id": "foot-note-798"
    }
  }, [_vm._v("172")]), _vm._v(". J. Berquist, “The Social Context of Postexilic Judaism,” in "), _c('em', [_vm._v("Passion, Vitality and Foment")]), _vm._v(": "), _c('em', [_vm._v("The Dynamics of Second Temple Judaism")]), _vm._v(", ed. L. M. Luker (Harrisburg, PA: Trinity Press International, 2001), 38–39. This policy did not continue during Xerxes’s reign, but taxes increased and the burden of the temple’s support fell on the laity (44).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-797",
      "id": "foot-note-797"
    }
  }, [_vm._v("173")]), _vm._v(". Fried ("), _c('em', [_vm._v("Priest and the Great King")]), _vm._v(", 223) points out that exemption from work corvée would be implied as well since it invariably accompanied taxes and tribute.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-796",
      "id": "foot-note-796"
    }
  }, [_vm._v("174")]), _vm._v(". Briant, "), _c('em', [_vm._v("Cyrus to Alexander")]), _vm._v(", 493.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-795",
      "id": "foot-note-795"
    }
  }, [_vm._v("175")]), _vm._v(". Briant ("), _c('em', [_vm._v("Cyrus to Alexander")]), _vm._v(", 578) has doubts about Ctesias’s account and so is not sure that Megabyzus ever became a satrap or that he ever revolted. If so, he may be the first satrap to revolt against the Persian emperor.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-794",
      "id": "foot-note-794"
    }
  }, [_vm._v("176")]), _vm._v(". Yamauchi, “Ezra-Nehemiah,” 571; J. Berquist, "), _c('em', [_vm._v("Judaism in Persia’s Shadow: A Social and Historical Approach")]), _vm._v(" (Minneapolis: Fortress, 1995), 110–11. See a full historical discussion of Persian period intrigues in Blenkinsopp, "), _c('em', [_vm._v("Ezra-Nehemiah")]), _vm._v(", 65.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-793",
      "id": "foot-note-793"
    }
  }, [_vm._v("177")]), _vm._v(". Berquist, "), _c('em', [_vm._v("Judaism in Persia’s Shadow")]), _vm._v(", 106.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-792",
      "id": "foot-note-792"
    }
  }, [_vm._v("178")]), _vm._v(". Blenkinsopp, "), _c('em', [_vm._v("Ezra-Nehemiah")]), _vm._v(", 67.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-791",
      "id": "foot-note-791"
    }
  }, [_vm._v("179")]), _vm._v(". B. Becking outlines five elements of Ezra’s commission: (1) surveying the degree of observance of the Jewish law; (2) transferring financial support to the temple in Jerusalem; (3) implementing a funding system at the temple; (4) keeping cultic personnel free of the burden of taxes; and (5) establishing magistrates and judges (“Law as Expression of Religion (Ezra 7–10),” in Becking and Albertz, "), _c('em', [_vm._v("Yahwism after the Exile")]), _vm._v(", 25); cf. other lists in Williamson, "), _c('em', [_vm._v("Ezra, Nehemiah")]), _vm._v(", 98; Eskenazi, "), _c('em', [_vm._v("In an Age of Prose")]), _vm._v(", 65; Blenkinsopp, "), _c('em', [_vm._v("Ezra-Nehemiah")]), _vm._v(", 146.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-790",
      "id": "foot-note-790"
    }
  }, [_vm._v("180")]), _vm._v(". See P. Frei, “Zentralgewalt und Lokalautonomie im Achämenidenreich,” in "), _c('em', [_vm._v("Reichsidee und Reichsorganisation im Perserreich")]), _vm._v(", by P. Frei and K. Koch, 2nd ed., OBO 55 (Fribourg: Universitätsverlag, 1996), who examines many contemporary texts and inscriptions from Egypt, Asia Minor, and Palestine. Briant ("), _c('em', [_vm._v("Cyrus to Alexander")]), _vm._v(", 510–11) explains that in this way, local populations were, at least in theory, protected from the arbitrary impulses of an unwise satrap. On the other hand, according to L. Fried ("), _c('em', [_vm._v("Priest and the Great King")]), _vm._v(", 217), the laws were just a nod at justice throughout the empire, a sort of abstraction. In reality, the judges would decide cases at will; their power lay in their position, not in the law codes. For example, as governor, Nehemiah had the authority and power to promulgate whatever law he wished.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-789",
      "id": "foot-note-789"
    }
  }, [_vm._v("181")]), _vm._v(". Cf. J. W. Watts, ed., "), _c('em', [_vm._v("Persia and Torah: The Theory of Imperial Authorization of the Pentateuch")]), _vm._v(", SymS 17 (Atlanta: SBL Press, 2001).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-788",
      "id": "foot-note-788"
    }
  }, [_vm._v("182")]), _vm._v(". Berquist, "), _c('em', [_vm._v("Judaism in Persia’s Shadow")]), _vm._v(", 112; cf. Briant, "), _c('em', [_vm._v("Cyrus to Alexander")]), _vm._v(", 111.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-787",
      "id": "foot-note-787"
    }
  }, [_vm._v("183")]), _vm._v(". Myers ("), _c('em', [_vm._v("Ezra, Nehemiah")]), _vm._v(", xxxiv) cites M. Noth, "), _c('em', [_vm._v("The History of Israel")]), _vm._v(" (1958), 324.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-786",
      "id": "foot-note-786"
    }
  }, [_vm._v("184")]), _vm._v(". Briant, "), _c('em', [_vm._v("Cyrus to Alexander")]), _vm._v(", 585.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-785",
      "id": "foot-note-785"
    }
  }, [_vm._v("185")]), _vm._v(". This tension represents a mixture of ethnicities and religions brought on by the Assyrian policy of intermingling captives to reduce loyalties. In addition, there was an age-old conflict between the Northern Kingdom of Israel, represented by the Samarians, and the Southern Kingdom, from which most of the returnees descended (see "), _c('span', {
    attrs: {
      "href": "#/014_Chapter03a#exc12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excursus 12, “Samarians and Samaritans,” pp. 294–96")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-784",
      "id": "foot-note-784"
    }
  }, [_vm._v("186")]), _vm._v(". According to Josephus, the wall was built over two years and four months ("), _c('em', [_vm._v("Antiquities")]), _vm._v(" 11.5). Perhaps this length of time takes in the whole project, including the construction of towers and gates (Myers, "), _c('em', [_vm._v("Ezra, Nehemiah")]), _vm._v(", xxxiv).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-783",
      "id": "foot-note-783"
    }
  }, [_vm._v("187")]), _vm._v(". Briant, "), _c('em', [_vm._v("Cyrus to Alexander")]), _vm._v(", 605.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-782",
      "id": "foot-note-782"
    }
  }, [_vm._v("188")]), _vm._v(". L. H. Schiffman notes that they agreed to discontinue animal sacrifices and accompanying offerings ("), _c('em', [_vm._v("From Text to Tradition: A History of Judaism in Second Temple and Rabbinic Times")]), _vm._v(" [Hoboken, NJ: Ktav, 1991], 42).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-781",
      "id": "foot-note-781"
    }
  }, [_vm._v("189")]), _vm._v(". Aramaic seals from the fifth or sixth centuries have been found in the Transjordan with the name of the province of Ammon, along with an official inscribed on them (Stern, "), _c('em', [_vm._v("Assyrian, Babylonian, and Persian Periods")]), _vm._v(", 552). Briant ("), _c('em', [_vm._v("Cyrus to Alexander")]), _vm._v(", 587) suggests that the Persians may even have recognized Tobiah as governor in the Transjordan.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-780",
      "id": "foot-note-780"
    }
  }, [_vm._v("190")]), _vm._v(". Briant, "), _c('em', [_vm._v("Cyrus to Alexander")]), _vm._v(", 587.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-779",
      "id": "foot-note-779"
    }
  }, [_vm._v("191")]), _vm._v(". S. Talmon, “‘Exile’ and ‘Restoration’ in the Conceptual World of Ancient Judaism,” in Scott, "), _c('em', [_vm._v("Restoration")]), _vm._v(", 112.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-778",
      "id": "foot-note-778"
    }
  }, [_vm._v("192")]), _vm._v(". J. Milgrom explains the difference in status between priests and Levites from the purification service described in Num 8:5–22 ("), _c('em', [_vm._v("The JPS Torah Commentary: Numbers")]), _vm._v(" [Philadelphia: Jewish Publication Society, 1990], 61). Whereas the priests have a holy status due to their anointing oil, the Levites do not and “are forbidden to enter the Tent or officiate at the altar” (cf. Num 18:3–4).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-777",
      "id": "foot-note-777"
    }
  }, [_vm._v("193")]), _vm._v(". Bickerman, "), _c('em', [_vm._v("From Ezra to the Last of the Maccabees")]), _vm._v(", 18.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-776",
      "id": "foot-note-776"
    }
  }, [_vm._v("194")]), _vm._v(". In this regard, B. Becking (“Law as Expression of Religion,” 23) draws attention to the three verbs in the verse.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-775",
      "id": "foot-note-775"
    }
  }, [_vm._v("195")]), _vm._v(". Talmon, “‘Exile’ and ‘Restoration,’” 134–41.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-774",
      "id": "foot-note-774"
    }
  }, [_vm._v("196")]), _vm._v(". For the older view, see G. von Rad, "), _c('em', [_vm._v("Theologie des Alten Testaments")]), _vm._v(", 6th ed. (Munich: Kaiser, 1969), 1:98–105, 214–15; T. C. Vriezen, "), _c('em', [_vm._v("Hoofdlijnen der Theologie van het Oude Testament")]), _vm._v(", 3rd ed. (Wageningen: Veenman, 1966), esp. 309–20, 435; H. H. Schaeder"), _c('em', [_vm._v(", Esra der Schreiber")]), _vm._v(" (Tübingen: Mohr, 1930). For a modern challenge, see W. Brueggemann, "), _c('em', [_vm._v("Theology of the Old Testament: Testimony, Dispute, Advocacy")]), _vm._v(" (Minneapolis: Fortress, 1997), esp. 93–95, 107–12.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-773",
      "id": "foot-note-773"
    }
  }, [_vm._v("197")]), _vm._v(". Respectively, M. Fishbane, "), _c('em', [_vm._v("Biblical Interpretation in Ancient Israel")]), _vm._v(" (Oxford: Clarendon, 1985); Talmon, “‘Exile’ and ‘Restoration.’”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-772",
      "id": "foot-note-772"
    }
  }, [_vm._v("198")]), _vm._v(". E. P. Sanders, "), _c('em', [_vm._v("Judaism: Practice and Belief, 63 BCE–66 CE")]), _vm._v(" (London: SCM; Philadelphia: Trinity Press International, 1992).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-771",
      "id": "foot-note-771"
    }
  }, [_vm._v("199")]), _vm._v(". Schiffman"), _c('em', [_vm._v(", From Text to Tradition")]), _vm._v(", 4–5.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-770",
      "id": "foot-note-770"
    }
  }, [_vm._v("200")]), _vm._v(". D. Edelman, “Introduction,” in "), _c('em', [_vm._v("The Triumph of Elohim: From Yahwisms to Judaisms")]), _vm._v(", ed. D. V. Edelman, CBET 13 (Kampen: Kok Pharos, 1995), 23–24. According to P. Davies, Judaism begins with first a “series of discrete historical developments” regarding cultural customs, which are then cultivated into a distinct lifestyle “in opposition to ‘Hellenism’ and finally as a set of competing and ever more religious definitions of that culture” (“Scenes from the Early History of Judaism,” in Edelman, "), _c('em', [_vm._v("Triumph of Elohim")]), _vm._v(", 180–81).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-769",
      "id": "foot-note-769"
    }
  }, [_vm._v("201")]), _vm._v(". J. Neusner, "), _c('em', [_vm._v("The Judaism the Rabbis Take for Granted")]), _vm._v(" (Atlanta: Scholars Press, 1994), 12, 18.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-768",
      "id": "foot-note-768"
    }
  }, [_vm._v("202")]), _vm._v(". G. Boccaccini, "), _c('em', [_vm._v("Roots of Rabbinic Judaism: An Intellectual History, From Ezekiel to Daniel")]), _vm._v(" (Grand Rapids: Eerdmans, 2002), 27.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-767",
      "id": "foot-note-767"
    }
  }, [_vm._v("203")]), _vm._v(". Fishbane ("), _c('em', [_vm._v("Biblical Interpretation")]), _vm._v(", 122) gives examples of the extension of Leviticus’s priestly laws to the whole nation in Deuteronomy (cf. Lev 21:5–6 and Deut 14:1–2; Deut 14:21 and Lev 17:15; so also J. Milgrom, "), _c('em', [_vm._v("Leviticus 17–22: A New Translation and Commentary")]), _vm._v(", AB 3A (New York: Doubleday, 2000), 1717).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-766",
      "id": "foot-note-766"
    }
  }, [_vm._v("204")]), _vm._v(". The Torah, although not explicitly labeled "), _c('em', [_vm._v("qādoš")]), _vm._v(", nevertheless takes on a central role, perhaps an even more important one than the temple itself. As an extension of Yahweh in the form of his word, the Torah is treated as holy throughout early Judaism and Christianity (cf. John 1:1).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-765",
      "id": "foot-note-765"
    }
  }, [_vm._v("205")]), _vm._v(". H. K. Harrington, “Holiness and Purity in Ezra-Nehemiah,” 99; Milgrom, "), _c('em', [_vm._v("Leviticus 17–22")]), _vm._v(", 1398.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-764",
      "id": "foot-note-764"
    }
  }, [_vm._v("206")]), _vm._v(". R. Bauckham, "), _c('em', [_vm._v("Jesus and the God of Israel: God Crucified and Other Studies on the New Testament’s Christology of Divine Identity")]), _vm._v(" (Grand Rapids: Eerdmans, 2008), 9. During First Temple times, the existence of other gods was acknowledged even among the Israelite faithful (cf. Judg 11:24). Furthermore, many Israelites worshiped pagan deities, and this became a major point of contention for the preexilic prophets and a primary reason for the exile.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-763",
      "id": "foot-note-763"
    }
  }, [_vm._v("207")]), _vm._v(". See the discussion of R. Bauckham and N. MacDonald in Bauckham, "), _c('em', [_vm._v("Jesus and the God of Israel")]), _vm._v(", 60–71.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-762",
      "id": "foot-note-762"
    }
  }, [_vm._v("208")]), _vm._v(". L. Grabbe is skeptical of what can really be ascertained about Judaic religion in the Persian period but agrees that two aspects differentiated it from other Northwest Semitic cults: “These are worship of a god called Yahweh; the other is the Jerusalem temple,” the first being the more important (“Israel’s Historical Reality after the Exile,” in "), _c('em', [_vm._v("The Crisis of Israelite Religion: Transformation of Religious Tradition in Exilic and Post-Exilic Times")]), _vm._v(", ed. B. Becking and M. Korpel, OTS 42 [Leiden: Brill, 1999], 23, 30). While preexilic Israel worshiped Yahweh, they also worshiped other gods.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-761",
      "id": "foot-note-761"
    }
  }, [_vm._v("209")]), _vm._v(". See R. Kletter, “Pots and Polities: Material Remains of Late Iron Age Judah in Relation to Its Political Borders,” "), _c('em', [_vm._v("BASOR")]), _vm._v(" 314 (1999): 19–54; O. Keel and Ch. Uehlinger, "), _c('em', [_vm._v("Gods, Goddesses, and Images of God in Ancient Israel")]), _vm._v(" (Minneapolis: Fortress, 1992), 387–91.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-760",
      "id": "foot-note-760"
    }
  }, [_vm._v("210")]), _vm._v(". Stern, "), _c('em', [_vm._v("Assyrian, Babylonian, and Persian Periods")]), _vm._v(", 479, 488; cf. S. Ackerman, who does not see a break with the veneration of other gods throughout the entire Old Testament period ("), _c('em', [_vm._v("Under Every Green Tree: Popular Religion in Sixth-Century Judah")]), _vm._v(" [Atlanta: SBL Press 1992], 5–99); cf. also C. Frevel, "), _c('em', [_vm._v("Aschera und der Ausschlie")]), _c('span', {
    staticClass: "greek-italic"
  }, [_vm._v("β")]), _c('em', [_vm._v("lichkeitsanspruch YHWHs")]), _vm._v(", BBB 94 (Weinheim: Beltz Athenäum, 1995).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-759",
      "id": "foot-note-759"
    }
  }, [_vm._v("211")]), _vm._v(". L. W. Hurtado, “Monotheism,” in "), _c('em', [_vm._v("DEJ")]), _vm._v(", 961–62.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-758",
      "id": "foot-note-758"
    }
  }, [_vm._v("212")]), _vm._v(". In the growing debate on who counted as a Jew, S. Weitzman suggests that a Jew was simply one who claimed to adhere to the Law of Moses ("), _c('em', [_vm._v("Surviving Sacrilege: Cultural Persistence in Jewish Antiquity")]), _vm._v(" [Cambridge, MA: Harvard University Press, 2005], 3).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-757",
      "id": "foot-note-757"
    }
  }, [_vm._v("213")]), _vm._v(". S. Schwartz, "), _c('em', [_vm._v("Imperialism and Jewish Society, 200 B.C.E. to 640 C.E.")]), _vm._v(" (Princeton, NJ: Princeton University Press, 2004).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-756",
      "id": "foot-note-756"
    }
  }, [_vm._v("214")]), _vm._v(". Breneman, "), _c('em', [_vm._v("Ezra, Nehemiah, Esther")]), _vm._v(", 53; Eskenazi, "), _c('em', [_vm._v("In an Age of Prose")]), _vm._v(", 58.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-755",
      "id": "foot-note-755"
    }
  }, [_vm._v("215")]), _vm._v(". J. Wright, “Seeking, Finding and Writing in Ezra-Nehemiah,” in Boda and Redditt, "), _c('em', [_vm._v("Unity and Disunity in Ezra-Nehemiah")]), _vm._v(", 279.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-754",
      "id": "foot-note-754"
    }
  }, [_vm._v("216")]), _vm._v(". Fried, "), _c('em', [_vm._v("Priest and the Great King")]), _vm._v(", 214–15, citing Briant, "), _c('em', [_vm._v("Cyrus to Alexander")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-753",
      "id": "foot-note-753"
    }
  }, [_vm._v("217")]), _vm._v(". Cf. Wright, “Seeking, Finding and Writing in Ezra-Nehemiah,” 300–301.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-752",
      "id": "foot-note-752"
    }
  }, [_vm._v("218")]), _vm._v(". Blenkinsopp ("), _c('em', [_vm._v("Ezra-Nehemiah")]), _vm._v(", 152–55) cites several examples of Deuteronomic law that are basic to the reforms of Ezra and Nehemiah (e.g., Ezra 9:1 and Neh 13:1 build on Deut 7:1–6; 23:1–9), although he admits influence from the priestly traditions as well.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-751",
      "id": "foot-note-751"
    }
  }, [_vm._v("219")]), _vm._v(". See the collected essays in T. Römer and K. Schmid, eds., "), _c('em', [_vm._v("Les dernières rédactions du Pentateuque, de l’Hexateuque et de l’ Ennéateuque")]), _vm._v(", BETL 203 (Leuven: Peeters, 2007); and in T. Römer, ed., "), _c('em', [_vm._v("The Books of Leviticus and Numbers")]), _vm._v(" (Leuven: Peeters, 2007). C. Nihan argues for three stages of composition in Leviticus parallel to the time of Ezra-Nehemiah, during the Persian Period, with closure effected in the late Persian or early Hellenistic period ("), _c('em', [_vm._v("From Priestly Torah to Pentateuch: A Study in the Composition of the Book of Leviticus")]), _vm._v(", FAT 2/25 [Tübingen: Mohr Siebeck, 2007], 19). The final redaction of Leviticus, however, cannot be later than the mid-third century BCE, because of the book’s appearance among early Dead Sea Scrolls. M. Douglas claims that Leviticus was written in opposition to the exclusionary attitude toward foreigners in Ezra-Nehemiah (“Responding to Ezra: The Priests and the Foreign Wives,” "), _c('em', [_vm._v("BibInt")]), _vm._v(" 10 [2002]: 16–23). According to M. Leuchter, Leviticus 1–16 supports Aaronide authority and combats Nehemiah’s support of the Levites (“The Politics of Ritual Rhetoric: A Proposed Sociopolitical Context for the Redaction of Leviticus 1–16,” "), _c('em', [_vm._v("VT")]), _vm._v(" 60 [2010]: 345–65). Not all scholars agree as to the “lateness” of Leviticus. I. Knohl dates the priestly stratum between the mid-tenth and mid-eighth centuries BCE ("), _c('em', [_vm._v("The Sanctuary of Silence: The Priestly Torah and the Holiness School")]), _vm._v(" [Minneapolis: Fortress, 1995], 220–21); Milgrom places the two major sections of Leviticus (P and H) in the last two centuries of the First Temple with final redaction no later than the exile ("), _c('em', [_vm._v("Leviticus 1–16")]), _vm._v(", 12–13, 28–29). The lack of Persian sociolinguistics in Leviticus is an argument favoring an earlier setting for Leviticus; see F. H. Polak, “Sociolinguistics and the Judean Speech Community in the Achaemenid Empire,” in "), _c('em', [_vm._v("Judah and the Judeans in the Persian Period")]), _vm._v(", ed. O. Lipschits and M. Oeming (Winona Lake, IN: Eisenbrauns, 2006), 592, 600–606.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-750",
      "id": "foot-note-750"
    }
  }, [_vm._v("220")]), _vm._v(". Kidner, "), _c('em', [_vm._v("Ezra and Nehemiah")]), _vm._v(", 26–27.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-749",
      "id": "foot-note-749"
    }
  }, [_vm._v("221")]), _vm._v(". S. Japhet, “What May Be Learned from Ezra–Nehemiah about the Composition of the Pentateuch?,” in "), _c('em', [_vm._v("The Formation of the Pentateuch: Bridging the Academic Cultures of Europe, Israel, and North America")]), _vm._v(", ed. J. C. Gertz et al., FAT 111 (Tübingen: Mohr Siebeck, 2016), 543–61; cf. Myers, "), _c('em', [_vm._v("Ezra-Nehemiah")]), _vm._v(", lxii; Breneman, "), _c('em', [_vm._v("Ezra, Nehemiah, Esther")]), _vm._v(", 48; on this question, see also C. Houtman, “Ezra and the Law,” "), _c('em', [_vm._v("OTS")]), _vm._v(" 21 (1981): 91–115; Williamson, "), _c('em', [_vm._v("Ezra, Nehemiah")]), _vm._v(", xxxvii–xxxix; Williamson, "), _c('em', [_vm._v("Studies in Persian Period History and Historiography")]), _vm._v(", 233: “There appear to be references to most major strands of the Pentateuch both in passages concerned with the law (e.g., Nehemiah 10) and with the early history of Israel (e.g., Nehemiah 9)”; Blenkinsopp, "), _c('em', [_vm._v("Ezra-Nehemiah")]), _vm._v(", 152–57.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-748",
      "id": "foot-note-748"
    }
  }, [_vm._v("222")]), _vm._v(". Furthermore, Darius’s edict shows familiarity with cultic needs known primarily from Leviticus: bulls, rams, lambs, wheat, salt, wine, and grain (Ezra 6:9–10). Bulls and rams were used for sacrifices of atonement (Lev 1:5; 4:3; 5:15). A lamb was offered every morning and evening along with grain and drink offerings (Lev 6:9–13[2–6]; Num 28:3–4), in addition to national feasts (Lev 23:4–44; Num 28:16–29:40), Sabbaths, and new moon celebrations (Num 28:9–15). Wheat was offered up as a grain offering in a variety of ways (e.g., raw flour, baked dough, toasted bread, or pancakes, Lev 2:1–7). Salt was necessary for all offerings, but especially the grain offering (Lev 2:13). Wine was needed for drink offerings (Exod 29:40; Lev 23:13), which, like the grain offerings, accompanied the meat sacrifices. Grain offerings were cooked with oil (Lev 2:1–7). More particularly, the "), _c('em', [_vm._v("tôdâ")]), _vm._v(" (“thanksgiving sacrifice”) of Lev 7, which is accompanied by loaves of bread (see vv. 12–13), plays a strong role in Nehemiah’s dedication of the wall (Neh 12:31).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-747",
      "id": "foot-note-747"
    }
  }, [_vm._v("223")]), _vm._v(". See the discussion in Williamson, "), _c('em', [_vm._v("Studies in Persian Period History and Historiography")]), _vm._v(", 238.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-746",
      "id": "foot-note-746"
    }
  }, [_vm._v("224")]), _vm._v(". Reinmuth, “Nehemiah 8,” 258. Interestingly, Ezra-Nehemiah’s version of Torah reading does not include Deuteronomy’s children and foreigners in the assembly.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-745",
      "id": "foot-note-745"
    }
  }, [_vm._v("225")]), _vm._v(". For further discussion of the terminology of Leviticus in Ezra-Nehemiah, see H. K. Harrington, “The Use of Leviticus in Ezra-Nehemiah,” "), _c('em', [_vm._v("Journal of Hebrew Scriptures")]), _vm._v(" (2013); M. Boda, "), _c('em', [_vm._v("Praying the Tradition")]), _vm._v(" (Berlin: de Gruyter, 1999), 43–51.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-744",
      "id": "foot-note-744"
    }
  }, [_vm._v("226")]), _vm._v(". J. Milgrom notes the continuation of this spelling in Qumran literature, in 1QM ix 8 and CD xii 16 ("), _c('em', [_vm._v("Leviticus 23–27: A New Translation with Introduction and Commentary")]), _vm._v(", AB 3B [New York: Doubleday, 2000], 2301; see "), _c('em', [_vm._v("BDB")]), _vm._v("). Alternatively, "), _c('em', [_vm._v("gā")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ʾ")]), _c('em', [_vm._v("al")]), _vm._v(" (with "), _c('em', [_vm._v("aleph")]), _vm._v(") can be translated “stain” (cf. Isa 63:3).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-743",
      "id": "foot-note-743"
    }
  }, [_vm._v("227")]), _vm._v(". Mary Douglas, “Responding to Ezra: The Priests and the Foreign Wives,” "), _c('em', [_vm._v("BibInt")]), _vm._v(" 10 (2002): 16–23.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-742",
      "id": "foot-note-742"
    }
  }, [_vm._v("228")]), _vm._v(". Blenkinsopp, "), _c('em', [_vm._v("Ezra-Nehemiah")]), _vm._v(", 155–56, surveys the use of the law throughout the monarchical period.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-741",
      "id": "foot-note-741"
    }
  }, [_vm._v("229")]), _vm._v(". Milgrom, "), _c('em', [_vm._v("Leviticus 1–16: A New Translation with Introduction and Commentary")]), _vm._v(", AB 3 (New York: Doubleday, 1991), 12.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-740",
      "id": "foot-note-740"
    }
  }, [_vm._v("230")]), _vm._v(". L. Grabbe, “The Law of Moses in the Ezra Tradition: More Virtual Than Real,” in Watts, "), _c('em', [_vm._v("Persia and Torah")]), _vm._v(", 91–114.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-739",
      "id": "foot-note-739"
    }
  }, [_vm._v("231")]), _vm._v(". When compared with MT, LXX presents a different order of furnishing in the Tabernacle, with some abbreviations, omissions, and added details; see D. W. Gooding, "), _c('em', [_vm._v("The Account of the Tabernacle: Translations and Textual Problems of the Greek Exodus")]), _vm._v(" (Cambridge: Cambridge University Press, 1959), 99–101.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-738",
      "id": "foot-note-738"
    }
  }, [_vm._v("232")]), _vm._v(". E. Ben Zvi, “Inclusion and Exclusion from Israel as Conveyed by the Use of the Term ‘Israel’ in Post-Monarchic Biblical Texts,” in "), _c('em', [_vm._v("The Pitcher Is Broken: Memorial Essays for Gösta Ahlström")]), _vm._v(", ed. S. W. Holloway and L. K. Handy (Sheffield: Sheffield Academic, 1995), 127; Fishbane, "), _c('em', [_vm._v("Biblical Interpretation")]), _vm._v(", 91–95.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-737",
      "id": "foot-note-737"
    }
  }, [_vm._v("233")]), _vm._v(". L. H. Schiffman, "), _c('em', [_vm._v("Qumran and Jerusalem: Studies in the DSS and the History of Judaism")]), _vm._v(" (Grand Rapids: Eerdmans, 2010), 193.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-736",
      "id": "foot-note-736"
    }
  }, [_vm._v("234")]), _vm._v(". Albertz and Becking, “Problems and Possibilities,” xii.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-735",
      "id": "foot-note-735"
    }
  }, [_vm._v("235")]), _vm._v(". Jaffee, "), _c('em', [_vm._v("Dynamics of Texts and Traditions")]), _vm._v(", 62.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-734",
      "id": "foot-note-734"
    }
  }, [_vm._v("236")]), _vm._v(". This table expands on data from Blenkinsopp, "), _c('em', [_vm._v("Ezra-Nehemiah")]), _vm._v(", 153–55.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-733",
      "id": "foot-note-733"
    }
  }, [_vm._v("237")]), _vm._v(". Eskenazi, “Unity and Disunity in Ezra-Nehemiah,” 326; cf. Reinmuth, “Nehemiah 8,” 19, 21.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-732",
      "id": "foot-note-732"
    }
  }, [_vm._v("238")]), _vm._v(". Schiffman, “Pre-Maccabean Halakhah,” 185.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-731",
      "id": "foot-note-731"
    }
  }, [_vm._v("239")]), _vm._v(". See a similar list in Schiffman, “Pre-Maccabean Halakhah,” 186–87. J. Blenkinsopp also adds religious homogeneity and political autonomy within the empire, stating that this ideal becomes a model for the later Maccabees, who achieved an independent nation of Jews in imperial times ("), _c('em', [_vm._v("Judaism: The First Phase: The Place of Ezra and Nehemiah in the Origins of Judaism")]), _vm._v(" [Grand Rapids: Eerdmans, 2009], 188). The dynasty usurped both the high priest and king positions and enforced its will by using the military as well as foreign mercenaries. According to the books of Maccabees, Nehemiah was the role model of a governor who enforced Jewish lifestyle.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-730",
      "id": "foot-note-730"
    }
  }, [_vm._v("240")]), _vm._v(". L. H. Schiffman, "), _c('em', [_vm._v("Who Was a Jew? Rabbinic and Halakhic Perspectives on the Jewish-Christian Schism")]), _vm._v(" (Hoboken, NJ: Ktav, 1985), 14–17.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-729",
      "id": "foot-note-729"
    }
  }, [_vm._v("241")]), _vm._v(". See W. Loader, "), _c('em', [_vm._v("Enoch, Levi, and Jubilees on Sexuality: Attitudes toward Sexuality in the Early Enoch Literature, the Aramaic Levi Document, and the Book of Jubilees")]), _vm._v(" (Grand Rapids: Eerdmans, 2007); "), _c('em', [_vm._v("The Dead Sea Scrolls on Sexuality: Attitudes towards Sexuality in Sectarian and Related Literature at Qumran")]), _vm._v(" (Grand Rapids: Eerdmans, 2009). For a more in-depth treatment of the intermarriage injunctions of Ezra-Nehemiah and their legacy in the Dead Sea Scrolls, see Harrington, “Intermarriage in the Qumran Texts,” 251–79.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-728",
      "id": "foot-note-728"
    }
  }, [_vm._v("242")]), _vm._v(". Schiffman, “Pre-Maccabean Halakhah,” 186; cf. 194: “Certain fundamentals of Pharisaic views on temple and purity issues, as well as a host of other halakhic topics, already existed not only in the Hasmonean period but even before.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-727",
      "id": "foot-note-727"
    }
  }, [_vm._v("243")]), _vm._v(". Schiffman, “Pre-Maccabean Halakhah,” 187.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-726",
      "id": "foot-note-726"
    }
  }, [_vm._v("244")]), _vm._v(". Milgrom, "), _c('em', [_vm._v("Leviticus 1–16")]), _vm._v(", 359–61. Milgrom also offers the explanation that only the resident non-Israelites were prohibited, because they were like the seven Canaanite nations of Deut 7, which were "), _c('em'), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ḥ")]), _c('em', [_vm._v("erem")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-725",
      "id": "foot-note-725"
    }
  }, [_vm._v("245")]), _vm._v(". See L. H. Schiffman, "), _c('em', [_vm._v("Halakhah at Qumran")]), _vm._v(", Studies in Judaism in Late Antiquity 16 (Leiden: Brill, 1975), 54–60. Schiffman (“Pre-Maccabean Halakhah,” 191) writes, “Much of this exegesis is based on analogy to parallel passages or language (like rabbinic "), _c('em', [_vm._v("heqeš")]), _vm._v(") or harmonization of material on one subject which is scattered in the Torah.” Cf. J. Milgrom, “The Scriptural Foundations and Derivations in the Laws of Purity of the Temple Scroll,” in "), _c('em', [_vm._v("Archaeology and History in the Dead Sea Scrolls: The New York University Conference in Memory of Yigael Yadin")]), _vm._v(", ed. L. H. Schiffman, JSOTSup 8 (Sheffield: JSOT Press, 1990), 83–99.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-724",
      "id": "foot-note-724"
    }
  }, [_vm._v("246")]), _vm._v(". M. Avi-Yonah, "), _c('em', [_vm._v("The Herodian Period")]), _vm._v(" (New Brunswick, NJ: Rutgers University Press, 1975), 333; S. Safrai and M. Stern, eds., "), _c('em', [_vm._v("The Jewish People in the First Century")]), _vm._v(" (Assen; Amsterdam: Van Gorcum, 1976), 2:914–33. Williamson ("), _c('em', [_vm._v("Ezra, Nehemiah")]), _vm._v(", 281–82) argues that these liturgical elements were already in place by Nehemiah’s day and were simply utilized on this occasion. They cannot be taken as evidence for an actual synagogue practice; nevertheless, the presence of these conventions in a single service outside of the Temple this early is significant.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-723",
      "id": "foot-note-723"
    }
  }, [_vm._v("247")]), _vm._v(". L. Levine, "), _c('em', [_vm._v("The Ancient Synagogue: The First Thousand Years")]), _vm._v(" (New Haven: Yale University Press, 2000), 139. Regular Jewish Torah reading sessions probably gave impetus to the creation of the LXX in the third century BCE. The Qumran sect engaged in ongoing Torah study sessions, but Philo implies that even the Essenes who lived throughout the land gathered in synagogues on the Sabbath to read and study the Torah ("), _c('em', [_vm._v("That Every Good Person Is Free")]), _vm._v(" 75–76, 81–83; see also "), _c('em', [_vm._v("Hypothetica")]), _vm._v(" 9.1; Josephus, "), _c('em', [_vm._v("Jewish War")]), _vm._v(" 2.124); so also the Therapeutae in Egypt (Philo, "), _c('em', [_vm._v("On the Contemplative Life")]), _vm._v(" 30–31; "), _c('em', [_vm._v("Every Good Person")]), _vm._v(" 81–84); see Luke 4:17–21.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-722",
      "id": "foot-note-722"
    }
  }, [_vm._v("248")]), _vm._v(". L. Levine, "), _c('em', [_vm._v("Ancient Synagogue")]), _vm._v(", 319–23"), _c('em', [_vm._v(".")]), _vm._v(" Josephus reports that the high priest stood on a platform to read from the Torah ("), _c('em', [_vm._v("Antiquities")]), _vm._v(" 4.209–211). Likewise, according to the Mishnah, King Agrippa read a section of the Torah from “a platform of wood in the Temple courtyard” (m. So"), _c('span', {
    staticClass: "chari-r"
  }, [_vm._v("ṭ")]), _vm._v("ah 7:8, translation mine)"), _c('em', [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-721",
      "id": "foot-note-721"
    }
  }, [_vm._v("249")]), _vm._v(". L. Levine, "), _c('em', [_vm._v("Ancient Synagogue")]), _vm._v(", 38–39.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-720",
      "id": "foot-note-720"
    }
  }, [_vm._v("250")]), _vm._v(". Blenkinsopp, "), _c('em', [_vm._v("Judaism")]), _vm._v(", 182–88.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-719",
      "id": "foot-note-719"
    }
  }, [_vm._v("251")]), _vm._v(". S. J. D. Cohen, “From the Bible to the Talmud: The Prohibition of Intermarriage,” "), _c('em', [_vm._v("Hebrew Annual Review")]), _vm._v(" 7 (1983), 23; C. E. Hayes, "), _c('em', [_vm._v("Gentile Impurities and Jewish Identities: Intermarriage and Conversion from the Bible to the Talmud")]), _vm._v(" (Oxford: Oxford University Press, 2002), 24–26.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-718",
      "id": "foot-note-718"
    }
  }, [_vm._v("252")]), _vm._v(". According to the priestly system, a gentile who wished to reside among Israel, a "), _c('em', [_vm._v("gēr")]), _vm._v(", could adopt Israel’s religion. The "), _c('em', [_vm._v("gēr")]), _vm._v(" was required to maintain the purity laws of Israel (Lev 17:15–16). In addition, Num 15:16 requires a purification offering that would atone for both the sins of Israel and those of the "), _c('em', [_vm._v("gēr")]), _vm._v(". Thus, according to the Torah, a "), _c('em', [_vm._v("gēr")]), _vm._v(" is obligated to maintain purity, and purifications are effective for him.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-717",
      "id": "foot-note-717"
    }
  }, [_vm._v("253")]), _vm._v(". Williamson ("), _c('em', [_vm._v("Ezra, Nehemiah")]), _vm._v(", 136) notes the more forceful language of Ezra 9:11 over Lev 18:24–30.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-716",
      "id": "foot-note-716"
    }
  }, [_vm._v("254")]), _vm._v(". J. M. Baumgarten, “The Disqualification of Priests in 4Q Fragments of the ‘Damascus Document,’ a Specimen of the Recovery of Pre-Rabbinic Halakha,” in "), _c('em', [_vm._v("The Madrid Qumran Congress")]), _vm._v(", ed. J. Trebolle-Barrera and L. V. Montaner, STDJ 11 (Leiden: E. J. Brill, 1992), 2:513; cf. E. Regev, “Pure Individualism: The Idea of Non-Priestly Purity in Ancient Judaism,” "), _c('em', [_vm._v("JSJ")]), _vm._v(" 31 (2000): 176–202.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-715",
      "id": "foot-note-715"
    }
  }, [_vm._v("255")]), _vm._v(". J. M. Baumgarten (“Disqualification of Priests in 4Q Fragments,” 508) was one of the first to point out the blur between moral and ritual impurity at Qumran. Also, the impurity of scale disease is referred to as the work of a malevolent spirit, not just a condition in need of the prescribed purifications of Leviticus 14 (4Q272 i 1–16).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-714",
      "id": "foot-note-714"
    }
  }, [_vm._v("256")]), _vm._v(". For a survey of relevant Qumran texts and discussion, see H. K. Harrington, "), _c('em', [_vm._v("The Purity Texts")]), _vm._v(", Companion to the Qumran Scrolls 5 (London: T&T Clark, 2004), 112–27.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-713",
      "id": "foot-note-713"
    }
  }, [_vm._v("257")]), _vm._v(". Blenkinsopp, “Temple and Society in Achaemenid Judah,” 53.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-712",
      "id": "foot-note-712"
    }
  }, [_vm._v("258")]), _vm._v(". The temple is second only to Yahweh himself for the returnees, according to Grabbe, “Israel’s Historical Reality after the Exile,” 30.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-711",
      "id": "foot-note-711"
    }
  }, [_vm._v("259")]), _vm._v(". P. R. Ackroyd, “The Temple Vessels—A Continuity Theme,” in "), _c('em', [_vm._v("Studies in the Religion of Ancient Israel")]), _vm._v(", ed. G. W. Anderson et al., VTSup 23 (Leiden: Brill, 1972), 178. See other links between the two temple building projects in J. Clauss, “Understanding the Mixed Marriages of Ezra-Nehemiah in the Light of Temple-Building and the Book’s Concept of Jerusalem,” in Frevel, "), _c('em', [_vm._v("Mixed Marriages")]), _vm._v(", 112–13; Williamson, "), _c('em', [_vm._v("Ezra, Nehemiah")]), _vm._v(", 48.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-710",
      "id": "foot-note-710"
    }
  }, [_vm._v("260")]), _vm._v(". Schiffman, "), _c('em', [_vm._v("From Text to Tradition")]), _vm._v(", 45.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-709",
      "id": "foot-note-709"
    }
  }, [_vm._v("261")]), _vm._v(". The majority of scholars maintain that the Qumranite self-concept as a sanctuary was only a temporary measure as the sect awaited the messianic era with a renewed sanctuary and purified cult; see CD iv 15–18; v 6–7; vi 11–13; 1QM ii 1–6; E. Regev, “Abominated Temple and a Holy Community: The Formation of the Notions of Purity and Impurity in Qumran,” "), _c('em', [_vm._v("DSD")]), _vm._v(" 10 (2003): 253, 271.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-708",
      "id": "foot-note-708"
    }
  }, [_vm._v("262")]), _vm._v(". P. Trudinger, "), _c('em', [_vm._v("The Psalms of the Tamid Service: A Liturgical Text from the Second Temple")]), _vm._v(" (Leiden: Brill, 2004), 50–51.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-707",
      "id": "foot-note-707"
    }
  }, [_vm._v("263")]), _vm._v(". Kidner, "), _c('em', [_vm._v("Ezra and Nehemiah")]), _vm._v(", 24.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-706",
      "id": "foot-note-706"
    }
  }, [_vm._v("264")]), _vm._v(". Eskenazi ("), _c('em', [_vm._v("In an Age of Prose")]), _vm._v(", 176, 179) claims that Ezra-Nehemiah is thematically different from Chronicles since it downplays its heroes and affirms the people.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-705",
      "id": "foot-note-705"
    }
  }, [_vm._v("265")]), _vm._v(". Eskenazi, "), _c('em', [_vm._v("In an Age of Prose")]), _vm._v(", 84–85. Against Eskenazi’s view, however, see Breneman, "), _c('em', [_vm._v("Ezra, Nehemiah, Esther")]), _vm._v(", 115, who says that the dimensions of the temple in Ezra 6:3 may be a scribal error.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-704",
      "id": "foot-note-704"
    }
  }, [_vm._v("266")]), _vm._v(". Eskenazi, "), _c('em', [_vm._v("In an Age of Prose")]), _vm._v(", 121; contra Blenkinsopp, “Ezra-Nehemiah,” 307, 307n4, who says the term is never used that way. On the other hand, the author of the Temple Scroll often refers to the house of God and the city interchangeably. Ezra-Nehemiah reflects an early stage of expansion of the boundary of holiness around the temple to its environs.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-703",
      "id": "foot-note-703"
    }
  }, [_vm._v("267")]), _vm._v(". For a list of the extra purity requirements required by the Temple Scroll in the temple city, see Harrington, "), _c('em', [_vm._v("Purity Texts")]), _vm._v(", 51.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-702",
      "id": "foot-note-702"
    }
  }, [_vm._v("268")]), _vm._v(". Fishbane, "), _c('em', [_vm._v("Biblical Interpretation")]), _vm._v(", 123. Also, note the parallel “remnant” language in Isa 6:13: Israel will be destroyed by its enemies down to the stump of its “holy seed.” The phrase in Isaiah is not in the LXX and is likely a scribal addition (Williamson, "), _c('em', [_vm._v("Ezra, Nehemiah")]), _vm._v(", 132). Ezra’s decree is drastic compared to the laws of the Pentateuch. In essence, he combines the notion of “holy nation” (Deut 7:6) with that of the “seed of Abraham” (Isa 41:8; Jer 33:26; Ps 105:6; 2 Chr 20:7).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-701",
      "id": "foot-note-701"
    }
  }, [_vm._v("269")]), _vm._v(". Fishbane ("), _c('em', [_vm._v("Biblical Interpretation")]), _vm._v(", 114) calls this identity “ritualized ethnicity.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-700",
      "id": "foot-note-700"
    }
  }, [_vm._v("270")]), _vm._v(". For further discussion of holiness in Second Temple Judaism, see H. K. Harrington, "), _c('em', [_vm._v("Holiness: Rabbinic Judaism and the Graeco-Roman World")]), _vm._v(" (London: Routledge, 2001); see also Milgrom"), _c('em', [_vm._v(", Leviticus 17–22")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-699",
      "id": "foot-note-699"
    }
  }, [_vm._v("271")]), _vm._v(". Of course, Ammon is a contemporary problem too (see Neh 13). The writer has added in the Ammonites, Moabites, and Egyptians (in LXX and 1 Esd 8:68, Edomites) from Deut 23’s list of marriage candidates that could only be included in Israel after several generations.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-698",
      "id": "foot-note-698"
    }
  }, [_vm._v("272")]), _vm._v(". Y. Kaufman, "), _c('em', [_vm._v("History of the Israelite Faith")]), _vm._v(" (Hebrew) (Jerusalem: Bialik Institute, 1956), 8:284ff. The Pentateuch warns against Canaanite intermarriage but does not dictate specific measures to be taken in cases of violation.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-697",
      "id": "foot-note-697"
    }
  }, [_vm._v("273")]), _vm._v(". Eskenazi, "), _c('em', [_vm._v("In an Age of Prose")]), _vm._v(", 112–21. A parallel development can be detected with regard to the written word: from royal decree supporting the temple to Ezra’s combination of both scribe and priest to the community at large that is taught and read to (Neh 8:8) and that finally learns to read the Word of God for itself (Neh 9:3). As J. Wright (“Seeking, Finding and Writing in Ezra-Nehemiah,” 301) puts it, “At a time when the high priesthood is corrupt, they stand in the midst of the fortified Jerusalem surrounded by the sanctified Wall (3:1ff.; see also 12:27ff.) and engage in the activity of seeking-and-finding with the help of a "), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("פחה")]), _vm._v(" devoted to the Torah and a "), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("ספר")]), _vm._v(" at his side.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-696",
      "id": "foot-note-696"
    }
  }, [_vm._v("274")]), _vm._v(". Eskenazi, “Unity and Disunity in Ezra-Nehemiah,” 322.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-695",
      "id": "foot-note-695"
    }
  }, [_vm._v("275")]), _vm._v(". T. C. Eskenazi, “The Missions of Ezra and Nehemiah,” in Lipschits and Oeming, "), _c('em', [_vm._v("Judah and the Judeans")]), _vm._v(", 509–29. S. J. D. Cohen, "), _c('em', [_vm._v("The Beginnings of Jewishness: Boundaries, Varieties, Uncertainties")]), _vm._v(" (Berkeley: University of California Press, 1999), 104–5, argues that the term “Jew” in both Hebrew and Greek texts ("), _c('em', [_vm._v("Yehudi")]), _vm._v(", "), _c('em', [_vm._v("Iudaios")]), _vm._v(") before the second century BCE does not denote an adherent of a religion or particular way of life, but Eskenazi counters that, according to Ezra-Nehemiah, Ezra built just such a Jewish community (“Missions of Ezra and Nehemiah,” 511).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-694",
      "id": "foot-note-694"
    }
  }, [_vm._v("276")]), _vm._v(". Many Second Temple authors refer to heaven as the “temple” where the angels worship God (e.g., 4Q400 1 i 13; 4Q405 23 ii 11; cf. the temples in heaven of 1 En. 14) or where Christ makes priestly intercession for the saints (Heb 8:2–4). For discussion of the Aramaic Levi Document, see Jonas D. Greenfield, Michael E. Stone, and Esther Eshel, "), _c('em', [_vm._v("The Aramaic Levi Document: Edition, Translation and Commentary")]), _vm._v(", SVTP 19 (Leiden: Brill, 2004), 74–75.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-693",
      "id": "foot-note-693"
    }
  }, [_vm._v("277")]), _vm._v(". Bickerman, "), _c('em', [_vm._v("From Ezra to the Last of the Maccabees")]), _vm._v(", 10.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-692",
      "id": "foot-note-692"
    }
  }, [_vm._v("278")]), _vm._v(". See arguments for Christianity from the perspective of rationalism in C. S. Lewis, "), _c('em', [_vm._v("Mere Christianity")]), _vm._v(" (London: Macmillan, 1952).")]), _vm._v(" "), _c('div', {
    staticClass: "img"
  }, [_c('p', {
    staticClass: "image",
    attrs: {
      "id": "m1"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/96.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image-captionc"
  }, [_vm._v("Yehud in the Persian Period")])]), _vm._v(" "), _c('p', {
    staticClass: "image",
    attrs: {
      "id": "fig1"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/97.jpg"
    }
  })])])])
}]}

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(87),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(89),
  /* template */
  __webpack_require__(90),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(92),
  /* template */
  __webpack_require__(93),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(95),
  /* template */
  __webpack_require__(96),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(98),
  /* template */
  __webpack_require__(99),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(101),
  /* template */
  __webpack_require__(102),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(104),
  /* template */
  __webpack_require__(105),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(107),
  /* template */
  __webpack_require__(108),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 108 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(110),
  /* template */
  __webpack_require__(111),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 111 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("Thank you for reading this sample. Here are other books you might like.")]), _c('div', [_c('div', {
    attrs: {
      "id": "textcafe-gallery-widget-container"
    }
  }), _vm._v(" "), _c('script', {
    attrs: {
      "type": "application/javascript"
    }
  }, [_vm._v("\n      TextCafeWidget.config({\n          'type':'related',\n          'id':'9781467464024',\n          'coverImageWidth': '30',\n          'hideDescriptions': true\n      });\n      var textCafeGalleryWidget = TextCafeWidget.widgets.galleryWidget.new({selector:'#textcafe-gallery-widget-container'});\n      textCafeGalleryWidget.render();\n    ")])])])
}]}

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Vuetify"] = factory();
	else
		root["Vuetify"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 29);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = createSimpleFunctional;
/* harmony export (immutable) */ __webpack_exports__["e"] = createSimpleTransition;
/* harmony export (immutable) */ __webpack_exports__["b"] = createJavaScriptTransition;
/* harmony export (immutable) */ __webpack_exports__["f"] = directiveConfig;
/* harmony export (immutable) */ __webpack_exports__["a"] = addOnceEventListener;
/* harmony export (immutable) */ __webpack_exports__["g"] = getObjectValueByPath;
/* harmony export (immutable) */ __webpack_exports__["c"] = createRange;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function createSimpleFunctional(c) {
  var el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'div';

  return {
    functional: true,

    render: function render(h, _ref) {
      var data = _ref.data,
          children = _ref.children;

      data.staticClass = (c + ' ' + (data.staticClass || '')).trim();

      return h(el, data, children);
    }
  };
}

function createSimpleTransition(name) {
  var origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top center 0';
  var mode = arguments[2];

  return {
    functional: true,

    props: {
      origin: {
        type: String,
        default: origin
      }
    },

    render: function render(h, context) {
      context.data = context.data || {};
      context.data.props = { name: name };
      context.data.on = context.data.on || {};

      if (mode) context.data.props.mode = mode;

      context.data.on.beforeEnter = function (el) {
        el.style.transformOrigin = origin;
        el.style.webkitTransformOrigin = origin;
      };

      return h('transition', context.data, context.children);
    }
  };
}

function createJavaScriptTransition(name, functions) {
  var css = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'in-out';

  return {
    functional: true,

    props: {
      css: {
        type: Boolean,
        default: css
      },
      mode: {
        type: String,
        default: mode
      }
    },

    render: function render(h, context) {
      var data = {
        props: _extends({}, context.props, {
          name: name
        }),
        on: functions
      };

      return h('transition', data, context.children);
    }
  };
}

function directiveConfig(binding) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return Object.assign({}, defaults, binding.modifiers, { value: binding.arg }, binding.value || {});
}

function addOnceEventListener(el, event, cb) {
  var once = function once() {
    cb();
    el.removeEventListener(event, once, false);
  };

  el.addEventListener(event, once, false);
}

function getObjectValueByPath(obj, path) {
  // credit: http://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key#comment55278413_6491621
  if (!path || path.constructor !== String) return;
  path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
  path = path.replace(/^\./, ''); // strip a leading dot
  var a = path.split('.');
  for (var i = 0, n = a.length; i < n; ++i) {
    var k = a[i];
    if (obj instanceof Object && k in obj) {
      obj = obj[k];
    } else {
      return;
    }
  }
  return obj;
}

function createRange(length) {
  return [].concat(_toConsumableArray(Array.from({ length: length }, function (v, k) {
    return k;
  })));
}

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    dark: Boolean,
    light: Boolean
  }
});

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isActive: !!this.value
    };
  },


  props: {
    value: {
      required: false
    }
  },

  watch: {
    value: function value(val) {
      this.isActive = !!val;
    },
    isActive: function isActive(val) {
      !!val !== this.value && this.$emit('input', val);
    }
  }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__ = __webpack_require__(8);



/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__["a" /* default */]],

  props: {
    disabled: Boolean,
    fa: Boolean,
    mdi: Boolean,
    large: Boolean,
    left: Boolean,
    medium: Boolean,
    right: Boolean,
    xLarge: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        _ref$children = _ref.children,
        children = _ref$children === undefined ? [] : _ref$children;

    if (props.fa || props.mdi) console.warn('The v-icon prop \'fa\' and \'mdi\' will be deprecated in the next release. Use \'fa\' or \'mdi\' prefix in icon name instead.');
    var iconName = '';
    var iconType = 'material-icons';

    if (children.length) {
      iconName = children.pop().text;
    } else if (data.domProps && data.domProps.textContent) {
      iconName = data.domProps.textContent;
      delete data.domProps.textContent;
    } else if (data.domProps && data.domProps.innerHTML) {
      iconName = data.domProps.innerHTML;
      delete data.domProps.innerHTML;
    }

    var thirdPartyIcon = iconName.indexOf('-') > -1;
    if (thirdPartyIcon) iconType = iconName.slice(0, iconName.indexOf('-'));

    // To keep things backwards compatible for now
    iconType = props.fa ? 'fa' : props.mdi ? 'mdi' : iconType;

    data.staticClass = (iconType + ' icon ' + (data.staticClass || '')).trim();
    data.attrs = data.attrs || {};

    var classes = {
      'icon--large': props.large,
      'icon--left': props.left,
      'icon--medium': props.medium,
      'icon--right': props.right,
      'icon--x-large': props.xLarge,
      'primary--text': props.primary,
      'secondary--text': props.secondary,
      'success--text': props.success,
      'info--text': props.info,
      'warning--text': props.warning,
      'error--text': props.error,
      'theme--dark': props.dark,
      'theme--light': props.light
    };

    var iconClasses = Object.keys(classes).filter(function (k) {
      return classes[k];
    }).join(' ');
    iconClasses && (data.staticClass += ' ' + iconClasses);

    // To keep things backwards compatible for now
    if (props.fa || props.mdi) {
      var comparison = props.fa ? 'fa' : 'mdi';

      if (iconName.indexOf(' ') > -1) data.staticClass += ' ' + comparison + '-' + iconName;else data.staticClass += ' ' + comparison + '-' + iconName.split(' ').join('-');
    }

    if (thirdPartyIcon) data.staticClass += ' ' + iconName;
    if (props.disabled) data.attrs.disabled = props.disabled;
    !(thirdPartyIcon || props.fa || props.mdi) && children.push(iconName);

    return h('i', data, children);
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__badge__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resize__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scroll__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tooltip__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__touch__ = __webpack_require__(81);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Badge", function() { return __WEBPACK_IMPORTED_MODULE_0__badge__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ClickOutside", function() { return __WEBPACK_IMPORTED_MODULE_1__click_outside__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Ripple", function() { return __WEBPACK_IMPORTED_MODULE_3__ripple__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Resize", function() { return __WEBPACK_IMPORTED_MODULE_2__resize__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Scroll", function() { return __WEBPACK_IMPORTED_MODULE_4__scroll__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tooltip", function() { return __WEBPACK_IMPORTED_MODULE_5__tooltip__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Touch", function() { return __WEBPACK_IMPORTED_MODULE_6__touch__["a"]; });










/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__["a" /* default */]],

  props: {
    activeClass: {
      type: String,
      default: 'btn--active'
    },
    block: Boolean,
    fab: Boolean,
    flat: Boolean,
    icon: Boolean,
    large: Boolean,
    loading: Boolean,
    outline: Boolean,
    ripple: {
      type: [Boolean, Object],
      default: true
    },
    round: Boolean,
    small: Boolean,
    tag: {
      type: String,
      default: 'button'
    },
    type: {
      type: String,
      default: 'button'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'btn': true,
        'btn--absolute': this.absolute,
        'btn--active': this.isActive,
        'btn--block': this.block,
        'btn--bottom': this.bottom,
        'btn--disabled': this.disabled,
        'btn--flat': this.flat,
        'btn--floating': this.fab,
        'btn--fixed': this.fixed,
        'btn--hover': this.hover,
        'btn--icon': this.icon,
        'btn--large': this.large,
        'btn--left': this.left,
        'btn--loader': this.loading,
        'btn--outline': this.outline,
        'btn--raised': !this.flat,
        'btn--right': this.right,
        'btn--round': this.round,
        'btn--small': this.small,
        'btn--top': this.top,
        'theme--dark': this.dark,
        'theme--light': this.light,
        'primary': this.primary && !this.outline,
        'secondary': this.secondary && !this.outline,
        'success': this.success && !this.outline,
        'info': this.info && !this.outline,
        'warning': this.warning && !this.outline,
        'error': this.error && !this.outline,
        'primary--text': this.primary && (this.outline || this.flat),
        'secondary--text': this.secondary && (this.outline || this.flat),
        'success--text': this.success && (this.outline || this.flat),
        'info--text': this.info && (this.outline || this.flat),
        'warning--text': this.warning && (this.outline || this.flat),
        'error--text': this.error && (this.outline || this.flat)
      };
    }
  },

  methods: {
    // Prevent focus to match md spec
    click: function click(e) {
      !this.fab && e.detail && this.$el.blur();

      this.$emit('click', e);
    },
    genContent: function genContent() {
      return this.$createElement('div', { 'class': 'btn__content' }, [this.$slots.default]);
    },
    genLoader: function genLoader() {
      var children = [];

      if (!this.$slots.loader) {
        children.push(this.$createElement('v-progress-circular', {
          props: {
            indeterminate: true,
            size: 26
          }
        }));
      } else {
        children.push(this.$slots.loader);
      }

      return this.$createElement('span', { 'class': 'btn__loading' }, children);
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    var children = [this.genContent()];

    tag === 'button' && (data.attrs.type = this.type);
    this.loading && children.push(this.genLoader());

    return h(tag, data, children);
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VCarouselTransition */
/* unused harmony export VCarouselReverseTransition */
/* unused harmony export VTabTransition */
/* unused harmony export VTabReverseTransition */
/* unused harmony export VMenuTransition */
/* unused harmony export VFabTransition */
/* unused harmony export VDialogTransition */
/* unused harmony export VDialogBottomTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VFadeTransition; });
/* unused harmony export VScaleTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return VSlideXTransition; });
/* unused harmony export VSlideXReverseTransition */
/* unused harmony export VSlideYTransition */
/* unused harmony export VSlideYReverseTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VExpandTransition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__expand_transition__ = __webpack_require__(71);




// Component specific transitions
var VCarouselTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-transition');
var VCarouselReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-reverse-transition');
var VTabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-transition');
var VTabReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-reverse-transition');
var VMenuTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('menu-transition');
var VFabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fab-transition', 'center center', 'out-in');

// Generic transitions
var VDialogTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-transition');
var VDialogBottomTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-bottom-transition');
var VFadeTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fade-transition');
var VScaleTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('scale-transition');
var VSlideXTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-transition');
var VSlideXReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-reverse-transition');
var VSlideYTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-transition');
var VSlideYReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-reverse-transition');

// JavaScript transitions
var VExpandTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["b" /* createJavaScriptTransition */])('expand-transition', __WEBPACK_IMPORTED_MODULE_1__expand_transition__["a" /* default */]);

/* harmony default export */ __webpack_exports__["d"] = ({
  VCarouselTransition: VCarouselTransition,
  VCarouselReverseTransition: VCarouselReverseTransition,
  VDialogTransition: VDialogTransition,
  VDialogBottomTransition: VDialogBottomTransition,
  VFabTransition: VFabTransition,
  VFadeTransition: VFadeTransition,
  VMenuTransition: VMenuTransition,
  VScaleTransition: VScaleTransition,
  VSlideXTransition: VSlideXTransition,
  VSlideXReverseTransition: VSlideXReverseTransition,
  VSlideYTransition: VSlideYTransition,
  VSlideYReverseTransition: VSlideYReverseTransition,
  VTabReverseTransition: VTabReverseTransition,
  VTabTransition: VTabTransition,
  VExpandTransition: VExpandTransition
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themeable__ = __webpack_require__(1);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__themeable__["a" /* default */]],

  data: function data() {
    return {
      errorBucket: [],
      focused: false,
      tabFocused: false,
      lazyValue: this.value
    };
  },


  props: {
    appendIcon: String,
    appendIconCb: Function,
    disabled: Boolean,
    error: Boolean,
    errorMessages: {
      type: [String, Array],
      default: function _default() {
        return [];
      }
    },
    hint: String,
    hideDetails: Boolean,
    label: String,
    persistentHint: Boolean,
    placeholder: String,
    prependIcon: String,
    prependIconCb: Function,
    required: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tabindex: {
      default: 0
    },
    value: {
      required: false
    }
  },

  computed: {
    hasError: function hasError() {
      return this.validations.length || this.error;
    },
    inputGroupClasses: function inputGroupClasses() {
      return Object.assign({
        'input-group': true,
        'input-group--focused': this.focused,
        'input-group--dirty': this.isDirty,
        'input-group--tab-focused': this.tabFocused,
        'input-group--disabled': this.disabled,
        'input-group--error': this.hasError,
        'input-group--append-icon': this.appendIcon,
        'input-group--prepend-icon': this.prependIcon,
        'input-group--required': this.required,
        'input-group--hide-details': this.hideDetails,
        'input-group--placeholder': !!this.placeholder,
        'theme--dark': this.dark,
        'theme--light': this.light
      }, this.classes);
    },
    isDirty: function isDirty() {
      return this.inputValue;
    },
    modifiers: function modifiers() {
      var modifiers = {
        lazy: false,
        number: false,
        trim: false
      };

      if (!this.$vnode.data.directives) {
        return modifiers;
      }

      var model = this.$vnode.data.directives.find(function (i) {
        return i.name === 'model';
      });

      if (!model) {
        return modifiers;
      }

      return Object.assign(modifiers, model.modifiers);
    },
    validations: function validations() {
      return (!Array.isArray(this.errorMessages) ? [this.errorMessages] : this.errorMessages).concat(this.errorBucket);
    }
  },

  watch: {
    rules: function rules() {
      this.validate();
    }
  },

  mounted: function mounted() {
    this.validate();
  },


  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    genMessages: function genMessages() {
      var _this = this;

      var messages = [];

      if ((this.hint && this.focused || this.hint && this.persistentHint) && this.validations.length === 0) {
        messages = [this.genHint()];
      } else if (this.validations.length) {
        messages = this.validations.map(function (i) {
          return _this.genError(i);
        });
      }

      return this.$createElement('transition-group', {
        'class': 'input-group__messages',
        props: {
          tag: 'div',
          name: 'slide-y-transition'
        }
      }, messages);
    },
    genHint: function genHint() {
      return this.$createElement('div', {
        'class': 'input-group__hint',
        key: this.hint,
        domProps: { innerHTML: this.hint }
      });
    },
    genError: function genError(error) {
      return this.$createElement('div', {
        'class': 'input-group__error',
        key: error
      }, error);
    },
    genIcon: function genIcon(type) {
      var _class;

      var icon = this[type + 'Icon'];
      var cb = this[type + 'IconCb'];
      var hasCallback = typeof cb === 'function';

      return this.$createElement('v-icon', {
        'class': (_class = {}, _defineProperty(_class, 'input-group__' + type + '-icon', true), _defineProperty(_class, 'input-group__icon-cb', hasCallback), _class),
        on: {
          click: function click(e) {
            hasCallback && cb(e);
          }
        }
      }, icon);
    },
    genInputGroup: function genInputGroup(input) {
      var _this2 = this;

      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var children = [];
      var wrapperChildren = [];
      var detailsChildren = [];

      data = Object.assign({}, {
        'class': this.inputGroupClasses,
        attrs: {
          tabindex: this.tabindex
        },
        on: {
          blur: function blur() {
            return _this2.tabFocused = false;
          },
          click: function click() {
            return _this2.tabFocused = false;
          },
          keyup: function keyup(e) {
            if ([9, 16].includes(e.keyCode)) {
              _this2.tabFocused = true;
            }
          },
          keydown: function keydown(e) {
            if (!_this2.toggle) return;

            if ([13, 32].includes(e.keyCode)) {
              e.preventDefault();
              _this2.toggle();
            }
          }
        }
      }, data);

      if (this.$slots.label || this.label) {
        children.push(this.genLabel());
      }

      wrapperChildren.push(input);

      if (this.prependIcon) {
        wrapperChildren.unshift(this.genIcon('prepend'));
      }

      if (this.appendIcon) {
        wrapperChildren.push(this.genIcon('append'));
      }

      children.push(this.$createElement('div', {
        'class': 'input-group__input'
      }, wrapperChildren));

      detailsChildren.push(this.genMessages());
      this.counter && detailsChildren.push(this.genCounter());

      children.push(this.$createElement('div', {
        'class': 'input-group__details'
      }, detailsChildren));

      return this.$createElement('div', data, children);
    },
    validate: function validate() {
      var _this3 = this;

      this.errorBucket = [];

      this.rules.forEach(function (rule) {
        var valid = typeof rule === 'function' ? rule(_this3.value) : rule;

        if (valid !== true) {
          _this3.errorBucket.push(valid);
        }
      });
    }
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    primary: Boolean,
    secondary: Boolean,
    success: Boolean,
    info: Boolean,
    warning: Boolean,
    error: Boolean
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    append: Boolean,
    disabled: Boolean,
    exact: Boolean,
    href: [String, Object],
    to: [String, Object],
    nuxt: Boolean,
    replace: Boolean,
    router: Boolean,
    ripple: {
      type: Boolean,
      default: true
    },
    tag: String
  },

  methods: {
    click: function click() {},
    generateRouteLink: function generateRouteLink() {
      var exact = this.exact;
      var tag = void 0;

      var data = {
        attrs: { disabled: this.disabled },
        class: this.classes,
        props: {},
        directives: [{
          name: 'ripple',
          value: this.ripple || false
        }],
        on: Object.assign({
          click: this.click
        }, this.$listeners || {})
      };

      if (typeof this.exact === 'undefined') {
        exact = this.to === '/' || this.to === Object(this.to) && this.to.path === '/';
      }

      if (this.to) {
        tag = this.nuxt ? 'nuxt-link' : 'router-link';
        data.props.to = this.to;
        data.props.exact = exact;
        data.props.activeClass = this.activeClass;
        data.props.append = this.append;
        data.props.replace = this.replace;
      } else {
        tag = this.href && 'a' || this.tag || 'a';

        if (tag === 'a') {
          data.attrs.href = this.href || 'javascript:;';
        }
      }

      return { tag: tag, data: data };
    }
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isBooted: false
    };
  },


  watch: {
    isActive: function isActive() {
      this.isBooted = true;
    }
  },

  methods: {
    showLazyContent: function showLazyContent(content) {
      return this.lazy && this.isBooted || !this.lazy ? content : null;
    }
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VListTileActionText */
/* unused harmony export VListTileAvatar */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VListTileContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VListTileTitle; });
/* unused harmony export VListTileSubTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VListGroup__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VListTileAction__ = __webpack_require__(21);







var VListTileActionText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__action-text', 'span');
var VListTileAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__avatar', 'v-avatar');
var VListTileContent = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__content', 'div');
var VListTileTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__title', 'div');
var VListTileSubTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__sub-title', 'div');

/* harmony default export */ __webpack_exports__["c"] = ({
  VList: __WEBPACK_IMPORTED_MODULE_1__VList__["a" /* default */],
  VListTile: __WEBPACK_IMPORTED_MODULE_3__VListTile__["a" /* default */],
  VListGroup: __WEBPACK_IMPORTED_MODULE_2__VListGroup__["a" /* default */],
  VListTileAction: __WEBPACK_IMPORTED_MODULE_4__VListTileAction__["a" /* default */],
  VListTileActionText: VListTileActionText,
  VListTileAvatar: VListTileAvatar,
  VListTileContent: VListTileContent,
  VListTileTitle: VListTileTitle,
  VListTileSubTitle: VListTileSubTitle
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    absolute: Boolean,
    bottom: Boolean,
    fixed: Boolean,
    left: Boolean,
    right: Boolean,
    top: Boolean
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    flat: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    hover: Boolean,
    img: String,
    raised: Boolean,
    tile: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card ' + (data.staticClass || '')).trim();
    data.style = data.style || {};
    data.style.height = props.height;

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.flat) data.staticClass += ' card--flat';
    if (props.horizontal) data.staticClass += ' card--horizontal';
    if (props.hover) data.staticClass += ' card--hover';
    if (props.light) data.staticClass += ' theme--light';
    if (props.raised) data.staticClass += ' card--raised';
    if (props.tile) data.staticClass += ' card--tile';

    if (props.img) {
      data.style.background = 'url(' + props.img + ') center center / cover no-repeat';
    }

    return h('div', data, children);
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isSaving: false
    };
  },


  props: {
    actions: Boolean,
    autosave: Boolean,
    landscape: Boolean,
    noTitle: Boolean,
    scrollable: Boolean,
    value: {
      required: true
    },
    light: {
      type: Boolean,
      default: true
    },
    dark: Boolean
  },

  methods: {
    save: function save() {},
    cancel: function cancel() {},
    genSlot: function genSlot() {
      return this.$scopedSlots.default({
        save: this.save,
        cancel: this.cancel
      });
    }
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    contentClass: {
      default: ''
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      if (_this._isDestroyed) return;

      var app = document.querySelector('[data-app]');

      if (!app) {
        return console.warn('Application is missing <v-app> component.');
      }

      app.insertBefore(_this.$refs.content, app.firstChild);
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.$refs.content) return;

    // IE11 Fix
    try {
      this.$refs.content.parentNode.removeChild(this.$refs.content);
    } catch (e) {}
  }
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      overlay: null,
      overlayOffset: 0,
      overlayTransitionDuration: 500
    };
  },


  props: {
    hideOverlay: Boolean
  },

  beforeDestroy: function beforeDestroy() {
    this.removeOverlay();
  },


  methods: {
    genOverlay: function genOverlay() {
      var _this = this;

      if (!this.isActive || this.hideOverlay || this.isActive && this.overlay) return;

      this.overlay = document.createElement('div');
      this.overlay.className = 'overlay';
      this.overlay.onclick = function () {
        if (_this.permanent) return;else if (!_this.persistent) _this.isActive = false;else if (_this.isMobile) _this.isActive = false;
      };

      if (this.absolute) this.overlay.className += ' overlay--absolute';

      this.hideScroll();

      if (this.absolute) {
        // Required for IE11
        var parent = this.$el.parentNode;
        parent.insertBefore(this.overlay, parent.firstChild);
      } else {
        document.querySelector('[data-app]').appendChild(this.overlay);
      }

      this.overlay.clientHeight; // Force repaint
      requestAnimationFrame(function () {
        _this.overlay.className += ' overlay--active';
      });

      return true;
    },
    removeOverlay: function removeOverlay() {
      var _this2 = this;

      if (!this.overlay) {
        return this.showScroll();
      }

      this.overlay.classList.remove('overlay--active');

      setTimeout(function () {
        // IE11 Fix
        try {
          _this2.overlay.parentNode.removeChild(_this2.overlay);
          _this2.overlay = null;
          _this2.showScroll();
        } catch (e) {}
      }, this.overlayTransitionDuration);
    },
    hideScroll: function hideScroll() {
      // Check documentElement first for IE11
      // this.overlayOffset = document.documentElement &&
      //   document.documentElement.scrollTop ||
      //   document.body.scrollTop

      // document.body.style.top = `-${this.overlayOffset}px`
      // document.body.style.position = 'fixed'
      document.documentElement.style.overflow = 'hidden';
    },
    showScroll: function showScroll() {
      document.documentElement.removeAttribute('style');

      // if (!this.overlayOffset) return
      // document.body.scrollTop = this.overlayOffset
      // document.documentElement.scrollTop = this.overlayOffset
    }
  }
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list',

  provide: function provide() {
    return {
      listClick: this.listClick,
      listClose: this.listClose
    };
  },


  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      uid: null,
      groups: []
    };
  },


  props: {
    dense: Boolean,
    subheader: Boolean,
    threeLine: Boolean,
    twoLine: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list': true,
        'list--two-line': this.twoLine,
        'list--dense': this.dense,
        'list--three-line': this.threeLine,
        'list--subheader': this.subheader,
        'theme--dark dark--bg': this.dark,
        'theme--light light--bg': this.light
      };
    }
  },

  watch: {
    uid: function uid() {
      var _this = this;

      this.$children.filter(function (i) {
        return i.$options._componentTag === 'v-list-group';
      }).forEach(function (i) {
        return i.toggle(_this.uid);
      });
    }
  },

  methods: {
    listClick: function listClick(uid, force) {
      if (force) {
        this.uid = uid;
      } else {
        this.uid = this.uid === uid ? null : uid;
      }
    },
    listClose: function listClose(uid) {
      if (this.uid === uid) {
        this.uid = null;
      }
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      attrs: { 'data-uid': this._uid }
    };

    return h('ul', data, [this.$slots.default]);
  }
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-tile',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_2__directives__["Ripple"]
  },

  inheritAttrs: false,

  props: {
    activeClass: {
      type: String,
      default: 'list__tile--active'
    },
    avatar: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list__tile': true,
        'list__tile--avatar': this.avatar,
        'list__tile--disabled': this.disabled
      };
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    data.attrs = Object.assign({}, data.attrs, this.$attrs);

    return h('li', {
      attrs: {
        disabled: this.disabled
      }
    }, [h(tag, data, [this.$slots.default])]);
  }
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function directive(e, el, binding, v) {
  var cb = function cb() {
    return true;
  };

  if (binding.value) cb = binding.value;

  if (v.context.isActive && e && e.target && e.target !== el && !el.contains(e.target) && cb(e)) {
    v.context.isActive = false;
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding, v) {
    v.context.$vuetify.load(function () {
      var outside = document.querySelector('[data-app]');
      var click = function click(e) {
        return directive(e, el, binding, v);
      };
      outside.addEventListener('click', click, false);
      el._clickOutside = click;
    });
  },
  unbind: function unbind(el) {
    var outside = document.querySelector('[data-app]');
    outside && outside.removeEventListener('click', el._clickOutside, false);
  }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function style(el, value) {
  ['transform', 'webkitTransform'].forEach(function (i) {
    el.style[i] = value;
  });
}

var ripple = {
  show: function show(e, el, _ref) {
    var _ref$value = _ref.value,
        value = _ref$value === undefined ? {} : _ref$value;

    var container = document.createElement('span');
    var animation = document.createElement('span');

    container.appendChild(animation);
    container.className = 'ripple__container';

    if (value.class) {
      container.className += ' ' + value.class;
    }

    var size = el.clientWidth > el.clientHeight ? el.clientWidth : el.clientHeight;
    animation.className = 'ripple__animation';
    animation.style.width = size * (value.center ? 1 : 2) + 'px';
    animation.style.height = animation.style.width;

    el.appendChild(container);
    var computed = window.getComputedStyle(el);
    if (computed.position !== 'absolute' && computed.position !== 'fixed') el.style.position = 'relative';

    var offset = el.getBoundingClientRect();
    var x = value.center ? '50%' : e.clientX - offset.left + 'px';
    var y = value.center ? '50%' : e.clientY - offset.top + 'px';

    animation.classList.add('ripple__animation--enter');
    animation.classList.add('ripple__animation--visible');
    style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ') scale3d(0.01,0.01,0.01)');
    animation.dataset.activated = Date.now();

    setTimeout(function () {
      animation.classList.remove('ripple__animation--enter');
      style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ')  scale3d(0.99,0.99,0.99)');
    }, 0);
  },

  hide: function hide(el) {
    var ripples = el.getElementsByClassName('ripple__animation');

    if (ripples.length === 0) return;
    var animation = ripples[ripples.length - 1];
    var diff = Date.now() - Number(animation.dataset.activated);
    var delay = 400 - diff;

    delay = delay < 0 ? 0 : delay;

    setTimeout(function () {
      animation.classList.remove('ripple__animation--visible');

      setTimeout(function () {
        // Need to figure out a new way to do this
        try {
          if (ripples.length < 1) el.style.position = null;
          animation.parentNode && el.removeChild(animation.parentNode);
        } catch (e) {}
      }, 300);
    }, delay);
  }
};

function directive(el, binding, v) {
  if (binding.value === false) return;

  if ('ontouchstart' in window) {
    el.addEventListener('touchend', function () {
      return ripple.hide(el);
    }, false);
    el.addEventListener('touchcancel', function () {
      return ripple.hide(el);
    }, false);
  }

  el.addEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.addEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.addEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

function unbind(el, binding) {
  el.removeEventListener('touchstart', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('touchend', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('touchcancel', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  unbind: unbind
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  name: 'list-tile-action',

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children;

    data.staticClass = data.staticClass ? 'list__tile__action ' + (data.staticClass || '') : 'list__tile__action';
    if ((children || []).length > 1) data.staticClass += ' list__tile__action--stack';

    return h('div', data, children);
  }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_activator__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_position__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_utils__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__directives__ = __webpack_require__(4);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-menu',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_activator__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_position__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_utils__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__["a" /* default */]],

  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_7__directives__["ClickOutside"]
  },

  data: function data() {
    return {
      autoIndex: null,
      dimensions: {
        activator: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        content: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        list: null,
        selected: null
      },
      direction: { vert: 'bottom', horiz: 'right' },
      isContentActive: false,
      isBooted: false,
      maxHeightAutoDefault: '200px',
      resizeTimeout: {},
      startIndex: 3,
      stopIndex: 0,
      tileLength: 0,
      window: {},
      absoluteX: 0,
      absoluteY: 0,
      hasJustFocused: false,
      focusedTimeout: {}
    };
  },


  props: {
    top: Boolean,
    left: Boolean,
    bottom: Boolean,
    right: Boolean,
    fullWidth: Boolean,
    auto: Boolean,
    offsetX: Boolean,
    offsetY: Boolean,
    disabled: Boolean,
    maxHeight: {
      default: 'auto'
    },
    nudgeTop: {
      type: Number,
      default: 0
    },
    nudgeBottom: {
      type: Number,
      default: 0
    },
    nudgeLeft: {
      type: Number,
      default: 0
    },
    nudgeRight: {
      type: Number,
      default: 0
    },
    nudgeWidth: {
      type: Number,
      default: 0
    },
    openOnClick: {
      type: Boolean,
      default: true
    },
    openOnHover: {
      type: Boolean,
      default: false
    },
    lazy: Boolean,
    closeOnClick: {
      type: Boolean,
      default: true
    },
    closeOnContentClick: {
      type: Boolean,
      default: true
    },
    activator: {
      default: null
    },
    origin: {
      type: String,
      default: 'top left'
    },
    transition: {
      type: String,
      default: 'menu-transition'
    },
    positionX: {
      type: Number,
      default: null
    },
    positionY: {
      type: Number,
      default: null
    },
    positionAbsolutely: {
      type: Boolean,
      default: false
    },
    maxWidth: [Number, String],
    minWidth: [Number, String]
  },

  computed: {
    calculatedMinWidth: function calculatedMinWidth() {
      var minWidth = parseInt(this.minWidth) || this.dimensions.activator.width + this.nudgeWidth + (this.auto ? 16 : 0);

      if (!this.maxWidth) return minWidth;

      var maxWidth = parseInt(this.maxWidth);

      return maxWidth < minWidth ? maxWidth : minWidth;
    },
    styles: function styles() {
      return {
        maxHeight: this.auto ? '200px' : isNaN(this.maxHeight) ? this.maxHeight : this.maxHeight + 'px',
        minWidth: this.calculatedMinWidth + 'px',
        maxWidth: parseInt(this.maxWidth) + 'px',
        top: this.calcTop() + 'px',
        left: this.calcLeft() + 'px'
      };
    },
    hasActivator: function hasActivator() {
      return !!this.$slots.activator || this.activator;
    }
  },

  watch: {
    activator: function activator(newActivator, oldActivator) {
      this.removeActivatorEvents(oldActivator);
      this.addActivatorEvents(newActivator);
    },
    disabled: function disabled(val) {
      val && this.deactivate();
    },
    hasJustFocused: function hasJustFocused(val) {
      var _this = this;

      if (!val) return;

      clearTimeout(this.focusedTimeout);
      this.focusedTimeout = setTimeout(function () {
        return _this.hasJustFocused = false;
      }, 550);
    },
    isActive: function isActive(val) {
      if (this.disabled) return;

      val && this.activate() || this.deactivate();
    },
    windowResizeHandler: function windowResizeHandler() {
      this.isBooted = false;
    }
  },

  mounted: function mounted() {
    window.addEventListener('resize', this.onResize, { passive: true });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onResize, { passive: true });
    window.removeEventListener('resize', this.windowResizeHandler);
  },


  methods: {
    activate: function activate() {
      if (typeof window === 'undefined') return;
      this.isBooted = true;
      this.getTiles();
      this.updateDimensions();
      requestAnimationFrame(this.startTransition);
      this.$emit('activate');
    },
    deactivate: function deactivate() {
      this.isContentActive = false;
      this.$emit('deactivate');
    },
    onResize: function onResize() {
      clearTimeout(this.resizeTimeout);
      if (!this.isActive) return;
      this.resizeTimeout = setTimeout(this.updateDimensions, 200);
    },
    startTransition: function startTransition() {
      var _this2 = this;

      requestAnimationFrame(function () {
        return _this2.isContentActive = true;
      });
      requestAnimationFrame(this.calculateScroll);
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': 'menu',
      style: {
        display: this.fullWidth ? 'block' : 'inline-block'
      },
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this3.closeOnClick;
        }
      }],
      on: {
        keydown: function keydown(e) {
          if (e.keyCode === 27) _this3.isActive = false;else _this3.changeListIndex(e);
        }
      }
    };

    return h('div', data, [this.genActivator(), this.genTransition()]);
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-linear',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["b" /* VFadeTransition */],
    VSlideXTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["c" /* VSlideXTransition */]
  },

  props: {
    active: {
      type: Boolean,
      default: true
    },
    buffer: Boolean,
    bufferValue: Number,
    error: Boolean,
    height: {
      type: [Number, String],
      default: 7
    },
    indeterminate: Boolean,
    info: Boolean,
    secondary: Boolean,
    success: Boolean,
    query: Boolean,
    warning: Boolean,
    value: {
      type: [Number, String],
      default: 0
    },
    colorFront: {
      type: String,
      default: null
    },
    colorBack: {
      type: String,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'progress-linear--query': this.query,
        'progress-linear--secondary': this.secondary,
        'progress-linear--success': this.success,
        'progress-linear--info': this.info,
        'progress-linear--warning': this.warning,
        'progress-linear--error': this.error
      };
    },
    styles: function styles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      if (this.buffer) {
        styles.width = this.bufferValue + '%';
      }

      return styles;
    },
    bufferStyles: function bufferStyles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      return styles;
    }
  },

  methods: {
    genDeterminate: function genDeterminate(h) {
      return h('div', {
        ref: 'front',
        class: ['progress-linear__bar__determinate', this.colorFront],
        style: { width: this.value + '%' }
      });
    },
    genBar: function genBar(h, name) {
      return h('div', {
        class: ['progress-linear__bar__indeterminate', name, this.colorFront]
      });
    },
    genIndeterminate: function genIndeterminate(h) {
      return h('div', {
        ref: 'front',
        class: {
          'progress-linear__bar__indeterminate': true,
          'progress-linear__bar__indeterminate--active': this.active
        }
      }, [this.genBar(h, 'long'), this.genBar(h, 'short')]);
    }
  },

  render: function render(h) {
    var fade = h('v-fade-transition', [this.indeterminate && this.genIndeterminate(h)]);
    var slide = h('v-slide-x-transition', [!this.indeterminate && this.genDeterminate(h)]);

    var bar = h('div', { class: ['progress-linear__bar', this.colorBack], style: this.styles }, [fade, slide]);

    return h('div', {
      class: ['progress-linear', this.classes],
      style: { height: this.height + 'px' },
      on: this.$listeners
    }, [bar]);
  }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_helpers__ = __webpack_require__(0);



















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-select',

  components: {
    VCard: __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__["a" /* default */],
    VCheckbox: __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__["a" /* default */],
    VList: __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__["a" /* default */],
    VListTile: __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__["a" /* default */],
    VListTileAction: __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__["a" /* default */],
    VListTileContent: __WEBPACK_IMPORTED_MODULE_10__components_lists__["a" /* VListTileContent */],
    VListTileTitle: __WEBPACK_IMPORTED_MODULE_10__components_lists__["b" /* VListTileTitle */],
    VMenu: __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__["a" /* default */]
  },

  directives: {
    clickOutside: __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */]],

  data: function data() {
    return {
      content: {},
      hasFocused: false,
      inputValue: this.multiple && !this.value ? [] : this.value,
      isBooted: false,
      lastItem: 20,
      isActive: false,
      searchInputValue: this.searchInput
    };
  },


  props: {
    appendIcon: {
      type: String,
      default: 'arrow_drop_down'
    },
    auto: Boolean,
    autocomplete: Boolean,
    bottom: Boolean,
    chips: Boolean,
    close: Boolean,
    debounce: {
      type: Number,
      default: 200
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    filter: Function,
    itemText: {
      type: String,
      default: 'text'
    },
    itemValue: {
      type: String,
      default: 'value'
    },
    itemDisabled: {
      type: String,
      default: 'disabled'
    },
    maxHeight: {
      type: [Number, String],
      default: 300
    },
    minWidth: {
      type: [Boolean, Number, String],
      default: false
    },
    multiple: Boolean,
    multiLine: Boolean,
    offset: Boolean,
    searchInput: null,
    singleLine: Boolean,
    top: Boolean,
    returnObject: Boolean,
    overflow: Boolean,
    segmented: Boolean,
    editable: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field input-group--select': true,
        'input-group--auto': this.auto,
        'input-group--overflow': this.overflow,
        'input-group--segmented': this.segmented,
        'input-group--editable': this.editable,
        'input-group--autocomplete': this.autocomplete,
        'input-group--single-line': this.singleLine || this.isDropdown,
        'input-group--multi-line': this.multiLine,
        'input-group--chips': this.chips,
        'input-group--multiple': this.multiple
      };
    },
    computedContentClass: function computedContentClass() {
      var children = [this.auto ? 'menu__content--auto' : '', this.isDropdown ? 'menu__content--dropdown' : ''];

      return children.join(' ');
    },
    filteredItems: function filteredItems() {
      var items = this.autocomplete && this.searchValue ? this.filterSearch() : this.items;

      return !this.auto ? items.slice(0, this.lastItem) : items;
    },
    hasError: function hasError() {
      return this.validations.length || this.error || this.hasFocused && !this.focused && !this.isDirty && this.required;
    },
    isDirty: function isDirty() {
      return this.selectedItems.length;
    },
    isDropdown: function isDropdown() {
      return this.segmented || this.overflow || this.editable;
    },

    searchValue: {
      get: function get() {
        return this.searchInput || this.searchInputValue;
      },
      set: function set(val) {
        this.searchInputValue = val;
        this.$emit('update:searchInput', val);
      }
    },
    selectedItems: function selectedItems() {
      var _this = this;

      if (this.inputValue === null || typeof this.inputValue === 'undefined') return [];

      return this.items.filter(function (i) {
        if (!_this.multiple) {
          return _this.getValue(i) === _this.getValue(_this.inputValue);
        } else {
          // Always return Boolean
          return _this.inputValue.find(function (j) {
            return _this.getValue(j) === _this.getValue(i);
          }) !== undefined;
        }
      });
    }
  },

  watch: {
    inputValue: function inputValue(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      this.inputValue = val;
      this.validate();
      if (this.autocomplete || this.editable) {
        this.$nextTick(this.$refs.menu.updateDimensions);
      }
    },
    isActive: function isActive(val) {
      this.isBooted = true;
      this.lastItem += !val ? 20 : 0;

      if (!val) this.blur();else this.focus();
    },
    isBooted: function isBooted() {
      var _this2 = this;

      this.$nextTick(function () {
        if (_this2.content) {
          _this2.content.addEventListener('scroll', _this2.onScroll, false);
        }
      });
    },
    searchValue: function searchValue() {
      this.$refs.menu.listIndex = -1;
    }
  },

  mounted: function mounted() {
    var _this3 = this;

    this.$vuetify.load(function () {
      if (_this3._isDestroyed) return;

      _this3.content = _this3.$refs.menu.$refs.content;
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.isBooted) {
      if (this.content) {
        this.content.removeEventListener('scroll', this.onScroll, false);
      }
    }
  },


  methods: {
    blur: function blur() {
      var _this4 = this;

      this.$nextTick(function () {
        _this4.focused = false;
        _this4.hasFocused = true;
        _this4.searchValue = null;
        _this4.$el.blur();
      });
    },
    focus: function focus() {
      var _this5 = this;

      this.focused = true;
      this.$refs.input && (this.autocomplete || this.editable) && this.$refs.input.focus();

      if (this.editable && this.inputValue !== null && typeof this.inputValue !== 'undefined') {
        this.$nextTick(function () {
          _this5.$refs.input.value = _this5.getValue(_this5.inputValue);
        });
      }
    },
    genLabel: function genLabel() {
      if (this.searchValue && !this.focused && this.isDirty) return null;

      var data = {};

      if (this.id) data.attrs = { for: this.id };

      return this.$createElement('label', data, this.label);
    },
    getPropertyFromItem: function getPropertyFromItem(item, field) {
      if (item !== Object(item)) return item;

      var value = Object(__WEBPACK_IMPORTED_MODULE_13__util_helpers__["g" /* getObjectValueByPath */])(item, field);

      return typeof value === 'undefined' ? item : value;
    },
    getText: function getText(item) {
      return this.getPropertyFromItem(item, this.itemText);
    },
    getValue: function getValue(item) {
      return this.getPropertyFromItem(item, this.itemValue);
    },
    onScroll: function onScroll() {
      var _this6 = this;

      if (!this.isActive) {
        requestAnimationFrame(function () {
          return _this6.content.scrollTop = 0;
        });
      } else {
        var showMoreItems = this.content.scrollHeight - (this.content.scrollTop + this.content.clientHeight) < 200;

        if (showMoreItems) {
          this.lastItem += 20;
        }
      }
    },
    selectItem: function selectItem(item) {
      var _this7 = this;

      if (!this.multiple) {
        this.inputValue = this.returnObject ? item : this.getValue(item);
      } else {
        var inputValue = this.inputValue.slice();
        var i = this.inputValue.findIndex(function (i) {
          return _this7.getValue(i) === _this7.getValue(item);
        });

        i !== -1 && inputValue.splice(i, 1) || inputValue.push(item);
        this.inputValue = inputValue.map(function (i) {
          return _this7.returnObject ? i : _this7.getValue(i);
        });
      }

      if (this.autocomplete || this.editable) {
        this.$nextTick(function () {
          _this7.searchValue = null;
          _this7.$refs.input && _this7.$refs.input.focus();
        });
      }

      this.$emit('change', this.inputValue);
    }
  },

  render: function render(h) {
    var _this8 = this;

    return this.genInputGroup([this.genSelectionsAndSearch(), this.genMenu()], {
      ref: 'activator',
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this8.isActive = false;
        }
      }],
      on: {
        keydown: this.onKeyDown // Located in mixins/autocomplete.js
      }
    });
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    noDataText: {
      type: String,
      default: 'No data available'
    }
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-checkbox',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_2__components_transitions__["b" /* VFadeTransition */],
    VIcon: __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__["a" /* default */]
  },

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_1__directives_ripple__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  data: function data() {
    return {
      inputIndeterminate: this.indeterminate
    };
  },


  props: {
    indeterminate: Boolean
  },

  computed: {
    classes: function classes() {
      return this.addColorClassChecks({
        'checkbox': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      if (this.inputIndeterminate) {
        return 'indeterminate_check_box';
      } else if (this.isActive) {
        return 'check_box';
      } else {
        return 'check_box_outline_blank';
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', [h('v-icon', {
      'class': {
        'icon--checkbox': this.icon === 'check_box'
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var data = {
      attrs: {
        role: 'checkbox',
        'aria-checked': this.inputIndeterminate && 'mixed' || this.isActive && 'true' || 'false',
        'aria-label': this.label
      }
    };

    return this.genInputGroup([transition, ripple], data);
  }
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colorable__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__input__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: null,
    falseValue: null,
    trueValue: null
  },

  computed: {
    isActive: function isActive() {
      if (Array.isArray(this.inputValue)) {
        return this.inputValue.indexOf(this.value) !== -1;
      }

      if (!this.trueValue || !this.falseValue) {
        return this.value ? this.value === this.inputValue : Boolean(this.inputValue);
      }

      return this.inputValue === this.trueValue;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      this.inputIndeterminate = val;
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle },
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    toggle: function toggle() {
      if (this.disabled) {
        return;
      }

      var input = this.inputValue;
      if (Array.isArray(input)) {
        input = input.slice();
        var i = input.indexOf(this.value);

        if (i === -1) {
          input.push(this.value);
        } else {
          input.splice(i, 1);
        }
      } else if (this.trueValue || this.falseValue) {
        input = input === this.trueValue ? this.falseValue : this.trueValue;
      } else if (this.value) {
        input = this.value === this.inputValue ? null : this.value;
      } else {
        input = !input;
      }

      this.$emit('change', input);
    }
  }
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    color: String
  },
  methods: {
    addColorClassChecks: function addColorClassChecks(classes) {
      var parts = this.color ? this.color.trim().split(' ') : [''];
      var color = parts[0] + '--text';
      if (parts.length > 1) color += ' text--' + parts[1];
      classes[color] = !!this.color;
      return classes;
    }
  }
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_load__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_semver__);
__webpack_require__(30);







function plugin(Vue) {
  Object.keys(__WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */]).forEach(function (key) {
    Vue.component(key, __WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */][key]);
  });

  Object.keys(__WEBPACK_IMPORTED_MODULE_2__directives__).forEach(function (key) {
    Vue.directive(key, __WEBPACK_IMPORTED_MODULE_2__directives__[key]);
  });

  Vue.prototype.$vuetify = {
    load: __WEBPACK_IMPORTED_MODULE_3__util_load__["a" /* default */]
  };
}

function checkVueVersion() {
  var vueDep = __WEBPACK_IMPORTED_MODULE_0__package_json__["devDependencies"].vue;
  if (!__WEBPACK_IMPORTED_MODULE_4_semver___default.a.satisfies(window.Vue.version, vueDep)) {
    console.warn('Vuetify requires Vue version ' + vueDep);
  }
}

if (typeof window !== 'undefined' && window.Vue) {
  if (window.Vue.version) {
    checkVueVersion();
  }
  window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["default"] = (plugin);

/***/ }),
/* 30 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = {
	"name": "vuetify",
	"version": "0.14.10",
	"author": {
		"name": "John Leider",
		"email": "john.j.leider@gmail.com"
	},
	"license": "MIT",
	"homepage": "http://vuetifyjs.com",
	"main": "dist/vuetify.js",
	"types": "index.d.ts",
	"scripts": {
		"watch": "cross-env TARGET=dev webpack --config build/config.js --progress --hide-modules --watch",
		"dev": "cross-env NODE_ENV=development webpack-dev-server --config build/webpack.dev.config.js --open --hot",
		"build": "rimraf dist && cross-env NODE_ENV=production node build/build.js --progress --hide-modules",
		"debug-build": "node --inspect --debug-brk build/build.js",
		"test": "cross-env NODE_ENV=test jest --no-cache --verbose",
		"test-coverage": "cross-env NODE_ENV=test jest --no-cache --coverage --verbose",
		"lint": "eslint --ext .js,.vue src"
	},
	"description": "Vue.js 2 Semantic Component Framework",
	"devDependencies": {
		"autoprefixer": "^6.6.0",
		"avoriaz": "^3.2.0",
		"babel-cli": "^6.24.1",
		"babel-core": "^6.24.1",
		"babel-eslint": "^7.1.1",
		"babel-jest": "^20.0.3",
		"babel-loader": "^7.1.1",
		"babel-plugin-add-filehash": "^6.9.4",
		"babel-plugin-module-resolver": "^2.7.1",
		"babel-plugin-transform-async-to-generator": "^6.24.1",
		"babel-plugin-transform-runtime": "^6.23.0",
		"babel-preset-env": "^1.5.1",
		"babel-preset-es2015": "^6.24.1",
		"babel-preset-stage-2": "^6.24.1",
		"chalk": "^1.1.3",
		"chromedriver": "^2.21.2",
		"cross-env": "^3.1.3",
		"cross-spawn": "^4.0.2",
		"css-loader": "^0.23.1",
		"css-mqpacker": "^6.0.1",
		"cssnano": "^3.10.0",
		"eslint": "^3.7.1",
		"eslint-config-standard": "^6.1.0",
		"eslint-config-vue": "^2.0.2",
		"eslint-friendly-formatter": "^2.0.5",
		"eslint-loader": "^1.6.1",
		"eslint-plugin-html": "^1.3.0",
		"eslint-plugin-promise": "^3.4.0",
		"eslint-plugin-pug": "^1.0.0",
		"eslint-plugin-standard": "^3.0.1",
		"eslint-plugin-vue": "^2.1.0",
		"eventsource-polyfill": "^0.9.6",
		"extract-text-webpack-plugin": "^3.0.0",
		"friendly-errors-webpack-plugin": "^1.6.1",
		"function-bind": "^1.0.2",
		"jest": "^20.0.4",
		"jest-cli": "^20.0.4",
		"jest-css-modules": "^1.1.0",
		"jest-serializer-html": "^4.0.0",
		"jest-vue-preprocessor": "^0.2.0",
		"lolex": "^1.4.0",
		"nightwatch": "^0.9.8",
		"opn": "^4.0.2",
		"optimize-css-assets-webpack-plugin": "^2.0.0",
		"optimize-js-plugin": "^0.0.4",
		"ora": "^0.3.0",
		"phantomjs-prebuilt": "^2.1.3",
		"postcss-loader": "^1.2.1",
		"precss": "^1.4.0",
		"pug": "^2.0.0-beta3",
		"pug-loader": "^2.3.0",
		"ress": "^1.1.1",
		"rimraf": "^2.5.4",
		"selenium-server": "2.53.1",
		"semver": "^5.3.0",
		"serialize-javascript": "^1.3.0",
		"shelljs": "^0.7.4",
		"style-loader": "^0.13.1",
		"stylus": "^0.54.5",
		"stylus-loader": "^2.1.1",
		"uglifyjs-webpack-plugin": "^0.4.6",
		"vue": "^2.4.1",
		"vue-loader": "^10.1.0",
		"vue-router": "^2.7.0",
		"vue-server-renderer": "^2.4.1",
		"vue-template-compiler": "^2.4.1",
		"webpack": "^3.2.0",
		"webpack-bundle-size-analyzer": "^2.7.0",
		"webpack-dev-server": "^2.6.1",
		"webpack-merge": "^4.1.0"
	},
	"dependencies": {},
	"engines": {
		"node": ">= 4.0.0",
		"npm": ">= 3.0.0"
	},
	"jest": {
		"verbose": false,
		"roots": [
			"<rootDir>/src"
		],
		"moduleFileExtensions": [
			"js",
			"vue"
		],
		"moduleDirectories": [
			"node_modules"
		],
		"moduleNameMapper": {
			"src/(.*)": "<rootDir>/src/$1"
		},
		"transform": {
			".*\\.(vue)$": "<rootDir>/node_modules/jest-vue-preprocessor",
			"\\.(styl)$": "<rootDir>/node_modules/jest-css-modules",
			".*\\.(vue|js)$": "<rootDir>/node_modules/babel-jest"
		},
		"transformIgnorePatterns": [
			"node_modules/(?!vue-router)"
		],
		"snapshotSerializers": [
			"jest-serializer-html"
		]
	}
};

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__alerts__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__avatars__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bottom_nav__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__buttons__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cards__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__carousel__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__chips__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pickers__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dialogs__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__dividers__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__expansion_panel__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__footer__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__grid__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__icons__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__menus__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__toolbar__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pagination__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__parallax__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__progress__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__selects__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__selection_controls__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__sliders__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__subheaders__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__steppers__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__tables__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__tabs__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__text_fields__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__snackbars__ = __webpack_require__(129);


































/* harmony default export */ __webpack_exports__["a"] = (Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__alerts__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__app__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__avatars__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__bottom_nav__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__buttons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__cards__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__carousel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__chips__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__pickers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__dialogs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__dividers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__expansion_panel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__footer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__grid__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__icons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__lists__["c" /* default */], __WEBPACK_IMPORTED_MODULE_17__menus__["a" /* default */], __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_19__toolbar__["a" /* default */], __WEBPACK_IMPORTED_MODULE_20__pagination__["a" /* default */], __WEBPACK_IMPORTED_MODULE_21__parallax__["a" /* default */], __WEBPACK_IMPORTED_MODULE_22__progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_23__selects__["a" /* default */], __WEBPACK_IMPORTED_MODULE_24__selection_controls__["a" /* default */], __WEBPACK_IMPORTED_MODULE_25__sliders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_26__subheaders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_27__steppers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_28__tables__["a" /* default */], __WEBPACK_IMPORTED_MODULE_29__tabs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_30__text_fields__["a" /* default */], __WEBPACK_IMPORTED_MODULE_31__transitions__["d" /* default */], __WEBPACK_IMPORTED_MODULE_32__snackbars__["a" /* default */]));

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VAlert__ = __webpack_require__(34);


/* harmony default export */ __webpack_exports__["a"] = ({
  VAlert: __WEBPACK_IMPORTED_MODULE_0__VAlert__["a" /* default */]
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__ = __webpack_require__(35);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-alert',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__["a" /* default */]],

  props: {
    dismissible: Boolean,
    hideIcon: Boolean,
    icon: String
  },

  computed: {
    classes: function classes() {
      return {
        'alert': true,
        'alert--dismissible': this.dismissible,
        'error': this.error,
        'info': this.info,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'warning': this.warning
      };
    },
    mdIcon: function mdIcon() {
      switch (true) {
        case !!this.icon:
          return this.icon;
        case this.error:
          return 'warning';
        case this.info:
          return 'info';
        case this.success:
          return 'check_circle';
        case this.warning:
          return 'priority_high';
      }
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [h('div', this.$slots.default)];

    if (!this.hideIcon && this.mdIcon) {
      children.unshift(h('v-icon', {
        'class': 'alert__icon'
      }, this.mdIcon));
    }

    if (this.dismissible) {
      var close = h('a', {
        'class': 'alert__dismissible',
        domProps: { href: 'javascript:;' },
        on: { click: function click() {
            return _this.$emit('input', false);
          } }
      }, [h('v-icon', {
        props: { right: true }
      }, 'cancel')]);

      children.push(close);
    }

    var alert = h('div', {
      'class': this.classes,
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, children);

    if (!this.transition) return alert;

    return h('transition', {
      props: {
        name: this.transition,
        origin: this.origin,
        mode: this.mode
      }
    }, [alert]);
  }
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    mode: String,
    origin: String,
    transition: String
  }
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VApp__ = __webpack_require__(37);


/* harmony default export */ __webpack_exports__["a"] = ({
  VApp: __WEBPACK_IMPORTED_MODULE_0__VApp__["a" /* default */]
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    fixedFooter: Boolean,
    footer: Boolean,
    id: {
      type: String,
      default: 'app'
    },
    toolbar: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('application ' + (data.staticClass || '')).trim();
    data.staticClass += ' application--' + (props.dark ? 'dark' : 'light');

    props.footer && (data.staticClass += ' application--footer');
    props.fixedFooter && (data.staticClass += ' application--footer-fixed');
    props.toolbar && (data.staticClass += ' application--toolbar');

    data.attrs = { 'data-app': true };
    data.domProps = { id: props.id };

    return h('div', data, children);
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VAvatar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var VAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('avatar');

/* harmony default export */ __webpack_exports__["a"] = ({
  VAvatar: VAvatar
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBottomNav__ = __webpack_require__(40);


/* harmony default export */ __webpack_exports__["a"] = ({
  VBottomNav: __WEBPACK_IMPORTED_MODULE_0__VBottomNav__["a" /* default */]
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    shift: Boolean,
    value: { required: false }
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('bottom-nav ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' bottom-nav--absolute';
    if (props.shift) data.staticClass += ' bottom-nav--shift';
    if (props.value) data.staticClass += ' bottom-nav--active';

    return h('div', data, children);
  }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__ = __webpack_require__(43);



/* harmony default export */ __webpack_exports__["a"] = ({
  VBreadcrumbs: __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__["a" /* default */],
  VBreadcrumbsItem: __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__["a" /* default */]
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs',

  provide: function provide() {
    return {
      divider: this.divider
    };
  },


  props: {
    divider: {
      type: String,
      default: '/'
    },
    icons: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'breadcrumbs': true,
        'breadcrumbs--with-icons': this.icons
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': this.classes,
      props: { items: this.items }
    }, this.$slots.default);
  }
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs-item',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  inject: ['divider'],

  props: {
    activeClass: {
      type: String,
      default: 'breadcrumbs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = _defineProperty({
        'breadcrumbs__item': true
      }, this.activeClass, !this.disabled);

      return classes;
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      attrs: { 'data-divider': this.divider }
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__ = __webpack_require__(46);




/* harmony default export */ __webpack_exports__["a"] = ({
  VBtn: __WEBPACK_IMPORTED_MODULE_0__VBtn__["a" /* default */],
  VBtnToggle: __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__["a" /* default */],
  VSpeedDial: __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__["a" /* default */]
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn-toggle',

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: {
      required: false
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    mandatory: Boolean,
    multiple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'btn-toggle': true,
        'btn-toggle--selected': this.inputValue && (!this.multiple || this.inputValue.length)
      };
    }
  },

  methods: {
    isSelected: function isSelected(item) {
      if (!this.multiple) {
        return this.inputValue === item.value;
      }

      return this.inputValue.includes(item.value);
    },
    updateValue: function updateValue(item) {
      if (!this.multiple) {
        if (this.mandatory && this.inputValue === item.value) return;
        return this.$emit('change', this.inputValue === item.value ? null : item.value);
      }

      var items = this.inputValue.slice();

      var i = items.indexOf(item.value);
      if (i > -1) {
        items.length >= 1 && !this.mandatory && items.splice(i, 1);
      } else {
        items.push(item.value);
      }

      this.$emit('change', items);
    }
  },

  render: function render(h) {
    var _this = this;

    var buttons = this.items.map(function (item, index) {
      var children = [];

      item.text && children.push(h('span', item.text));
      item.icon && children.push(h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], item.icon));

      return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], {
        key: index,
        props: {
          flat: true
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.updateValue(item);
          }
        },
        attrs: {
          'data-selected': _this.isSelected(item),
          'data-index': index,
          'data-only-child': _this.isSelected(item) && (!_this.multiple || _this.inputValue.length === 1)
        }
      }, children);
    });

    return h('div', { class: this.classes }, buttons);
  }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-speed-dial',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    direction: {
      type: String,
      default: 'top',
      validator: function validator(val) {
        return ['top', 'right', 'bottom', 'left'].includes(val);
      }
    },
    hover: Boolean,
    transition: {
      type: String,
      default: 'scale-transition'
    }
  },

  computed: {
    classes: function classes() {
      return _defineProperty({
        'speed-dial': true,
        'speed-dial--top': this.top,
        'speed-dial--right': this.right,
        'speed-dial--bottom': this.bottom,
        'speed-dial--left': this.left,
        'speed-dial--absolute': this.absolute,
        'speed-dial--fixed': this.fixed
      }, 'speed-dial--direction-' + this.direction, true);
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [];
    var data = {
      'class': this.classes,
      directives: [{
        name: 'click-outside'
      }],
      on: {
        click: function click() {
          return _this.isActive = !_this.isActive;
        }
      }
    };

    if (this.hover) {
      data.on.mouseenter = function () {
        return _this.isActive = true;
      };
      data.on.mouseleave = function () {
        return _this.isActive = false;
      };
    }

    if (this.isActive) {
      children = (this.$slots.default || []).map(function (b, i) {
        b.key = i;

        return b;
      });
    }

    var list = h('transition-group', {
      'class': 'speed-dial__list',
      props: {
        name: this.transition,
        tag: 'div'
      }
    }, children);

    return h('div', data, [this.$slots.activator, list]);
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VCardMedia__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VCardTitle__ = __webpack_require__(49);





var VCardActions = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__actions');
var VCardText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__text');

/* harmony default export */ __webpack_exports__["a"] = ({
  VCard: __WEBPACK_IMPORTED_MODULE_1__VCard__["a" /* default */],
  VCardActions: VCardActions,
  VCardMedia: __WEBPACK_IMPORTED_MODULE_2__VCardMedia__["a" /* default */],
  VCardText: VCardText,
  VCardTitle: __WEBPACK_IMPORTED_MODULE_3__VCardTitle__["a" /* default */]
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-card-media',

  props: {
    contain: Boolean,
    height: {
      type: [Number, String],
      default: 'auto'
    },
    src: {
      type: String
    }
  },

  render: function render(h) {
    var data = {
      'class': 'card__media',
      style: {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      },
      on: this.$listeners
    };

    var children = [];

    if (this.src) {
      children.push(h('div', {
        'class': 'card__media__background',
        style: {
          background: 'url(' + this.src + ') center center / ' + (this.contain ? 'contain' : 'cover') + ' no-repeat'
        }
      }));
    }

    children.push(h('div', {
      'class': 'card__media__content'
    }, this.$slots.default));

    return h('div', data, children);
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    primaryTitle: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card__title ' + (data.staticClass || '')).trim();

    if (props.primaryTitle) data.staticClass += ' card__title--primary';

    return h('div', data, children);
  }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCarousel__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__ = __webpack_require__(52);



/* harmony default export */ __webpack_exports__["a"] = ({
  VCarousel: __WEBPACK_IMPORTED_MODULE_0__VCarousel__["a" /* default */],
  VCarouselItem: __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__["a" /* default */]
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      current: null,
      items: [],
      slideInterval: {},
      reverse: false
    };
  },


  props: {
    cycle: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: 'fiber_manual_record'
    },
    interval: {
      type: Number,
      default: 6000
    },
    leftControlIcon: {
      type: [Boolean, String],
      default: 'chevron_left'
    },
    rightControlIcon: {
      type: [Boolean, String],
      default: 'chevron_right'
    }
  },

  computed: {
    defaultState: function defaultState() {
      return {
        current: null,
        reverse: false
      };
    }
  },

  watch: {
    current: function current() {
      var _this = this;

      // Evaluate items when current changes to account for
      // dynamic changing of children
      this.items = this.$children.filter(function (i) {
        return i.$el.classList && i.$el.classList.contains('carousel__item');
      });

      this.items.forEach(function (i) {
        return i.open(_this.items[_this.current]._uid, _this.reverse);
      });

      !this.isBooted && this.cycle && this.restartInterval();
      this.isBooted = true;
    },
    cycle: function cycle(val) {
      val && this.restartInterval() || clearInterval(this.slideInterval);
    }
  },

  mounted: function mounted() {
    this.init();
  },


  methods: {
    genControls: function genControls() {
      return this.$createElement('div', {
        staticClass: 'carousel__controls'
      }, this.genItems());
    },
    genIcon: function genIcon(direction, icon, fn) {
      if (!icon) return null;

      return this.$createElement('div', {
        staticClass: 'carousel__' + direction
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
        props: {
          icon: true,
          dark: this.dark || !this.light,
          light: this.light
        },
        on: { click: fn }
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], icon)])]);
    },
    genItems: function genItems() {
      var _this2 = this;

      return this.items.map(function (item, index) {
        return _this2.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
          class: {
            'carousel__controls__item': true,
            'carousel__controls__item--active': index === _this2.current
          },
          props: {
            icon: true,
            dark: _this2.dark || !_this2.light,
            light: _this2.light
          },
          key: index,
          on: { click: _this2.select.bind(_this2, index) }
        }, [_this2.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], _this2.icon)]);
      });
    },
    restartInterval: function restartInterval() {
      clearInterval(this.slideInterval);
      this.$nextTick(this.startInterval);
    },
    init: function init() {
      this.current = 0;
    },
    next: function next() {
      this.reverse = false;

      if (this.current + 1 === this.items.length) {
        return this.current = 0;
      }

      this.current++;
    },
    prev: function prev() {
      this.reverse = true;

      if (this.current - 1 < 0) {
        return this.current = this.items.length - 1;
      }

      this.current--;
    },
    select: function select(index) {
      this.reverse = index < this.current;
      this.current = index;
    },
    startInterval: function startInterval() {
      this.slideInterval = setInterval(this.next, this.interval);
    }
  },

  render: function render(h) {
    return h('div', {
      staticClass: 'carousel',
      directives: [{
        name: 'touch',
        value: {
          left: this.next,
          right: this.prev
        }
      }]
    }, [this.genIcon('left', this.leftControlIcon, this.prev), this.genIcon('right', this.rightControlIcon, this.next), this.genControls(), this.$slots.default]);
  }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel-item',

  data: function data() {
    return {
      active: false,
      reverse: false
    };
  },


  props: {
    src: {
      type: String,
      required: true
    },

    transition: {
      type: String,
      default: 'tab-transition'
    },

    reverseTransition: {
      type: String,
      default: 'tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    },
    styles: function styles() {
      return {
        backgroundImage: 'url(' + this.src + ')'
      };
    }
  },

  methods: {
    open: function open(id, reverse) {
      this.active = this._uid === id;
      this.reverse = reverse;
    }
  },

  render: function render(h) {
    var item = h('div', {
      class: {
        'carousel__item': true,
        'reverse': this.reverse
      },
      style: this.styles,
      on: this.$listeners,
      directives: [{
        name: 'show',
        value: this.active
      }]
    }, [this.$slots.default]);

    return h('transition', { props: { name: this.computedTransition } }, [item]);
  }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VChip__ = __webpack_require__(54);


/* harmony default export */ __webpack_exports__["a"] = ({
  VChip: __WEBPACK_IMPORTED_MODULE_0__VChip__["a" /* default */]
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-chip',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    close: Boolean,
    label: Boolean,
    outline: Boolean,
    small: Boolean,
    value: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'chip': true,
        'chip--label': this.label,
        'chip--outline': this.outline,
        'chip--small': this.small,
        'chip--removable': this.close
      };
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [this.$slots.default];
    var data = {
      'class': this.classes,
      attrs: { tabindex: -1 },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    };

    if (this.close) {
      children.push(h('a', {
        'class': 'chip__close',
        domProps: { href: 'javascript:;' },
        on: {
          click: function click(e) {
            e.stopPropagation();

            _this.$emit('input', false);
          }
        }
      }, [h('v-icon', { props: { right: true } }, 'cancel')]));
    }

    return h('span', data, children);
  }
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDatePicker__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTimePicker__ = __webpack_require__(61);



/* harmony default export */ __webpack_exports__["a"] = ({
  VDatePicker: __WEBPACK_IMPORTED_MODULE_0__VDatePicker__["a" /* default */],
  VTimePicker: __WEBPACK_IMPORTED_MODULE_1__VTimePicker__["a" /* default */]
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_date_title__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_helpers__ = __webpack_require__(0);







var defaultDateFormat = function defaultDateFormat(val) {
  return new Date(val).toISOString().substr(0, 10);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-date-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_date_title__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_picker__["a" /* default */]],

  data: function data() {
    return {
      tableDate: new Date(),
      originalDate: this.value,
      currentDay: null,
      currentMonth: null,
      currentYear: null,
      isSelected: false,
      isReversing: false,
      narrowDays: []
    };
  },


  props: {
    locale: {
      type: String,
      default: 'en-us'
    },
    dateFormat: {
      type: Function,
      default: defaultDateFormat
    },
    titleDateFormat: {
      type: Object,
      default: function _default() {
        return { weekday: 'short', month: 'short', day: 'numeric' };
      }
    },
    headerDateFormat: {
      type: Object,
      default: function _default() {
        return { month: 'long', year: 'numeric' };
      }
    },
    formattedValue: {
      required: false
    },
    allowedDates: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    firstDayOfWeek: {
      type: [String, Number],
      default: 0
    },
    yearIcon: String
  },

  computed: {
    firstAllowedDate: function firstAllowedDate() {
      var date = new Date();
      date.setHours(12, 0, 0, 0);

      if (this.allowedDates) {
        var millisecondOffset = 1 * 24 * 60 * 60 * 1000;
        var valid = new Date(date);
        for (var i = 0; i < 31; i++) {
          if (this.isAllowed(valid)) return valid;

          valid.setTime(valid.getTime() + millisecondOffset);
        }
      }

      return date;
    },

    inputDate: {
      get: function get() {
        if (!this.value) return this.firstAllowedDate;
        if (this.value instanceof Date) return this.value;
        if (!isNaN(this.value) || typeof this.value === 'string' && this.value.indexOf(':') !== -1) return new Date(this.value);

        return new Date(this.value + 'T12:00:00');
      },
      set: function set(val) {
        this.$emit('input', val ? defaultDateFormat(val) : this.originalDate);
        this.$emit('update:formattedValue', val ? this.dateFormat(val) : this.dateFormat(this.originalDate));
      }
    },
    day: function day() {
      return this.inputDate.getDate();
    },
    month: function month() {
      return this.inputDate.getMonth();
    },
    year: function year() {
      return this.inputDate.getFullYear();
    },
    tableMonth: function tableMonth() {
      return this.tableDate.getMonth();
    },
    tableYear: function tableYear() {
      return this.tableDate.getFullYear();
    },
    computedTransition: function computedTransition() {
      return this.isReversing ? 'v-tab-reverse-transition' : 'v-tab-transition';
    }
  },

  watch: {
    isSelected: function isSelected(val) {
      var _this = this;

      val && this.$nextTick(function () {
        _this.$refs.years.scrollTop = _this.$refs.years.scrollHeight / 2 - 125;
      });
    },
    tableDate: function tableDate(val, prev) {
      this.isReversing = val < prev;
    },
    value: function value(val) {
      if (val) this.tableDate = this.inputDate;
    }
  },

  methods: {
    save: function save() {
      if (this.originalDate) {
        this.originalDate = this.value;
      } else {
        this.originalDate = this.inputDate;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputDate = this.originalDate;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(date) {
      if (!this.allowedDates) return true;

      if (Array.isArray(this.allowedDates)) {
        return !!this.allowedDates.find(function (allowedDate) {
          var d = new Date(allowedDate);
          d.setHours(12, 0, 0, 0);

          return d - date === 0;
        });
      } else if (this.allowedDates instanceof Function) {
        return this.allowedDates(date);
      } else if (this.allowedDates instanceof Object) {
        var min = new Date(this.allowedDates.min);
        min.setHours(12, 0, 0, 0);
        var max = new Date(this.allowedDates.max);
        max.setHours(12, 0, 0, 0);

        return date >= min && date <= max;
      }

      return true;
    }
  },

  created: function created() {
    var _this2 = this;

    var date = new Date();
    date.setDate(date.getDate() - date.getDay() + parseInt(this.firstDayOfWeek));

    Object(__WEBPACK_IMPORTED_MODULE_5__util_helpers__["c" /* createRange */])(7).forEach(function () {
      var narrow = date.toLocaleString(_this2.locale, { weekday: 'narrow' });
      _this2.narrowDays.push(narrow);

      date.setDate(date.getDate() + 1);
    });
  },
  mounted: function mounted() {
    this.currentDay = this.tableDate.getDate();
    this.currentMonth = this.tableDate.getMonth();
    this.currentYear = this.tableDate.getFullYear();
    this.tableDate = this.inputDate;
  },
  render: function render(h) {
    var children = [];

    !this.noTitle && children.push(this.genTitle());

    if (!this.isSelected) {
      var bodyChildren = [];

      bodyChildren.push(this.genHeader());
      bodyChildren.push(this.genTable());

      children.push(h('div', {
        'class': 'picker__body'
      }, bodyChildren));
    } else {
      children.push(this.genYears());
    }

    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--date': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark
      }
    }, children);
  }
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYearIcon: function genYearIcon() {
      return this.yearIcon ? this.$createElement('v-icon', {
        props: {
          dark: true
        }
      }, this.yearIcon) : null;
    },
    genTitle: function genTitle() {
      var _this = this;

      var date = new Date(this.year, this.month, this.day);
      date = date.toLocaleString(this.locale, this.titleDateFormat);

      if (this.landscape) {
        if (date.indexOf(',') > -1) date = date.replace(',', ',<br>');else if (date.indexOf(' ') > -1) date = date.replace(' ', '<br>');
      }

      var text = this.$createElement('transition', {
        props: {
          name: 'slide-x-transition',
          mode: 'out-in'
        }
      }, [this.$createElement('div', {
        domProps: { innerHTML: date },
        key: date
      })]);

      return this.$createElement('div', {
        'class': 'picker__title'
      }, [this.$createElement('div', {
        'class': {
          'picker--date__title-year': true,
          'active': this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = true;
          }
        }
      }, [this.year, this.genYearIcon()]), this.$createElement('div', {
        'class': {
          'picker--date__title-date': true,
          'active': !this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = false;
          }
        }
      }, [text])]);
    }
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genHeader: function genHeader() {
      return this.$createElement('div', {
        'class': 'picker--date__header'
      }, [this.genSelector()]);
    },
    genBtn: function genBtn(change, children) {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          dark: this.dark,
          icon: true
        },
        nativeOn: {
          click: function click(e) {
            e.stopPropagation();
            _this.tableDate = new Date(_this.tableYear, change);
          }
        }
      }, children);
    },
    genSelector: function genSelector() {
      var date = new Date(this.tableYear, this.tableMonth);
      var header = this.$createElement('div', {
        'class': 'picker--date__header-selector-date'
      }, [this.$createElement(this.computedTransition, [this.$createElement('strong', {
        key: this.tableMonth
      }, date.toLocaleString(this.locale, this.headerDateFormat))])]);

      return this.$createElement('div', {
        'class': 'picker--date__header-selector'
      }, [this.genBtn(this.tableMonth - 1, [this.$createElement('v-icon', 'chevron_left')]), header, this.genBtn(this.tableMonth + 1, [this.$createElement('v-icon', 'chevron_right')])]);
    }
  }
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    wheelScroll: function wheelScroll(e) {
      e.preventDefault();

      var month = this.tableMonth;

      if (e.deltaY < 0) month++;else month--;

      this.tableDate = new Date(this.tableYear, month);
    },
    touch: function touch(value) {
      this.tableDate = new Date(this.tableYear, this.tableMonth + value);
    },
    genTable: function genTable() {
      var _this = this;

      var children = [];
      var data = {
        'class': 'picker--date__table',
        directives: [{
          name: 'touch',
          value: {
            left: function left(e) {
              return e.offsetX < -15 && _this.touch(1);
            },
            right: function right(e) {
              return e.offsetX > 15 && _this.touch(-1);
            }
          }
        }]
      };

      if (this.scrollable) {
        data.on = { wheel: this.wheelScroll };
      }

      children.push(this.$createElement('table', {
        key: this.tableMonth
      }, [this.genTHead(), this.genTBody()]));

      return this.$createElement('div', data, [this.$createElement(this.computedTransition, children)]);
    },
    genTHead: function genTHead() {
      var _this2 = this;

      var days = this.narrowDays.map(function (day) {
        return _this2.$createElement('th', day);
      });
      return this.$createElement('thead', this.genTR(days));
    },
    genTBody: function genTBody() {
      var _this3 = this;

      var children = [];
      var rows = [];
      var length = new Date(this.tableYear, this.tableMonth + 1, 0).getDate();

      var day = new Date(this.tableYear, this.tableMonth).getDay() - parseInt(this.firstDayOfWeek);

      for (var i = 0; i < day; i++) {
        rows.push(this.$createElement('td'));
      }

      var _loop = function _loop(_i) {
        var date = new Date(_this3.tableYear, _this3.tableMonth, _i, 12, 0, 0, 0);
        rows.push(_this3.$createElement('td', [_this3.$createElement('button', {
          'class': {
            'btn btn--floating btn--small btn--flat': true,
            'btn--active': _this3.isActive(_i),
            'btn--current': _this3.isCurrent(_i),
            'btn--light': _this3.dark,
            'btn--disabled': !_this3.isAllowed(date)
          },
          attrs: {
            type: 'button'
          },
          domProps: {
            innerHTML: '<span class="btn__content">' + _i + '</span>'
          },
          on: {
            click: function click() {
              var day = _i < 10 ? '0' + _i : _i;
              var tableYear = _this3.tableYear;
              var tableMonth = _this3.tableMonth + 1;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;

              _this3.inputDate = tableYear + '-' + tableMonth + '-' + day + 'T12:00:00';
              _this3.$nextTick(function () {
                return _this3.autosave && _this3.save();
              });
            }
          }
        })]));

        if (rows.length % 7 === 0) {
          children.push(_this3.genTR(rows));
          rows = [];
        }
      };

      for (var _i = 1; _i <= length; _i++) {
        _loop(_i);
      }

      if (rows.length) {
        children.push(this.genTR(rows));
      }

      children.length < 6 && children.push(this.genTR([this.$createElement('td', { domProps: { innerHTML: '&nbsp;' } })]));

      return this.$createElement('tbody', children);
    },
    genTR: function genTR() {
      var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return [this.$createElement('tr', data, children)];
    },
    isActive: function isActive(i) {
      return this.tableYear === this.year && this.tableMonth === this.month && this.day === i;
    },
    isCurrent: function isCurrent(i) {
      return this.currentYear === this.tableYear && this.currentMonth === this.tableMonth && this.currentDay === i;
    }
  }
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYears: function genYears() {
      return this.$createElement('ul', {
        'class': 'picker--date__years',
        ref: 'years'
      }, this.genYearItems());
    },
    genYearItems: function genYearItems() {
      var _this = this;

      var children = [];

      var _loop = function _loop(i, length) {
        children.push(_this.$createElement('li', {
          'class': {
            active: _this.year === i
          },
          on: {
            click: function click(e) {
              e.stopPropagation();

              var tableMonth = _this.tableMonth + 1;
              var day = _this.day;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;
              day = day < 10 ? '0' + day : day;

              _this.inputDate = i + '-' + tableMonth + '-' + day;
              _this.isSelected = false;
            }
          }
        }, i));
      };

      for (var i = this.year + 100, length = this.year - 100; i > length; i--) {
        _loop(i, length);
      }
      return children;
    }
  }
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_helpers__ = __webpack_require__(0);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-time-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_picker__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__["a" /* default */]],

  data: function data() {
    return {
      isDragging: false,
      rotate: 0,
      originalTime: this.value,
      period: 'am',
      selectingHour: true,
      ranges: {
        hours: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(24),
        minutes: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(60)
      }
    };
  },


  props: {
    format: {
      type: String,
      default: 'ampm',
      validator: function validator(val) {
        return ['ampm', '24hr'].includes(val);
      }
    },
    allowedHours: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    allowedMinutes: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    }
  },

  computed: {
    is24hr: function is24hr() {
      return this.format !== 'ampm';
    },
    is24hrAfter12: function is24hrAfter12() {
      return this.selectingHour && this.is24hr && this.hour >= 12;
    },
    divider: function divider() {
      return this.selectingHour ? 12 : 60;
    },
    degrees: function degrees() {
      return this.degreesPerUnit * Math.PI / 180;
    },
    degreesPerUnit: function degreesPerUnit() {
      return 360 / this.divider;
    },

    inputTime: {
      get: function get() {
        if (this.value && !(this.value instanceof Date)) {
          if (!this.is24hr) {
            this.period = this.value.match(/pm/) ? 'pm' : 'am';
          }

          return this.value;
        }
        var value = new Date();

        if (this.value instanceof Date) {
          value = this.value;
        }

        var hour = value.getHours();
        var minute = value.getMinutes();
        var period = '';

        if (!this.is24hr) {
          hour = hour > 12 ? hour - 12 : hour;
          period = hour > 12 ? 'pm' : 'am';
        }

        period && (this.period = period);

        hour = this.firstAllowed('hour', hour);
        minute = this.firstAllowed('minute', minute);

        return hour + ':' + minute + period;
      },
      set: function set(val) {
        return this.$emit('input', val);
      }
    },
    timeArray: function timeArray() {
      return this.inputTime.replace(/(am|pm)/, '').split(':');
    },

    hour: {
      get: function get() {
        return parseInt(this.timeArray[0]);
      },
      set: function set(val) {
        if (!this.is24hr) {
          val = val > 12 ? val - 12 : val < 1 ? 12 : val;
        } else {
          val = val < 10 ? '0' + val : val > 23 ? '00' : val;
        }

        this.inputTime = val + ':' + this.minute + (!this.is24hr ? this.period : '');
      }
    },
    minute: {
      get: function get() {
        var minute = parseInt(this.timeArray[1]);

        return minute < 10 ? '0' + minute : minute > 59 ? '00' : minute;
      },
      set: function set(val) {
        val = val < 10 ? '0' + parseInt(val) : val > 59 ? '00' : val;
        var hour = this.hour;

        if (this.is24hr && hour < 10) {
          hour = '0' + hour;
        }

        this.inputTime = hour + ':' + val + (!this.is24hr ? this.period : '');
      }
    },
    clockHand: function clockHand() {
      if (this.selectingHour) return this.degreesPerUnit * this.hour;
      return this.degreesPerUnit * this.minute;
    },
    radius: function radius() {
      return this.clockSize / 2;
    },

    clockSize: {
      get: function get() {
        return this.size;
      },
      set: function set(val) {
        this.size = val;
      }
    },
    size: function size() {
      return this.landscape ? 250 : 280;
    }
  },

  watch: {
    period: function period(val) {
      var hour = !!this.allowedHours && this.selectingHour ? this.firstAllowed('hour', this.hour - 1) : this.hour;
      this.inputTime = hour + ':' + this.minute + val;
    },
    value: function value(val) {
      if (this.isSaving) {
        this.originalTime = this.inputTime;
        this.isSaving = false;
      }
    }
  },

  methods: {
    save: function save() {
      if (this.originalTime) {
        this.originalTime = this.value;
      } else {
        this.inputTime = this.inputTime;
        this.originalTime = this.inputTime;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputTime = this.originalTime;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(type, value) {
      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return true;

      if (Array.isArray(allowed)) {
        return !!allowed.find(function (v) {
          return v === value;
        });
      } else if (allowed instanceof Function) {
        return allowed(value);
      } else if (allowed === Object(allowed)) {
        var range = type === 'minute' ? this.ranges.minutes : this.ranges.hours;
        var mod = type === 'minute' ? 60 : 24;

        if (allowed.min === String(allowed.min)) {
          allowed.min = this.convert12to24hr(allowed.min);
        }

        if (allowed.max === String(allowed.max)) {
          allowed.max = this.convert12to24hr(allowed.max);
        }

        var steps = allowed.max - allowed.min;
        value = type === 'hour' && !this.is24hr && this.period === 'pm' ? value + 12 : value;

        for (var i = 0; i <= steps; i++) {
          var index = (allowed.min + i) % mod;
          if (range[index] === value) return true;
        }

        return false;
      }

      return true;
    },
    convert12to24hr: function convert12to24hr(input) {
      input = input.toLowerCase();
      var pm = input.indexOf('pm') !== -1;
      var hour = parseInt(input.slice(0, input.indexOf(pm ? 'pm' : 'am')));

      return pm ? hour + 12 : hour;
    },
    generateRange: function generateRange(type, start) {
      var range = type === 'hour' ? this.ranges.hours : this.ranges.minutes;
      var offset = 1;

      if (type === 'hour' && !this.is24hr) {
        range = range.slice(1, 13);
        offset = 0;
      }

      return range.slice(start + offset, range.length).concat(range.slice(0, start + offset));
    },
    firstAllowed: function firstAllowed(type, value) {
      var _this = this;

      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return value;

      var range = this.generateRange(type, value);

      var first = range.find(function (v) {
        return _this.isAllowed(type, v);
      });

      return first || value;
    }
  },

  render: function render(h) {
    var children = [this.genBody()];

    !this.noTitle && children.unshift(this.genTitle());
    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--time': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark,
        'picker--time--hours': this.selectingHour
      }
    }, children);
  }
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTitle: function genTitle() {
      var children = [this.genTime()];

      if (this.format === 'ampm') {
        children.push(this.genAMPM());
      }

      return this.$createElement('div', {
        'class': 'picker__title'
      }, children);
    },
    genTime: function genTime() {
      var _this = this;

      var hour = this.hour;

      if (this.is24hr && hour < 10) {
        hour = '0' + hour;
      }

      return this.$createElement('div', {
        'class': 'picker--time__title'
      }, [this.$createElement('span', {
        'class': { active: this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = true;
          }
        }
      }, hour), this.$createElement('span', {
        'class': { active: !this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = false;
          }
        }
      }, ':' + this.minute)]);
    },
    genAMPM: function genAMPM() {
      return this.$createElement('div', [this.genPeriod('am'), this.genPeriod('pm')]);
    },
    genPeriod: function genPeriod(period) {
      var _this2 = this;

      return this.$createElement('span', {
        'class': { active: this.period === period },
        on: { click: function click() {
            return _this2.period = period;
          } }
      }, period.toUpperCase());
    }
  }
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      hasChanged: false
    };
  },

  methods: {
    genBody: function genBody() {
      var _this = this;

      var children = [this.genHand(this.selectingHour ? 'hour' : 'minute')];
      var data = {
        'class': 'picker--time__clock',
        on: {
          mousedown: this.onMouseDown,
          mouseup: this.onMouseUp,
          mouseleave: function mouseleave() {
            _this.isDragging && _this.onMouseUp();
          },
          touchstart: this.onMouseDown,
          touchend: this.onMouseUp,
          mousemove: this.onDragMove,
          touchmove: this.onDragMove
        },
        key: this.selectingHour ? 'hour' : 'minute',
        ref: 'clock'
      };

      this.selectingHour && children.push(this.genHours()) || children.push(this.genMinutes());

      if (this.scrollable) {
        data.on.wheel = function (e) {
          e.preventDefault();

          var diff = e.wheelDelta > 0 ? 1 : -1;
          var changing = _this.selectingHour ? 'changeHour' : 'changeMinute';

          _this[changing](diff);
        };
      }

      return this.$createElement('div', {
        'class': 'picker__body'
      }, [this.$createElement('v-fade-transition', {
        props: { mode: 'out-in' }
      }, [this.$createElement('div', data, children)])]);
    },
    genHand: function genHand(type) {
      var scale = this.is24hrAfter12 ? 'scaleY(0.6)' : '';
      return [this.$createElement('div', {
        'class': 'picker--time__clock-hand ' + type,
        style: {
          transform: 'rotate(' + this.clockHand + 'deg) ' + scale
        }
      })];
    },
    genHours: function genHours() {
      var hours = this.is24hr ? 24 : 12;
      var children = [];
      var start = 0;

      if (hours === 12) {
        hours++;
        start = 1;
      }

      for (var i = start; i < hours; i++) {
        children.push(this.$createElement('span', {
          'class': {
            'active': i === this.hour,
            'disabled': !this.isAllowed('hour', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + i + '</span>' }
        }));
      }

      return children;
    },
    genMinutes: function genMinutes() {
      var children = [];

      for (var i = 0; i < 60; i = i + 5) {
        var num = i;

        if (num < 10) num = '0' + num;
        if (num === 60) num = '00';

        children.push(this.$createElement('span', {
          'class': {
            'active': num.toString() === this.minute.toString(),
            'disabled': !this.isAllowed('minute', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + num + '</span>' }
        }));
      }

      return children;
    },
    getTransform: function getTransform(i) {
      var _getPosition = this.getPosition(i),
          x = _getPosition.x,
          y = _getPosition.y;

      return { transform: 'translate(' + x + 'px, ' + y + 'px)' };
    },
    getPosition: function getPosition(i) {
      var radiusPercentage = this.selectingHour && this.is24hr && i >= 12 ? 0.5 : 0.8;
      var r = this.radius * radiusPercentage;
      i = this.selectingHour && this.is24hr ? i % 12 : i;
      return {
        x: Math.round(Math.sin(i * this.degrees) * r),
        y: Math.round(-Math.cos(i * this.degrees) * r)
      };
    },
    changeHour: function changeHour(time) {
      var _this2 = this;

      var range = this.generateRange('hour', this.hour);

      time < 0 && (range = range.reverse().slice(1));
      this.hour = range.find(function (h) {
        return _this2.allowedHours ? _this2.isAllowed('hour', h) : true;
      });

      return true;
    },
    changeMinute: function changeMinute(time) {
      var _this3 = this;

      var current = Number(this.minute);
      var range = this.generateRange('minute', current);

      time < 0 && (range = range.reverse().slice(1));
      var minute = range.find(function (m) {
        return _this3.allowedMinutes ? _this3.isAllowed('minute', m) : true;
      });

      this.minute = minute < 10 ? '0' + minute : minute;

      return true;
    },
    onMouseDown: function onMouseDown(e) {
      e.preventDefault();

      this.isDragging = true;
      this.onDragMove(e);
    },
    onMouseUp: function onMouseUp() {
      this.isDragging = false;
      !this.selectingHour && this.autosave && this.save();
      if (this.hasChanged) {
        this.selectingHour = false;
        this.hasChanged = false;
      }
    },
    onDragMove: function onDragMove(e) {
      e.preventDefault();
      if (!this.isDragging && e.type !== 'click') return;

      var rect = this.$refs.clock.getBoundingClientRect();
      var center = { x: rect.width / 2, y: 0 - rect.width / 2 };
      var clientY = 'touches' in e ? e.touches[0].clientY : e.clientY;
      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var coords = {
        y: rect.top - clientY,
        x: clientX - rect.left
      };

      var selecting = this.selectingHour ? 'hour' : 'minute';
      var value = Math.round(this.angle(center, coords) / this.degreesPerUnit);

      if (this.selectingHour && this.is24hr) {
        var insideClick = this.euclidean(center, coords) / this.radius < 0.65;
        value = insideClick ? value + 12 : value;

        // Necessary to fix edge case when selecting left part of 0 and 12
        value = this.angle(center, coords) >= 345 ? (value + 12) % 24 : value;
      }

      if (this.isAllowed(selecting, value)) {
        this[selecting] = value;
        this.hasChanged = true;
      }
    },
    euclidean: function euclidean(p0, p1) {
      var dx = Math.abs(p1.x - p0.x);
      var dy = Math.abs(p1.y - p0.y);

      return Math.sqrt(dx * dx + dy * dy);
    },
    angle: function angle(center, p1) {
      var p0 = {
        x: center.x,
        y: center.y + Math.sqrt(Math.abs(p1.x - center.x) * Math.abs(p1.x - center.x) + Math.abs(p1.y - center.y) * Math.abs(p1.y - center.y))
      };

      var value = 2 * Math.atan2(p1.y - p0.y, p1.x - p0.x);
      return Math.abs(value * 180 / Math.PI);
    }
  }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDialog__ = __webpack_require__(65);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDialog: __WEBPACK_IMPORTED_MODULE_0__VDialog__["a" /* default */]
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-dialog',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__["a" /* default */]],

  props: {
    disabled: Boolean,
    persistent: Boolean,
    fullscreen: Boolean,
    fullWidth: Boolean,
    lazy: Boolean,
    origin: {
      type: String,
      default: 'center center'
    },
    width: {
      type: [String, Number],
      default: 290
    },
    scrollable: Boolean,
    transition: {
      type: [String, Boolean],
      default: 'dialog-transition'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'dialog': true,
        'dialog--active': this.isActive,
        'dialog--persistent': this.persistent,
        'dialog--fullscreen': this.fullscreen,
        'dialog--stacked-actions': this.stackedActions && !this.fullscreen,
        'dialog--scrollable': this.scrollable
      };
    }
  },

  watch: {
    isActive: function isActive(val) {
      if (val) {
        !this.fullscreen && !this.hideOverlay && this.genOverlay();
        this.fullscreen && this.hideScroll();
      } else {
        if (!this.fullscreen) this.removeOverlay();else this.showScroll();
      }
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.isBooted = this.isActive;
    this.$vuetify.load(function () {
      return _this.isActive && _this.genOverlay();
    });
  },


  methods: {
    closeConditional: function closeConditional(e) {
      // close dialog if !persistent and clicked outside
      return !this.persistent;
    }
  },

  render: function render(h) {
    var _this2 = this;

    var children = [];
    var data = {
      'class': this.classes,
      ref: 'dialog',
      directives: [{ name: 'click-outside', value: this.closeConditional }, { name: 'show', value: this.isActive }]
    };

    if (!this.fullscreen) {
      data.style = {
        width: isNaN(this.width) ? this.width : this.width + 'px'
      };
    }

    if (this.$slots.activator) {
      children.push(h('div', {
        'class': 'dialog__activator',
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (!_this2.disabled) _this2.isActive = !_this2.isActive;
          }
        }
      }, [this.$slots.activator]));
    }

    var dialog = h('transition', {
      props: {
        name: this.transition || '', // If false, show nothing
        origin: this.origin
      }
    }, [h('div', data, this.showLazyContent(this.$slots.default))]);

    children.push(h('div', {
      'class': ('dialog__content ' + this.contentClass).trim(),
      ref: 'content'
    }, [dialog]));

    return h('div', {
      'class': 'dialog__container',
      style: {
        display: !this.$slots.activator && 'none' || this.fullWidth ? 'block' : 'inline-block'
      }
    }, children);
  }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDivider__ = __webpack_require__(67);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDivider: __WEBPACK_IMPORTED_MODULE_0__VDivider__["a" /* default */]
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('divider ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.inset) data.staticClass += ' divider--inset';
    if (props.light) data.staticClass += ' theme--light';

    return h('hr', data);
  }
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__ = __webpack_require__(70);



/* harmony default export */ __webpack_exports__["a"] = ({
  VExpansionPanel: __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__["a" /* default */],
  VExpansionPanelContent: __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__["a" /* default */]
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel',

  props: {
    expand: Boolean
  },

  computed: {
    params: function params() {
      return {
        expand: this.expand
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': 'expansion-panel'
    }, this.$slots.default);
  }
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      height: 'auto'
    };
  },


  props: {
    ripple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'expansion-panel__header': true,
        'expansion-panel__header--active': this.isActive
      };
    }
  },

  methods: {
    closeConditional: function closeConditional(e) {
      return this.$parent.$el.contains(e.target) && !this.$parent.expand && !this.$el.contains(e.target);
    },
    toggle: function toggle() {
      this.isActive = !this.isActive;
    },
    genHeader: function genHeader(h) {
      var _this = this;

      return h('div', {
        class: this.classes,
        directives: [{
          name: 'click-outside',
          value: this.closeConditional
        }, {
          name: 'ripple',
          value: this.ripple
        }],
        on: {
          click: function click() {
            _this.isActive = !_this.isActive;
          }
        }
      }, [this.$slots.header]);
    },
    genBody: function genBody(h) {
      return h('div', {
        ref: 'body',
        class: 'expansion-panel__body',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [this.$slots.default]);
    }
  },

  render: function render(h) {
    var children = [];

    this.$slots.header && children.push(this.genHeader(h));
    children.push(h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [this.genBody(h)]));

    return h('li', children);
  }
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  enter: function enter(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Get height that is to be scrolled
    el.style.overflow = 'hidden';
    el.style.height = null;
    el.style.display = 'block';
    var height = el.clientHeight + 'px';
    el.style.height = 0;
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = height;
    }, 50);
  },
  afterEnter: function afterEnter(el) {
    el.style.height = 'auto';
    el.style.overflow = null;
  },
  leave: function leave(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Set height before we transition to 0
    el.style.overflow = 'hidden';
    el.style.height = el.clientHeight + 'px';
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = 0;
    }, 50);
  }
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VFooter__ = __webpack_require__(73);


/* harmony default export */ __webpack_exports__["a"] = ({
  VFooter: __WEBPACK_IMPORTED_MODULE_0__VFooter__["a" /* default */]
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    fixed: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('footer ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' footer--absolute';
    if (props.fixed) data.staticClass += ' footer--fixed';

    return h('footer', data, children);
  }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var Grid = function Grid(name) {
  return {
    functional: true,

    props: {
      id: String
    },

    render: function render(h, _ref) {
      var props = _ref.props,
          data = _ref.data,
          children = _ref.children;

      data.staticClass = (name + ' ' + (data.staticClass || '')).trim();

      if (data.attrs) {
        data.staticClass += ' ' + Object.keys(data.attrs).join(' ');
        delete data.attrs;
      }

      if (props.id) {
        data.domProps = data.domProps || {};
        data.domProps.id = props.id;
      }

      return h('div', data, children);
    }
  };
};

var VContainer = Grid('container');
var VFlex = Grid('flex');
var VLayout = Grid('layout');
var VSpacer = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('spacer');

/* harmony default export */ __webpack_exports__["a"] = ({
  VContainer: VContainer,
  VFlex: VFlex,
  VLayout: VLayout,
  VSpacer: VSpacer
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  VIcon: __WEBPACK_IMPORTED_MODULE_0__VIcon__["a" /* default */]
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-group',

  inject: ['listClick', 'listClose'],

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      isBooted: this.value
    };
  },


  props: {
    group: String,
    lazy: Boolean,
    noAction: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list--group__header': true,
        'list--group__header--active': this.isActive,
        'list--group__header--no-action': this.noAction
      };
    }
  },

  watch: {
    isActive: function isActive() {
      this.isBooted = true;

      if (!this.isActive) {
        this.listClose(this._uid);
      }
    },
    $route: function $route(to) {
      var isActive = this.matchRoute(to.path);

      if (this.group) {
        if (isActive && this.isActive !== isActive) {
          this.listClick(this._uid);
        }
        this.isActive = isActive;
      }
    }
  },

  mounted: function mounted() {
    if (this.group) {
      this.isActive = this.matchRoute(this.$route.path);
    }

    if (this.isActive) {
      this.listClick(this._uid);
    }
  },


  methods: {
    click: function click() {
      var _this = this;

      if (!this.$refs.item.querySelector('.list__tile--disabled')) {
        requestAnimationFrame(function () {
          return _this.listClick(_this._uid);
        });
      }
    },
    toggle: function toggle(uid) {
      this.isActive = this._uid === uid;
    },
    matchRoute: function matchRoute(to) {
      if (!this.group) return false;
      return to.match(this.group) !== null;
    }
  },

  render: function render(h) {
    var group = h('ul', {
      'class': 'list list--group',
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      ref: 'group'
    }, [this.lazy && !this.isBooted ? null : this.$slots.default]);

    var item = h('div', {
      'class': this.classes,
      on: Object.assign({}, { click: this.click }, this.$listeners),
      ref: 'item'
    }, [this.$slots.item]);

    var transition = h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [group]);

    return h('div', { 'class': 'list--group__container' }, [item, transition]);
  }
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    icon: false,
    left: false,
    bottom: false,
    overlap: false,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  if (config.overlap) el.classList.add('badge--overlap');
  if (config.icon) el.classList.add('badge--icon');
  if (config.left) el.classList.add('badge--left');
  if (config.bottom) el.classList.add('badge--bottom');

  el.dataset.badge = config.value;
  el.classList.add('badge');
}

function unbind(el) {
  el.removeAttribute('data-badge');
  el.classList.remove('badge');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var debounce = function debounce(cb) {
    return setTimeout(cb, 50);
  };
  var onResize = function onResize() {
    clearTimeout(debounce);
    debounce(binding.value);
  };

  window.addEventListener('resize', onResize, { passive: true });
  el._onResize = onResize;
}

function unbind(el, binding) {
  window.removeEventListener('resize', el._onResize);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var callback = typeof binding.value === 'function' ? binding.value : binding.value.callback;
  var options = binding.value.options || { passive: true };
  var target = binding.value.target || window;
  if (target === 'undefined') return;

  if (target !== window) {
    target = document.querySelector(target);
  }

  target.addEventListener('scroll', callback, options);

  el._onScroll = {
    target: target,
    options: options
  };
}

function unbind(el, binding) {
  var _el$_onScroll = el._onScroll,
      target = _el$_onScroll.target,
      options = _el$_onScroll.options;


  target.removeEventListener('scroll', binding.callback, options);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    top: true,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  unbind(el, binding, config);

  el.dataset.tooltip = config.html;
  el.dataset['tooltipLocation'] = config.value;
}

function unbind(el) {
  el.removeAttribute('data-tooltip');
  el.removeAttribute('data-tooltip-location');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var touchstart = function touchstart(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchstartX = touch.clientX;
  wrapper.touchstartY = touch.clientY;

  wrapper.start && wrapper.start(Object.assign(event, wrapper));
};

var touchend = function touchend(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchendX = touch.clientX;
  wrapper.touchendY = touch.clientY;

  wrapper.end && wrapper.end(Object.assign(event, wrapper));

  handleGesture(wrapper);
};

var touchmove = function touchmove(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchmoveX = touch.clientX;
  wrapper.touchmoveY = touch.clientY;

  wrapper.move && wrapper.move(Object.assign(event, wrapper));
};

var handleGesture = function handleGesture(wrapper) {
  var touchstartX = wrapper.touchstartX,
      touchendX = wrapper.touchendX,
      touchstartY = wrapper.touchstartY,
      touchendY = wrapper.touchendY;

  wrapper.offsetX = touchendX - touchstartX;
  wrapper.offsetY = touchendY - touchstartY;

  if (touchendX < touchstartX) {
    wrapper.left && wrapper.left(wrapper);
  }
  if (touchendX > touchstartX) {
    wrapper.right && wrapper.right(wrapper);
  }
  if (touchendY < touchstartY) {
    wrapper.up && wrapper.up(wrapper);
  }
  if (touchendY > touchstartY) {
    wrapper.down && wrapper.down(wrapper);
  }
};

function inserted(el, _ref) {
  var value = _ref.value;

  var wrapper = {
    touchstartX: 0,
    touchstartY: 0,
    touchendX: 0,
    touchendY: 0,
    touchmoveX: 0,
    touchmoveY: 0,
    offsetX: 0,
    offsetY: 0,
    left: value.left,
    right: value.right,
    up: value.up,
    down: value.down,
    start: value.start,
    move: value.move,
    end: value.end
  };

  var target = value.parent ? el.parentNode : el;
  var options = value.options || {};

  target.addEventListener('touchstart', function (e) {
    return touchstart(e, wrapper);
  }, options);
  target.addEventListener('touchend', function (e) {
    return touchend(e, wrapper);
  }, options);
  target.addEventListener('touchmove', function (e) {
    return touchmove(e, wrapper);
  }, options);
}

function unbind(el, _ref2) {
  var value = _ref2.value;

  var target = value.parent ? el.parentNode : el;

  if (!target) return;

  target.removeEventListener('touchstart', touchstart);
  target.removeEventListener('touchend', touchend);
  target.removeEventListener('touchmove', touchmove);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VMenu_js__ = __webpack_require__(22);


/* harmony default export */ __webpack_exports__["a"] = ({
  VMenu: __WEBPACK_IMPORTED_MODULE_0__VMenu_js__["a" /* default */]
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    getActivator: function getActivator() {
      if (this.activator) return this.activator;
      return this.$refs.activator.children ? this.$refs.activator.children[0] : this.$refs.activator;
    },
    activatorClickHandler: function activatorClickHandler(e) {
      if (this.disabled) return;else if (this.openOnClick && !this.isActive) {
        this.isActive = true;
        this.absoluteX = e.clientX;
        this.absoluteY = e.clientY;
      } else if (this.closeOnClick && this.isActive) this.isActive = false;
    },
    mouseEnterHandler: function mouseEnterHandler(e) {
      if (this.disabled || this.hasJustFocused) return;
      this.hasJustFocused = true;
      this.isActive = true;
    },
    mouseLeaveHandler: function mouseLeaveHandler(e) {
      if (this.isContentActive) return;
      this.isActive = false;
    },
    addActivatorEvents: function addActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.addEventListener('click', this.activatorClickHandler);
    },
    removeActivatorEvents: function removeActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.removeEventListener('click', this.activatorClickHandler);
    }
  }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genActivator: function genActivator() {
      if (!this.$slots.activator) return null;

      var options = {
        'class': {
          'menu__activator--active': this.hasJustFocused || this.isActive
        },
        staticClass: 'menu__activator',
        ref: 'activator',
        slot: 'activator',
        on: {}
      };

      if (this.openOnHover) {
        options.on['mouseenter'] = this.mouseEnterHandler;
        options.on['mouseleave'] = this.mouseLeaveHandler;
      } else if (this.openOnClick) {
        options.on['click'] = this.activatorClickHandler;
      }

      return this.$createElement('div', options, this.$slots.activator);
    },
    genTransition: function genTransition() {
      return this.$createElement('transition', {
        props: {
          name: this.transition,
          origin: this.origin
        }
      }, [this.genContent()]);
    },
    genContent: function genContent() {
      var _this = this;

      var booted = this.lazy && this.isBooted || !this.lazy;
      return this.$createElement('div', {
        'class': ('menu__content ' + this.contentClass).trim(),
        ref: 'content',
        style: this.styles,
        directives: [{
          name: 'show',
          value: this.isContentActive
        }],
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (e.target.getAttribute('disabled')) return;
            if (_this.closeOnContentClick) _this.isActive = false;
          },
          mouseleave: function mouseleave(e) {
            _this.openOnHover && (_this.isActive = false);
          }
        }
      }, [booted ? this.$slots.default : null]);
    }
  }
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    // Revisit this
    calculateScroll: function calculateScroll() {
      if (this.selectedIndex === null) return;

      var scrollTop = 0;

      if (this.selectedIndex >= this.stopIndex) {
        scrollTop = this.$refs.content.scrollHeight;
      } else if (this.selectedIndex > this.startIndex) {
        scrollTop = this.selectedIndex * 48 - 56;
      }

      this.$refs.content.scrollTop = scrollTop;
    },
    calcLeftAuto: function calcLeftAuto() {
      var a = this.dimensions.activator;

      return parseInt(a.left - 16);
    },
    calcTopAuto: function calcTopAuto() {
      if (!this.hasActivator) return this.calcTop(true);

      var selectedIndex = Array.from(this.tiles).findIndex(function (n) {
        return n.classList.contains('list__tile--active');
      });

      if (selectedIndex === -1) {
        this.selectedIndex = null;

        return this.calcTop(true);
      }

      this.selectedIndex = selectedIndex;
      var actingIndex = selectedIndex;

      var offsetPadding = 1;
      // #708 Stop index should vary by tile length
      this.stopIndex = this.tiles.length > 4 ? this.tiles.length - 4 : this.tiles.length;

      if (selectedIndex > this.startIndex && selectedIndex < this.stopIndex) {
        actingIndex = 2;
        offsetPadding = 41;
      } else if (selectedIndex >= this.stopIndex) {
        offsetPadding = 9;
        actingIndex = selectedIndex - this.stopIndex;
      }

      return this.calcTop(true) + offsetPadding - actingIndex * 48;
    },
    calcLeft: function calcLeft() {
      if (this.auto) return this.calcLeftAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var left = this.left ? a.right - c.width : a.left;

      if (this.offsetX) left += this.left ? -a.width : a.width;
      if (this.nudgeLeft) left += this.nudgeLeft;
      if (this.nudgeRight) left -= this.nudgeRight;

      return this.calcXOverflow(left);
    },
    calcTop: function calcTop(force) {
      if (this.auto && !force) return this.calcTopAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var top = this.top ? a.bottom - c.height : a.top;

      if (this.offsetY) top += this.top ? -a.height : a.height;
      if (this.nudgeTop) top -= this.nudgeTop;
      if (this.nudgeBottom) top += this.nudgeBottom;

      var defined = typeof window !== 'undefined';
      var pageYOffset = defined ? window.pageYOffset : 0;

      return this.calcYOverflow(top) + pageYOffset;
    },
    calcXOverflow: function calcXOverflow(left) {
      var hasWindow = typeof window !== 'undefined';
      var innerWidth = hasWindow ? window.innerWidth : 0;
      var maxWidth = Math.max(this.dimensions.content.width, this.calculatedMinWidth, parseInt(this.maxWidth) || 0);
      var totalWidth = left + maxWidth;
      var availableWidth = totalWidth - innerWidth;

      if ((!this.left || this.right) && availableWidth > 0) {
        left = innerWidth - maxWidth - (innerWidth > 1024 ? 30 : 12) // Account for scrollbar
        ;
      } else if (this.left && left < 0) left = 12;

      return left;
    },
    calcYOverflow: function calcYOverflow(top) {
      var totalHeight = top + this.dimensions.content.height;
      var defined = typeof window !== 'undefined';
      var innerHeight = defined ? window.innerHeight : 0;

      if (this.top && top < 0) top = 12;else if ((!this.top || this.bottom) && innerHeight < totalHeight) {
        top = innerHeight - this.dimensions.content.height;
      }

      return top < 12 ? 12 : top;
    },
    sneakPeek: function sneakPeek(cb) {
      var _this = this;

      requestAnimationFrame(function () {
        var el = _this.$refs.content;
        var currentDisplay = el.style.display;

        el.style.display = 'inline-block';
        cb();
        el.style.display = currentDisplay;
      });
    },
    absolutePosition: function absolutePosition() {
      return {
        offsetTop: 0,
        scrollHeight: 0,
        top: this.positionY || this.absoluteY,
        bottom: this.positionY || this.absoluteY,
        left: this.positionX || this.absoluteX,
        right: this.positionX || this.absoluteX,
        height: 0,
        width: 0
      };
    },
    updateDimensions: function updateDimensions() {
      var _this2 = this;

      this.sneakPeek(function () {
        _this2.dimensions = {
          activator: !_this2.hasActivator || _this2.positionAbsolutely ? _this2.absolutePosition() : _this2.measure(_this2.getActivator()),
          content: _this2.measure(_this2.$refs.content)
        };
      });
    }
  }
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    measure: function measure(el, selector) {
      var getParent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      el = selector ? el.querySelector(selector) : el;

      if (!el) return null;

      var _el$getBoundingClient = el.getBoundingClientRect(),
          top = _el$getBoundingClient.top,
          bottom = _el$getBoundingClient.bottom,
          left = _el$getBoundingClient.left,
          right = _el$getBoundingClient.right,
          height = _el$getBoundingClient.height,
          width = _el$getBoundingClient.width;

      return {
        offsetTop: el.offsetTop,
        scrollHeight: el.scrollHeight,
        top: top, bottom: bottom, left: left, right: right, height: height, width: width
      };
    }
  }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      listIndex: -1,
      isUsingKeys: false,
      tiles: []
    };
  },

  watch: {
    isActive: function isActive(val) {
      if (!val) this.listIndex = -1;
    },
    listIndex: function listIndex(next, prev) {
      // For infinite scroll and autocomplete, re-evaluate children
      this.getTiles();

      if (next in this.tiles) {
        this.tiles[next].classList.add('list__tile--highlighted');
        this.$refs.content.scrollTop = next * 48;
      }

      prev in this.tiles && this.tiles[prev].classList.remove('list__tile--highlighted');
    }
  },

  methods: {
    changeListIndex: function changeListIndex(e) {
      [40, 38, 13].includes(e.keyCode) && e.preventDefault();
      e.keyCode === 32 && !this.isActive && e.preventDefault();

      if (this.listIndex === -1) this.setActiveListIndex();
      if ([27, 9].includes(e.keyCode)) return this.isActive = false;else if (!this.isActive && [13, 32].includes(e.keyCode)) {
        return this.isActive = true;
      }

      if (e.keyCode === 40 && this.listIndex < this.tiles.length - 1) {
        this.listIndex++;
      } else if (e.keyCode === 38 && this.listIndex > 0) {
        this.listIndex--;
      } else if (e.keyCode === 13 && this.listIndex !== -1) {
        this.tiles[this.listIndex].click();
      }
    },
    getTiles: function getTiles() {
      this.tiles = this.$refs.content.querySelectorAll('.list__tile');
    },
    setActiveListIndex: function setActiveListIndex() {
      var _this = this;

      this.tiles.forEach(function (t, i) {
        if (t.classList.contains('list__tile--active')) {
          _this.listIndex = i;
          return;
        }
      });
    }
  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__ = __webpack_require__(89);


/* harmony default export */ __webpack_exports__["a"] = ({
  VNavigationDrawer: __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__["a" /* default */]
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-navigation-drawer',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_2__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isActive: this.value,
      isBooted: false,
      isMobile: false,
      touchArea: {
        left: 0,
        right: 0
      }
    };
  },


  props: {
    absolute: Boolean,
    clipped: Boolean,
    disableRouteWatcher: Boolean,
    enableResizeWatcher: Boolean,
    height: String,
    floating: Boolean,
    miniVariant: Boolean,
    mobileBreakPoint: {
      type: Number,
      default: 1024
    },
    permanent: Boolean,
    persistent: Boolean,
    right: Boolean,
    temporary: Boolean,
    touchless: Boolean,
    value: { required: false }
  },

  computed: {
    calculatedHeight: function calculatedHeight() {
      return this.height || '100%';
    },
    classes: function classes() {
      return {
        'navigation-drawer': true,
        'navigation-drawer--absolute': this.absolute,
        'navigation-drawer--clipped': this.clipped,
        'navigation-drawer--close': !this.isActive,
        'navigation-drawer--floating': this.floating,
        'navigation-drawer--is-booted': this.isBooted,
        'navigation-drawer--is-mobile': this.isMobile,
        'navigation-drawer--mini-variant': this.miniVariant,
        'navigation-drawer--open': this.isActive,
        'navigation-drawer--permanent': this.permanent,
        'navigation-drawer--persistent': this.persistent,
        'navigation-drawer--right': this.right,
        'navigation-drawer--temporary': this.temporary,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    showOverlay: function showOverlay() {
      return !this.permanent && this.isActive && (this.temporary || this.isMobile);
    }
  },

  watch: {
    $route: function $route() {
      if (!this.disableRouteWatcher) {
        this.isActive = !this.closeConditional();
      }
    },
    isActive: function isActive(val) {
      this.$emit('input', val);
      this.showOverlay && val && this.genOverlay() || this.removeOverlay();
      this.$el.scrollTop = 0;
    },
    isMobile: function isMobile(val) {
      !val && this.removeOverlay();
    },
    permanent: function permanent(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      if (this.permanent) return;
      if (val !== this.isActive) this.isActive = val;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.checkIfMobile();
      setTimeout(function () {
        return _this.isBooted = true;
      }, 0);

      if (this.permanent) this.isActive = true;else if (this.isMobile) this.isActive = false;else if (!this.value && (this.persistent || this.temporary)) this.isActive = false;
    },
    checkIfMobile: function checkIfMobile() {
      this.isMobile = window.innerWidth < parseInt(this.mobileBreakPoint);
    },
    closeConditional: function closeConditional() {
      return !this.permanent && (this.temporary || this.isMobile);
    },
    onResize: function onResize() {
      var _this2 = this;

      clearTimeout(this.resizeTimeout);

      if (!this.enableResizeWatcher || this.permanent || this.temporary) return;

      this.resizeTimeout = setTimeout(function () {
        _this2.checkIfMobile();
        _this2.isActive = !_this2.isMobile;
      }, 200);
    },
    swipeRight: function swipeRight(e) {
      if (this.isActive && !this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (!this.right && e.touchstartX <= this.touchArea.left) this.isActive = true;else if (this.right && this.isActive) this.isActive = false;
    },
    swipeLeft: function swipeLeft(e) {
      if (this.isActive && this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (this.right && e.touchstartX >= this.touchArea.right) this.isActive = true;else if (!this.right && this.isActive) this.isActive = false;
    },
    calculateTouchArea: function calculateTouchArea() {
      if (!this.$el.parentNode) return;
      var parentRect = this.$el.parentNode.getBoundingClientRect();

      this.touchArea = {
        left: parentRect.left + 50,
        right: parentRect.right - 50
      };
    },
    genDirectives: function genDirectives() {
      var directives = [{
        name: 'click-outside',
        value: this.closeConditional
      }, {
        name: 'resize',
        value: this.onResize
      }];

      !this.touchless && directives.push({
        name: 'touch',
        value: {
          parent: true,
          left: this.swipeLeft,
          right: this.swipeRight
        }
      });

      return directives;
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': this.classes,
      style: { height: this.calculatedHeight },
      directives: this.genDirectives(),
      on: Object.assign({}, {
        click: function click() {
          return _this3.$emit('update:miniVariant', false);
        }
      }, this.$listeners)
    };

    return h('aside', data, [this.$slots.default, h('div', { 'class': 'navigation-drawer__border' })]);
  }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VSystemBar__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VToolbar__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__ = __webpack_require__(93);






var VToolbarTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__title');
var VToolbarItems = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__items');

/* harmony default export */ __webpack_exports__["a"] = ({
  VSystemBar: __WEBPACK_IMPORTED_MODULE_1__VSystemBar__["a" /* default */],
  VToolbar: __WEBPACK_IMPORTED_MODULE_2__VToolbar__["a" /* default */],
  VToolbarItems: VToolbarItems,
  VToolbarTitle: VToolbarTitle,
  VToolbarSideIcon: __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__["a" /* default */]
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    lightsOut: Boolean,
    status: Boolean,
    window: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('system-bar ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.light) data.staticClass += ' theme--light';
    if (props.status) data.staticClass += ' system-bar--status';
    if (props.window) data.staticClass += ' system-bar--window';
    if (props.lightsOut) data.staticClass += ' system-bar--lights-out';

    return h('div', data, children);
  }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isExtended: false,
      isScrolling: false,
      marginTop: 0,
      previousScroll: null,
      target: null
    };
  },

  props: {
    absolute: Boolean,
    card: Boolean,
    dense: Boolean,
    extended: Boolean,
    fixed: Boolean,
    flat: Boolean,
    floating: Boolean,
    prominent: Boolean,
    scrollOffScreen: Boolean,
    scrollTarget: String,
    scrollThreshHold: {
      type: Number,
      default: 100
    }
  },

  computed: {
    classes: function classes() {
      return {
        'toolbar': true,
        'elevation-0': this.flat,
        'toolbar--absolute': this.absolute,
        'toolbar--card': this.card,
        'toolbar--dense': this.dense,
        'toolbar--fixed': this.fixed,
        'toolbar--floating': this.floating,
        'toolbar--prominent': this.prominent,
        'toolbar--extended': this.isExtended,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    styles: function styles() {
      return {
        marginTop: this.marginTop
      };
    }
  },

  watch: {
    isScrolling: function isScrolling(val) {
      if (!val) this.marginTop = 0;else this.marginTop = -this.$refs.content.clientHeight - 6 + 'px';
    }
  },

  methods: {
    onScroll: function onScroll() {
      if (typeof window === 'undefined') return;

      if (!this.target) {
        this.target = this.scrollTarget ? document.querySelector(this.scrollTarget) : window;
      }

      var currentScroll = this.scrollTarget ? this.target.scrollTop : this.target.pageYOffset || document.documentElement.scrollTop;

      if (currentScroll < this.scrollThreshHold) return;

      if (this.previousScroll === null) {
        this.previousScroll = currentScroll;
      }

      this.isScrolling = this.previousScroll < currentScroll;

      this.previousScroll = currentScroll;
    }
  },

  render: function render(h) {
    this.isExtended = this.extended || !!this.$slots.extension;
    var children = [];
    var data = {
      'class': this.classes,
      style: this.styles,
      on: this.$listeners
    };

    if (this.scrollOffScreen) {
      data.directives = [{
        name: 'scroll',
        value: {
          callback: this.onScroll,
          target: this.scrollTarget
        }
      }];
    }

    children.push(h('div', {
      'class': 'toolbar__content',
      ref: 'content'
    }, this.$slots.default));

    if (this.isExtended) {
      children.push(h('div', {
        'class': 'toolbar__extension'
      }, this.$slots.extension));
    }

    return h('nav', data, children);
  }
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar-side-icon',

  functional: true,

  render: function render(h, _ref) {
    var slots = _ref.slots,
        listeners = _ref.listeners,
        props = _ref.props;

    var data = {
      staticClass: 'toolbar__side-icon',
      props: Object.assign(props, {
        icon: true
      }),
      on: listeners
    };

    var defaultSlot = slots().default;

    return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], data, defaultSlot || [h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], 'menu')]);
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VPagination__ = __webpack_require__(95);


/* harmony default export */ __webpack_exports__["a"] = ({
  VPagination: __WEBPACK_IMPORTED_MODULE_0__VPagination__["a" /* default */]
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-pagination',

  props: {
    circle: Boolean,
    disabled: Boolean,
    length: {
      type: Number,
      default: 0,
      validator: function validator(val) {
        return val % 1 === 0;
      }
    },
    value: {
      type: Number,
      default: 0
    },
    prevIcon: {
      type: String,
      default: 'chevron_left'
    },
    nextIcon: {
      type: String,
      default: 'chevron_right'
    }
  },

  watch: {
    value: function value() {
      this.init();
    }
  },

  computed: {
    classes: function classes() {
      return {
        'pagination': true,
        'pagination--circle': this.circle,
        'pagination--disabled': this.disabled
      };
    },
    items: function items() {
      if (this.length <= 5) {
        return this.range(1, this.length);
      }

      var min = this.value - 3;
      min = min > 0 ? min : 1;

      var max = min + 6;
      max = max <= this.length ? max : this.length;

      if (max === this.length) {
        min = this.length - 6;
      }

      var range = this.range(min, max);

      if (this.value >= 4 && this.length > 6) {
        range.splice(0, 2, 1, '...');
      }

      if (this.value + 3 < this.length && this.length > 6) {
        range.splice(range.length - 2, 2, '...', this.length);
      }

      return range;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load.call(this, this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.selected = null;

      // Change this
      setTimeout(function () {
        return _this.selected = _this.value;
      }, 100);
    },
    next: function next(e) {
      e.preventDefault();
      this.$emit('input', this.value + 1);
      this.$emit('next');
    },
    previous: function previous(e) {
      e.preventDefault();
      this.$emit('input', this.value - 1);
      this.$emit('previous');
    },
    range: function range(from, to) {
      var range = [];

      from = from > 0 ? from : 1;

      for (var i = from; i <= to; i++) {
        range.push(i);
      }

      return range;
    },
    genIcon: function genIcon(h, icon, disabled, fn) {
      return h('li', [h('a', {
        class: {
          'pagination__navigation': true,
          'pagination__navigation--disabled': disabled
        },
        attrs: { href: '#!' },
        on: { click: fn }
      }, [h(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], [icon])])]);
    },
    genItem: function genItem(h, i) {
      var _this2 = this;

      return h('a', {
        class: {
          'pagination__item': true,
          'pagination__item--active': i === this.value
        },
        attrs: { href: '#!' },
        on: {
          click: function click(e) {
            e.preventDefault();
            _this2.$emit('input', i);
          }
        }
      }, [i]);
    },
    genItems: function genItems(h) {
      var _this3 = this;

      return this.items.map(function (i) {
        return h('li', [isNaN(i) && h('span', { class: 'pagination__more' }, [i]) || _this3.genItem(h, i)]);
      });
    }
  },

  render: function render(h) {
    var children = [this.genIcon(h, this.prevIcon, this.value === 1, this.previous), this.genItems(h), this.genIcon(h, this.nextIcon, this.value === this.length, this.next)];

    return h('ul', { class: this.classes }, children);
  }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VParallax__ = __webpack_require__(97);


/* harmony default export */ __webpack_exports__["a"] = ({
  VParallax: __WEBPACK_IMPORTED_MODULE_0__VParallax__["a" /* default */]
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_translatable__ = __webpack_require__(98);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-parallax',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_translatable__["a" /* default */]],

  props: {
    height: {
      type: [String, Number],
      default: 500
    },
    src: String
  },

  computed: {
    styles: function styles() {
      return {
        display: 'block',
        transform: 'translate3d(-50%, ' + this.parallax + 'px, 0)'
      };
    }
  },

  methods: {
    init: function init() {
      var _this = this;

      if (!this.$refs.img) return;

      if (this.$refs.img.complete) {
        this.translate();
        this.listeners();
      } else {
        this.$refs.img.addEventListener('load', function () {
          _this.translate();
          _this.listeners();
        }, false);
      }
    },
    objHeight: function objHeight() {
      return this.$refs.img.naturalHeight;
    },
    elOffsetTop: function elOffsetTop() {
      return this.$el.offsetTop;
    }
  },

  render: function render(h) {
    var container = h('div', {
      staticClass: 'parallax__image-container'
    }, [h('img', {
      staticClass: 'parallax__image',
      style: this.styles,
      attrs: {
        src: this.src
      },
      ref: 'img'
    })]);

    var content = h('div', {
      staticClass: 'parallax__content'
    }, this.$slots.default);

    return h('div', {
      staticClass: 'parallax',
      style: {
        height: parseInt(this.normalizedHeight) + 'px'
      },
      on: this.$listeners
    }, [container, content]);
  }
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      parallax: null,
      parallaxDist: null,
      percentScrolled: null,
      scrollTop: null,
      windowHeight: null,
      windowBottom: null
    };
  },


  computed: {
    normalizedHeight: function normalizedHeight() {
      return Number(this.height.toString().replace(/(^[0-9]*$)/, '$1'));
    },
    imgHeight: function imgHeight() {
      return this.objHeight();
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.translate, false);
    window.removeEventListener('resize', this.translate, false);
  },


  methods: {
    listeners: function listeners() {
      window.addEventListener('scroll', this.translate, false);
      window.addEventListener('resize', this.translate, false);
    },
    translate: function translate() {
      this.calcDimensions();

      this.percentScrolled = (this.windowBottom - this.elOffsetTop) / (this.normalizedHeight + this.windowHeight);

      this.parallax = Math.round(this.parallaxDist * this.percentScrolled);

      if (this.translated) {
        this.translated();
      }
    },
    calcDimensions: function calcDimensions() {
      var offset = this.$el.getBoundingClientRect();

      this.scrollTop = window.pageYOffset;
      this.parallaxDist = this.imgHeight - this.normalizedHeight;
      this.elOffsetTop = offset.top + this.scrollTop;
      this.windowHeight = window.innerHeight;
      this.windowBottom = this.scrollTop + this.windowHeight;
    }
  }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__ = __webpack_require__(100);



/* harmony default export */ __webpack_exports__["a"] = ({
  VProgressLinear: __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__["a" /* default */],
  VProgressCircular: __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__["a" /* default */]
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _this = this;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-circular',

  props: {
    button: Boolean,

    fill: {
      type: String,
      default: function _default() {
        return _this.indeterminate ? 'none' : 'transparent';
      }
    },

    indeterminate: Boolean,

    rotate: {
      type: Number,
      default: 0
    },

    size: {
      type: [Number, String],
      default: 32
    },

    width: {
      type: Number,
      default: 4
    },

    value: {
      type: Number,
      default: 0
    }
  },

  computed: {
    calculatedSize: function calculatedSize() {
      var size = Number(this.size);

      if (this.button) {
        size += 8;
      }

      return size;
    },
    circumference: function circumference() {
      return 2 * Math.PI * this.radius;
    },
    classes: function classes() {
      return {
        'progress-circular': true,
        'progress-circular--indeterminate': this.indeterminate,
        'progress-circular--button': this.button
      };
    },
    cxy: function cxy() {
      return this.indeterminate && !this.button ? 50 : this.calculatedSize / 2;
    },
    normalizedValue: function normalizedValue() {
      if (this.value < 0) {
        return 0;
      }

      if (this.value > 100) {
        return 100;
      }

      return this.value;
    },
    radius: function radius() {
      return this.indeterminate && !this.button ? 20 : (this.calculatedSize - this.width) / 2;
    },
    strokeDashArray: function strokeDashArray() {
      return Math.round(this.circumference * 1000) / 1000;
    },
    strokeDashOffset: function strokeDashOffset() {
      return (100 - this.normalizedValue) / 100 * this.circumference + 'px';
    },
    styles: function styles() {
      return {
        height: this.calculatedSize + 'px',
        width: this.calculatedSize + 'px'
      };
    },
    svgSize: function svgSize() {
      return this.indeterminate ? false : this.calculatedSize;
    },
    svgStyles: function svgStyles() {
      return {
        transform: 'rotate(' + this.rotate + 'deg)'
      };
    },
    viewBox: function viewBox() {
      return this.indeterminate ? '25 25 50 50' : false;
    }
  },

  methods: {
    genCircle: function genCircle(h, name, offset) {
      return h('circle', {
        class: 'progress-circular__' + name,
        attrs: {
          fill: 'transparent',
          cx: this.cxy,
          cy: this.cxy,
          r: this.radius,
          'stroke-width': this.width,
          'stroke-dasharray': this.strokeDashArray,
          'stroke-dashoffset': offset
        }
      });
    },
    genSvg: function genSvg(h) {
      var children = [!this.indeterminate && this.genCircle(h, 'underlay', 0), this.genCircle(h, 'overlay', this.strokeDashOffset)];

      return h('svg', {
        style: this.svgStyles,
        attrs: {
          xmlns: 'http://www.w3.org/2000/svg',
          height: this.svgSize,
          width: this.svgSize,
          viewBox: this.viewBox
        }
      }, children);
    }
  },

  render: function render(h) {
    var info = h('div', { class: 'progress-circular__info' }, [this.$slots.default]);
    var svg = this.genSvg(h);

    return h('div', {
      class: this.classes,
      style: this.styles,
      on: this.$listeners
    }, [svg, info]);
  }
});

/*
<template lang="pug">
  div(
    class="progress-circular"
    v-bind:class="classes"
    v-bind:style="styles"
    v-on="$listeners"
  )
    svg(
      xmlns="http://www.w3.org/2000/svg"
      v-bind:height="svgSize"
      v-bind:width="svgSize"
      v-bind:viewBox="viewBox"
      v-bind:style="svgStyles"
    )
      circle(
        class="progress-circular__underlay"
        fill="transparent"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="0"
        v-if="!indeterminate"
      )
      circle(
        class="progress-circular__overlay"
        v-bind:fill="fill"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="strokeDashOffset"
      )
    div(class="progress-circular__info")
      slot
</template>
*/

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSelect__ = __webpack_require__(24);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSelect: __WEBPACK_IMPORTED_MODULE_0__VSelect__["a" /* default */]
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    filterSearch: function filterSearch() {
      var _this = this;

      return this.items.filter(function (i) {
        var text = _this.getText(i);
        if (typeof text !== 'string') return false;

        return text.toLowerCase().indexOf(_this.searchValue.toLowerCase()) !== -1;
      });
    },
    onKeyDown: function onKeyDown(e) {
      this.$refs.menu.changeListIndex(e);
    }
  }
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genMenu: function genMenu() {
      var _this = this;

      var offsetY = this.autocomplete || this.offset || this.isDropdown;
      var data = {
        ref: 'menu',
        props: {
          activator: this.$refs.activator,
          auto: this.auto,
          closeOnClick: false,
          closeOnContentClick: !this.multiple,
          contentClass: this.computedContentClass,
          disabled: this.disabled,
          maxHeight: this.maxHeight,
          nudgeTop: this.isDropdown ? 22 : offsetY ? 38 : 0,
          offsetY: offsetY,
          value: this.isActive
        },
        on: { input: function input(val) {
            return _this.isActive = val;
          } }
      };

      this.minWidth && (data.props.minWidth = this.minWidth);

      return this.$createElement('v-menu', data, [this.genList()]);
    },
    genSelectionsAndSearch: function genSelectionsAndSearch() {
      var _this2 = this;

      var input = void 0;

      if (this.autocomplete || this.editable) {
        input = this.$createElement('input', {
          'class': 'input-group--select__autocomplete',
          domProps: { value: this.searchValue },
          on: { input: function input(e) {
              return _this2.searchValue = e.target.value;
            } },
          attrs: { tabindex: -1 },
          ref: 'input',
          key: 'input'
        });
      }

      var selections = this.isDirty && (!this.editable || this.editable && !this.focused) ? this.genSelections() : [];
      input && selections.push(input);
      var group = this.$createElement('div', selections);

      return this.$createElement('div', {
        'class': 'input-group__selections',
        style: { 'overflow': 'hidden' },
        ref: 'activator'
      }, [group]);
    },
    genSelections: function genSelections() {
      var _this3 = this;

      var children = [];
      var chips = this.chips;
      var slots = this.$scopedSlots.selection;
      var length = this.selectedItems.length;

      this.selectedItems.forEach(function (item, i) {
        if (slots) {
          children.push(_this3.genSlotSelection(item));
        } else if (chips) {
          children.push(_this3.genChipSelection(item));
        } else {
          children.push(_this3.genCommaSelection(item, i < length - 1));
        }
      });

      return children;
    },
    genSlotSelection: function genSlotSelection(item) {
      return this.$scopedSlots.selection({ parent: this, item: item });
    },
    genChipSelection: function genChipSelection(item) {
      var _this4 = this;

      return this.$createElement('v-chip', {
        'class': 'chip--select-multi',
        props: { close: true },
        on: {
          input: function input() {
            return _this4.selectItem(item);
          },
          click: function click(e) {
            return e.stopPropagation();
          }
        },
        key: this.getValue(item)
      }, this.getText(item));
    },
    genCommaSelection: function genCommaSelection(item, comma) {
      return this.$createElement('div', {
        'class': 'input-group__selections__comma',
        key: JSON.stringify(this.getValue(item)) // Item may be an object
      }, '' + this.getText(item) + (comma ? ', ' : ''));
    },
    genList: function genList() {
      var _this5 = this;

      var children = this.filteredItems.map(function (o) {
        if (o.header) return _this5.genHeader(o);
        if (o.divider) return _this5.genDivider(o);else return _this5.genTile(o);
      });

      if (!children.length) {
        children.push(this.genTile(this.noDataText, true));
      }

      return this.$createElement('v-card', [this.$createElement('v-list', {
        ref: 'list'
      }, children)]);
    },
    genHeader: function genHeader(item) {
      return this.$createElement('v-subheader', {
        props: item
      }, item.header);
    },
    genDivider: function genDivider(item) {
      return this.$createElement('v-divider', {
        props: item
      });
    },
    genTile: function genTile(item, disabled) {
      var _this6 = this;

      var active = this.selectedItems.indexOf(item) !== -1;

      if (typeof disabled === 'undefined') {
        disabled = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["g" /* getObjectValueByPath */])(item, this.itemDisabled);
      }

      var data = {
        on: { click: function click(e) {
            return _this6.selectItem(item);
          } },
        props: {
          avatar: item === Object(item) && 'avatar' in item,
          ripple: true,
          value: active
        }
      };

      if (disabled) {
        data.props.disabled = disabled;
      }

      if (this.$scopedSlots.item) {
        return this.$createElement('v-list-tile', data, [this.$scopedSlots.item({ parent: this, item: item })]);
      }

      return this.$createElement('v-list-tile', data, [this.genAction(item, active), this.genContent(item)]);
    },
    genAction: function genAction(item, active) {
      var _this7 = this;

      if (!this.multiple) return null;

      var data = {
        'class': {
          'list__tile__action--select-multi': this.multiple
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this7.selectItem(item);
          }
        }
      };

      return this.$createElement('v-list-tile-action', data, [this.$createElement('v-checkbox', { props: { inputValue: active } })]);
    },
    genContent: function genContent(item) {
      return this.$createElement('v-list-tile-content', [this.$createElement('v-list-tile-title', this.getText(item))]);
    }
  }
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VRadio__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSwitch__ = __webpack_require__(106);




/* harmony default export */ __webpack_exports__["a"] = ({
  VCheckbox: __WEBPACK_IMPORTED_MODULE_0__VCheckbox__["a" /* default */],
  VRadio: __WEBPACK_IMPORTED_MODULE_1__VRadio__["a" /* default */],
  VSwitch: __WEBPACK_IMPORTED_MODULE_2__VSwitch__["a" /* default */]
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__ = __webpack_require__(28);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'radio',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: [String, Number]
  },

  computed: {
    isActive: function isActive() {
      return this.inputValue === this.value;
    },
    classes: function classes() {
      return this.addColorClassChecks({
        'radio': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      return this.isActive ? 'radio_button_checked' : 'radio_button_unchecked';
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle }
      }, this.label);
    },
    toggle: function toggle() {
      if (!this.disabled) {
        this.$emit('change', this.value);
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', {}, [h('v-icon', {
      'class': {
        'icon--radio': this.isActive
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    return this.genInputGroup([transition, ripple]);
  }
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'switch',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  computed: {
    classes: function classes() {
      return {
        'input-group--selection-controls switch': true
      };
    },
    rippleClasses: function rippleClasses() {
      return {
        'input-group--selection-controls__ripple': true,
        'input-group--selection-controls__ripple--active': this.isActive
      };
    },
    containerClasses: function containerClasses() {
      return this.addColorClassChecks({
        'input-group--selection-controls__container': true,
        'input-group--selection-controls__container--light': this.light,
        'input-group--selection-controls__container--disabled': this.disabled
      });
    },
    toggleClasses: function toggleClasses() {
      return {
        'input-group--selection-controls__toggle': true,
        'input-group--selection-controls__toggle--active': this.isActive
      };
    }
  },

  render: function render(h) {
    var ripple = h('div', {
      'class': this.rippleClasses,
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var container = h('div', {
      'class': this.containerClasses
    }, [h('div', { 'class': this.toggleClasses }), ripple]);

    return this.genInputGroup([container]);
  }
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSlider__ = __webpack_require__(108);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSlider: __WEBPACK_IMPORTED_MODULE_0__VSlider__["a" /* default */]
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_helpers__ = __webpack_require__(0);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-slider',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  data: function data() {
    return {
      app: {},
      isActive: false,
      inputWidth: 0
    };
  },


  props: {
    inverted: Boolean,
    min: {
      type: [Number, String],
      default: 0
    },
    max: {
      type: [Number, String],
      default: 100
    },
    step: {
      type: [Number, String],
      default: null
    },
    thumbLabel: Boolean,
    value: [Number, String],
    vertical: Boolean,
    snap: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group input-group--slider': true,
        'input-group--active': this.isActive,
        'input-group--dirty': this.inputWidth > 0,
        'input-group--disabled': this.disabled,
        'input-group--ticks': !this.disabled && this.step
      };
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        var min = this.min,
            max = this.max,
            step = this.step,
            snap = this.snap;

        val = val < min ? min : val > max ? max : val;
        if (Math.ceil(val) !== Math.ceil(this.lazyValue)) {
          this.inputWidth = this.calculateWidth(val);
        }

        var value = snap ? Math.round(val / step) * step : parseInt(val);
        this.lazyValue = value;

        if (value !== this.value) {
          this.$emit('input', value);
        }
      }
    },
    interval: function interval() {
      return 100 / (this.max - this.min) * this.step;
    },
    thumbContainerClasses: function thumbContainerClasses() {
      return {
        'slider__thumb-container': true,
        'slider__thumb-container--label': this.thumbLabel
      };
    },
    thumbStyles: function thumbStyles() {
      return {
        left: this.inputWidth + '%'
      };
    },
    tickContainerStyles: function tickContainerStyles() {
      return {
        transform: 'translate3d(0, -50%, 0)'
      };
    },
    trackStyles: function trackStyles() {
      var scaleX = this.calculateScale(1 - this.inputWidth / 100);
      var translateX = this.inputWidth < 1 && !this.isActive ? 8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    trackFillStyles: function trackFillStyles() {
      var inputWidth = this.inputWidth;
      var scaleX = this.calculateScale(inputWidth / 100);
      var translateX = inputWidth > 99 && !this.thumbLabel ? -8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    numTicks: function numTicks() {
      return parseInt((this.max - this.min) / this.step);
    }
  },

  watch: {
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.inputValue = this.value;
    this.$nextTick(function () {
      _this.inputWidth = _this.calculateWidth(_this.inputValue);
    });

    // Without a v-app, iOS does not work with body selectors
    this.app = document.querySelector('[data-app]') || console.warn('The v-slider component requires the present of v-app or a non-body wrapping element with the [data-app] attribute.');
  },


  methods: {
    calculateWidth: function calculateWidth(val) {
      if (this.snap) {
        val = Math.round(val / this.step) * this.step;
      }

      val = (val - this.min) / (this.max - this.min) * 100;

      return val < 0.15 ? 0 : val;
    },
    calculateScale: function calculateScale(scale) {
      if (scale < 0.02 && !this.thumbLabel) {
        return 0;
      }

      return this.disabled ? scale - 0.015 : scale;
    },
    onMouseDown: function onMouseDown(e) {
      var options = { passive: true };
      this.isActive = true;

      if ('touches' in e) {
        this.app.addEventListener('touchmove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'touchend', this.onMouseUp);
      } else {
        this.app.addEventListener('mousemove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'mouseup', this.onMouseUp);
      }
    },
    onMouseUp: function onMouseUp() {
      var options = { passive: true };
      this.isActive = false;
      this.app.removeEventListener('touchmove', this.onMouseMove, options);
      this.app.removeEventListener('mousemove', this.onMouseMove, options);
    },
    onMouseMove: function onMouseMove(e) {
      var _$refs$track$getBound = this.$refs.track.getBoundingClientRect(),
          offsetLeft = _$refs$track$getBound.left,
          trackWidth = _$refs$track$getBound.width;

      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var left = (clientX - offsetLeft) / trackWidth * 100;

      left = left < 0 ? 0 : left > 100 ? 100 : left;

      this.inputValue = this.min + left / 100 * (this.max - this.min);
    },
    onKeyDown: function onKeyDown(e) {
      if (!e.keyCode === 37 && !e.keyCode === 39) return;

      var direction = e.keyCode === 37 && -1 || e.keyCode === 39 && 1 || 0;
      var multiplier = e.shiftKey && 3 || e.ctrlKey && 2 || 1;
      var amount = this.snap && this.step || 1;

      this.inputValue = this.inputValue + direction * amount * multiplier;
    },
    sliderMove: function sliderMove(e) {
      if (!this.isActive) {
        this.onMouseMove(e);
      }
    },
    genThumbLabel: function genThumbLabel(h) {
      return h('v-scale-transition', {
        props: { origin: 'bottom center' }
      }, [h('div', {
        'class': 'slider__thumb--label__container',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [h('div', { 'class': 'slider__thumb--label' }, [h('span', {}, parseInt(this.inputValue))])])]);
    },
    genThumbContainer: function genThumbContainer(h) {
      var children = [];
      children.push(h('div', { 'class': 'slider__thumb' }));

      this.thumbLabel && children.push(this.genThumbLabel(h));

      return h('div', {
        'class': this.thumbContainerClasses,
        style: this.thumbStyles,
        on: {
          touchstart: this.onMouseDown,
          mousedown: this.onMouseDown
        },
        ref: 'thumb'
      }, children);
    },
    genSteps: function genSteps(h) {
      var _this2 = this;

      var ticks = Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["c" /* createRange */])(this.numTicks + 1).map(function (i) {
        var span = h('span', {
          class: 'slider__tick',
          style: {
            left: i * (100 / _this2.numTicks) + '%'
          }
        });

        return span;
      });

      return h('div', {
        'class': 'slider__ticks-container',
        style: this.tickContainerStyles
      }, ticks);
    },
    genTrackContainer: function genTrackContainer(h) {
      var children = [h('div', {
        'class': 'slider__track',
        style: this.trackStyles
      }), h('div', {
        'class': 'slider__track-fill',
        style: this.trackFillStyles
      })];

      return h('div', {
        'class': 'slider__track__container',
        ref: 'track'
      }, children);
    }
  },

  render: function render(h) {
    var children = [];

    children.push(this.genTrackContainer(h));
    this.step && children.push(this.genSteps(h));
    children.push(this.genThumbContainer(h));

    var slider = h('div', { 'class': 'slider' }, children);

    return this.genInputGroup([slider], {
      attrs: {
        role: 'slider',
        tabindex: this.tabindex
      },
      on: Object.assign({}, {
        mouseup: this.sliderMove,
        keydown: this.onKeyDown
      }, this.$listeners),
      directives: [{
        name: 'click-outside'
      }]
    });
  }
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSubheader__ = __webpack_require__(110);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSubheader: __WEBPACK_IMPORTED_MODULE_0__VSubheader__["a" /* default */]
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children,
        props = _ref.props;

    data.staticClass = ('subheader ' + (data.staticClass || '')).trim();

    if (props.inset) data.staticClass += ' subheader--inset';
    if (props.light) data.staticClass += ' theme--light';
    if (props.dark) data.staticClass += ' theme--dark';

    return h('li', data, children);
  }
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VStepper__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VStepperStep__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VStepperContent__ = __webpack_require__(114);





var VStepperHeader = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('stepper__header');

/* harmony default export */ __webpack_exports__["a"] = ({
  VStepper: __WEBPACK_IMPORTED_MODULE_1__VStepper__["a" /* default */],
  VStepperContent: __WEBPACK_IMPORTED_MODULE_3__VStepperContent__["a" /* default */],
  VStepperHeader: VStepperHeader,
  VStepperStep: __WEBPACK_IMPORTED_MODULE_2__VStepperStep__["a" /* default */]
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    return {
      stepClick: this.stepClick
    };
  },
  data: function data() {
    return {
      inputValue: null,
      isBooted: false,
      steps: [],
      content: [],
      isReverse: false
    };
  },


  props: {
    nonLinear: Boolean,
    altLabels: Boolean,
    vertical: Boolean,
    value: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper': true,
        'stepper--is-booted': this.isBooted,
        'stepper--vertical': this.vertical,
        'stepper--alt-labels': this.altLabels,
        'stepper--non-linear': this.nonLinear,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    inputValue: function inputValue(val, prev) {
      var _this = this;

      this.isReverse = Number(val) < Number(prev);
      this.steps.forEach(function (i) {
        return i.toggle(_this.inputValue);
      });
      this.content.forEach(function (i) {
        return i.toggle(_this.inputValue, _this.isReverse);
      });

      this.$emit('input', this.inputValue);
      prev && (this.isBooted = true);
    },
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this2 = this;

      this.$children.forEach(function (i) {
        if (i.$options._componentTag === 'v-stepper-step') {
          _this2.steps.push(i);
        } else if (i.$options._componentTag === 'v-stepper-content') {
          i.isVertical = _this2.vertical;
          _this2.content.push(i);
        }
      });

      this.inputValue = this.value || this.steps[0].step || 1;
    },
    stepClick: function stepClick(step) {
      this.inputValue = step;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes
    }, this.$slots.default);
  }
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-step',

  inject: ['stepClick'],

  data: function data() {
    return {
      isActive: false,
      isInactive: true
    };
  },


  props: {
    complete: Boolean,
    completeIcon: {
      type: String,
      default: 'check'
    },
    editIcon: {
      type: String,
      default: 'edit'
    },
    errorIcon: {
      type: String,
      default: 'warning'
    },
    editable: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    step: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__step': true,
        'stepper__step--active': this.isActive,
        'stepper__step--editable': this.editable,
        'stepper__step--inactive': this.isInactive,
        'stepper__step--error': this.hasError,
        'stepper__step--complete': this.complete
      };
    },
    hasError: function hasError() {
      return this.rules.some(function (i) {
        return i() !== true;
      });
    }
  },

  methods: {
    click: function click(e) {
      e.stopPropagation();

      if (this.editable) {
        this.stepClick(this.step);
      }
    },
    toggle: function toggle(step) {
      this.isActive = step.toString() === this.step.toString();
      this.isInactive = Number(step) < Number(this.step);
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      directives: [{
        name: 'ripple',
        value: this.editable
      }],
      on: { click: this.click }
    };
    var stepContent = void 0;

    if (this.hasError) {
      stepContent = [h('v-icon', {}, this.errorIcon)];
    } else if (this.complete) {
      if (this.editable) {
        stepContent = [h('v-icon', {}, this.editIcon)];
      } else {
        stepContent = [h('v-icon', {}, this.completeIcon)];
      }
    } else {
      stepContent = this.step;
    }

    var step = h('span', { 'class': 'stepper__step__step' }, stepContent);
    var label = h('div', { 'class': 'stepper__label' }, this.$slots.default);

    return h('div', data, [step, label]);
  }
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-content',

  data: function data() {
    return {
      height: 0,
      isActive: false,
      isReverse: false,
      isVertical: false
    };
  },


  props: {
    step: {
      type: [Number, String],
      required: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__content': true
      };
    },
    computedTransition: function computedTransition() {
      return this.isReverse ? 'v-tab-reverse-transition' : 'v-tab-transition';
    },
    styles: function styles() {
      if (!this.isVertical) return {};

      return {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'stepper__wrapper': true
      };
    }
  },

  watch: {
    isActive: function isActive() {
      if (!this.isVertical) {
        return;
      }

      if (this.isActive) {
        this.enter();
      } else {
        this.leave();
      }
    }
  },

  mounted: function mounted() {
    this.$refs.wrapper.addEventListener('transitionend', this.onTransition, false);
  },
  beforeDestroy: function beforeDestroy() {
    this.$refs.wrapper.removeEventListener('transitionend', this.onTransition, false);
  },


  methods: {
    onTransition: function onTransition() {
      if (!this.isActive) return;

      this.height = 'auto';
    },
    enter: function enter() {
      var _this = this;

      var scrollHeight = 0;

      // Render bug with height
      setTimeout(function () {
        scrollHeight = _this.$refs.wrapper.scrollHeight;
      }, 0);

      this.height = 0;

      // Give the collapsing element time to collapse
      setTimeout(function () {
        return _this.height = scrollHeight || 'auto';
      }, 450);
    },
    leave: function leave() {
      var _this2 = this;

      this.height = this.$refs.wrapper.clientHeight;
      setTimeout(function () {
        return _this2.height = 0;
      }, 0);
    },
    toggle: function toggle(step, reverse) {
      this.isActive = step.toString() === this.step.toString();
      this.isReverse = reverse;
    }
  },

  render: function render(h) {
    var contentData = {
      'class': this.classes
    };
    var wrapperData = {
      'class': this.wrapperClasses,
      style: this.styles,
      ref: 'wrapper'
    };

    if (!this.isVertical) {
      contentData.directives = [{
        name: 'show',
        value: this.isActive
      }];
    }

    var wrapper = h('div', wrapperData, [this.$slots.default]);
    var content = h('div', contentData, [wrapper]);

    return h(this.computedTransition, {
      on: this.$listeners
    }, [content]);
  }
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VTableOverflow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VDataTable__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VEditDialog__ = __webpack_require__(121);




var VTableOverflow = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('table__overflow');

/* harmony default export */ __webpack_exports__["a"] = ({
  VDataTable: __WEBPACK_IMPORTED_MODULE_1__VDataTable__["a" /* default */],
  VEditDialog: __WEBPACK_IMPORTED_MODULE_2__VEditDialog__["a" /* default */],
  VTableOverflow: VTableOverflow
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_head__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_body__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_foot__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_progress__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_helpers__ = __webpack_require__(0);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-datatable',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_head__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_foot__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__["a" /* default */]],

  components: {
    VBtn: __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__["a" /* default */],
    VProgressLinear: __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__["a" /* default */],
    VSelect: __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__["a" /* default */],
    // Importing does not work properly
    'v-table-overflow': Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["d" /* createSimpleFunctional */])('table__overflow')
  },

  data: function data() {
    return {
      all: false,
      searchLength: 0,
      defaultPagination: {
        page: 1,
        rowsPerPage: 5,
        descending: false,
        totalItems: 0
      }
    };
  },


  props: {
    headers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    headerText: {
      type: String,
      default: 'text'
    },
    hideActions: Boolean,
    noResultsText: {
      type: String,
      default: 'No matching records found'
    },
    rowsPerPageItems: {
      type: Array,
      default: function _default() {
        return [5, 10, 25, { text: 'All', value: -1 }];
      }
    },
    rowsPerPageText: {
      type: String,
      default: 'Rows per page:'
    },
    selectAll: [Boolean, String],
    search: {
      required: false
    },
    filter: {
      type: Function,
      default: function _default(val, search) {
        return val !== null && ['undefined', 'boolean'].indexOf(typeof val === 'undefined' ? 'undefined' : _typeof(val)) === -1 && val.toString().toLowerCase().indexOf(search) !== -1;
      }
    },
    customFilter: {
      type: Function,
      default: function _default(items, search, filter) {
        search = search.toString().toLowerCase();
        return items.filter(function (i) {
          return Object.keys(i).some(function (j) {
            return filter(i[j], search);
          });
        });
      }
    },
    customSort: {
      type: Function,
      default: function _default(items, index, isDescending) {
        if (index === null) return items;

        return items.sort(function (a, b) {
          var sortA = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(a, index);
          var sortB = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(b, index);

          if (isDescending) {
            var _ref = [sortB, sortA];
            sortA = _ref[0];
            sortB = _ref[1];
          }

          // Check if both are numbers
          if (!isNaN(sortA) && !isNaN(sortB)) {
            return sortA - sortB;
          }

          // Check if both cannot be evaluated
          if (sortA === null && sortB === null) {
            return 0;
          }

          var _map = [sortA, sortB].map(function (s) {
            return (s || '').toString().toLocaleLowerCase();
          });

          var _map2 = _slicedToArray(_map, 2);

          sortA = _map2[0];
          sortB = _map2[1];


          if (sortA > sortB) return 1;
          if (sortA < sortB) return -1;

          return 0;
        });
      }
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    items: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    totalItems: {
      type: Number,
      default: null
    },
    loading: {
      type: [Boolean, String],
      default: false
    },
    selectedKey: {
      type: String,
      default: 'id'
    },
    pagination: {
      type: Object,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'datatable table': true,
        'datatable--select-all': this.selectAll !== false,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    computedPagination: function computedPagination() {
      return this.pagination || this.defaultPagination;
    },
    hasSelectAll: function hasSelectAll() {
      return this.selectAll !== undefined && this.selectAll !== false;
    },
    itemsLength: function itemsLength() {
      if (this.search) return this.searchLength;
      return this.totalItems || this.items.length;
    },
    indeterminate: function indeterminate() {
      return this.hasSelectAll && this.someItems && !this.everyItem;
    },
    everyItem: function everyItem() {
      var _this = this;

      return this.filteredItems.length && this.filteredItems.every(function (i) {
        return _this.isSelected(i);
      });
    },
    someItems: function someItems() {
      var _this2 = this;

      return this.filteredItems.some(function (i) {
        return _this2.isSelected(i);
      });
    },
    getPage: function getPage() {
      var rowsPerPage = this.computedPagination.rowsPerPage;


      return rowsPerPage === Object(rowsPerPage) ? rowsPerPage.value : rowsPerPage;
    },
    pageStart: function pageStart() {
      return this.getPage === -1 ? 0 : (this.computedPagination.page - 1) * this.getPage;
    },
    pageStop: function pageStop() {
      return this.getPage === -1 ? this.itemsLength : this.computedPagination.page * this.getPage;
    },
    filteredItems: function filteredItems() {
      if (this.totalItems) return this.items;

      var items = this.items.slice();
      var hasSearch = typeof this.search !== 'undefined' && this.search !== null;

      if (hasSearch) {
        items = this.customFilter(items, this.search, this.filter);
        this.searchLength = items.length;
      }

      items = this.customSort(items, this.computedPagination.sortBy, this.computedPagination.descending);

      return this.hideActions && !this.pagination ? items : items.slice(this.pageStart, this.pageStop);
    },
    selected: function selected() {
      var _this3 = this;

      var selected = {};
      this.value.forEach(function (i) {
        return selected[i[_this3.selectedKey]] = true;
      });
      return selected;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      if (val) this.all = true;
    },
    someItems: function someItems(val) {
      if (!val) this.all = false;
    },
    search: function search() {
      this.updatePagination({ page: 1 });
    },
    everyItem: function everyItem(val) {
      if (val) this.all = true;
    }
  },

  methods: {
    updatePagination: function updatePagination(val) {
      var pagination = this.pagination || this.defaultPagination;
      var updatedPagination = Object.assign({}, pagination, val);

      if (this.pagination) {
        this.$emit('update:pagination', updatedPagination);
      } else {
        this.defaultPagination = updatedPagination;
      }
    },
    isSelected: function isSelected(item) {
      return this.selected[item[this.selectedKey]];
    },
    sort: function sort(index) {
      var _computedPagination = this.computedPagination,
          sortBy = _computedPagination.sortBy,
          descending = _computedPagination.descending;

      if (sortBy === null) {
        this.updatePagination({ sortBy: index, descending: false });
      } else if (sortBy === index && !descending) {
        this.updatePagination({ descending: true });
      } else if (sortBy !== index) {
        this.updatePagination({ sortBy: index, descending: false });
      } else {
        this.updatePagination({ sortBy: null, descending: null });
      }
    },
    needsTR: function needsTR(row) {
      return row.length && row.find(function (c) {
        return c.tag === 'td';
      });
    },
    genTR: function genTR(children) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.$createElement('tr', data, children);
    },
    toggle: function toggle(value) {
      var _this4 = this;

      var selected = Object.assign({}, this.selected);
      this.filteredItems.forEach(function (i) {
        return selected[i[_this4.selectedKey]] = value;
      });

      this.$emit('input', this.items.filter(function (i) {
        return selected[i[_this4.selectedKey]];
      }));
    }
  },

  created: function created() {
    var firstSortable = this.headers.find(function (h) {
      return !('sortable' in h) || h.sortable;
    });

    this.defaultPagination.sortBy = firstSortable ? firstSortable.value : null;

    if (!this.rowsPerPageItems.length) {
      console.warn('The prop \'rows-per-page-items\' in v-data-table can not be empty.');
    } else {
      this.defaultPagination.rowsPerPage = this.rowsPerPageItems[0];
    }

    this.updatePagination(Object.assign({}, this.defaultPagination, this.pagination));
  },
  render: function render(h) {
    return h('v-table-overflow', {}, [h('table', {
      'class': this.classes
    }, [this.genTHead(), this.genTProgress(), this.genTBody(), this.genTFoot()])]);
  }
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTHead: function genTHead() {
      var _this = this;

      var children = [];

      if (this.$scopedSlots.headers) {
        var row = this.$scopedSlots.headers({
          headers: this.headers,
          indeterminate: this.indeterminate,
          all: this.all
        });

        children = this.needsTR(row) ? this.genTR(row) : row;
      } else {
        var _row = this.headers.map(function (o) {
          return _this.genHeader(o);
        });
        var checkbox = this.$createElement('v-checkbox', {
          props: {
            dark: this.dark,
            light: this.light,
            color: this.selectAll === true && '' || this.selectAll,
            hideDetails: true,
            inputValue: this.all,
            indeterminate: this.indeterminate
          },
          on: { change: this.toggle }
        });

        this.hasSelectAll && _row.unshift(this.$createElement('th', [checkbox]));

        children = this.genTR(_row);
      }

      return this.$createElement('thead', [children]);
    },
    genHeader: function genHeader(header) {
      var array = [this.$scopedSlots.headerCell ? this.$scopedSlots.headerCell({ header: header }) : header[this.headerText]];

      return this.$createElement.apply(this, ['th'].concat(_toConsumableArray(this.genHeaderData(header, array))));
    },
    genHeaderData: function genHeaderData(header, children) {
      var _this2 = this;

      var classes = ['column'];
      var data = {};
      var pagination = this.computedPagination;

      if ('sortable' in header && header.sortable || !('sortable' in header)) {
        data.on = { click: function click() {
            return _this2.sort(header.value);
          } };
        if (!('value' in header)) {
          console.warn('Data table headers must have a value property that corresponds to a value in the v-model array');
        }

        classes.push('sortable');
        var icon = this.$createElement('v-icon', 'arrow_upward');
        if (header.align && header.align === 'left') {
          children.push(icon);
        } else {
          children.unshift(icon);
        }

        var beingSorted = pagination.sortBy === header.value;
        if (beingSorted) {
          classes.push('active');
          classes.push(pagination.descending ? 'desc' : 'asc');
        }
      }

      classes.push('text-xs-' + (header.align || 'right'));
      data.class = classes;

      return [data, children];
    }
  }
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTBody: function genTBody() {
      var children = [];

      if (!this.itemsLength) {
        children.push(this.genEmptyBody(this.noDataText));
      } else if (!this.filteredItems.length) {
        children.push(this.genEmptyBody(this.noResultsText));
      } else {
        children.push(this.genFilteredItems());
      }

      return this.$createElement('tbody', children);
    },
    genFilteredItems: function genFilteredItems() {
      var _this = this;

      return this.filteredItems.map(function (item, index) {
        var props = { item: item, index: index };
        var key = _this.selectedKey;

        Object.defineProperty(props, 'selected', {
          get: function get() {
            return _this.selected[item[_this.selectedKey]];
          },
          set: function set(value) {
            var selected = _this.value.slice();
            if (value) selected.push(item);else selected = selected.filter(function (i) {
              return i[key] !== item[key];
            });

            _this.$emit('input', selected);
          }
        });

        var row = _this.$scopedSlots.items(props);

        return _this.needsTR(row) ? _this.genTR(row, {
          attrs: { active: _this.isSelected(item) }
        }) : row;
      });
    },
    genEmptyBody: function genEmptyBody(text) {
      return this.genTR([this.$createElement('td', {
        'class': 'text-xs-center',
        attrs: { colspan: '100%' }
      }, text)]);
    }
  }
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genPrevIcon: function genPrevIcon() {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          disabled: this.computedPagination.page === 1,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this.computedPagination.page;
            _this.updatePagination({ page: page - 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_left')]);
    },
    genNextIcon: function genNextIcon() {
      var _this2 = this;

      var pagination = this.computedPagination;
      var disabled = pagination.rowsPerPage < 0 || pagination.page * pagination.rowsPerPage >= this.itemsLength || this.pageStop < 0;

      return this.$createElement('v-btn', {
        props: {
          disabled: disabled,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this2.computedPagination.page;
            _this2.updatePagination({ page: page + 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_right')]);
    },
    genSelect: function genSelect() {
      var _this3 = this;

      return this.$createElement('div', {
        'class': 'datatable__actions__select'
      }, [this.rowsPerPageText, this.$createElement('v-select', {
        props: {
          items: this.rowsPerPageItems,
          value: this.computedPagination.rowsPerPage,
          hideDetails: true,
          auto: true,
          minWidth: '75px'
        },
        on: {
          input: function input(val) {
            _this3.updatePagination({
              page: 1,
              rowsPerPage: val
            });
          }
        }
      })]);
    },
    genPagination: function genPagination() {
      var pagination = '–';

      if (this.itemsLength) {
        var stop = this.itemsLength < this.pageStop || this.pageStop < 0 ? this.itemsLength : this.pageStop;

        pagination = this.$scopedSlots.pageText ? this.$scopedSlots.pageText({
          pageStart: this.pageStart + 1,
          pageStop: stop,
          itemsLength: this.itemsLength
        }) : this.pageStart + 1 + '-' + stop + ' of ' + this.itemsLength;
      }

      return this.$createElement('div', {
        'class': 'datatable__actions__pagination'
      }, [pagination]);
    },
    genActions: function genActions() {
      return [this.$createElement('div', {
        'class': 'datatable__actions'
      }, [this.genSelect(), this.genPagination(), this.genPrevIcon(), this.genNextIcon()])];
    },
    genTFoot: function genTFoot() {
      var children = [];

      if (this.$slots.footer) {
        var footer = this.$slots.footer;
        var row = this.needsTR(footer) ? this.genTR(footer) : footer;

        children.push(row);
      }

      if (!this.hideActions) {
        children.push(this.genTR([this.$createElement('td', {
          attrs: { colspan: '100%' }
        }, this.genActions())]));
      }

      if (!children.length) return null;
      return this.$createElement('tfoot', children);
    }
  }
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      color: ''
    };
  },


  watch: {
    loading: function loading(val) {
      if (val) this.color = val;
    }
  },

  methods: {
    genTProgress: function genTProgress() {
      var loader = this.$createElement('v-progress-linear', {
        props: {
          primary: this.color === 'primary',
          secondary: this.color === 'secondary',
          success: this.color === 'success',
          info: this.color === 'info',
          warning: this.color === 'warning',
          error: this.color === 'error',
          indeterminate: true,
          height: 3,
          active: !!this.loading
        }
      });

      var col = this.$createElement('th', {
        class: 'column',
        attrs: {
          colspan: '100%'
        }
      }, [loader]);

      return this.$createElement('thead', {
        class: 'datatable__progress'
      }, [this.genTR([col])]);
    }
  }
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-edit-dialog',

  data: function data() {
    return {
      isActive: false,
      isSaving: false
    };
  },


  props: {
    cancelText: {
      default: 'Cancel'
    },
    large: Boolean,
    lazy: Boolean,
    saveText: {
      default: 'Save'
    },
    transition: {
      type: String,
      default: 'slide-x-reverse-transition'
    }
  },

  watch: {
    isActive: function isActive(val) {
      val && this.$emit('open') && setTimeout(this.focus, 50); // Give DOM time to paint

      if (!val) {
        !this.isSaving && this.$emit('cancel');
        this.isSaving && this.$emit('close');
        this.isSaving = false;
      }
    }
  },

  methods: {
    cancel: function cancel() {
      this.isActive = false;
    },
    focus: function focus() {
      var input = this.$refs.content.querySelector('input');
      input && input.focus();
    },
    save: function save() {
      this.isSaving = true;
      this.isActive = false;
      this.$emit('save');
    },
    genButton: function genButton(fn, text) {
      return this.$createElement('v-btn', {
        props: {
          flat: true,
          primary: true,
          light: true
        },
        on: { click: fn }
      }, text);
    },
    genActions: function genActions() {
      return this.$createElement('div', {
        'class': 'small-dialog__actions',
        directives: [{
          name: 'show',
          value: this.large
        }]
      }, [this.genButton(this.cancel, this.cancelText), this.genButton(this.save, this.saveText)]);
    },
    genContent: function genContent() {
      var _this = this;

      return this.$createElement('div', {
        'class': 'small-dialog__content',
        on: {
          keydown: function keydown(e) {
            e.keyCode === 27 && _this.cancel();
            e.keyCode === 13 && _this.save();
          }
        },
        ref: 'content'
      }, [this.$slots.input]);
    }
  },

  render: function render(h) {
    var _this2 = this;

    return h('v-menu', {
      'class': 'small-dialog',
      props: {
        transition: this.transition,
        origin: 'top right',
        right: true,
        value: this.isActive,
        closeOnContentClick: false,
        lazy: this.lazy
      },
      on: {
        input: function input(val) {
          return _this2.isActive = val;
        }
      }
    }, [h('a', {
      domProps: { href: 'javascript:;' },
      slot: 'activator'
    }, this.$slots.default), this.genContent(), this.genActions()]);
  }
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTabs__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VTabsItem__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VTabsContent__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VTabsBar__ = __webpack_require__(126);






var VTabsSlider = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('tabs__slider', 'li');

var VTabsItems = {
  name: 'v-tabs-items',

  render: function render(h) {
    return h('div', { 'class': { 'tabs__items': true } }, [this.$slots.default]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  VTabsItem: __WEBPACK_IMPORTED_MODULE_2__VTabsItem__["a" /* default */],
  VTabsItems: VTabsItems,
  VTabs: __WEBPACK_IMPORTED_MODULE_1__VTabs__["a" /* default */],
  VTabsContent: __WEBPACK_IMPORTED_MODULE_3__VTabsContent__["a" /* default */],
  VTabsBar: __WEBPACK_IMPORTED_MODULE_4__VTabsBar__["a" /* default */],
  VTabsSlider: VTabsSlider
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    var _this = this;

    return {
      slider: this.slider,
      tabClick: this.tabClick,
      isScrollable: function isScrollable() {
        return _this.scrollable;
      },
      isMobile: function isMobile() {
        return _this.isMobile;
      }
    };
  },
  data: function data() {
    return {
      activators: [],
      activeIndex: null,
      isMobile: false,
      reverse: false,
      target: null,
      tabsSlider: null,
      targetEl: null,
      tabsContainer: null
    };
  },


  props: {
    centered: Boolean,
    fixed: Boolean,
    grow: Boolean,
    icons: Boolean,
    mobileBreakPoint: {
      type: [Number, String],
      default: 1024
    },
    value: String,
    scrollable: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'tabs': true,
        'tabs--centered': this.centered,
        'tabs--fixed': this.fixed,
        'tabs--grow': this.grow,
        'tabs--icons': this.icons,
        'tabs--mobile': this.isMobile,
        'tabs--scroll-bars': this.scrollable,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    value: function value() {
      this.tabClick(this.value);
    },
    activeIndex: function activeIndex() {
      this.updateTabs();
      this.$emit('input', this.target);
      this.isBooted = true;
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    this.$vuetify.load(function () {
      var activators = _this2.$slots.activators;

      if (!activators || !activators.length || !activators[0].componentInstance) return;

      var bar = activators[0].componentInstance.$children;
      // // This is a workaround to detect if link is active
      // // when being used as a router or nuxt link
      var i = bar.findIndex(function (t) {
        return t.$el.firstChild.classList.contains('tabs__item--active');
      });

      var tab = _this2.value || (bar[i !== -1 ? i : 0] || {}).action;

      tab && _this2.tabClick(tab) && _this2.onResize();
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.resize, { passive: true });
  },


  methods: {
    onResize: function onResize() {
      this.isMobile = window.innerWidth < this.mobileBreakPoint;
      this.slider();
    },
    slider: function slider(el) {
      var _this3 = this;

      this.tabsSlider = this.tabsSlider || this.$el.querySelector('.tabs__slider');

      this.tabsContainer = this.tabsContainer || this.$el.querySelector('.tabs__container');

      if (!this.tabsSlider || !this.tabsContainer) return;

      this.targetEl = el || this.targetEl;

      if (!this.targetEl || !this.tabsContainer) return;

      // Gives DOM time to paint when
      // processing slider for
      // dynamic tabs
      this.$nextTick(function () {
        // #684 Calculate width as %
        var width = _this3.targetEl.scrollWidth / _this3.tabsContainer.clientWidth * 100;

        _this3.tabsSlider.style.width = width + '%';
        _this3.tabsSlider.style.left = _this3.targetEl.offsetLeft + 'px';
      });
    },
    tabClick: function tabClick(target) {
      var _this4 = this;

      var setActiveIndex = function setActiveIndex(index) {
        if (_this4.activeIndex === index) {
          // #762 update tabs display
          // In case tabs count got changed but activeIndex didn't
          _this4.updateTabs();
        } else {
          _this4.activeIndex = index;
        }
      };

      this.target = target;

      var content = this.$refs.content;
      if (!content) {
        setActiveIndex(target);
        return;
      }

      this.$nextTick(function () {
        var nextIndex = content.$children.findIndex(function (i) {
          return i.id === target;
        });
        _this4.reverse = nextIndex < _this4.activeIndex;
        setActiveIndex(nextIndex);
      });
    },
    updateTabs: function updateTabs() {
      var _this5 = this;

      var activators = this.$slots.activators;
      var content = this.$refs.content;

      if (!activators || !activators.length || activators.length && !activators[0].componentInstance) return;

      activators[0].componentInstance.$children.filter(function (i) {
        return i.$options._componentTag === 'v-tabs-item';
      }).forEach(function (i) {
        return i.toggle(_this5.target);
      });

      content && content.$children.forEach(function (i) {
        return i.toggle(_this5.target, _this5.reverse, _this5.isBooted);
      });
    }
  },

  render: function render(h) {
    var content = [];
    var slot = [];
    var iter = this.$slots.default || [];

    iter.forEach(function (c) {
      if (!c.componentOptions) slot.push(c);else if (c.componentOptions.tag === 'v-tabs-content') content.push(c);else slot.push(c);
    });

    var tabs = content.length ? h('v-tabs-items', {
      ref: 'content'
    }, content) : null;

    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [slot, this.$slots.activators, tabs]);
  }
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-item',

  inject: ['slider', 'tabClick'],

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  data: function data() {
    return {
      isActive: false
    };
  },


  props: {
    activeClass: {
      type: String,
      default: 'tabs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = {
        'tabs__item': true,
        'tabs__item--disabled': this.disabled
      };

      classes[this.activeClass] = !this.to && this.isActive;

      return classes;
    },
    action: function action() {
      var to = this.to || this.href;

      if (!to || to === Object(to)) return this._uid;

      return to.replace('#', '');
    }
  },

  watch: {
    $route: function $route() {
      this.to && this.callSlider();
    }
  },

  mounted: function mounted() {
    this.callSlider();
  },


  methods: {
    callSlider: function callSlider() {
      var _this = this;

      setTimeout(function () {
        _this.$el.firstChild.classList.contains('tabs__item--active') && _this.slider(_this.$el);
      }, 0);
    },
    click: function click(e) {
      e.preventDefault();

      if (!this.to && !this.href) return;

      if (!this.to) {
        this.tabClick(this.action);
      }

      this.callSlider();
    },
    toggle: function toggle(action) {
      var _this2 = this;

      this.isActive = this.action === action;

      this.$nextTick(function () {
        _this2.isActive && _this2.slider(_this2.$el);
      });
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      'class': 'tabs__li'
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */]],

  data: function data() {
    return {
      isActive: false,
      reverse: false
    };
  },


  props: {
    id: {
      type: String,
      required: true
    },
    lazy: Boolean,
    transition: {
      type: String,
      default: 'v-tab-transition'
    },
    reverseTransition: {
      type: String,
      default: 'v-tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    }
  },

  methods: {
    toggle: function toggle(target, reverse, showTransition) {
      this.$el.style.transition = !showTransition ? 'none' : null;
      this.reverse = reverse;
      this.isActive = this.id === target;
    }
  },

  render: function render(h) {
    return h(this.computedTransition, {}, [h('div', {
      'class': 'tabs__content',
      domProps: { id: this.id },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, this.lazy && this.isBooted || !this.lazy ? this.$slots.default : null)]);
  }
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-bar',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  inject: ['isScrollable', 'isMobile'],

  data: function data() {
    return {
      isOverflowing: false,
      scrollOffset: 0,
      itemOffset: 0,
      startX: 0
    };
  },


  computed: {
    classes: function classes() {
      return {
        'tabs__bar': true
      };
    },
    containerClasses: function containerClasses() {
      return {
        'tabs__container': true
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'tabs__wrapper': true,
        'tabs__wrapper--scrollable': this.isScrollable(),
        'tabs__wrapper--overflow': this.isOverflowing
      };
    },
    containerStyles: function containerStyles() {
      return {
        'transform': 'translateX(' + -this.scrollOffset + 'px)'
      };
    },
    leftIconVisible: function leftIconVisible() {
      return !this.isMobile() && this.isScrollable() && this.isOverflowing && this.scrollOffset > 0;
    },
    rightIconVisible: function rightIconVisible() {
      if (this.isMobile() || !this.isScrollable() || !this.isOverflowing) return;

      // Check one scroll ahead to know the width of right-most item
      var container = this.$refs.container;
      var item = this.newOffsetRight(this.scrollOffset, this.itemOffset);
      var itemWidth = item && container.children[item.index].clientWidth || 0;
      var scrollOffset = this.scrollOffset + container.clientWidth;

      return container.scrollWidth - scrollOffset > itemWidth * 0.30;
    }
  },

  methods: {
    genContainer: function genContainer() {
      return this.$createElement('ul', {
        'class': this.containerClasses,
        'style': this.containerStyles,
        ref: 'container'
      }, this.$slots.default);
    },
    genIcon: function genIcon(direction) {
      var capitalize = direction.charAt(0).toUpperCase() + direction.slice(1);
      return this.$createElement(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], {
        props: _defineProperty({}, '' + direction, true),
        style: { display: 'inline-flex' },
        on: {
          click: this['scroll' + capitalize]
        }
      }, 'chevron_' + direction);
    },
    genWrapper: function genWrapper() {
      return this.$createElement('div', {
        class: this.wrapperClasses,
        directives: [{
          name: 'touch',
          value: {
            start: this.start,
            move: this.move,
            end: this.end
          }
        }]
      }, [this.genContainer()]);
    },
    start: function start(e) {
      this.startX = this.scrollOffset + e.touchstartX;
      this.$refs.container.style.transition = 'none';
    },
    move: function move(e) {
      var offset = this.startX - e.touchmoveX;
      this.scrollOffset = offset;
    },
    end: function end(e) {
      this.onResize();
      var container = this.$refs.container;
      var scrollWidth = container.scrollWidth - this.$el.clientWidth / 2;
      container.style.transition = null;

      if (this.scrollOffset < 0 || !this.isOverflowing) {
        this.scrollOffset = 0;
      } else if (this.scrollOffset >= scrollWidth) {
        var lastItem = container.children[container.children.length - 1];
        this.scrollOffset = scrollWidth - lastItem.clientWidth;
      }
    },
    scrollLeft: function scrollLeft() {
      var _newOffset = this.newOffset('Left'),
          offset = _newOffset.offset,
          index = _newOffset.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    scrollRight: function scrollRight() {
      var _newOffset2 = this.newOffset('Right'),
          offset = _newOffset2.offset,
          index = _newOffset2.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    onResize: function onResize() {
      if (this._isDestroyed) return;

      var container = this.$refs.container;
      this.isOverflowing = container.clientWidth < container.scrollWidth;
    },
    newOffset: function newOffset(direction) {
      return this['newOffset' + direction](this.scrollOffset, this.itemOffset);
    },
    newOffsetLeft: function newOffsetLeft(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = 0;

      for (var index = currentIndex - 1; index >= 0; index--) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset >= container.clientWidth) {
            return { offset: currentOffset - offset, index: index + 1 };
          }
          offset = newOffset;
        }
      }

      return { offset: 0, index: 0 };
    },
    newOffsetRight: function newOffsetRight(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = currentOffset;

      for (var index = currentIndex; index < items.length; index++) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset > currentOffset + container.clientWidth) {
            return { offset: offset, index: index };
          }
          offset = newOffset;
        }
      }

      return null;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [this.genWrapper(), this.leftIconVisible ? this.genIcon('left') : null, this.rightIconVisible ? this.genIcon('right') : null]);
  }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VTextField__ = __webpack_require__(128);


/* harmony default export */ __webpack_exports__["a"] = ({
  VTextField: __WEBPACK_IMPORTED_MODULE_0__VTextField__["a" /* default */]
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-text-field',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  inheritAttrs: false,

  data: function data() {
    return {
      hasFocused: false,
      inputHeight: null
    };
  },


  props: {
    autofocus: Boolean,
    autoGrow: Boolean,
    counter: Boolean,
    fullWidth: Boolean,
    max: [Number, String],
    min: [Number, String],
    multiLine: Boolean,
    placeholder: String,
    prefix: String,
    rows: {
      default: 5
    },
    singleLine: Boolean,
    solo: Boolean,
    suffix: String,
    textarea: Boolean,
    type: {
      type: String,
      default: 'text'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field': true,
        'input-group--single-line': this.singleLine,
        'input-group--solo': this.solo,
        'input-group--multi-line': this.multiLine,
        'input-group--full-width': this.fullWidth,
        'input-group--prefix': this.prefix,
        'input-group--suffix': this.suffix,
        'input-group--textarea': this.textarea
      };
    },
    hasError: function hasError() {
      return this.validations.length || this.errorMessages.length > 0 || !this.counterIsValid() || !this.validateIsValid() || this.error;
    },
    count: function count() {
      var inputLength = void 0;
      if (this.inputValue) inputLength = this.inputValue.toString().length;else inputLength = 0;
      var min = inputLength;

      if (this.counterMin !== 0 && inputLength < this.counterMin) {
        min = this.counterMin;
      }

      return min + ' / ' + this.counterMax;
    },
    counterMin: function counterMin() {
      var parsedMin = parseInt(this.min, 10);
      return isNaN(parsedMin) ? 0 : parsedMin;
    },
    counterMax: function counterMax() {
      var parsedMax = parseInt(this.max, 10);
      return isNaN(parsedMax) ? 25 : parsedMax;
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        if (this.modifiers.trim) {
          val = val.trim();
        }

        if (this.modifiers.number) {
          val = Number(val);
        }

        if (!this.modifiers.lazy) {
          this.$emit('input', val);
        }

        this.lazyValue = val;
      }
    },
    isDirty: function isDirty() {
      return this.lazyValue !== null && typeof this.lazyValue !== 'undefined' && this.lazyValue.toString().length > 0 || this.placeholder;
    }
  },

  watch: {
    focused: function focused(val) {
      this.hasFocused = true;
    },
    value: function value() {
      this.lazyValue = this.value;
      this.validate();
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      _this.multiLine && _this.autoGrow && _this.calculateInputHeight();
      _this.autofocus && _this.focus();
    });
  },


  methods: {
    calculateInputHeight: function calculateInputHeight() {
      var _this2 = this;

      this.inputHeight = null;

      this.$nextTick(function () {
        var height = _this2.$refs.input.scrollHeight;
        var minHeight = _this2.rows * 24;
        var inputHeight = height < minHeight ? minHeight : height;
        _this2.inputHeight = inputHeight;
      });
    },
    onChange: function onChange(e) {
      this.lazyValue = e.target.value;
      this.$emit('change', this.lazyValue || null);
    },
    onInput: function onInput(e) {
      this.inputValue = e.target.value;
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    },
    blur: function blur(e) {
      var _this3 = this;

      this.validate();
      this.$nextTick(function () {
        return _this3.focused = false;
      });
      this.$emit('blur', e);
    },
    focus: function focus(e) {
      this.focused = true;
      this.$refs.input.focus();
      this.$emit('focus', e);
    },
    genCounter: function genCounter() {
      return this.$createElement('div', {
        'class': {
          'input-group__counter': true,
          'input-group__counter--error': !this.counterIsValid()
        }
      }, this.count);
    },
    genInput: function genInput() {
      var tag = this.multiLine || this.textarea ? 'textarea' : 'input';

      var data = {
        style: {
          'height': this.inputHeight && this.inputHeight + 'px'
        },
        domProps: {
          autofocus: this.autofocus,
          disabled: this.disabled,
          required: this.required,
          value: this.lazyValue
        },
        attrs: _extends({}, this.$attrs, {
          tabindex: this.tabindex,
          'aria-label': !this.$attrs.id && this.label // Label `for` will be set if we have an id
        }),
        on: _extends({}, this.$listeners, {
          blur: this.blur,
          input: this.onInput,
          focus: this.focus
        }),
        ref: 'input'
      };

      if (this.placeholder) data.domProps.placeholder = this.placeholder;

      if (!this.counter) {
        if (![undefined, null].includes(this.max)) data.attrs.max = this.max;
        if (![undefined, null].includes(this.min)) data.attrs.min = this.min;
      }

      if (!this.textarea && !this.multiLine) {
        data.domProps.type = this.type;
      } else {
        data.domProps.rows = this.rows;
      }

      var children = [this.$createElement(tag, data)];

      this.prefix && children.unshift(this.genFix('prefix'));
      this.suffix && children.push(this.genFix('suffix'));

      return children;
    },
    genFix: function genFix(type) {
      return this.$createElement('span', {
        'class': 'input-group--text-field__' + type
      }, this[type]);
    },

    counterIsValid: function counterIsValid() {
      var val = this.inputValue && this.inputValue.toString() || '';

      return !this.counter || val.length >= this.counterMin && val.length <= this.counterMax;
    },
    validateIsValid: function validateIsValid() {
      return !this.required || this.required && this.isDirty || !this.hasFocused || this.hasFocused && this.focused;
    }
  },

  render: function render() {
    return this.genInputGroup(this.genInput(), { attrs: { tabindex: false } });
  }
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSnackbar__ = __webpack_require__(130);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSnackbar: __WEBPACK_IMPORTED_MODULE_0__VSnackbar__["a" /* default */]
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-snackbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      activeTimeout: {}
    };
  },


  props: {
    absolute: Boolean,
    bottom: Boolean,
    left: Boolean,
    multiLine: Boolean,
    right: Boolean,
    top: Boolean,
    timeout: {
      type: Number,
      default: 6000
    },
    vertical: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'snack': true,
        'snack--active': this.isActive,
        'snack--absolute': this.absolute,
        'snack--bottom': this.bottom || !this.top,
        'snack--left': this.left,
        'snack--multi-line': this.multiLine && !this.vertical,
        'snack--right': this.right,
        'snack--top': this.top,
        'snack--vertical': this.vertical,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'info': this.info,
        'warning': this.warning,
        'error': this.error
      };
    },
    computedTransition: function computedTransition() {
      return this.top ? 'v-slide-y-transition' : 'v-slide-y-reverse-transition';
    }
  },

  watch: {
    isActive: function isActive() {
      var _this = this;

      clearTimeout(this.activeTimeout);

      if (this.isActive && this.timeout) {
        this.activeTimeout = setTimeout(function () {
          _this.isActive = false;
        }, this.timeout);
      }
    }
  },

  render: function render(h) {
    var children = [];

    if (this.isActive) {
      children.push(h('div', {
        'class': 'snack__content'
      }, this.$slots.default));
    }

    return h('div', {
      'class': this.classes,
      on: this.$listeners
    }, [h(this.computedTransition, children)]);
  }
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function load(cb) {
  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (document.readyState === 'complete') {
    return setTimeout(cb, 0);
  }

  if (document.readyState === 'interactive' && i <= 10) {
    return setTimeout(function () {
      return load(cb, i + 1);
    }, 200);
  }

  window.addEventListener('load', cb);
}

/* harmony default export */ __webpack_exports__["a"] = (load);

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {exports = module.exports = SemVer;

// The debug function is excluded entirely from the minified version.
/* nomin */ var debug;
/* nomin */ if (typeof process === 'object' &&
    /* nomin */ process.env &&
    /* nomin */ process.env.NODE_DEBUG &&
    /* nomin */ /\bsemver\b/i.test(process.env.NODE_DEBUG))
  /* nomin */ debug = function() {
    /* nomin */ var args = Array.prototype.slice.call(arguments, 0);
    /* nomin */ args.unshift('SEMVER');
    /* nomin */ console.log.apply(console, args);
    /* nomin */ };
/* nomin */ else
  /* nomin */ debug = function() {};

// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
exports.SEMVER_SPEC_VERSION = '2.0.0';

var MAX_LENGTH = 256;
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

// The actual regexps go on exports.re
var re = exports.re = [];
var src = exports.src = [];
var R = 0;

// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.

// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.

var NUMERICIDENTIFIER = R++;
src[NUMERICIDENTIFIER] = '0|[1-9]\\d*';
var NUMERICIDENTIFIERLOOSE = R++;
src[NUMERICIDENTIFIERLOOSE] = '[0-9]+';


// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.

var NONNUMERICIDENTIFIER = R++;
src[NONNUMERICIDENTIFIER] = '\\d*[a-zA-Z-][a-zA-Z0-9-]*';


// ## Main Version
// Three dot-separated numeric identifiers.

var MAINVERSION = R++;
src[MAINVERSION] = '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')';

var MAINVERSIONLOOSE = R++;
src[MAINVERSIONLOOSE] = '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')';

// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.

var PRERELEASEIDENTIFIER = R++;
src[PRERELEASEIDENTIFIER] = '(?:' + src[NUMERICIDENTIFIER] +
                            '|' + src[NONNUMERICIDENTIFIER] + ')';

var PRERELEASEIDENTIFIERLOOSE = R++;
src[PRERELEASEIDENTIFIERLOOSE] = '(?:' + src[NUMERICIDENTIFIERLOOSE] +
                                 '|' + src[NONNUMERICIDENTIFIER] + ')';


// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.

var PRERELEASE = R++;
src[PRERELEASE] = '(?:-(' + src[PRERELEASEIDENTIFIER] +
                  '(?:\\.' + src[PRERELEASEIDENTIFIER] + ')*))';

var PRERELEASELOOSE = R++;
src[PRERELEASELOOSE] = '(?:-?(' + src[PRERELEASEIDENTIFIERLOOSE] +
                       '(?:\\.' + src[PRERELEASEIDENTIFIERLOOSE] + ')*))';

// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.

var BUILDIDENTIFIER = R++;
src[BUILDIDENTIFIER] = '[0-9A-Za-z-]+';

// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.

var BUILD = R++;
src[BUILD] = '(?:\\+(' + src[BUILDIDENTIFIER] +
             '(?:\\.' + src[BUILDIDENTIFIER] + ')*))';


// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.

// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.

var FULL = R++;
var FULLPLAIN = 'v?' + src[MAINVERSION] +
                src[PRERELEASE] + '?' +
                src[BUILD] + '?';

src[FULL] = '^' + FULLPLAIN + '$';

// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
var LOOSEPLAIN = '[v=\\s]*' + src[MAINVERSIONLOOSE] +
                 src[PRERELEASELOOSE] + '?' +
                 src[BUILD] + '?';

var LOOSE = R++;
src[LOOSE] = '^' + LOOSEPLAIN + '$';

var GTLT = R++;
src[GTLT] = '((?:<|>)?=?)';

// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
var XRANGEIDENTIFIERLOOSE = R++;
src[XRANGEIDENTIFIERLOOSE] = src[NUMERICIDENTIFIERLOOSE] + '|x|X|\\*';
var XRANGEIDENTIFIER = R++;
src[XRANGEIDENTIFIER] = src[NUMERICIDENTIFIER] + '|x|X|\\*';

var XRANGEPLAIN = R++;
src[XRANGEPLAIN] = '[v=\\s]*(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:' + src[PRERELEASE] + ')?' +
                   src[BUILD] + '?' +
                   ')?)?';

var XRANGEPLAINLOOSE = R++;
src[XRANGEPLAINLOOSE] = '[v=\\s]*(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:' + src[PRERELEASELOOSE] + ')?' +
                        src[BUILD] + '?' +
                        ')?)?';

var XRANGE = R++;
src[XRANGE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAIN] + '$';
var XRANGELOOSE = R++;
src[XRANGELOOSE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAINLOOSE] + '$';

// Tilde ranges.
// Meaning is "reasonably at or greater than"
var LONETILDE = R++;
src[LONETILDE] = '(?:~>?)';

var TILDETRIM = R++;
src[TILDETRIM] = '(\\s*)' + src[LONETILDE] + '\\s+';
re[TILDETRIM] = new RegExp(src[TILDETRIM], 'g');
var tildeTrimReplace = '$1~';

var TILDE = R++;
src[TILDE] = '^' + src[LONETILDE] + src[XRANGEPLAIN] + '$';
var TILDELOOSE = R++;
src[TILDELOOSE] = '^' + src[LONETILDE] + src[XRANGEPLAINLOOSE] + '$';

// Caret ranges.
// Meaning is "at least and backwards compatible with"
var LONECARET = R++;
src[LONECARET] = '(?:\\^)';

var CARETTRIM = R++;
src[CARETTRIM] = '(\\s*)' + src[LONECARET] + '\\s+';
re[CARETTRIM] = new RegExp(src[CARETTRIM], 'g');
var caretTrimReplace = '$1^';

var CARET = R++;
src[CARET] = '^' + src[LONECARET] + src[XRANGEPLAIN] + '$';
var CARETLOOSE = R++;
src[CARETLOOSE] = '^' + src[LONECARET] + src[XRANGEPLAINLOOSE] + '$';

// A simple gt/lt/eq thing, or just "" to indicate "any version"
var COMPARATORLOOSE = R++;
src[COMPARATORLOOSE] = '^' + src[GTLT] + '\\s*(' + LOOSEPLAIN + ')$|^$';
var COMPARATOR = R++;
src[COMPARATOR] = '^' + src[GTLT] + '\\s*(' + FULLPLAIN + ')$|^$';


// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
var COMPARATORTRIM = R++;
src[COMPARATORTRIM] = '(\\s*)' + src[GTLT] +
                      '\\s*(' + LOOSEPLAIN + '|' + src[XRANGEPLAIN] + ')';

// this one has to use the /g flag
re[COMPARATORTRIM] = new RegExp(src[COMPARATORTRIM], 'g');
var comparatorTrimReplace = '$1$2$3';


// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
var HYPHENRANGE = R++;
src[HYPHENRANGE] = '^\\s*(' + src[XRANGEPLAIN] + ')' +
                   '\\s+-\\s+' +
                   '(' + src[XRANGEPLAIN] + ')' +
                   '\\s*$';

var HYPHENRANGELOOSE = R++;
src[HYPHENRANGELOOSE] = '^\\s*(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s+-\\s+' +
                        '(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s*$';

// Star ranges basically just allow anything at all.
var STAR = R++;
src[STAR] = '(<|>)?=?\\s*\\*';

// Compile to actual regexp objects.
// All are flag-free, unless they were created above with a flag.
for (var i = 0; i < R; i++) {
  debug(i, src[i]);
  if (!re[i])
    re[i] = new RegExp(src[i]);
}

exports.parse = parse;
function parse(version, loose) {
  if (version instanceof SemVer)
    return version;

  if (typeof version !== 'string')
    return null;

  if (version.length > MAX_LENGTH)
    return null;

  var r = loose ? re[LOOSE] : re[FULL];
  if (!r.test(version))
    return null;

  try {
    return new SemVer(version, loose);
  } catch (er) {
    return null;
  }
}

exports.valid = valid;
function valid(version, loose) {
  var v = parse(version, loose);
  return v ? v.version : null;
}


exports.clean = clean;
function clean(version, loose) {
  var s = parse(version.trim().replace(/^[=v]+/, ''), loose);
  return s ? s.version : null;
}

exports.SemVer = SemVer;

function SemVer(version, loose) {
  if (version instanceof SemVer) {
    if (version.loose === loose)
      return version;
    else
      version = version.version;
  } else if (typeof version !== 'string') {
    throw new TypeError('Invalid Version: ' + version);
  }

  if (version.length > MAX_LENGTH)
    throw new TypeError('version is longer than ' + MAX_LENGTH + ' characters')

  if (!(this instanceof SemVer))
    return new SemVer(version, loose);

  debug('SemVer', version, loose);
  this.loose = loose;
  var m = version.trim().match(loose ? re[LOOSE] : re[FULL]);

  if (!m)
    throw new TypeError('Invalid Version: ' + version);

  this.raw = version;

  // these are actually numbers
  this.major = +m[1];
  this.minor = +m[2];
  this.patch = +m[3];

  if (this.major > MAX_SAFE_INTEGER || this.major < 0)
    throw new TypeError('Invalid major version')

  if (this.minor > MAX_SAFE_INTEGER || this.minor < 0)
    throw new TypeError('Invalid minor version')

  if (this.patch > MAX_SAFE_INTEGER || this.patch < 0)
    throw new TypeError('Invalid patch version')

  // numberify any prerelease numeric ids
  if (!m[4])
    this.prerelease = [];
  else
    this.prerelease = m[4].split('.').map(function(id) {
      if (/^[0-9]+$/.test(id)) {
        var num = +id;
        if (num >= 0 && num < MAX_SAFE_INTEGER)
          return num;
      }
      return id;
    });

  this.build = m[5] ? m[5].split('.') : [];
  this.format();
}

SemVer.prototype.format = function() {
  this.version = this.major + '.' + this.minor + '.' + this.patch;
  if (this.prerelease.length)
    this.version += '-' + this.prerelease.join('.');
  return this.version;
};

SemVer.prototype.toString = function() {
  return this.version;
};

SemVer.prototype.compare = function(other) {
  debug('SemVer.compare', this.version, this.loose, other);
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return this.compareMain(other) || this.comparePre(other);
};

SemVer.prototype.compareMain = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return compareIdentifiers(this.major, other.major) ||
         compareIdentifiers(this.minor, other.minor) ||
         compareIdentifiers(this.patch, other.patch);
};

SemVer.prototype.comparePre = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  // NOT having a prerelease is > having one
  if (this.prerelease.length && !other.prerelease.length)
    return -1;
  else if (!this.prerelease.length && other.prerelease.length)
    return 1;
  else if (!this.prerelease.length && !other.prerelease.length)
    return 0;

  var i = 0;
  do {
    var a = this.prerelease[i];
    var b = other.prerelease[i];
    debug('prerelease compare', i, a, b);
    if (a === undefined && b === undefined)
      return 0;
    else if (b === undefined)
      return 1;
    else if (a === undefined)
      return -1;
    else if (a === b)
      continue;
    else
      return compareIdentifiers(a, b);
  } while (++i);
};

// preminor will bump the version up to the next minor release, and immediately
// down to pre-release. premajor and prepatch work the same way.
SemVer.prototype.inc = function(release, identifier) {
  switch (release) {
    case 'premajor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor = 0;
      this.major++;
      this.inc('pre', identifier);
      break;
    case 'preminor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor++;
      this.inc('pre', identifier);
      break;
    case 'prepatch':
      // If this is already a prerelease, it will bump to the next version
      // drop any prereleases that might already exist, since they are not
      // relevant at this point.
      this.prerelease.length = 0;
      this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;
    // If the input is a non-prerelease version, this acts the same as
    // prepatch.
    case 'prerelease':
      if (this.prerelease.length === 0)
        this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;

    case 'major':
      // If this is a pre-major version, bump up to the same major version.
      // Otherwise increment major.
      // 1.0.0-5 bumps to 1.0.0
      // 1.1.0 bumps to 2.0.0
      if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0)
        this.major++;
      this.minor = 0;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'minor':
      // If this is a pre-minor version, bump up to the same minor version.
      // Otherwise increment minor.
      // 1.2.0-5 bumps to 1.2.0
      // 1.2.1 bumps to 1.3.0
      if (this.patch !== 0 || this.prerelease.length === 0)
        this.minor++;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'patch':
      // If this is not a pre-release version, it will increment the patch.
      // If it is a pre-release it will bump up to the same patch version.
      // 1.2.0-5 patches to 1.2.0
      // 1.2.0 patches to 1.2.1
      if (this.prerelease.length === 0)
        this.patch++;
      this.prerelease = [];
      break;
    // This probably shouldn't be used publicly.
    // 1.0.0 "pre" would become 1.0.0-0 which is the wrong direction.
    case 'pre':
      if (this.prerelease.length === 0)
        this.prerelease = [0];
      else {
        var i = this.prerelease.length;
        while (--i >= 0) {
          if (typeof this.prerelease[i] === 'number') {
            this.prerelease[i]++;
            i = -2;
          }
        }
        if (i === -1) // didn't increment anything
          this.prerelease.push(0);
      }
      if (identifier) {
        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
        if (this.prerelease[0] === identifier) {
          if (isNaN(this.prerelease[1]))
            this.prerelease = [identifier, 0];
        } else
          this.prerelease = [identifier, 0];
      }
      break;

    default:
      throw new Error('invalid increment argument: ' + release);
  }
  this.format();
  this.raw = this.version;
  return this;
};

exports.inc = inc;
function inc(version, release, loose, identifier) {
  if (typeof(loose) === 'string') {
    identifier = loose;
    loose = undefined;
  }

  try {
    return new SemVer(version, loose).inc(release, identifier).version;
  } catch (er) {
    return null;
  }
}

exports.diff = diff;
function diff(version1, version2) {
  if (eq(version1, version2)) {
    return null;
  } else {
    var v1 = parse(version1);
    var v2 = parse(version2);
    if (v1.prerelease.length || v2.prerelease.length) {
      for (var key in v1) {
        if (key === 'major' || key === 'minor' || key === 'patch') {
          if (v1[key] !== v2[key]) {
            return 'pre'+key;
          }
        }
      }
      return 'prerelease';
    }
    for (var key in v1) {
      if (key === 'major' || key === 'minor' || key === 'patch') {
        if (v1[key] !== v2[key]) {
          return key;
        }
      }
    }
  }
}

exports.compareIdentifiers = compareIdentifiers;

var numeric = /^[0-9]+$/;
function compareIdentifiers(a, b) {
  var anum = numeric.test(a);
  var bnum = numeric.test(b);

  if (anum && bnum) {
    a = +a;
    b = +b;
  }

  return (anum && !bnum) ? -1 :
         (bnum && !anum) ? 1 :
         a < b ? -1 :
         a > b ? 1 :
         0;
}

exports.rcompareIdentifiers = rcompareIdentifiers;
function rcompareIdentifiers(a, b) {
  return compareIdentifiers(b, a);
}

exports.major = major;
function major(a, loose) {
  return new SemVer(a, loose).major;
}

exports.minor = minor;
function minor(a, loose) {
  return new SemVer(a, loose).minor;
}

exports.patch = patch;
function patch(a, loose) {
  return new SemVer(a, loose).patch;
}

exports.compare = compare;
function compare(a, b, loose) {
  return new SemVer(a, loose).compare(b);
}

exports.compareLoose = compareLoose;
function compareLoose(a, b) {
  return compare(a, b, true);
}

exports.rcompare = rcompare;
function rcompare(a, b, loose) {
  return compare(b, a, loose);
}

exports.sort = sort;
function sort(list, loose) {
  return list.sort(function(a, b) {
    return exports.compare(a, b, loose);
  });
}

exports.rsort = rsort;
function rsort(list, loose) {
  return list.sort(function(a, b) {
    return exports.rcompare(a, b, loose);
  });
}

exports.gt = gt;
function gt(a, b, loose) {
  return compare(a, b, loose) > 0;
}

exports.lt = lt;
function lt(a, b, loose) {
  return compare(a, b, loose) < 0;
}

exports.eq = eq;
function eq(a, b, loose) {
  return compare(a, b, loose) === 0;
}

exports.neq = neq;
function neq(a, b, loose) {
  return compare(a, b, loose) !== 0;
}

exports.gte = gte;
function gte(a, b, loose) {
  return compare(a, b, loose) >= 0;
}

exports.lte = lte;
function lte(a, b, loose) {
  return compare(a, b, loose) <= 0;
}

exports.cmp = cmp;
function cmp(a, op, b, loose) {
  var ret;
  switch (op) {
    case '===':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a === b;
      break;
    case '!==':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a !== b;
      break;
    case '': case '=': case '==': ret = eq(a, b, loose); break;
    case '!=': ret = neq(a, b, loose); break;
    case '>': ret = gt(a, b, loose); break;
    case '>=': ret = gte(a, b, loose); break;
    case '<': ret = lt(a, b, loose); break;
    case '<=': ret = lte(a, b, loose); break;
    default: throw new TypeError('Invalid operator: ' + op);
  }
  return ret;
}

exports.Comparator = Comparator;
function Comparator(comp, loose) {
  if (comp instanceof Comparator) {
    if (comp.loose === loose)
      return comp;
    else
      comp = comp.value;
  }

  if (!(this instanceof Comparator))
    return new Comparator(comp, loose);

  debug('comparator', comp, loose);
  this.loose = loose;
  this.parse(comp);

  if (this.semver === ANY)
    this.value = '';
  else
    this.value = this.operator + this.semver.version;

  debug('comp', this);
}

var ANY = {};
Comparator.prototype.parse = function(comp) {
  var r = this.loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var m = comp.match(r);

  if (!m)
    throw new TypeError('Invalid comparator: ' + comp);

  this.operator = m[1];
  if (this.operator === '=')
    this.operator = '';

  // if it literally is just '>' or '' then allow anything.
  if (!m[2])
    this.semver = ANY;
  else
    this.semver = new SemVer(m[2], this.loose);
};

Comparator.prototype.toString = function() {
  return this.value;
};

Comparator.prototype.test = function(version) {
  debug('Comparator.test', version, this.loose);

  if (this.semver === ANY)
    return true;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  return cmp(version, this.operator, this.semver, this.loose);
};


exports.Range = Range;
function Range(range, loose) {
  if ((range instanceof Range) && range.loose === loose)
    return range;

  if (!(this instanceof Range))
    return new Range(range, loose);

  this.loose = loose;

  // First, split based on boolean or ||
  this.raw = range;
  this.set = range.split(/\s*\|\|\s*/).map(function(range) {
    return this.parseRange(range.trim());
  }, this).filter(function(c) {
    // throw out any that are not relevant for whatever reason
    return c.length;
  });

  if (!this.set.length) {
    throw new TypeError('Invalid SemVer Range: ' + range);
  }

  this.format();
}

Range.prototype.format = function() {
  this.range = this.set.map(function(comps) {
    return comps.join(' ').trim();
  }).join('||').trim();
  return this.range;
};

Range.prototype.toString = function() {
  return this.range;
};

Range.prototype.parseRange = function(range) {
  var loose = this.loose;
  range = range.trim();
  debug('range', range, loose);
  // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
  var hr = loose ? re[HYPHENRANGELOOSE] : re[HYPHENRANGE];
  range = range.replace(hr, hyphenReplace);
  debug('hyphen replace', range);
  // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
  range = range.replace(re[COMPARATORTRIM], comparatorTrimReplace);
  debug('comparator trim', range, re[COMPARATORTRIM]);

  // `~ 1.2.3` => `~1.2.3`
  range = range.replace(re[TILDETRIM], tildeTrimReplace);

  // `^ 1.2.3` => `^1.2.3`
  range = range.replace(re[CARETTRIM], caretTrimReplace);

  // normalize spaces
  range = range.split(/\s+/).join(' ');

  // At this point, the range is completely trimmed and
  // ready to be split into comparators.

  var compRe = loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var set = range.split(' ').map(function(comp) {
    return parseComparator(comp, loose);
  }).join(' ').split(/\s+/);
  if (this.loose) {
    // in loose mode, throw out any that are not valid comparators
    set = set.filter(function(comp) {
      return !!comp.match(compRe);
    });
  }
  set = set.map(function(comp) {
    return new Comparator(comp, loose);
  });

  return set;
};

// Mostly just for testing and legacy API reasons
exports.toComparators = toComparators;
function toComparators(range, loose) {
  return new Range(range, loose).set.map(function(comp) {
    return comp.map(function(c) {
      return c.value;
    }).join(' ').trim().split(' ');
  });
}

// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
function parseComparator(comp, loose) {
  debug('comp', comp);
  comp = replaceCarets(comp, loose);
  debug('caret', comp);
  comp = replaceTildes(comp, loose);
  debug('tildes', comp);
  comp = replaceXRanges(comp, loose);
  debug('xrange', comp);
  comp = replaceStars(comp, loose);
  debug('stars', comp);
  return comp;
}

function isX(id) {
  return !id || id.toLowerCase() === 'x' || id === '*';
}

// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0
function replaceTildes(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceTilde(comp, loose);
  }).join(' ');
}

function replaceTilde(comp, loose) {
  var r = loose ? re[TILDELOOSE] : re[TILDE];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('tilde', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p))
      // ~1.2 == >=1.2.0 <1.3.0
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    else if (pr) {
      debug('replaceTilde pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      ret = '>=' + M + '.' + m + '.' + p + pr +
            ' <' + M + '.' + (+m + 1) + '.0';
    } else
      // ~1.2.3 == >=1.2.3 <1.3.0
      ret = '>=' + M + '.' + m + '.' + p +
            ' <' + M + '.' + (+m + 1) + '.0';

    debug('tilde return', ret);
    return ret;
  });
}

// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0
// ^1.2.3 --> >=1.2.3 <2.0.0
// ^1.2.0 --> >=1.2.0 <2.0.0
function replaceCarets(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceCaret(comp, loose);
  }).join(' ');
}

function replaceCaret(comp, loose) {
  debug('caret', comp, loose);
  var r = loose ? re[CARETLOOSE] : re[CARET];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('caret', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p)) {
      if (M === '0')
        ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
      else
        ret = '>=' + M + '.' + m + '.0 <' + (+M + 1) + '.0.0';
    } else if (pr) {
      debug('replaceCaret pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p + pr +
              ' <' + (+M + 1) + '.0.0';
    } else {
      debug('no pr');
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p +
              ' <' + (+M + 1) + '.0.0';
    }

    debug('caret return', ret);
    return ret;
  });
}

function replaceXRanges(comp, loose) {
  debug('replaceXRanges', comp, loose);
  return comp.split(/\s+/).map(function(comp) {
    return replaceXRange(comp, loose);
  }).join(' ');
}

function replaceXRange(comp, loose) {
  comp = comp.trim();
  var r = loose ? re[XRANGELOOSE] : re[XRANGE];
  return comp.replace(r, function(ret, gtlt, M, m, p, pr) {
    debug('xRange', comp, ret, gtlt, M, m, p, pr);
    var xM = isX(M);
    var xm = xM || isX(m);
    var xp = xm || isX(p);
    var anyX = xp;

    if (gtlt === '=' && anyX)
      gtlt = '';

    if (xM) {
      if (gtlt === '>' || gtlt === '<') {
        // nothing is allowed
        ret = '<0.0.0';
      } else {
        // nothing is forbidden
        ret = '*';
      }
    } else if (gtlt && anyX) {
      // replace X with 0
      if (xm)
        m = 0;
      if (xp)
        p = 0;

      if (gtlt === '>') {
        // >1 => >=2.0.0
        // >1.2 => >=1.3.0
        // >1.2.3 => >= 1.2.4
        gtlt = '>=';
        if (xm) {
          M = +M + 1;
          m = 0;
          p = 0;
        } else if (xp) {
          m = +m + 1;
          p = 0;
        }
      } else if (gtlt === '<=') {
        // <=0.7.x is actually <0.8.0, since any 0.7.x should
        // pass.  Similarly, <=7.x is actually <8.0.0, etc.
        gtlt = '<';
        if (xm)
          M = +M + 1;
        else
          m = +m + 1;
      }

      ret = gtlt + M + '.' + m + '.' + p;
    } else if (xm) {
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    } else if (xp) {
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    }

    debug('xRange return', ret);

    return ret;
  });
}

// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
function replaceStars(comp, loose) {
  debug('replaceStars', comp, loose);
  // Looseness is ignored here.  star is always as loose as it gets!
  return comp.trim().replace(re[STAR], '');
}

// This function is passed to string.replace(re[HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0
function hyphenReplace($0,
                       from, fM, fm, fp, fpr, fb,
                       to, tM, tm, tp, tpr, tb) {

  if (isX(fM))
    from = '';
  else if (isX(fm))
    from = '>=' + fM + '.0.0';
  else if (isX(fp))
    from = '>=' + fM + '.' + fm + '.0';
  else
    from = '>=' + from;

  if (isX(tM))
    to = '';
  else if (isX(tm))
    to = '<' + (+tM + 1) + '.0.0';
  else if (isX(tp))
    to = '<' + tM + '.' + (+tm + 1) + '.0';
  else if (tpr)
    to = '<=' + tM + '.' + tm + '.' + tp + '-' + tpr;
  else
    to = '<=' + to;

  return (from + ' ' + to).trim();
}


// if ANY of the sets match ALL of its comparators, then pass
Range.prototype.test = function(version) {
  if (!version)
    return false;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  for (var i = 0; i < this.set.length; i++) {
    if (testSet(this.set[i], version))
      return true;
  }
  return false;
};

function testSet(set, version) {
  for (var i = 0; i < set.length; i++) {
    if (!set[i].test(version))
      return false;
  }

  if (version.prerelease.length) {
    // Find the set of versions that are allowed to have prereleases
    // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
    // That should allow `1.2.3-pr.2` to pass.
    // However, `1.2.4-alpha.notready` should NOT be allowed,
    // even though it's within the range set by the comparators.
    for (var i = 0; i < set.length; i++) {
      debug(set[i].semver);
      if (set[i].semver === ANY)
        continue;

      if (set[i].semver.prerelease.length > 0) {
        var allowed = set[i].semver;
        if (allowed.major === version.major &&
            allowed.minor === version.minor &&
            allowed.patch === version.patch)
          return true;
      }
    }

    // Version has a -pre, but it's not one of the ones we like.
    return false;
  }

  return true;
}

exports.satisfies = satisfies;
function satisfies(version, range, loose) {
  try {
    range = new Range(range, loose);
  } catch (er) {
    return false;
  }
  return range.test(version);
}

exports.maxSatisfying = maxSatisfying;
function maxSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return rcompare(a, b, loose);
  })[0] || null;
}

exports.minSatisfying = minSatisfying;
function minSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return compare(a, b, loose);
  })[0] || null;
}

exports.validRange = validRange;
function validRange(range, loose) {
  try {
    // Return '*' instead of '' so that truthiness works.
    // This will throw if it's invalid anyway
    return new Range(range, loose).range || '*';
  } catch (er) {
    return null;
  }
}

// Determine if version is less than all the versions possible in the range
exports.ltr = ltr;
function ltr(version, range, loose) {
  return outside(version, range, '<', loose);
}

// Determine if version is greater than all the versions possible in the range.
exports.gtr = gtr;
function gtr(version, range, loose) {
  return outside(version, range, '>', loose);
}

exports.outside = outside;
function outside(version, range, hilo, loose) {
  version = new SemVer(version, loose);
  range = new Range(range, loose);

  var gtfn, ltefn, ltfn, comp, ecomp;
  switch (hilo) {
    case '>':
      gtfn = gt;
      ltefn = lte;
      ltfn = lt;
      comp = '>';
      ecomp = '>=';
      break;
    case '<':
      gtfn = lt;
      ltefn = gte;
      ltfn = gt;
      comp = '<';
      ecomp = '<=';
      break;
    default:
      throw new TypeError('Must provide a hilo val of "<" or ">"');
  }

  // If it satisifes the range it is not outside
  if (satisfies(version, range, loose)) {
    return false;
  }

  // From now on, variable terms are as if we're in "gtr" mode.
  // but note that everything is flipped for the "ltr" function.

  for (var i = 0; i < range.set.length; ++i) {
    var comparators = range.set[i];

    var high = null;
    var low = null;

    comparators.forEach(function(comparator) {
      if (comparator.semver === ANY) {
        comparator = new Comparator('>=0.0.0')
      }
      high = high || comparator;
      low = low || comparator;
      if (gtfn(comparator.semver, high.semver, loose)) {
        high = comparator;
      } else if (ltfn(comparator.semver, low.semver, loose)) {
        low = comparator;
      }
    });

    // If the edge version comparator has a operator then our version
    // isn't outside it
    if (high.operator === comp || high.operator === ecomp) {
      return false;
    }

    // If the lowest version comparator has an operator and our version
    // is less than it then it isn't higher than the range
    if ((!low.operator || low.operator === comp) &&
        ltefn(version, low.semver)) {
      return false;
    } else if (low.operator === ecomp && ltfn(version, low.semver)) {
      return false;
    }
  }
  return true;
}

exports.prerelease = prerelease;
function prerelease(version, loose) {
  var parsed = parse(version, loose);
  return (parsed && parsed.prerelease.length) ? parsed.prerelease : null;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(133)))

/***/ }),
/* 133 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ })
/******/ ]);
});
//# sourceMappingURL=vuetify.js.map

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define("VueShortkey",[],t):"object"==typeof exports?exports.VueShortkey=t():e.VueShortkey=t()}("undefined"!=typeof self?self:this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="../dist/",t(t.s=0)}([function(e,t,n){"use strict";(function(r){function o(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}var c;n(2),n(3);var u={},i={},a=[],l=[],s=!1,f=function(e){return e="string"==typeof e?JSON.parse(e.replace(/\'/gi,'"')):e,e instanceof Array?{"":e}:e},p=function(e,t,n,r){var o=!0===n.modifiers.push,c=!0===n.modifiers.avoid,u=!0==!n.modifiers.focus,i=!0===n.modifiers.once;c?(a=a.filter(function(e){return!e===t}),a.push(t)):v({b:e,push:o,once:i,focus:u,el:r.elm})},y=function(e,t){for(var n in e){var r=u.encodeKey(e[n]),o=i[r].el.indexOf(t);i[r].el.length>1&&o>-1?i[r].el.splice(o,1):delete i[r]}};u.install=function(e,t){l=[].concat(o(t&&t.prevent?t.prevent:[])),e.directive("shortkey",{bind:function(e,t,n){var r=f(t.value);p(r,e,t,n)},update:function(e,t,n){var r=f(t.oldValue);y(r,e);var o=f(t.value);p(o,e,t,n)},unbind:function(e,t){var n=f(t.value);y(n,e)}})},u.decodeKey=function(e){return d(e)},u.encodeKey=function(e){var t={};t.shiftKey=e.includes("shift"),t.ctrlKey=e.includes("ctrl"),t.metaKey=e.includes("meta"),t.altKey=e.includes("alt");var n=d(t);return n+=e.filter(function(e){return!["shift","ctrl","meta","alt"].includes(e)}).join("")};var d=function(e){var t="";return("Shift"===e.key||e.shiftKey)&&(t+="shift"),("Control"===e.key||e.ctrlKey)&&(t+="ctrl"),("Meta"===e.key||e.metaKey)&&(t+="meta"),("Alt"===e.key||e.altKey)&&(t+="alt"),"ArrowUp"===e.key&&(t+="arrowup"),"ArrowLeft"===e.key&&(t+="arrowleft"),"ArrowRight"===e.key&&(t+="arrowright"),"ArrowDown"===e.key&&(t+="arrowdown"),"AltGraph"===e.key&&(t+="altgraph"),"Escape"===e.key&&(t+="esc"),"Enter"===e.key&&(t+="enter"),"Tab"===e.key&&(t+="tab")," "===e.key&&(t+="space"),"PageUp"===e.key&&(t+="pageup"),"PageDown"===e.key&&(t+="pagedown"),"Home"===e.key&&(t+="home"),"End"===e.key&&(t+="end"),"Delete"===e.key&&(t+="del"),"Backspace"===e.key&&(t+="backspace"),"Insert"===e.key&&(t+="insert"),"NumLock"===e.key&&(t+="numlock"),"CapsLock"===e.key&&(t+="capslock"),"Pause"===e.key&&(t+="pause"),"ContextMenu"===e.key&&(t+="contextmenu"),"ScrollLock"===e.key&&(t+="scrolllock"),"BrowserHome"===e.key&&(t+="browserhome"),"MediaSelect"===e.key&&(t+="mediaselect"),(e.key&&" "!==e.key&&1===e.key.length||/F\d{1,2}|\//g.test(e.key))&&(t+=e.key.toLowerCase()),t},h=function(e){var t=new CustomEvent("shortkey",{bubbles:!1});i[e].key&&(t.srcKey=i[e].key);var n=i[e].el;n[n.length-1].dispatchEvent(t)};u.keyDown=function(e){(!i[e].once&&!i[e].push||i[e].push&&!s)&&h(e)},r&&Object({NODE_ENV:"production"})&&function(){document.addEventListener("keydown",function(e){var t=u.decodeKey(e);if(m(t))if(e.preventDefault(),e.stopPropagation(),i[t].focus)u.keyDown(t),s=!0;else if(!s){var n=i[t].el;n[n.length-1].focus(),s=!0}},!0),document.addEventListener("keyup",function(e){var t=u.decodeKey(e);m(t)&&(e.preventDefault(),e.stopPropagation(),(i[t].once||i[t].push)&&h(t)),s=!1},!0)}();var v=function(e){var t=e.b,n=e.push,r=e.once,o=e.focus,c=e.el;for(var a in t){var l=u.encodeKey(t[a]),s=i[l]&&i[l].el?i[l].el:[];s.push(c),i[l]={push:n,once:r,focus:o,key:a,el:s}}},m=function(e){var t=!!a.find(function(e){return e===document.activeElement}),n=!!l.find(function(e){return document.activeElement&&document.activeElement.matches(e)});return!!i[e]&&!(t||n)};void 0!==e&&e.exports?e.exports=u:void 0!==(c=function(){return u}.call(t,n,t,e))&&(e.exports=c)}).call(t,n(1))},function(e,t){function n(){throw new Error("setTimeout has not been defined")}function r(){throw new Error("clearTimeout has not been defined")}function o(e){if(s===setTimeout)return setTimeout(e,0);if((s===n||!s)&&setTimeout)return s=setTimeout,setTimeout(e,0);try{return s(e,0)}catch(t){try{return s.call(null,e,0)}catch(t){return s.call(this,e,0)}}}function c(e){if(f===clearTimeout)return clearTimeout(e);if((f===r||!f)&&clearTimeout)return f=clearTimeout,clearTimeout(e);try{return f(e)}catch(t){try{return f.call(null,e)}catch(t){return f.call(this,e)}}}function u(){h&&y&&(h=!1,y.length?d=y.concat(d):v=-1,d.length&&i())}function i(){if(!h){var e=o(u);h=!0;for(var t=d.length;t;){for(y=d,d=[];++v<t;)y&&y[v].run();v=-1,t=d.length}y=null,h=!1,c(e)}}function a(e,t){this.fun=e,this.array=t}function l(){}var s,f,p=e.exports={};!function(){try{s="function"==typeof setTimeout?setTimeout:n}catch(e){s=n}try{f="function"==typeof clearTimeout?clearTimeout:r}catch(e){f=r}}();var y,d=[],h=!1,v=-1;p.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];d.push(new a(e,t)),1!==d.length||h||o(i)},a.prototype.run=function(){this.fun.apply(null,this.array)},p.title="browser",p.browser=!0,p.env={},p.argv=[],p.version="",p.versions={},p.on=l,p.addListener=l,p.once=l,p.off=l,p.removeListener=l,p.removeAllListeners=l,p.emit=l,p.prependListener=l,p.prependOnceListener=l,p.listeners=function(e){return[]},p.binding=function(e){throw new Error("process.binding is not supported")},p.cwd=function(){return"/"},p.chdir=function(e){throw new Error("process.chdir is not supported")},p.umask=function(){return 0}},function(e,t){Element.prototype.matches||(Element.prototype.matches=Element.prototype.matchesSelector||Element.prototype.msMatchesSelector||Element.prototype.webkitMatchesSelector)},function(e,t){!function(){if("undefined"!=typeof window)try{var e=new window.CustomEvent("test",{cancelable:!0});if(e.preventDefault(),!0!==e.defaultPrevented)throw new Error("Could not prevent default")}catch(e){var t=function(e,t){var n,r;return t=t||{},t.bubbles=!!t.bubbles,t.cancelable=!!t.cancelable,n=document.createEvent("CustomEvent"),n.initCustomEvent(e,t.bubbles,t.cancelable,t.detail),r=n.preventDefault,n.preventDefault=function(){r.call(this);try{Object.defineProperty(this,"defaultPrevented",{get:function(){return!0}})}catch(e){this.defaultPrevented=!0}},n};t.prototype=window.Event.prototype,window.CustomEvent=t}}()}])});
//# sourceMappingURL=index.js.map

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(__webpack_require__(115)) :
  typeof define === 'function' && define.amd ? define(['hammerjs'], factory) :
  (factory(global.Hammer));
}(this, (function (Hammer) { 'use strict';

Hammer = 'default' in Hammer ? Hammer['default'] : Hammer;

function assign(target) {
  var sources = [], len = arguments.length - 1;
  while ( len-- > 0 ) sources[ len ] = arguments[ len + 1 ];
  for (var i = 0; i < sources.length; i++) {
    var source = sources[i];
    var keys = Object.keys(source);
    for (var i$1 = 0; i$1 < keys.length; i$1++) {
      var key = keys[i$1];
      target[key] = source[key];
    }
  }
  return target
}
function createProp() {
  return {
    type: Object,
    default: function() { return {} }
  }
}
function capitalize (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}
var directions = ['up', 'down', 'left', 'right', 'horizontal', 'vertical', 'all'];
function guardDirections (options) {
  var dir = options.direction;
  if (typeof dir === 'string') {
    var hammerDirection = 'DIRECTION_' + dir.toUpperCase();
    if (directions.indexOf(dir) > -1 && Hammer.hasOwnProperty(hammerDirection)) {
      options.direction = Hammer[hammerDirection];
    } else {
      console.warn('[vue-touch] invalid direction: ' + dir);
    }
  }
  return options
}
var config = {
};
var customEvents = {
};
var gestures = [
  'pan','panstart','panmove','panend','pancancel','panleft','panright','panup','pandown',
  'pinch','pinchstart','pinchmove','pinchend','pinchcancel','pinchin','pinchout',
  'press','pressup',
  'rotate','rotatestart','rotatemove','rotateend','rotatecancel',
  'swipe','swipeleft','swiperight','swipeup','swipedown',
  'tap'
];
var gestureMap = {
  pan: 'pan',
  panstart: 'pan',
  panmove: 'pan',
  panend: 'pan',
  pancancel: 'pan',
  panleft: 'pan',
  panright: 'pan',
  panup: 'pan',
  pandown: 'pan',
  pinch: 'pinch',
  pinchstart: 'pinch',
  pinchmove: 'pinch',
  pinchend: 'pinch',
  pinchcancel: 'pinch',
  pinchin: 'pinch',
  pinchout: 'pinch',
  press: 'press',
  pressup: 'press',
  rotate: 'rotate',
  rotatestart: 'rotate',
  rotatemove: 'rotate',
  rotateend: 'rotate',
  rotatecancel: 'rotate',
  swipe: 'swipe',
  swipeleft: 'swipe',
  swiperight: 'swipe',
  swipeup: 'swipe',
  swipedown: 'swipe',
  tap: 'tap'
};

var Component = {
  props: {
    options: createProp(),
    tapOptions: createProp(),
    panOptions: createProp(),
    pinchOptions: createProp(),
    pressOptions: createProp(),
    rotateOptions: createProp(),
    swipeOptions: createProp(),
    tag: { type: String, default: 'div' },
    enabled: {
      default: true,
      type: [Boolean, Object],
    }
  },
  mounted: function mounted() {
    if (!this.$isServer) {
      this.hammer = new Hammer.Manager(this.$el, this.options);
      this.recognizers = {};
      this.setupBuiltinRecognizers();
      this.setupCustomRecognizers();
      this.updateEnabled(this.enabled);
    }
  },
  destroyed: function destroyed() {
    if (!this.$isServer) {
      this.hammer.destroy();
    }
  },
  watch: {
    enabled: {
      deep: true,
      handler: function handler() {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];
        (ref = this).updateEnabled.apply(ref, args);
        var ref;
      }
    }
  },
  methods: {
    setupBuiltinRecognizers: function setupBuiltinRecognizers()  {
      var this$1 = this;
      for (var i = 0; i < gestures.length; i++) {
        var gesture = gestures[i];
        if (this$1._events[gesture]) {
          var mainGesture = gestureMap[gesture];
          var options = assign({}, (config[mainGesture] || {}), this$1[(mainGesture + "Options")]);
          this$1.addRecognizer(mainGesture, options);
          this$1.addEvent(gesture);
        }
      }
    },
    setupCustomRecognizers: function setupCustomRecognizers() {
      var this$1 = this;
      var gestures$$1 = Object.keys(customEvents);
      for (var i = 0; i < gestures$$1.length; i++) {
        var gesture = gestures$$1[i];
        if (this$1._events[gesture]) {
          var opts = customEvents[gesture];
          var localCustomOpts = this$1[(gesture + "Options")] || {};
          var options = assign({}, opts, localCustomOpts);
          this$1.addRecognizer(gesture, options, {mainGesture: options.type});
          this$1.addEvent(gesture);
        }
      }
    },
    addRecognizer: function addRecognizer(gesture, options, ref) {
      if ( ref === void 0 ) ref = {};
      var mainGesture = ref.mainGesture;
      if (!this.recognizers[gesture]) {
        var recognizer = new Hammer[capitalize(mainGesture || gesture)](guardDirections(options));
        this.recognizers[gesture] = recognizer;
        this.hammer.add(recognizer);
        recognizer.recognizeWith(this.hammer.recognizers);
      }
    },
    addEvent: function addEvent(gesture) {
      var this$1 = this;
      this.hammer.on(gesture, function (e) { return this$1.$emit(gesture, e); });
    },
    updateEnabled: function updateEnabled(newVal, oldVal) {
      var this$1 = this;
      if (newVal === true) {
        this.enableAll();
      } else if (newVal === false) {
        this.disableAll();
      } else if (typeof newVal === 'object') {
        var keys = Object.keys(newVal);
        for (var i = 0; i < keys.length; i++) {
          var event = keys[i];
          if (this$1.recognizers[event]) {
            newVal[event]
              ? this$1.enable(event)
              : this$1.disable(event);
          }
        }
      }
    },
    enable: function enable(r) {
      var recognizer = this.recognizers[r];
      if (!recognizer.options.enable) {
        recognizer.set({ enable: true });
      }
    },
    disable: function disable(r) {
      var recognizer = this.recognizers[r];
      if (recognizer.options.enable) {
        recognizer.set({ enable: false });
      }
    },
    toggle: function toggle(r) {
      var recognizer = this.recognizers[r];
      if (recognizer) {
        recognizer.options.enable
          ? this.disable(r)
          : this.enable(r);
      }
    },
    enableAll: function enableAll(r) {
      this.toggleAll({ enable: true });
    },
    disableAll: function disableAll(r) {
      this.toggleAll({ enable: false });
    },
    toggleAll: function toggleAll(ref) {
      var this$1 = this;
      var enable = ref.enable;
      var keys = Object.keys(this.recognizers);
      for (var i = 0; i < keys.length; i++) {
        var r = this$1.recognizers[keys[i]];
        if (r.options.enable !== enable) {
          r.set({ enable: enable });
        }
      }
    },
    isEnabled: function isEnabled(r) {
      return this.recognizers[r] && this.recognizers[r].options.enable
    }
  },
  render: function render(h) {
    return h(this.tag, {}, this.$slots.default)
  }
};

var installed = false;
var vueTouch = { config: config, customEvents: customEvents };
vueTouch.install = function install(Vue, opts) {
  if ( opts === void 0 ) opts = {};
  var name = opts.name || 'v-touch';
  Vue.component(name, assign(Component, { name: name }));
  installed = true;
}.bind(vueTouch);
vueTouch.registerCustomEvent = function registerCustomEvent(event, options) {
  if ( options === void 0 ) options = {};
  if (installed) {
    console.warn(("\n      [vue-touch]: Custom Event '" + event + "' couldn't be added to vue-touch.\n      Custom Events have to be registered before installing the plugin.\n      "));
    return
  }
  options.event = event;
  customEvents[event] = options;
  Component.props[(event + "Options")] = {
    type: Object,
    default: function default$1() { return {} }
  };
}.bind(vueTouch);
vueTouch.component = Component;
if (true) {
  module.exports = vueTouch;
} else if (typeof define == "function" && define.amd) {
  define([], function(){ return vueTouch });
} else if (typeof window !== 'undefined' && window.Vue) {
  window.VueTouch = vueTouch;
  Vue.use(vueTouch);
}

})));
//# sourceMappingURL=vue-touch.js.map


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(window, document, exportName, undefined) {
  'use strict';

var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
var TEST_ELEMENT = document.createElement('div');

var TYPE_FUNCTION = 'function';

var round = Math.round;
var abs = Math.abs;
var now = Date.now;

/**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */
function setTimeoutContext(fn, timeout, context) {
    return setTimeout(bindFn(fn, context), timeout);
}

/**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */
function invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        each(arg, context[fn], context);
        return true;
    }
    return false;
}

/**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */
function each(obj, iterator, context) {
    var i;

    if (!obj) {
        return;
    }

    if (obj.forEach) {
        obj.forEach(iterator, context);
    } else if (obj.length !== undefined) {
        i = 0;
        while (i < obj.length) {
            iterator.call(context, obj[i], i, obj);
            i++;
        }
    } else {
        for (i in obj) {
            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
        }
    }
}

/**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */
function deprecate(method, name, message) {
    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
    return function() {
        var e = new Error('get-stack-trace');
        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
            .replace(/^\s+at\s+/gm, '')
            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';

        var log = window.console && (window.console.warn || window.console.log);
        if (log) {
            log.call(window.console, deprecationMessage, stack);
        }
        return method.apply(this, arguments);
    };
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */
var assign;
if (typeof Object.assign !== 'function') {
    assign = function assign(target) {
        if (target === undefined || target === null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var output = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for (var nextKey in source) {
                    if (source.hasOwnProperty(nextKey)) {
                        output[nextKey] = source[nextKey];
                    }
                }
            }
        }
        return output;
    };
} else {
    assign = Object.assign;
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */
var extend = deprecate(function extend(dest, src, merge) {
    var keys = Object.keys(src);
    var i = 0;
    while (i < keys.length) {
        if (!merge || (merge && dest[keys[i]] === undefined)) {
            dest[keys[i]] = src[keys[i]];
        }
        i++;
    }
    return dest;
}, 'extend', 'Use `assign`.');

/**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */
var merge = deprecate(function merge(dest, src) {
    return extend(dest, src, true);
}, 'merge', 'Use `assign`.');

/**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */
function inherit(child, base, properties) {
    var baseP = base.prototype,
        childP;

    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;

    if (properties) {
        assign(childP, properties);
    }
}

/**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */
function bindFn(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}

/**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */
function boolOrFn(val, args) {
    if (typeof val == TYPE_FUNCTION) {
        return val.apply(args ? args[0] || undefined : undefined, args);
    }
    return val;
}

/**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */
function ifUndefined(val1, val2) {
    return (val1 === undefined) ? val2 : val1;
}

/**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function addEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.addEventListener(type, handler, false);
    });
}

/**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function removeEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.removeEventListener(type, handler, false);
    });
}

/**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */
function hasParent(node, parent) {
    while (node) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

/**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */
function inStr(str, find) {
    return str.indexOf(find) > -1;
}

/**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */
function splitStr(str) {
    return str.trim().split(/\s+/g);
}

/**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */
function inArray(src, find, findByKey) {
    if (src.indexOf && !findByKey) {
        return src.indexOf(find);
    } else {
        var i = 0;
        while (i < src.length) {
            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
                return i;
            }
            i++;
        }
        return -1;
    }
}

/**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */
function toArray(obj) {
    return Array.prototype.slice.call(obj, 0);
}

/**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */
function uniqueArray(src, key, sort) {
    var results = [];
    var values = [];
    var i = 0;

    while (i < src.length) {
        var val = key ? src[i][key] : src[i];
        if (inArray(values, val) < 0) {
            results.push(src[i]);
        }
        values[i] = val;
        i++;
    }

    if (sort) {
        if (!key) {
            results = results.sort();
        } else {
            results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
    }

    return results;
}

/**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */
function prefixed(obj, property) {
    var prefix, prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);

    var i = 0;
    while (i < VENDOR_PREFIXES.length) {
        prefix = VENDOR_PREFIXES[i];
        prop = (prefix) ? prefix + camelProp : property;

        if (prop in obj) {
            return prop;
        }
        i++;
    }
    return undefined;
}

/**
 * get a unique id
 * @returns {number} uniqueId
 */
var _uniqueId = 1;
function uniqueId() {
    return _uniqueId++;
}

/**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */
function getWindowForElement(element) {
    var doc = element.ownerDocument || element;
    return (doc.defaultView || doc.parentWindow || window);
}

var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;

var SUPPORT_TOUCH = ('ontouchstart' in window);
var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);

var INPUT_TYPE_TOUCH = 'touch';
var INPUT_TYPE_PEN = 'pen';
var INPUT_TYPE_MOUSE = 'mouse';
var INPUT_TYPE_KINECT = 'kinect';

var COMPUTE_INTERVAL = 25;

var INPUT_START = 1;
var INPUT_MOVE = 2;
var INPUT_END = 4;
var INPUT_CANCEL = 8;

var DIRECTION_NONE = 1;
var DIRECTION_LEFT = 2;
var DIRECTION_RIGHT = 4;
var DIRECTION_UP = 8;
var DIRECTION_DOWN = 16;

var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;

var PROPS_XY = ['x', 'y'];
var PROPS_CLIENT_XY = ['clientX', 'clientY'];

/**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */
function Input(manager, callback) {
    var self = this;
    this.manager = manager;
    this.callback = callback;
    this.element = manager.element;
    this.target = manager.options.inputTarget;

    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
    // so when disabled the input events are completely bypassed.
    this.domHandler = function(ev) {
        if (boolOrFn(manager.options.enable, [manager])) {
            self.handler(ev);
        }
    };

    this.init();

}

Input.prototype = {
    /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */
    handler: function() { },

    /**
     * bind the events
     */
    init: function() {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    },

    /**
     * unbind the events
     */
    destroy: function() {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    }
};

/**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */
function createInputInstance(manager) {
    var Type;
    var inputClass = manager.options.inputClass;

    if (inputClass) {
        Type = inputClass;
    } else if (SUPPORT_POINTER_EVENTS) {
        Type = PointerEventInput;
    } else if (SUPPORT_ONLY_TOUCH) {
        Type = TouchInput;
    } else if (!SUPPORT_TOUCH) {
        Type = MouseInput;
    } else {
        Type = TouchMouseInput;
    }
    return new (Type)(manager, inputHandler);
}

/**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */
function inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));

    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;

    if (isFirst) {
        manager.session = {};
    }

    // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType;

    // compute scale, rotation etc
    computeInputData(manager, input);

    // emit secret event
    manager.emit('hammer.input', input);

    manager.recognize(input);
    manager.session.prevInput = input;
}

/**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */
function computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length;

    // store the first input to calculate the distance and direction
    if (!session.firstInput) {
        session.firstInput = simpleCloneInputData(input);
    }

    // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) {
        session.firstMultiple = simpleCloneInputData(input);
    } else if (pointersLength === 1) {
        session.firstMultiple = false;
    }

    var firstInput = session.firstInput;
    var firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;

    var center = input.center = getCenter(pointers);
    input.timeStamp = now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;

    input.angle = getAngle(offsetCenter, center);
    input.distance = getDistance(offsetCenter, center);

    computeDeltaXY(session, input);
    input.offsetDirection = getDirection(input.deltaX, input.deltaY);

    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;

    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;

    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);

    computeIntervalInputData(session, input);

    // find the correct target
    var target = manager.element;
    if (hasParent(input.srcEvent.target, target)) {
        target = input.srcEvent.target;
    }
    input.target = target;
}

function computeDeltaXY(session, input) {
    var center = input.center;
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};

    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };

        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }

    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}

/**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */
function computeIntervalInputData(session, input) {
    var last = session.lastInterval || input,
        deltaTime = input.timeStamp - last.timeStamp,
        velocity, velocityX, velocityY, direction;

    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;

        var v = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
        direction = getDirection(deltaX, deltaY);

        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }

    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}

/**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */
function simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i = 0;
    while (i < input.pointers.length) {
        pointers[i] = {
            clientX: round(input.pointers[i].clientX),
            clientY: round(input.pointers[i].clientY)
        };
        i++;
    }

    return {
        timeStamp: now(),
        pointers: pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}

/**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */
function getCenter(pointers) {
    var pointersLength = pointers.length;

    // no need to loop when only one touch
    if (pointersLength === 1) {
        return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
    }

    var x = 0, y = 0, i = 0;
    while (i < pointersLength) {
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }

    return {
        x: round(x / pointersLength),
        y: round(y / pointersLength)
    };
}

/**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */
function getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}

/**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */
function getDirection(x, y) {
    if (x === y) {
        return DIRECTION_NONE;
    }

    if (abs(x) >= abs(y)) {
        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
    }
    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
}

/**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */
function getDistance(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];

    return Math.sqrt((x * x) + (y * y));
}

/**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */
function getAngle(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}

/**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */
function getRotation(start, end) {
    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
}

/**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */
function getScale(start, end) {
    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
}

var MOUSE_INPUT_MAP = {
    mousedown: INPUT_START,
    mousemove: INPUT_MOVE,
    mouseup: INPUT_END
};

var MOUSE_ELEMENT_EVENTS = 'mousedown';
var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';

/**
 * Mouse events input
 * @constructor
 * @extends Input
 */
function MouseInput() {
    this.evEl = MOUSE_ELEMENT_EVENTS;
    this.evWin = MOUSE_WINDOW_EVENTS;

    this.pressed = false; // mousedown state

    Input.apply(this, arguments);
}

inherit(MouseInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function MEhandler(ev) {
        var eventType = MOUSE_INPUT_MAP[ev.type];

        // on start we want to have the left mouse button down
        if (eventType & INPUT_START && ev.button === 0) {
            this.pressed = true;
        }

        if (eventType & INPUT_MOVE && ev.which !== 1) {
            eventType = INPUT_END;
        }

        // mouse must be down
        if (!this.pressed) {
            return;
        }

        if (eventType & INPUT_END) {
            this.pressed = false;
        }

        this.callback(this.manager, eventType, {
            pointers: [ev],
            changedPointers: [ev],
            pointerType: INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    }
});

var POINTER_INPUT_MAP = {
    pointerdown: INPUT_START,
    pointermove: INPUT_MOVE,
    pointerup: INPUT_END,
    pointercancel: INPUT_CANCEL,
    pointerout: INPUT_CANCEL
};

// in IE10 the pointer types is defined as an enum
var IE10_POINTER_TYPE_ENUM = {
    2: INPUT_TYPE_TOUCH,
    3: INPUT_TYPE_PEN,
    4: INPUT_TYPE_MOUSE,
    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};

var POINTER_ELEMENT_EVENTS = 'pointerdown';
var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';

// IE10 has prefixed support, and case-sensitive
if (window.MSPointerEvent && !window.PointerEvent) {
    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
}

/**
 * Pointer events input
 * @constructor
 * @extends Input
 */
function PointerEventInput() {
    this.evEl = POINTER_ELEMENT_EVENTS;
    this.evWin = POINTER_WINDOW_EVENTS;

    Input.apply(this, arguments);

    this.store = (this.manager.session.pointerEvents = []);
}

inherit(PointerEventInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function PEhandler(ev) {
        var store = this.store;
        var removePointer = false;

        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;

        var isTouch = (pointerType == INPUT_TYPE_TOUCH);

        // get index of the event in the store
        var storeIndex = inArray(store, ev.pointerId, 'pointerId');

        // start and mouse must be down
        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            removePointer = true;
        }

        // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) {
            return;
        }

        // update the event in the store
        store[storeIndex] = ev;

        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [ev],
            pointerType: pointerType,
            srcEvent: ev
        });

        if (removePointer) {
            // remove from the store
            store.splice(storeIndex, 1);
        }
    }
});

var SINGLE_TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Touch events input
 * @constructor
 * @extends Input
 */
function SingleTouchInput() {
    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
    this.started = false;

    Input.apply(this, arguments);
}

inherit(SingleTouchInput, Input, {
    handler: function TEhandler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];

        // should we handle the touch events?
        if (type === INPUT_START) {
            this.started = true;
        }

        if (!this.started) {
            return;
        }

        var touches = normalizeSingleTouches.call(this, ev, type);

        // when done, reset the started state
        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
            this.started = false;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function normalizeSingleTouches(ev, type) {
    var all = toArray(ev.touches);
    var changed = toArray(ev.changedTouches);

    if (type & (INPUT_END | INPUT_CANCEL)) {
        all = uniqueArray(all.concat(changed), 'identifier', true);
    }

    return [all, changed];
}

var TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */
function TouchInput() {
    this.evTarget = TOUCH_TARGET_EVENTS;
    this.targetIds = {};

    Input.apply(this, arguments);
}

inherit(TouchInput, Input, {
    handler: function MTEhandler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);
        if (!touches) {
            return;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function getTouches(ev, type) {
    var allTouches = toArray(ev.touches);
    var targetIds = this.targetIds;

    // when there is only one touch, the process can be simplified
    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [allTouches, allTouches];
    }

    var i,
        targetTouches,
        changedTouches = toArray(ev.changedTouches),
        changedTargetTouches = [],
        target = this.target;

    // get target touches from touches
    targetTouches = allTouches.filter(function(touch) {
        return hasParent(touch.target, target);
    });

    // collect touches
    if (type === INPUT_START) {
        i = 0;
        while (i < targetTouches.length) {
            targetIds[targetTouches[i].identifier] = true;
            i++;
        }
    }

    // filter changed touches to only contain touches that exist in the collected target ids
    i = 0;
    while (i < changedTouches.length) {
        if (targetIds[changedTouches[i].identifier]) {
            changedTargetTouches.push(changedTouches[i]);
        }

        // cleanup removed touches
        if (type & (INPUT_END | INPUT_CANCEL)) {
            delete targetIds[changedTouches[i].identifier];
        }
        i++;
    }

    if (!changedTargetTouches.length) {
        return;
    }

    return [
        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
        changedTargetTouches
    ];
}

/**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */

var DEDUP_TIMEOUT = 2500;
var DEDUP_DISTANCE = 25;

function TouchMouseInput() {
    Input.apply(this, arguments);

    var handler = bindFn(this.handler, this);
    this.touch = new TouchInput(this.manager, handler);
    this.mouse = new MouseInput(this.manager, handler);

    this.primaryTouch = null;
    this.lastTouches = [];
}

inherit(TouchMouseInput, Input, {
    /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */
    handler: function TMEhandler(manager, inputEvent, inputData) {
        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);

        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
            return;
        }

        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
        if (isTouch) {
            recordTouches.call(this, inputEvent, inputData);
        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
            return;
        }

        this.callback(manager, inputEvent, inputData);
    },

    /**
     * remove the event listeners
     */
    destroy: function destroy() {
        this.touch.destroy();
        this.mouse.destroy();
    }
});

function recordTouches(eventType, eventData) {
    if (eventType & INPUT_START) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        setLastTouch.call(this, eventData);
    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
        setLastTouch.call(this, eventData);
    }
}

function setLastTouch(eventData) {
    var touch = eventData.changedPointers[0];

    if (touch.identifier === this.primaryTouch) {
        var lastTouch = {x: touch.clientX, y: touch.clientY};
        this.lastTouches.push(lastTouch);
        var lts = this.lastTouches;
        var removeLastTouch = function() {
            var i = lts.indexOf(lastTouch);
            if (i > -1) {
                lts.splice(i, 1);
            }
        };
        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
    }
}

function isSyntheticEvent(eventData) {
    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
    for (var i = 0; i < this.lastTouches.length; i++) {
        var t = this.lastTouches[i];
        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
            return true;
        }
    }
    return false;
}

var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;

// magical touchAction value
var TOUCH_ACTION_COMPUTE = 'compute';
var TOUCH_ACTION_AUTO = 'auto';
var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
var TOUCH_ACTION_NONE = 'none';
var TOUCH_ACTION_PAN_X = 'pan-x';
var TOUCH_ACTION_PAN_Y = 'pan-y';
var TOUCH_ACTION_MAP = getTouchActionProps();

/**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */
function TouchAction(manager, value) {
    this.manager = manager;
    this.set(value);
}

TouchAction.prototype = {
    /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */
    set: function(value) {
        // find out the touch-action by the event handlers
        if (value == TOUCH_ACTION_COMPUTE) {
            value = this.compute();
        }

        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        }
        this.actions = value.toLowerCase().trim();
    },

    /**
     * just re-set the touchAction value
     */
    update: function() {
        this.set(this.manager.options.touchAction);
    },

    /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */
    compute: function() {
        var actions = [];
        each(this.manager.recognizers, function(recognizer) {
            if (boolOrFn(recognizer.options.enable, [recognizer])) {
                actions = actions.concat(recognizer.getTouchAction());
            }
        });
        return cleanTouchActions(actions.join(' '));
    },

    /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */
    preventDefaults: function(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection;

        // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }

        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];

        if (hasNone) {
            //do not prevent defaults if this is a tap gesture

            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;

            if (isTapPointer && isTapMovement && isTapTouchTime) {
                return;
            }
        }

        if (hasPanX && hasPanY) {
            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
        }

        if (hasNone ||
            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
            (hasPanX && direction & DIRECTION_VERTICAL)) {
            return this.preventSrc(srcEvent);
        }
    },

    /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */
    preventSrc: function(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    }
};

/**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */
function cleanTouchActions(actions) {
    // none
    if (inStr(actions, TOUCH_ACTION_NONE)) {
        return TOUCH_ACTION_NONE;
    }

    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);

    // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) {
        return TOUCH_ACTION_NONE;
    }

    // pan-x OR pan-y
    if (hasPanX || hasPanY) {
        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
    }

    // manipulation
    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
        return TOUCH_ACTION_MANIPULATION;
    }

    return TOUCH_ACTION_AUTO;
}

function getTouchActionProps() {
    if (!NATIVE_TOUCH_ACTION) {
        return false;
    }
    var touchMap = {};
    var cssSupports = window.CSS && window.CSS.supports;
    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {

        // If css.supports is not supported but there is native touch-action assume it supports
        // all values. This is the case for IE 10 and 11.
        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
    });
    return touchMap;
}

/**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */
var STATE_POSSIBLE = 1;
var STATE_BEGAN = 2;
var STATE_CHANGED = 4;
var STATE_ENDED = 8;
var STATE_RECOGNIZED = STATE_ENDED;
var STATE_CANCELLED = 16;
var STATE_FAILED = 32;

/**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */
function Recognizer(options) {
    this.options = assign({}, this.defaults, options || {});

    this.id = uniqueId();

    this.manager = null;

    // default is enable true
    this.options.enable = ifUndefined(this.options.enable, true);

    this.state = STATE_POSSIBLE;

    this.simultaneous = {};
    this.requireFail = [];
}

Recognizer.prototype = {
    /**
     * @virtual
     * @type {Object}
     */
    defaults: {},

    /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */
    set: function(options) {
        assign(this.options, options);

        // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    },

    /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    recognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
            return this;
        }

        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    },

    /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRecognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    },

    /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    requireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
            return this;
        }

        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    },

    /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRequireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index = inArray(this.requireFail, otherRecognizer);
        if (index > -1) {
            this.requireFail.splice(index, 1);
        }
        return this;
    },

    /**
     * has require failures boolean
     * @returns {boolean}
     */
    hasRequireFailures: function() {
        return this.requireFail.length > 0;
    },

    /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */
    canRecognizeWith: function(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    },

    /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */
    emit: function(input) {
        var self = this;
        var state = this.state;

        function emit(event) {
            self.manager.emit(event, input);
        }

        // 'panstart' and 'panmove'
        if (state < STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }

        emit(self.options.event); // simple 'eventName' events

        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
            emit(input.additionalEvent);
        }

        // panend and pancancel
        if (state >= STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }
    },

    /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */
    tryEmit: function(input) {
        if (this.canEmit()) {
            return this.emit(input);
        }
        // it's failing anyway
        this.state = STATE_FAILED;
    },

    /**
     * can we emit?
     * @returns {boolean}
     */
    canEmit: function() {
        var i = 0;
        while (i < this.requireFail.length) {
            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                return false;
            }
            i++;
        }
        return true;
    },

    /**
     * update the recognizer
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = assign({}, inputData);

        // is is enabled and allow recognizing?
        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
            this.reset();
            this.state = STATE_FAILED;
            return;
        }

        // reset when we've reached the end
        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
            this.state = STATE_POSSIBLE;
        }

        this.state = this.process(inputDataClone);

        // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
            this.tryEmit(inputDataClone);
        }
    },

    /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */
    process: function(inputData) { }, // jshint ignore:line

    /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */
    getTouchAction: function() { },

    /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */
    reset: function() { }
};

/**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */
function stateStr(state) {
    if (state & STATE_CANCELLED) {
        return 'cancel';
    } else if (state & STATE_ENDED) {
        return 'end';
    } else if (state & STATE_CHANGED) {
        return 'move';
    } else if (state & STATE_BEGAN) {
        return 'start';
    }
    return '';
}

/**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */
function directionStr(direction) {
    if (direction == DIRECTION_DOWN) {
        return 'down';
    } else if (direction == DIRECTION_UP) {
        return 'up';
    } else if (direction == DIRECTION_LEFT) {
        return 'left';
    } else if (direction == DIRECTION_RIGHT) {
        return 'right';
    }
    return '';
}

/**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */
function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) {
        return manager.get(otherRecognizer);
    }
    return otherRecognizer;
}

/**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */
function AttrRecognizer() {
    Recognizer.apply(this, arguments);
}

inherit(AttrRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof AttrRecognizer
     */
    defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
    },

    /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */
    attrTest: function(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    },

    /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */
    process: function(input) {
        var state = this.state;
        var eventType = input.eventType;

        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
        var isValid = this.attrTest(input);

        // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
            return state | STATE_CANCELLED;
        } else if (isRecognized || isValid) {
            if (eventType & INPUT_END) {
                return state | STATE_ENDED;
            } else if (!(state & STATE_BEGAN)) {
                return STATE_BEGAN;
            }
            return state | STATE_CHANGED;
        }
        return STATE_FAILED;
    }
});

/**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function PanRecognizer() {
    AttrRecognizer.apply(this, arguments);

    this.pX = null;
    this.pY = null;
}

inherit(PanRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PanRecognizer
     */
    defaults: {
        event: 'pan',
        threshold: 10,
        pointers: 1,
        direction: DIRECTION_ALL
    },

    getTouchAction: function() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & DIRECTION_HORIZONTAL) {
            actions.push(TOUCH_ACTION_PAN_Y);
        }
        if (direction & DIRECTION_VERTICAL) {
            actions.push(TOUCH_ACTION_PAN_X);
        }
        return actions;
    },

    directionTest: function(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY;

        // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & DIRECTION_HORIZONTAL) {
                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
                hasMoved = x != this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
                hasMoved = y != this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    },

    attrTest: function(input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) &&
            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
    },

    emit: function(input) {

        this.pX = input.deltaX;
        this.pY = input.deltaY;

        var direction = directionStr(input.direction);

        if (direction) {
            input.additionalEvent = this.options.event + direction;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */
function PinchRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(PinchRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'pinch',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
    },

    emit: function(input) {
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? 'in' : 'out';
            input.additionalEvent = this.options.event + inOut;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */
function PressRecognizer() {
    Recognizer.apply(this, arguments);

    this._timer = null;
    this._input = null;
}

inherit(PressRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PressRecognizer
     */
    defaults: {
        event: 'press',
        pointers: 1,
        time: 251, // minimal time of the pointer to be pressed
        threshold: 9 // a minimal movement is ok, but keep it low
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_AUTO];
    },

    process: function(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;

        this._input = input;

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
            this.reset();
        } else if (input.eventType & INPUT_START) {
            this.reset();
            this._timer = setTimeoutContext(function() {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
            }, options.time, this);
        } else if (input.eventType & INPUT_END) {
            return STATE_RECOGNIZED;
        }
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function(input) {
        if (this.state !== STATE_RECOGNIZED) {
            return;
        }

        if (input && (input.eventType & INPUT_END)) {
            this.manager.emit(this.options.event + 'up', input);
        } else {
            this._input.timeStamp = now();
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */
function RotateRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(RotateRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof RotateRecognizer
     */
    defaults: {
        event: 'rotate',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
    }
});

/**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function SwipeRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(SwipeRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof SwipeRecognizer
     */
    defaults: {
        event: 'swipe',
        threshold: 10,
        velocity: 0.3,
        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
        pointers: 1
    },

    getTouchAction: function() {
        return PanRecognizer.prototype.getTouchAction.call(this);
    },

    attrTest: function(input) {
        var direction = this.options.direction;
        var velocity;

        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
            velocity = input.overallVelocity;
        } else if (direction & DIRECTION_HORIZONTAL) {
            velocity = input.overallVelocityX;
        } else if (direction & DIRECTION_VERTICAL) {
            velocity = input.overallVelocityY;
        }

        return this._super.attrTest.call(this, input) &&
            direction & input.offsetDirection &&
            input.distance > this.options.threshold &&
            input.maxPointers == this.options.pointers &&
            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
    },

    emit: function(input) {
        var direction = directionStr(input.offsetDirection);
        if (direction) {
            this.manager.emit(this.options.event + direction, input);
        }

        this.manager.emit(this.options.event, input);
    }
});

/**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */
function TapRecognizer() {
    Recognizer.apply(this, arguments);

    // previous time and center,
    // used for tap counting
    this.pTime = false;
    this.pCenter = false;

    this._timer = null;
    this._input = null;
    this.count = 0;
}

inherit(TapRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'tap',
        pointers: 1,
        taps: 1,
        interval: 300, // max time between the multi-tap taps
        time: 250, // max time of the pointer to be down (like finger on the screen)
        threshold: 9, // a minimal movement is ok, but keep it low
        posThreshold: 10 // a multi-tap can be a bit off the initial position
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_MANIPULATION];
    },

    process: function(input) {
        var options = this.options;

        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;

        this.reset();

        if ((input.eventType & INPUT_START) && (this.count === 0)) {
            return this.failTimeout();
        }

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType != INPUT_END) {
                return this.failTimeout();
            }

            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;

            this.pTime = input.timeStamp;
            this.pCenter = input.center;

            if (!validMultiTap || !validInterval) {
                this.count = 1;
            } else {
                this.count += 1;
            }

            this._input = input;

            // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) {
                    return STATE_RECOGNIZED;
                } else {
                    this._timer = setTimeoutContext(function() {
                        this.state = STATE_RECOGNIZED;
                        this.tryEmit();
                    }, options.interval, this);
                    return STATE_BEGAN;
                }
            }
        }
        return STATE_FAILED;
    },

    failTimeout: function() {
        this._timer = setTimeoutContext(function() {
            this.state = STATE_FAILED;
        }, this.options.interval, this);
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function() {
        if (this.state == STATE_RECOGNIZED) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Hammer(element, options) {
    options = options || {};
    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
    return new Manager(element, options);
}

/**
 * @const {string}
 */
Hammer.VERSION = '2.0.7';

/**
 * default settings
 * @namespace
 */
Hammer.defaults = {
    /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */
    domEvents: false,

    /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */
    touchAction: TOUCH_ACTION_COMPUTE,

    /**
     * @type {Boolean}
     * @default true
     */
    enable: true,

    /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */
    inputTarget: null,

    /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */
    inputClass: null,

    /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */
    preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [RotateRecognizer, {enable: false}],
        [PinchRecognizer, {enable: false}, ['rotate']],
        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
        [TapRecognizer],
        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
        [PressRecognizer]
    ],

    /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */
    cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: 'none',

        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: 'none',

        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: 'none',

        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: 'none',

        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: 'none',

        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: 'rgba(0,0,0,0)'
    }
};

var STOP = 1;
var FORCED_STOP = 2;

/**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Manager(element, options) {
    this.options = assign({}, Hammer.defaults, options || {});

    this.options.inputTarget = this.options.inputTarget || element;

    this.handlers = {};
    this.session = {};
    this.recognizers = [];
    this.oldCssProps = {};

    this.element = element;
    this.input = createInputInstance(this);
    this.touchAction = new TouchAction(this, this.options.touchAction);

    toggleCssProps(this, true);

    each(this.options.recognizers, function(item) {
        var recognizer = this.add(new (item[0])(item[1]));
        item[2] && recognizer.recognizeWith(item[2]);
        item[3] && recognizer.requireFailure(item[3]);
    }, this);
}

Manager.prototype = {
    /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */
    set: function(options) {
        assign(this.options, options);

        // Options that need a little more setup
        if (options.touchAction) {
            this.touchAction.update();
        }
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    },

    /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */
    stop: function(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
    },

    /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        var session = this.session;
        if (session.stopped) {
            return;
        }

        // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);

        var recognizer;
        var recognizers = this.recognizers;

        // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer;

        // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
            curRecognizer = session.curRecognizer = null;
        }

        var i = 0;
        while (i < recognizers.length) {
            recognizer = recognizers[i];

            // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== FORCED_STOP && ( // 1
                    !curRecognizer || recognizer == curRecognizer || // 2
                    recognizer.canRecognizeWith(curRecognizer))) { // 3
                recognizer.recognize(inputData);
            } else {
                recognizer.reset();
            }

            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                curRecognizer = session.curRecognizer = recognizer;
            }
            i++;
        }
    },

    /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */
    get: function(recognizer) {
        if (recognizer instanceof Recognizer) {
            return recognizer;
        }

        var recognizers = this.recognizers;
        for (var i = 0; i < recognizers.length; i++) {
            if (recognizers[i].options.event == recognizer) {
                return recognizers[i];
            }
        }
        return null;
    },

    /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */
    add: function(recognizer) {
        if (invokeArrayArg(recognizer, 'add', this)) {
            return this;
        }

        // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) {
            this.remove(existing);
        }

        this.recognizers.push(recognizer);
        recognizer.manager = this;

        this.touchAction.update();
        return recognizer;
    },

    /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */
    remove: function(recognizer) {
        if (invokeArrayArg(recognizer, 'remove', this)) {
            return this;
        }

        recognizer = this.get(recognizer);

        // let's make sure this recognizer exists
        if (recognizer) {
            var recognizers = this.recognizers;
            var index = inArray(recognizers, recognizer);

            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }

        return this;
    },

    /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */
    on: function(events, handler) {
        if (events === undefined) {
            return;
        }
        if (handler === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        });
        return this;
    },

    /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */
    off: function(events, handler) {
        if (events === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            if (!handler) {
                delete handlers[event];
            } else {
                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            }
        });
        return this;
    },

    /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */
    emit: function(event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) {
            triggerDomEvent(event, data);
        }

        // no handlers, so skip it all
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) {
            return;
        }

        data.type = event;
        data.preventDefault = function() {
            data.srcEvent.preventDefault();
        };

        var i = 0;
        while (i < handlers.length) {
            handlers[i](data);
            i++;
        }
    },

    /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */
    destroy: function() {
        this.element && toggleCssProps(this, false);

        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    }
};

/**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */
function toggleCssProps(manager, add) {
    var element = manager.element;
    if (!element.style) {
        return;
    }
    var prop;
    each(manager.options.cssProps, function(value, name) {
        prop = prefixed(element.style, name);
        if (add) {
            manager.oldCssProps[prop] = element.style[prop];
            element.style[prop] = value;
        } else {
            element.style[prop] = manager.oldCssProps[prop] || '';
        }
    });
    if (!add) {
        manager.oldCssProps = {};
    }
}

/**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */
function triggerDomEvent(event, data) {
    var gestureEvent = document.createEvent('Event');
    gestureEvent.initEvent(event, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}

assign(Hammer, {
    INPUT_START: INPUT_START,
    INPUT_MOVE: INPUT_MOVE,
    INPUT_END: INPUT_END,
    INPUT_CANCEL: INPUT_CANCEL,

    STATE_POSSIBLE: STATE_POSSIBLE,
    STATE_BEGAN: STATE_BEGAN,
    STATE_CHANGED: STATE_CHANGED,
    STATE_ENDED: STATE_ENDED,
    STATE_RECOGNIZED: STATE_RECOGNIZED,
    STATE_CANCELLED: STATE_CANCELLED,
    STATE_FAILED: STATE_FAILED,

    DIRECTION_NONE: DIRECTION_NONE,
    DIRECTION_LEFT: DIRECTION_LEFT,
    DIRECTION_RIGHT: DIRECTION_RIGHT,
    DIRECTION_UP: DIRECTION_UP,
    DIRECTION_DOWN: DIRECTION_DOWN,
    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
    DIRECTION_ALL: DIRECTION_ALL,

    Manager: Manager,
    Input: Input,
    TouchAction: TouchAction,

    TouchInput: TouchInput,
    MouseInput: MouseInput,
    PointerEventInput: PointerEventInput,
    TouchMouseInput: TouchMouseInput,
    SingleTouchInput: SingleTouchInput,

    Recognizer: Recognizer,
    AttrRecognizer: AttrRecognizer,
    Tap: TapRecognizer,
    Pan: PanRecognizer,
    Swipe: SwipeRecognizer,
    Pinch: PinchRecognizer,
    Rotate: RotateRecognizer,
    Press: PressRecognizer,

    on: addEventListeners,
    off: removeEventListeners,
    each: each,
    merge: merge,
    extend: extend,
    assign: assign,
    inherit: inherit,
    bindFn: bindFn,
    prefixed: prefixed
});

// this prevents errors when Hammer is loaded in the presence of an AMD
//  style loader but by script tag, not by the loader.
var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
freeGlobal.Hammer = Hammer;

if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
        return Hammer;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else if (typeof module != 'undefined' && module.exports) {
    module.exports = Hammer;
} else {
    window[exportName] = Hammer;
}

})(window, document, 'Hammer');


/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Url */
/* unused harmony export Http */
/* unused harmony export Resource */
/*!
 * vue-resource v1.5.1
 * https://github.com/pagekit/vue-resource
 * Released under the MIT License.
 */

/**
 * Promises/A+ polyfill v1.1.4 (https://github.com/bramstein/promis)
 */

var RESOLVED = 0;
var REJECTED = 1;
var PENDING = 2;

function Promise$1(executor) {

    this.state = PENDING;
    this.value = undefined;
    this.deferred = [];

    var promise = this;

    try {
        executor(function (x) {
            promise.resolve(x);
        }, function (r) {
            promise.reject(r);
        });
    } catch (e) {
        promise.reject(e);
    }
}

Promise$1.reject = function (r) {
    return new Promise$1(function (resolve, reject) {
        reject(r);
    });
};

Promise$1.resolve = function (x) {
    return new Promise$1(function (resolve, reject) {
        resolve(x);
    });
};

Promise$1.all = function all(iterable) {
    return new Promise$1(function (resolve, reject) {
        var count = 0, result = [];

        if (iterable.length === 0) {
            resolve(result);
        }

        function resolver(i) {
            return function (x) {
                result[i] = x;
                count += 1;

                if (count === iterable.length) {
                    resolve(result);
                }
            };
        }

        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolver(i), reject);
        }
    });
};

Promise$1.race = function race(iterable) {
    return new Promise$1(function (resolve, reject) {
        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolve, reject);
        }
    });
};

var p = Promise$1.prototype;

p.resolve = function resolve(x) {
    var promise = this;

    if (promise.state === PENDING) {
        if (x === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        var called = false;

        try {
            var then = x && x['then'];

            if (x !== null && typeof x === 'object' && typeof then === 'function') {
                then.call(x, function (x) {
                    if (!called) {
                        promise.resolve(x);
                    }
                    called = true;

                }, function (r) {
                    if (!called) {
                        promise.reject(r);
                    }
                    called = true;
                });
                return;
            }
        } catch (e) {
            if (!called) {
                promise.reject(e);
            }
            return;
        }

        promise.state = RESOLVED;
        promise.value = x;
        promise.notify();
    }
};

p.reject = function reject(reason) {
    var promise = this;

    if (promise.state === PENDING) {
        if (reason === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        promise.state = REJECTED;
        promise.value = reason;
        promise.notify();
    }
};

p.notify = function notify() {
    var promise = this;

    nextTick(function () {
        if (promise.state !== PENDING) {
            while (promise.deferred.length) {
                var deferred = promise.deferred.shift(),
                    onResolved = deferred[0],
                    onRejected = deferred[1],
                    resolve = deferred[2],
                    reject = deferred[3];

                try {
                    if (promise.state === RESOLVED) {
                        if (typeof onResolved === 'function') {
                            resolve(onResolved.call(undefined, promise.value));
                        } else {
                            resolve(promise.value);
                        }
                    } else if (promise.state === REJECTED) {
                        if (typeof onRejected === 'function') {
                            resolve(onRejected.call(undefined, promise.value));
                        } else {
                            reject(promise.value);
                        }
                    }
                } catch (e) {
                    reject(e);
                }
            }
        }
    });
};

p.then = function then(onResolved, onRejected) {
    var promise = this;

    return new Promise$1(function (resolve, reject) {
        promise.deferred.push([onResolved, onRejected, resolve, reject]);
        promise.notify();
    });
};

p.catch = function (onRejected) {
    return this.then(undefined, onRejected);
};

/**
 * Promise adapter.
 */

if (typeof Promise === 'undefined') {
    window.Promise = Promise$1;
}

function PromiseObj(executor, context) {

    if (executor instanceof Promise) {
        this.promise = executor;
    } else {
        this.promise = new Promise(executor.bind(context));
    }

    this.context = context;
}

PromiseObj.all = function (iterable, context) {
    return new PromiseObj(Promise.all(iterable), context);
};

PromiseObj.resolve = function (value, context) {
    return new PromiseObj(Promise.resolve(value), context);
};

PromiseObj.reject = function (reason, context) {
    return new PromiseObj(Promise.reject(reason), context);
};

PromiseObj.race = function (iterable, context) {
    return new PromiseObj(Promise.race(iterable), context);
};

var p$1 = PromiseObj.prototype;

p$1.bind = function (context) {
    this.context = context;
    return this;
};

p$1.then = function (fulfilled, rejected) {

    if (fulfilled && fulfilled.bind && this.context) {
        fulfilled = fulfilled.bind(this.context);
    }

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.then(fulfilled, rejected), this.context);
};

p$1.catch = function (rejected) {

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.catch(rejected), this.context);
};

p$1.finally = function (callback) {

    return this.then(function (value) {
        callback.call(this);
        return value;
    }, function (reason) {
        callback.call(this);
        return Promise.reject(reason);
    }
    );
};

/**
 * Utility functions.
 */

var ref = {};
var hasOwnProperty = ref.hasOwnProperty;
var ref$1 = [];
var slice = ref$1.slice;
var debug = false, ntick;

var inBrowser = typeof window !== 'undefined';

function Util (ref) {
    var config = ref.config;
    var nextTick = ref.nextTick;

    ntick = nextTick;
    debug = config.debug || !config.silent;
}

function warn(msg) {
    if (typeof console !== 'undefined' && debug) {
        console.warn('[VueResource warn]: ' + msg);
    }
}

function error(msg) {
    if (typeof console !== 'undefined') {
        console.error(msg);
    }
}

function nextTick(cb, ctx) {
    return ntick(cb, ctx);
}

function trim(str) {
    return str ? str.replace(/^\s*|\s*$/g, '') : '';
}

function trimEnd(str, chars) {

    if (str && chars === undefined) {
        return str.replace(/\s+$/, '');
    }

    if (!str || !chars) {
        return str;
    }

    return str.replace(new RegExp(("[" + chars + "]+$")), '');
}

function toLower(str) {
    return str ? str.toLowerCase() : '';
}

function toUpper(str) {
    return str ? str.toUpperCase() : '';
}

var isArray = Array.isArray;

function isString(val) {
    return typeof val === 'string';
}

function isFunction(val) {
    return typeof val === 'function';
}

function isObject(obj) {
    return obj !== null && typeof obj === 'object';
}

function isPlainObject(obj) {
    return isObject(obj) && Object.getPrototypeOf(obj) == Object.prototype;
}

function isBlob(obj) {
    return typeof Blob !== 'undefined' && obj instanceof Blob;
}

function isFormData(obj) {
    return typeof FormData !== 'undefined' && obj instanceof FormData;
}

function when(value, fulfilled, rejected) {

    var promise = PromiseObj.resolve(value);

    if (arguments.length < 2) {
        return promise;
    }

    return promise.then(fulfilled, rejected);
}

function options(fn, obj, opts) {

    opts = opts || {};

    if (isFunction(opts)) {
        opts = opts.call(obj);
    }

    return merge(fn.bind({$vm: obj, $options: opts}), fn, {$options: opts});
}

function each(obj, iterator) {

    var i, key;

    if (isArray(obj)) {
        for (i = 0; i < obj.length; i++) {
            iterator.call(obj[i], obj[i], i);
        }
    } else if (isObject(obj)) {
        for (key in obj) {
            if (hasOwnProperty.call(obj, key)) {
                iterator.call(obj[key], obj[key], key);
            }
        }
    }

    return obj;
}

var assign = Object.assign || _assign;

function merge(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source, true);
    });

    return target;
}

function defaults(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {

        for (var key in source) {
            if (target[key] === undefined) {
                target[key] = source[key];
            }
        }

    });

    return target;
}

function _assign(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source);
    });

    return target;
}

function _merge(target, source, deep) {
    for (var key in source) {
        if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
            if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
                target[key] = {};
            }
            if (isArray(source[key]) && !isArray(target[key])) {
                target[key] = [];
            }
            _merge(target[key], source[key], deep);
        } else if (source[key] !== undefined) {
            target[key] = source[key];
        }
    }
}

/**
 * Root Prefix Transform.
 */

function root (options$$1, next) {

    var url = next(options$$1);

    if (isString(options$$1.root) && !/^(https?:)?\//.test(url)) {
        url = trimEnd(options$$1.root, '/') + '/' + url;
    }

    return url;
}

/**
 * Query Parameter Transform.
 */

function query (options$$1, next) {

    var urlParams = Object.keys(Url.options.params), query = {}, url = next(options$$1);

    each(options$$1.params, function (value, key) {
        if (urlParams.indexOf(key) === -1) {
            query[key] = value;
        }
    });

    query = Url.params(query);

    if (query) {
        url += (url.indexOf('?') == -1 ? '?' : '&') + query;
    }

    return url;
}

/**
 * URL Template v2.0.6 (https://github.com/bramstein/url-template)
 */

function expand(url, params, variables) {

    var tmpl = parse(url), expanded = tmpl.expand(params);

    if (variables) {
        variables.push.apply(variables, tmpl.vars);
    }

    return expanded;
}

function parse(template) {

    var operators = ['+', '#', '.', '/', ';', '?', '&'], variables = [];

    return {
        vars: variables,
        expand: function expand(context) {
            return template.replace(/\{([^{}]+)\}|([^{}]+)/g, function (_, expression, literal) {
                if (expression) {

                    var operator = null, values = [];

                    if (operators.indexOf(expression.charAt(0)) !== -1) {
                        operator = expression.charAt(0);
                        expression = expression.substr(1);
                    }

                    expression.split(/,/g).forEach(function (variable) {
                        var tmp = /([^:*]*)(?::(\d+)|(\*))?/.exec(variable);
                        values.push.apply(values, getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
                        variables.push(tmp[1]);
                    });

                    if (operator && operator !== '+') {

                        var separator = ',';

                        if (operator === '?') {
                            separator = '&';
                        } else if (operator !== '#') {
                            separator = operator;
                        }

                        return (values.length !== 0 ? operator : '') + values.join(separator);
                    } else {
                        return values.join(',');
                    }

                } else {
                    return encodeReserved(literal);
                }
            });
        }
    };
}

function getValues(context, operator, key, modifier) {

    var value = context[key], result = [];

    if (isDefined(value) && value !== '') {
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            value = value.toString();

            if (modifier && modifier !== '*') {
                value = value.substring(0, parseInt(modifier, 10));
            }

            result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
        } else {
            if (modifier === '*') {
                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            result.push(encodeValue(operator, value[k], k));
                        }
                    });
                }
            } else {
                var tmp = [];

                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        tmp.push(encodeValue(operator, value));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            tmp.push(encodeURIComponent(k));
                            tmp.push(encodeValue(operator, value[k].toString()));
                        }
                    });
                }

                if (isKeyOperator(operator)) {
                    result.push(encodeURIComponent(key) + '=' + tmp.join(','));
                } else if (tmp.length !== 0) {
                    result.push(tmp.join(','));
                }
            }
        }
    } else {
        if (operator === ';') {
            result.push(encodeURIComponent(key));
        } else if (value === '' && (operator === '&' || operator === '?')) {
            result.push(encodeURIComponent(key) + '=');
        } else if (value === '') {
            result.push('');
        }
    }

    return result;
}

function isDefined(value) {
    return value !== undefined && value !== null;
}

function isKeyOperator(operator) {
    return operator === ';' || operator === '&' || operator === '?';
}

function encodeValue(operator, value, key) {

    value = (operator === '+' || operator === '#') ? encodeReserved(value) : encodeURIComponent(value);

    if (key) {
        return encodeURIComponent(key) + '=' + value;
    } else {
        return value;
    }
}

function encodeReserved(str) {
    return str.split(/(%[0-9A-Fa-f]{2})/g).map(function (part) {
        if (!/%[0-9A-Fa-f]/.test(part)) {
            part = encodeURI(part);
        }
        return part;
    }).join('');
}

/**
 * URL Template (RFC 6570) Transform.
 */

function template (options) {

    var variables = [], url = expand(options.url, options.params, variables);

    variables.forEach(function (key) {
        delete options.params[key];
    });

    return url;
}

/**
 * Service for URL templating.
 */

function Url(url, params) {

    var self = this || {}, options$$1 = url, transform;

    if (isString(url)) {
        options$$1 = {url: url, params: params};
    }

    options$$1 = merge({}, Url.options, self.$options, options$$1);

    Url.transforms.forEach(function (handler) {

        if (isString(handler)) {
            handler = Url.transform[handler];
        }

        if (isFunction(handler)) {
            transform = factory(handler, transform, self.$vm);
        }

    });

    return transform(options$$1);
}

/**
 * Url options.
 */

Url.options = {
    url: '',
    root: null,
    params: {}
};

/**
 * Url transforms.
 */

Url.transform = {template: template, query: query, root: root};
Url.transforms = ['template', 'query', 'root'];

/**
 * Encodes a Url parameter string.
 *
 * @param {Object} obj
 */

Url.params = function (obj) {

    var params = [], escape = encodeURIComponent;

    params.add = function (key, value) {

        if (isFunction(value)) {
            value = value();
        }

        if (value === null) {
            value = '';
        }

        this.push(escape(key) + '=' + escape(value));
    };

    serialize(params, obj);

    return params.join('&').replace(/%20/g, '+');
};

/**
 * Parse a URL and return its components.
 *
 * @param {String} url
 */

Url.parse = function (url) {

    var el = document.createElement('a');

    if (document.documentMode) {
        el.href = url;
        url = el.href;
    }

    el.href = url;

    return {
        href: el.href,
        protocol: el.protocol ? el.protocol.replace(/:$/, '') : '',
        port: el.port,
        host: el.host,
        hostname: el.hostname,
        pathname: el.pathname.charAt(0) === '/' ? el.pathname : '/' + el.pathname,
        search: el.search ? el.search.replace(/^\?/, '') : '',
        hash: el.hash ? el.hash.replace(/^#/, '') : ''
    };
};

function factory(handler, next, vm) {
    return function (options$$1) {
        return handler.call(vm, options$$1, next);
    };
}

function serialize(params, obj, scope) {

    var array = isArray(obj), plain = isPlainObject(obj), hash;

    each(obj, function (value, key) {

        hash = isObject(value) || isArray(value);

        if (scope) {
            key = scope + '[' + (plain || hash ? key : '') + ']';
        }

        if (!scope && array) {
            params.add(value.name, value.value);
        } else if (hash) {
            serialize(params, value, key);
        } else {
            params.add(key, value);
        }
    });
}

/**
 * XDomain client (Internet Explorer).
 */

function xdrClient (request) {
    return new PromiseObj(function (resolve) {

        var xdr = new XDomainRequest(), handler = function (ref) {
                var type = ref.type;


                var status = 0;

                if (type === 'load') {
                    status = 200;
                } else if (type === 'error') {
                    status = 500;
                }

                resolve(request.respondWith(xdr.responseText, {status: status}));
            };

        request.abort = function () { return xdr.abort(); };

        xdr.open(request.method, request.getUrl());

        if (request.timeout) {
            xdr.timeout = request.timeout;
        }

        xdr.onload = handler;
        xdr.onabort = handler;
        xdr.onerror = handler;
        xdr.ontimeout = handler;
        xdr.onprogress = function () {};
        xdr.send(request.getBody());
    });
}

/**
 * CORS Interceptor.
 */

var SUPPORTS_CORS = inBrowser && 'withCredentials' in new XMLHttpRequest();

function cors (request) {

    if (inBrowser) {

        var orgUrl = Url.parse(location.href);
        var reqUrl = Url.parse(request.getUrl());

        if (reqUrl.protocol !== orgUrl.protocol || reqUrl.host !== orgUrl.host) {

            request.crossOrigin = true;
            request.emulateHTTP = false;

            if (!SUPPORTS_CORS) {
                request.client = xdrClient;
            }
        }
    }

}

/**
 * Form data Interceptor.
 */

function form (request) {

    if (isFormData(request.body)) {
        request.headers.delete('Content-Type');
    } else if (isObject(request.body) && request.emulateJSON) {
        request.body = Url.params(request.body);
        request.headers.set('Content-Type', 'application/x-www-form-urlencoded');
    }

}

/**
 * JSON Interceptor.
 */

function json (request) {

    var type = request.headers.get('Content-Type') || '';

    if (isObject(request.body) && type.indexOf('application/json') === 0) {
        request.body = JSON.stringify(request.body);
    }

    return function (response) {

        return response.bodyText ? when(response.text(), function (text) {

            var type = response.headers.get('Content-Type') || '';

            if (type.indexOf('application/json') === 0 || isJson(text)) {

                try {
                    response.body = JSON.parse(text);
                } catch (e) {
                    response.body = null;
                }

            } else {
                response.body = text;
            }

            return response;

        }) : response;

    };
}

function isJson(str) {

    var start = str.match(/^\s*(\[|\{)/);
    var end = {'[': /]\s*$/, '{': /}\s*$/};

    return start && end[start[1]].test(str);
}

/**
 * JSONP client (Browser).
 */

function jsonpClient (request) {
    return new PromiseObj(function (resolve) {

        var name = request.jsonp || 'callback', callback = request.jsonpCallback || '_jsonp' + Math.random().toString(36).substr(2), body = null, handler, script;

        handler = function (ref) {
            var type = ref.type;


            var status = 0;

            if (type === 'load' && body !== null) {
                status = 200;
            } else if (type === 'error') {
                status = 500;
            }

            if (status && window[callback]) {
                delete window[callback];
                document.body.removeChild(script);
            }

            resolve(request.respondWith(body, {status: status}));
        };

        window[callback] = function (result) {
            body = JSON.stringify(result);
        };

        request.abort = function () {
            handler({type: 'abort'});
        };

        request.params[name] = callback;

        if (request.timeout) {
            setTimeout(request.abort, request.timeout);
        }

        script = document.createElement('script');
        script.src = request.getUrl();
        script.type = 'text/javascript';
        script.async = true;
        script.onload = handler;
        script.onerror = handler;

        document.body.appendChild(script);
    });
}

/**
 * JSONP Interceptor.
 */

function jsonp (request) {

    if (request.method == 'JSONP') {
        request.client = jsonpClient;
    }

}

/**
 * Before Interceptor.
 */

function before (request) {

    if (isFunction(request.before)) {
        request.before.call(this, request);
    }

}

/**
 * HTTP method override Interceptor.
 */

function method (request) {

    if (request.emulateHTTP && /^(PUT|PATCH|DELETE)$/i.test(request.method)) {
        request.headers.set('X-HTTP-Method-Override', request.method);
        request.method = 'POST';
    }

}

/**
 * Header Interceptor.
 */

function header (request) {

    var headers = assign({}, Http.headers.common,
        !request.crossOrigin ? Http.headers.custom : {},
        Http.headers[toLower(request.method)]
    );

    each(headers, function (value, name) {
        if (!request.headers.has(name)) {
            request.headers.set(name, value);
        }
    });

}

/**
 * XMLHttp client (Browser).
 */

function xhrClient (request) {
    return new PromiseObj(function (resolve) {

        var xhr = new XMLHttpRequest(), handler = function (event) {

                var response = request.respondWith(
                'response' in xhr ? xhr.response : xhr.responseText, {
                    status: xhr.status === 1223 ? 204 : xhr.status, // IE9 status bug
                    statusText: xhr.status === 1223 ? 'No Content' : trim(xhr.statusText)
                });

                each(trim(xhr.getAllResponseHeaders()).split('\n'), function (row) {
                    response.headers.append(row.slice(0, row.indexOf(':')), row.slice(row.indexOf(':') + 1));
                });

                resolve(response);
            };

        request.abort = function () { return xhr.abort(); };

        xhr.open(request.method, request.getUrl(), true);

        if (request.timeout) {
            xhr.timeout = request.timeout;
        }

        if (request.responseType && 'responseType' in xhr) {
            xhr.responseType = request.responseType;
        }

        if (request.withCredentials || request.credentials) {
            xhr.withCredentials = true;
        }

        if (!request.crossOrigin) {
            request.headers.set('X-Requested-With', 'XMLHttpRequest');
        }

        // deprecated use downloadProgress
        if (isFunction(request.progress) && request.method === 'GET') {
            xhr.addEventListener('progress', request.progress);
        }

        if (isFunction(request.downloadProgress)) {
            xhr.addEventListener('progress', request.downloadProgress);
        }

        // deprecated use uploadProgress
        if (isFunction(request.progress) && /^(POST|PUT)$/i.test(request.method)) {
            xhr.upload.addEventListener('progress', request.progress);
        }

        if (isFunction(request.uploadProgress) && xhr.upload) {
            xhr.upload.addEventListener('progress', request.uploadProgress);
        }

        request.headers.forEach(function (value, name) {
            xhr.setRequestHeader(name, value);
        });

        xhr.onload = handler;
        xhr.onabort = handler;
        xhr.onerror = handler;
        xhr.ontimeout = handler;
        xhr.send(request.getBody());
    });
}

/**
 * Http client (Node).
 */

function nodeClient (request) {

    var client = __webpack_require__(117);

    return new PromiseObj(function (resolve) {

        var url = request.getUrl();
        var body = request.getBody();
        var method = request.method;
        var headers = {}, handler;

        request.headers.forEach(function (value, name) {
            headers[name] = value;
        });

        client(url, {body: body, method: method, headers: headers}).then(handler = function (resp) {

            var response = request.respondWith(resp.body, {
                status: resp.statusCode,
                statusText: trim(resp.statusMessage)
            });

            each(resp.headers, function (value, name) {
                response.headers.set(name, value);
            });

            resolve(response);

        }, function (error$$1) { return handler(error$$1.response); });
    });
}

/**
 * Base client.
 */

function Client (context) {

    var reqHandlers = [sendRequest], resHandlers = [];

    if (!isObject(context)) {
        context = null;
    }

    function Client(request) {
        while (reqHandlers.length) {

            var handler = reqHandlers.pop();

            if (isFunction(handler)) {

                var response = (void 0), next = (void 0);

                response = handler.call(context, request, function (val) { return next = val; }) || next;

                if (isObject(response)) {
                    return new PromiseObj(function (resolve, reject) {

                        resHandlers.forEach(function (handler) {
                            response = when(response, function (response) {
                                return handler.call(context, response) || response;
                            }, reject);
                        });

                        when(response, resolve, reject);

                    }, context);
                }

                if (isFunction(response)) {
                    resHandlers.unshift(response);
                }

            } else {
                warn(("Invalid interceptor of type " + (typeof handler) + ", must be a function"));
            }
        }
    }

    Client.use = function (handler) {
        reqHandlers.push(handler);
    };

    return Client;
}

function sendRequest(request) {

    var client = request.client || (inBrowser ? xhrClient : nodeClient);

    return client(request);
}

/**
 * HTTP Headers.
 */

var Headers = function Headers(headers) {
    var this$1 = this;


    this.map = {};

    each(headers, function (value, name) { return this$1.append(name, value); });
};

Headers.prototype.has = function has (name) {
    return getName(this.map, name) !== null;
};

Headers.prototype.get = function get (name) {

    var list = this.map[getName(this.map, name)];

    return list ? list.join() : null;
};

Headers.prototype.getAll = function getAll (name) {
    return this.map[getName(this.map, name)] || [];
};

Headers.prototype.set = function set (name, value) {
    this.map[normalizeName(getName(this.map, name) || name)] = [trim(value)];
};

Headers.prototype.append = function append (name, value) {

    var list = this.map[getName(this.map, name)];

    if (list) {
        list.push(trim(value));
    } else {
        this.set(name, value);
    }
};

Headers.prototype.delete = function delete$1 (name) {
    delete this.map[getName(this.map, name)];
};

Headers.prototype.deleteAll = function deleteAll () {
    this.map = {};
};

Headers.prototype.forEach = function forEach (callback, thisArg) {
        var this$1 = this;

    each(this.map, function (list, name) {
        each(list, function (value) { return callback.call(thisArg, value, name, this$1); });
    });
};

function getName(map, name) {
    return Object.keys(map).reduce(function (prev, curr) {
        return toLower(name) === toLower(curr) ? curr : prev;
    }, null);
}

function normalizeName(name) {

    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
        throw new TypeError('Invalid character in header field name');
    }

    return trim(name);
}

/**
 * HTTP Response.
 */

var Response = function Response(body, ref) {
    var url = ref.url;
    var headers = ref.headers;
    var status = ref.status;
    var statusText = ref.statusText;


    this.url = url;
    this.ok = status >= 200 && status < 300;
    this.status = status || 0;
    this.statusText = statusText || '';
    this.headers = new Headers(headers);
    this.body = body;

    if (isString(body)) {

        this.bodyText = body;

    } else if (isBlob(body)) {

        this.bodyBlob = body;

        if (isBlobText(body)) {
            this.bodyText = blobText(body);
        }
    }
};

Response.prototype.blob = function blob () {
    return when(this.bodyBlob);
};

Response.prototype.text = function text () {
    return when(this.bodyText);
};

Response.prototype.json = function json () {
    return when(this.text(), function (text) { return JSON.parse(text); });
};

Object.defineProperty(Response.prototype, 'data', {

    get: function get() {
        return this.body;
    },

    set: function set(body) {
        this.body = body;
    }

});

function blobText(body) {
    return new PromiseObj(function (resolve) {

        var reader = new FileReader();

        reader.readAsText(body);
        reader.onload = function () {
            resolve(reader.result);
        };

    });
}

function isBlobText(body) {
    return body.type.indexOf('text') === 0 || body.type.indexOf('json') !== -1;
}

/**
 * HTTP Request.
 */

var Request = function Request(options$$1) {

    this.body = null;
    this.params = {};

    assign(this, options$$1, {
        method: toUpper(options$$1.method || 'GET')
    });

    if (!(this.headers instanceof Headers)) {
        this.headers = new Headers(this.headers);
    }
};

Request.prototype.getUrl = function getUrl () {
    return Url(this);
};

Request.prototype.getBody = function getBody () {
    return this.body;
};

Request.prototype.respondWith = function respondWith (body, options$$1) {
    return new Response(body, assign(options$$1 || {}, {url: this.getUrl()}));
};

/**
 * Service for sending network requests.
 */

var COMMON_HEADERS = {'Accept': 'application/json, text/plain, */*'};
var JSON_CONTENT_TYPE = {'Content-Type': 'application/json;charset=utf-8'};

function Http(options$$1) {

    var self = this || {}, client = Client(self.$vm);

    defaults(options$$1 || {}, self.$options, Http.options);

    Http.interceptors.forEach(function (handler) {

        if (isString(handler)) {
            handler = Http.interceptor[handler];
        }

        if (isFunction(handler)) {
            client.use(handler);
        }

    });

    return client(new Request(options$$1)).then(function (response) {

        return response.ok ? response : PromiseObj.reject(response);

    }, function (response) {

        if (response instanceof Error) {
            error(response);
        }

        return PromiseObj.reject(response);
    });
}

Http.options = {};

Http.headers = {
    put: JSON_CONTENT_TYPE,
    post: JSON_CONTENT_TYPE,
    patch: JSON_CONTENT_TYPE,
    delete: JSON_CONTENT_TYPE,
    common: COMMON_HEADERS,
    custom: {}
};

Http.interceptor = {before: before, method: method, jsonp: jsonp, json: json, form: form, header: header, cors: cors};
Http.interceptors = ['before', 'method', 'jsonp', 'json', 'form', 'header', 'cors'];

['get', 'delete', 'head', 'jsonp'].forEach(function (method$$1) {

    Http[method$$1] = function (url, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1}));
    };

});

['post', 'put', 'patch'].forEach(function (method$$1) {

    Http[method$$1] = function (url, body, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1, body: body}));
    };

});

/**
 * Service for interacting with RESTful services.
 */

function Resource(url, params, actions, options$$1) {

    var self = this || {}, resource = {};

    actions = assign({},
        Resource.actions,
        actions
    );

    each(actions, function (action, name) {

        action = merge({url: url, params: assign({}, params)}, options$$1, action);

        resource[name] = function () {
            return (self.$http || Http)(opts(action, arguments));
        };
    });

    return resource;
}

function opts(action, args) {

    var options$$1 = assign({}, action), params = {}, body;

    switch (args.length) {

        case 2:

            params = args[0];
            body = args[1];

            break;

        case 1:

            if (/^(POST|PUT|PATCH)$/i.test(options$$1.method)) {
                body = args[0];
            } else {
                params = args[0];
            }

            break;

        case 0:

            break;

        default:

            throw 'Expected up to 2 arguments [params, body], got ' + args.length + ' arguments';
    }

    options$$1.body = body;
    options$$1.params = assign({}, options$$1.params, params);

    return options$$1;
}

Resource.actions = {

    get: {method: 'GET'},
    save: {method: 'POST'},
    query: {method: 'GET'},
    update: {method: 'PUT'},
    remove: {method: 'DELETE'},
    delete: {method: 'DELETE'}

};

/**
 * Install plugin.
 */

function plugin(Vue) {

    if (plugin.installed) {
        return;
    }

    Util(Vue);

    Vue.url = Url;
    Vue.http = Http;
    Vue.resource = Resource;
    Vue.Promise = PromiseObj;

    Object.defineProperties(Vue.prototype, {

        $url: {
            get: function get() {
                return options(Vue.url, this, this.$options.url);
            }
        },

        $http: {
            get: function get() {
                return options(Vue.http, this, this.$options.http);
            }
        },

        $resource: {
            get: function get() {
                return Vue.resource.bind(this);
            }
        },

        $promise: {
            get: function get() {
                var this$1 = this;

                return function (executor) { return new Vue.Promise(executor, this$1); };
            }
        }

    });
}

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["a"] = (plugin);



/***/ }),
/* 117 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,n){if(true)module.exports=n();else if("function"==typeof define&&define.amd)define([],n);else{var t=n();for(var r in t)("object"==typeof exports?exports:e)[r]=t[r]}}("undefined"!=typeof self?self:this,(function(){return function(e){var n={};function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{enumerable:!0,get:r})},t.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},t.t=function(e,n){if(1&n&&(e=t(e)),8&n)return e;if(4&n&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(t.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&n&&"string"!=typeof e)for(var o in e)t.d(r,o,function(n){return e[n]}.bind(null,o));return r},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,n){return Object.prototype.hasOwnProperty.call(e,n)},t.p="",t(t.s=0)}([function(e,n,t){"use strict";function r(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function o(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?r(t,!0).forEach((function(n){i(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):r(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}function i(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}t.r(n);var c={$vue:null,id:null,router:null,fields:{},customIdFields:{},ignoreRoutes:[],linkers:[],commands:{},disabled:!1,customResourceURL:null,set:[],require:[],ecommerce:{enabled:!1,options:null,enhanced:!1},autoTracking:{screenview:!1,shouldRouterUpdate:null,skipSamePath:!1,exception:!1,exceptionLogs:!0,page:!0,transformQueryString:!0,pageviewOnLoad:!0,pageviewTemplate:null,untracked:!0,prependBase:!0},debug:{enabled:!1,trace:!1,sendHitTask:!0},batch:{enabled:!1,delay:500,amount:2},checkDuplicatedScript:!1,disableScriptLoader:!1,beforeFirstHit:s,ready:s,untracked:[]},a=o({},c);function u(e){!function e(n,t){return Object.keys(t).forEach((function(r){var o=n[r]&&Object.prototype.toString.call(n[r]);"[object Object]"!==o&&"[object Array]"!==o?n[r]=t[r]:e(n[r],t[r])})),n}(a,e)}function f(){return a.id?[].concat(a.id):[]}var l=a;function s(){}var p=function(e){console.warn("[vue-analytics] ".concat(e))};function d(e,n){return new Promise((function(t,r){var o=document.head||document.getElementsByTagName("head")[0],i=document.createElement("script");if(i.async=!0,i.src=e,i.charset="utf-8",n){var c=document.createElement("link");c.href=n,c.rel="preconnect",o.appendChild(c)}o.appendChild(i),i.onload=t,i.onerror=r}))}function y(e){return e.name||e.replace(/-/gi,"")}function b(e,n){if(f().length>1){var t=y(n);return"".concat(t,".").concat(e)}return e}var m,v=function(e){if(e.then)return e;if("function"==typeof e){var n=e();return n.then?n:Promise.resolve(n)}return Promise.resolve(e)};function g(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var h=[];function w(e){for(var n=arguments.length,t=new Array(n>1?n-1:0),r=1;r<n;r++)t[r-1]=arguments[r];"undefined"!=typeof window&&f().forEach((function(n){var r,o={m:b(e,n),a:t};window.ga?l.batch.enabled?(h.push(o),m||(m=setInterval((function(){h.length?h.splice(0,l.batch.amount).forEach((function(e){var n;(n=window).ga.apply(n,[e.m].concat(g(e.a)))})):(clearInterval(m),m=null)}),l.batch.delay))):(r=window).ga.apply(r,[b(e,n)].concat(t)):l.untracked.push(o)}))}function O(e){return(O="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function j(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];"object"!==O(n[0])||n[0].constructor!==Object?w("set",n[0],n[1]):w("set",n[0])}function P(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function S(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function k(){if(window.ga||!l.debug.enabled){if(window.ga){var e=f();l.debug.enabled&&(window.ga_debug={trace:l.debug.trace}),e.forEach((function(n){var t=y(n),r=l.customIdFields[n]||{},o=e.length>1?function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?P(t,!0).forEach((function(n){S(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):P(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},l.fields,{},r,{name:t}):l.fields;window.ga("create",n.id||n,"auto",o)})),l.beforeFirstHit();var n=l.ecommerce;if(n.enabled){var t=n.enhanced?"ec":"ecommerce";n.options?w("require",t,n.options):w("require",t)}l.linkers.length>0&&(w("require","linker"),w("linker:autoLink",l.linkers)),l.debug.sendHitTask||j("sendHitTask",null)}}else p("Google Analytics has probably been blocked.")}var E=function(){2!=arguments.length?w("require",arguments.length<=0?void 0:arguments[0]):w("require",arguments.length<=0?void 0:arguments[0],arguments.length<=1?void 0:arguments[1])};function A(e){return(A="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var x=function(){var e;l.set.forEach((function(e){var n=e.field,t=e.value;if(void 0===n||void 0===t)throw new Error('[vue-analytics] Wrong configuration in the plugin options.\nThe "set" array requires each item to have a "field" and a "value" property.');j(n,t)})),e=["ec","ecommerce"],l.require.forEach((function(n){if(-1!==e.indexOf(n)||-1!==e.indexOf(n.name))throw new Error("[vue-analytics] The ecommerce features are built-in in the plugin. \nFollow the ecommerce instructions available in the documentation.");if("string"!=typeof n&&"object"!==A(n))throw new Error('[vue-analytics] Wrong configuration in the plugin options. \nThe "require" array requires each item to be a string or to have a "name" and an "options" property.');var t=n.name||n;n.options?E(t,n.options):E(t)}))};function T(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r=n[0];if(1===n.length&&"string"==typeof r)return w("send","screenview",{screenName:r});w.apply(void 0,["send","screenview"].concat(n))}function D(e){return(D="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function q(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r;n.length&&!n[0]||(n.length&&n[0].currentRoute&&(r=n[0].currentRoute),n.length&&function(e){return e.query&&e.params}(n[0])&&(r=n[0]),r?R(r):(j("page","object"===D(n[0])?n[0].page:n[0]),w.apply(void 0,["send","pageview"].concat(n))))}function R(e){if(![(n=e).name,n.path].filter(Boolean).find((function(e){return-1!==l.ignoreRoutes.indexOf(e)}))){var n,t=l.autoTracking,r=e.meta.analytics,o=(void 0===r?{}:r).pageviewTemplate||t.pageviewTemplate;if(t.screenview&&!e.name)throw new Error("[vue-analytics] Route name is mandatory when using screenview.");if(t.screenview)T(e.name);else if(o)q(o(e));else{var i=l.router,c=l.autoTracking,a=c.transformQueryString,u=c.prependBase,f=function(e){var n=Object.keys(e).reduce((function(n,t,r,o){var i=r===o.length-1,c=e[t];return null==c?n:n+="".concat(t,"=").concat(c).concat(i?"":"&")}),"");return""!==n?"?".concat(n):""}(e.query),s=i&&i.options.base,p=u&&s,d=e.path+(a?f:"");q(d=p?function(e,n){var t=n.split("/"),r=e.split("/");return""===t[0]&&"/"===e[e.length-1]&&t.shift(),r.join("/")+t.join("/")}(s,d):d)}}}function I(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var L=function(){var e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];"undefined"!=typeof window&&f().forEach((function(n){window["ga-disable-".concat(n)]=e}))},_=function(){if("undefined"!=typeof document&&"undefined"!=typeof window){if(l.id){var e,n,t=[v(l.id),v(l.disabled)];if(e=l.checkDuplicatedScript,n=l.disableScriptLoader,[Boolean(window&&window.ga),e&&!(Array.prototype.slice.call(document.getElementsByTagName("script")).filter((function(e){return-1!==e.src.indexOf("analytics")||-1!==e.src.indexOf("gtag")})).length>0),!n].some(Boolean)){var r="https://www.google-analytics.com",o=l.debug.enabled?"analytics_debug":"analytics",i=l.customResourceURL?d(l.customResourceURL):d("".concat(r,"/").concat(o,".js"),r);t.push(i.catch((function(){p("An error occured! Please check your connection or disable your AD blocker")})))}return Promise.all(t).then((function(e){var n,t,r;u({id:e[0],disabled:e[1]}),L(l.disabled),k(),x(),l.untracked.forEach((function(e){w.apply(void 0,[e.m].concat(I(e.a)))})),n=l.router,t=l.autoTracking,r=l.$vue,t.page&&n&&n.onReady((function(){t.pageviewOnLoad&&n.history.ready&&R(n.currentRoute),n.afterEach((function(e,o){var i=t.skipSamePath,c=t.shouldRouterUpdate;i&&e.path===o.path||("function"!=typeof c||c(e,o))&&r.nextTick().then((function(){R(n.currentRoute)}))}))})),l.ready()})).catch((function(e){l.debug.enabled&&p(e.message)}))}p('Missing the "id" parameter. Add at least one tracking domain ID')}};var B=function(e){var n=arguments.length>1&&void 0!==arguments[1]&&arguments[1];w("send","exception",{exDescription:e,exFatal:n})},H=function(e){if(l.autoTracking.exception){window.addEventListener("error",(function(e){B(e.message)}));var n=e.config.errorHandler;e.config.errorHandler=function(e,t,r){B(e.message),l.autoTracking.exceptionLogs&&console.error(e),"function"==typeof n&&n.call(void 0,e,t,r)}}},F=B;function M(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function U(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}var $=function(e){return"".concat(l.ecommerce.enhanced?"ec":"ecommerce",":").concat(e)},C=["addItem","addTransaction","addProduct","addImpression","setAction","addPromo","send"].reduce((function(e,n){return function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?M(t,!0).forEach((function(n){U(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):M(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},e,U({},n,(function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];w.apply(void 0,[$(n)].concat(t))})))}),{}),N={event:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","event"].concat(n))},exception:F,page:q,query:w,require:E,set:j,social:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","social"].concat(n))},time:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","timing"].concat(n))},screenview:T,ecommerce:C,disable:function(){return L(!0)},enable:function(){return L(!1)},commands:l.commands},Q={inserted:function(e,n,t){var r=Object.keys(n.modifiers);0===r.length&&r.push("click"),r.forEach((function(r){e.addEventListener(r,(function(){var e="string"==typeof n.value?l.commands[n.value]:n.value;if(!e)throw new Error("[vue-analytics] The value passed to v-ga is not defined in the commands list.");e.apply(t.context)}))}))}};function W(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}function G(e,n){return function(e){if(Array.isArray(e))return e}(e)||function(e,n){if(!(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e)))return;var t=[],r=!0,o=!1,i=void 0;try{for(var c,a=e[Symbol.iterator]();!(r=(c=a.next()).done)&&(t.push(c.value),!n||t.length!==n);r=!0);}catch(e){o=!0,i=e}finally{try{r||null==a.return||a.return()}finally{if(o)throw i}}return t}(e,n)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}function z(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function J(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function K(e){u(function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?z(t,!0).forEach((function(n){J(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):z(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},{$vue:e})),e.directive("ga",Q),e.prototype.$ga=e.$ga=N,H(e),_()}t.d(n,"default",(function(){return K})),t.d(n,"analyticsMiddleware",(function(){return V})),t.d(n,"onAnalyticsReady",(function(){return X})),t.d(n,"event",(function(){return Y})),t.d(n,"ecommerce",(function(){return Z})),t.d(n,"set",(function(){return ee})),t.d(n,"page",(function(){return ne})),t.d(n,"query",(function(){return te})),t.d(n,"screenview",(function(){return re})),t.d(n,"time",(function(){return oe})),t.d(n,"require",(function(){return ie})),t.d(n,"exception",(function(){return ce})),t.d(n,"social",(function(){return ae}));var V=function(e){e.subscribe((function(e){var n=e.payload;if(n&&n.meta&&n.meta.analytics){var t=n.meta.analytics;if(!Array.isArray(t))throw new Error('The "analytics" property needs to be an array');t.forEach((function(e){var n,t,r=e.shift(),o=e;if(r.includes(":")){var i=G(r.split(":"),2);r=i[0],n=i[1]}if(!(r in N))throw new Error('[vue-analytics:vuex] The type "'.concat(r,"\" doesn't exist."));if(n&&!(n in N[r]))throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" has not method "').concat(n,'".'));if("ecommerce"===r&&!n)throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" needs to call a method. Check documentation.'));n?(t=N[r])[n].apply(t,W(o)):N[r].apply(N,W(o))}))}}))},X=function(){return new Promise((function(e,n){var t=setInterval((function(){"undefined"!=typeof window&&window.ga&&(e(),clearInterval(t))}),10)}))},Y=N.event,Z=N.ecommerce,ee=N.set,ne=N.page,te=N.query,re=N.screenview,oe=N.time,ie=N.require,ce=N.exception,ae=N.social}])}));

/***/ })
],[16]);


// WEBPACK FOOTER //
// js/app.e20859df6524890d72fe.js